var React = require('react');
var sgDashboardSdk = require('sg-dashboard-sdk');
require('react-dom');

var ProducerType;
(function (ProducerType) {
  ProducerType["SgWidget"] = "SgWidget";
  ProducerType["JsLoader"] = "JsLoader";
  ProducerType["Source"] = "Source";
})(ProducerType || (ProducerType = {}));

var Level;
(function (Level) {
  Level[Level["Error"] = 0] = "Error";
  Level[Level["Warning"] = 1] = "Warning";
  Level[Level["Info"] = 2] = "Info";
  Level[Level["Debug"] = 3] = "Debug";
})(Level || (Level = {}));
var Category;
(function (Category) {
  Category[Category["Common"] = 0] = "Common";
  Category[Category["Test"] = 1] = "Test";
  Category[Category["Api"] = 2] = "Api";
  Category[Category["Graph"] = 3] = "Graph";
  Category[Category["Task"] = 4] = "Task";
  Category[Category["Producer"] = 5] = "Producer";
  Category[Category["Board"] = 6] = "Board";
  Category[Category["Editor"] = 7] = "Editor";
  Category[Category["SGWT"] = 8] = "SGWT";
  Category[Category["Widget"] = 9] = "Widget";
  Category[Category["EditorSelfBi"] = 10] = "EditorSelfBi";
  Category[Category["Admin"] = 11] = "Admin";
  Category[Category["Projects"] = 12] = "Projects";
  Category[Category["Accessibility"] = 13] = "Accessibility";
  Category[Category["ValidationTest"] = 14] = "ValidationTest";
})(Category || (Category = {}));
const categories = [];
// config:
const defaultLevel = Level.Warning; // IMPORTANT: all log levels starting from 'defaultLevel' will be sent to the backend
categories[Category.Common] = defaultLevel;
categories[Category.Test] = defaultLevel;
categories[Category.Api] = defaultLevel;
categories[Category.Graph] = defaultLevel;
categories[Category.Task] = defaultLevel;
categories[Category.Producer] = defaultLevel;
categories[Category.Board] = defaultLevel;
categories[Category.Editor] = defaultLevel;
categories[Category.SGWT] = defaultLevel;
categories[Category.Widget] = defaultLevel;
categories[Category.ValidationTest] = defaultLevel;
function formatMessage(category, level, msg) {
  return "[" + new Date().toISOString() + "][" + Category[category] + "][" + Level[level] + "] " + msg;
}
function chunkString(str, len) {
  const size = Math.ceil(str.length / len);
  const r = Array(size);
  let offset = 0;
  for (let i = 0; i < size; i++) {
    r[i] = str.substr(offset, len);
    offset += len;
  }
  return r;
}
// this function is automatically called by the macros
function log(msg) {
  //
  // workaround the 'Show more' in chrome devtools console
  const len = 1024;
  if (msg.length > len) {
    const messages = chunkString(msg, len);
    console.log('START long log message');
    messages.forEach(chunk => console.log(chunk));
    console.log('STOP long log message');
  }
}
const Logger = {
  Category,
  Level,
  categories,
  formatMessage,
  log
};

//
const Log$9 = Logger; // needed for jest
var Priority;
(function (Priority) {
  Priority[Priority["VeryHigh"] = 1] = "VeryHigh";
  Priority[Priority["High"] = 2] = "High";
  Priority[Priority["Medium"] = 3] = "Medium";
  Priority[Priority["Normal"] = 4] = "Normal";
})(Priority || (Priority = {}));
class ProducerDictionary {
  constructor() {
    this.producers = new Map();
    this.count = 0;
  }
  clone() {
    const res = new ProducerDictionary();
    this.producers.forEach(_ref => {
      let {
        type,
        producer
      } = _ref;
      return res.add(producer.clone(), type);
    });
    return res;
  }
  get(key) {
    const item = this.producers.get(key);
    if (!item) {
      return function () {
        {
          const formattedMessage = Log$9.formatMessage(Category.Producer, Log$9.Level.Error, "ProducerDictionary.get() invalid key[" + key + "]");
          console.log(formattedMessage);
          Log$9.log(formattedMessage);
          throw new Error(formattedMessage);
        }
      }();
    }
    return item.producer;
  }
  remove(key) {
    const producer = this.producers.get(key);
    if (!producer) {
      return function () {
        {
          const formattedMessage = Log$9.formatMessage(Category.Producer, Log$9.Level.Error, "ProducerDictionary.remove() key[" + key + "] does not exist");
          console.log(formattedMessage);
          Log$9.log(formattedMessage);
          throw new Error(formattedMessage);
        }
      }();
    }
    (function () {
      if (Log$9.categories[Category.Producer] >= Level.Debug) {
        const formattedMessage = Log$9.formatMessage(Category.Producer, Level.Debug, "ProducerDictionary.remove() key[" + key + "]");
        console.log(formattedMessage);
        return Log$9.log(formattedMessage);
      }
    })();
    this.producers.delete(key);
  }
  nextKey() {
    ++this.count;
    return "" + this.count;
  }
  forEach(cb) {
    this.producers.forEach(_ref2 => {
      let {
        producer
      } = _ref2;
      return cb(producer);
    });
  }
  toArray() {
    return Array.from(this.producers.values()).map(_ref3 => {
      let {
        producer
      } = _ref3;
      return producer;
    });
  }
  getType(key) {
    const item = this.producers.get(key);
    if (!item) {
      return function () {
        {
          const formattedMessage = Log$9.formatMessage(Category.Producer, Log$9.Level.Error, "ProducerDictionary.getType() invalid key[" + key + "]");
          console.log(formattedMessage);
          Log$9.log(formattedMessage);
          throw new Error(formattedMessage);
        }
      }();
    }
    return item.type;
  }
  add(producer, type) {
    const key = producer.key;
    if (this.producers.has(key)) {
      return function () {
        {
          const formattedMessage = Log$9.formatMessage(Category.Producer, Log$9.Level.Error, "ProducerDictionary.add() key[" + key + "] already exists");
          console.log(formattedMessage);
          Log$9.log(formattedMessage);
          throw new Error(formattedMessage);
        }
      }();
    }
    this.producers.set(key, {
      producer,
      type
    });
    this.count = Math.max(this.count, Number(key));
  }
  getProducer(key, type) {
    const item = this.producers.get(key);
    if (!item || item.type !== type) {
      return function () {
        {
          const formattedMessage = Log$9.formatMessage(Category.Producer, Log$9.Level.Error, "ProducerDictionary.getProducer() invalid key[" + key + "]");
          console.log(formattedMessage);
          Log$9.log(formattedMessage);
          throw new Error(formattedMessage);
        }
      }();
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return item.producer;
  }
  getSgWidget(key) {
    return this.getProducer(key, ProducerType.SgWidget);
  }
  addSgWidget(producer) {
    this.add(producer, ProducerType.SgWidget);
  }
  // getJsLoader not used currently
  getJsLoader(key) {
    return this.getProducer(key, ProducerType.JsLoader);
  }
  addJsLoader(producer) {
    this.add(producer, ProducerType.JsLoader);
  }
  addSourceProducer(producer) {
    this.add(producer, ProducerType.Source);
  }
  getSourceProducerByIdentifier(identifier) {
    const res = Array.from(this.producers.values()).filter(_ref4 => {
      let {
        type
      } = _ref4;
      return type === ProducerType.Source;
    }).map(_ref5 => {
      let {
        producer
      } = _ref5;
      return producer;
    }).filter(p => p.identifier === identifier);
    return res.length === 1 ? res[0] : null;
  }
  getJsLoaderByUrl(url) {
    const res = Array.from(this.producers.values()).filter(_ref6 => {
      let {
        type
      } = _ref6;
      return type === ProducerType.JsLoader;
    }).map(_ref7 => {
      let {
        producer
      } = _ref7;
      return producer;
    }).filter(p => p.url === url);
    return res.length === 1 ? res[0] : null;
  }
}

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function createCommonjsModule(fn) {
  var module = { exports: {} };
	return fn(module, module.exports), module.exports;
}

/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

var lodash = createCommonjsModule(function (module, exports) {
(function() {

  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
  var undefined$1;

  /** Used as the semantic version number. */
  var VERSION = '4.17.21';

  /** Used as the size to enable large array optimizations. */
  var LARGE_ARRAY_SIZE = 200;

  /** Error message constants. */
  var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.',
      FUNC_ERROR_TEXT = 'Expected a function',
      INVALID_TEMPL_VAR_ERROR_TEXT = 'Invalid `variable` option passed into `_.template`';

  /** Used to stand-in for `undefined` hash values. */
  var HASH_UNDEFINED = '__lodash_hash_undefined__';

  /** Used as the maximum memoize cache size. */
  var MAX_MEMOIZE_SIZE = 500;

  /** Used as the internal argument placeholder. */
  var PLACEHOLDER = '__lodash_placeholder__';

  /** Used to compose bitmasks for cloning. */
  var CLONE_DEEP_FLAG = 1,
      CLONE_FLAT_FLAG = 2,
      CLONE_SYMBOLS_FLAG = 4;

  /** Used to compose bitmasks for value comparisons. */
  var COMPARE_PARTIAL_FLAG = 1,
      COMPARE_UNORDERED_FLAG = 2;

  /** Used to compose bitmasks for function metadata. */
  var WRAP_BIND_FLAG = 1,
      WRAP_BIND_KEY_FLAG = 2,
      WRAP_CURRY_BOUND_FLAG = 4,
      WRAP_CURRY_FLAG = 8,
      WRAP_CURRY_RIGHT_FLAG = 16,
      WRAP_PARTIAL_FLAG = 32,
      WRAP_PARTIAL_RIGHT_FLAG = 64,
      WRAP_ARY_FLAG = 128,
      WRAP_REARG_FLAG = 256,
      WRAP_FLIP_FLAG = 512;

  /** Used as default options for `_.truncate`. */
  var DEFAULT_TRUNC_LENGTH = 30,
      DEFAULT_TRUNC_OMISSION = '...';

  /** Used to detect hot functions by number of calls within a span of milliseconds. */
  var HOT_COUNT = 800,
      HOT_SPAN = 16;

  /** Used to indicate the type of lazy iteratees. */
  var LAZY_FILTER_FLAG = 1,
      LAZY_MAP_FLAG = 2,
      LAZY_WHILE_FLAG = 3;

  /** Used as references for various `Number` constants. */
  var INFINITY = 1 / 0,
      MAX_SAFE_INTEGER = 9007199254740991,
      MAX_INTEGER = 1.7976931348623157e+308,
      NAN = 0 / 0;

  /** Used as references for the maximum length and index of an array. */
  var MAX_ARRAY_LENGTH = 4294967295,
      MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1,
      HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;

  /** Used to associate wrap methods with their bit flags. */
  var wrapFlags = [
    ['ary', WRAP_ARY_FLAG],
    ['bind', WRAP_BIND_FLAG],
    ['bindKey', WRAP_BIND_KEY_FLAG],
    ['curry', WRAP_CURRY_FLAG],
    ['curryRight', WRAP_CURRY_RIGHT_FLAG],
    ['flip', WRAP_FLIP_FLAG],
    ['partial', WRAP_PARTIAL_FLAG],
    ['partialRight', WRAP_PARTIAL_RIGHT_FLAG],
    ['rearg', WRAP_REARG_FLAG]
  ];

  /** `Object#toString` result references. */
  var argsTag = '[object Arguments]',
      arrayTag = '[object Array]',
      asyncTag = '[object AsyncFunction]',
      boolTag = '[object Boolean]',
      dateTag = '[object Date]',
      domExcTag = '[object DOMException]',
      errorTag = '[object Error]',
      funcTag = '[object Function]',
      genTag = '[object GeneratorFunction]',
      mapTag = '[object Map]',
      numberTag = '[object Number]',
      nullTag = '[object Null]',
      objectTag = '[object Object]',
      promiseTag = '[object Promise]',
      proxyTag = '[object Proxy]',
      regexpTag = '[object RegExp]',
      setTag = '[object Set]',
      stringTag = '[object String]',
      symbolTag = '[object Symbol]',
      undefinedTag = '[object Undefined]',
      weakMapTag = '[object WeakMap]',
      weakSetTag = '[object WeakSet]';

  var arrayBufferTag = '[object ArrayBuffer]',
      dataViewTag = '[object DataView]',
      float32Tag = '[object Float32Array]',
      float64Tag = '[object Float64Array]',
      int8Tag = '[object Int8Array]',
      int16Tag = '[object Int16Array]',
      int32Tag = '[object Int32Array]',
      uint8Tag = '[object Uint8Array]',
      uint8ClampedTag = '[object Uint8ClampedArray]',
      uint16Tag = '[object Uint16Array]',
      uint32Tag = '[object Uint32Array]';

  /** Used to match empty string literals in compiled template source. */
  var reEmptyStringLeading = /\b__p \+= '';/g,
      reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
      reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;

  /** Used to match HTML entities and HTML characters. */
  var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g,
      reUnescapedHtml = /[&<>"']/g,
      reHasEscapedHtml = RegExp(reEscapedHtml.source),
      reHasUnescapedHtml = RegExp(reUnescapedHtml.source);

  /** Used to match template delimiters. */
  var reEscape = /<%-([\s\S]+?)%>/g,
      reEvaluate = /<%([\s\S]+?)%>/g,
      reInterpolate = /<%=([\s\S]+?)%>/g;

  /** Used to match property names within property paths. */
  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
      reIsPlainProp = /^\w*$/,
      rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

  /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */
  var reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
      reHasRegExpChar = RegExp(reRegExpChar.source);

  /** Used to match leading whitespace. */
  var reTrimStart = /^\s+/;

  /** Used to match a single whitespace character. */
  var reWhitespace = /\s/;

  /** Used to match wrap detail comments. */
  var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,
      reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
      reSplitDetails = /,? & /;

  /** Used to match words composed of alphanumeric characters. */
  var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;

  /**
   * Used to validate the `validate` option in `_.template` variable.
   *
   * Forbids characters which could potentially change the meaning of the function argument definition:
   * - "()," (modification of function parameters)
   * - "=" (default value)
   * - "[]{}" (destructuring of function parameters)
   * - "/" (beginning of a comment)
   * - whitespace
   */
  var reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/;

  /** Used to match backslashes in property paths. */
  var reEscapeChar = /\\(\\)?/g;

  /**
   * Used to match
   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
   */
  var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;

  /** Used to match `RegExp` flags from their coerced string values. */
  var reFlags = /\w*$/;

  /** Used to detect bad signed hexadecimal string values. */
  var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

  /** Used to detect binary string values. */
  var reIsBinary = /^0b[01]+$/i;

  /** Used to detect host constructors (Safari). */
  var reIsHostCtor = /^\[object .+?Constructor\]$/;

  /** Used to detect octal string values. */
  var reIsOctal = /^0o[0-7]+$/i;

  /** Used to detect unsigned integer values. */
  var reIsUint = /^(?:0|[1-9]\d*)$/;

  /** Used to match Latin Unicode letters (excluding mathematical operators). */
  var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;

  /** Used to ensure capturing order of template delimiters. */
  var reNoMatch = /($^)/;

  /** Used to match unescaped characters in compiled string literals. */
  var reUnescapedString = /['\n\r\u2028\u2029\\]/g;

  /** Used to compose unicode character classes. */
  var rsAstralRange = '\\ud800-\\udfff',
      rsComboMarksRange = '\\u0300-\\u036f',
      reComboHalfMarksRange = '\\ufe20-\\ufe2f',
      rsComboSymbolsRange = '\\u20d0-\\u20ff',
      rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
      rsDingbatRange = '\\u2700-\\u27bf',
      rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
      rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
      rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
      rsPunctuationRange = '\\u2000-\\u206f',
      rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
      rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
      rsVarRange = '\\ufe0e\\ufe0f',
      rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;

  /** Used to compose unicode capture groups. */
  var rsApos = "['\u2019]",
      rsAstral = '[' + rsAstralRange + ']',
      rsBreak = '[' + rsBreakRange + ']',
      rsCombo = '[' + rsComboRange + ']',
      rsDigits = '\\d+',
      rsDingbat = '[' + rsDingbatRange + ']',
      rsLower = '[' + rsLowerRange + ']',
      rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
      rsFitz = '\\ud83c[\\udffb-\\udfff]',
      rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
      rsNonAstral = '[^' + rsAstralRange + ']',
      rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
      rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
      rsUpper = '[' + rsUpperRange + ']',
      rsZWJ = '\\u200d';

  /** Used to compose unicode regexes. */
  var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
      rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
      rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
      rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
      reOptMod = rsModifier + '?',
      rsOptVar = '[' + rsVarRange + ']?',
      rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
      rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])',
      rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])',
      rsSeq = rsOptVar + reOptMod + rsOptJoin,
      rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq,
      rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

  /** Used to match apostrophes. */
  var reApos = RegExp(rsApos, 'g');

  /**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */
  var reComboMark = RegExp(rsCombo, 'g');

  /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
  var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

  /** Used to match complex or compound words. */
  var reUnicodeWord = RegExp([
    rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
    rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')',
    rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
    rsUpper + '+' + rsOptContrUpper,
    rsOrdUpper,
    rsOrdLower,
    rsDigits,
    rsEmoji
  ].join('|'), 'g');

  /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
  var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');

  /** Used to detect strings that need a more robust regexp to match words. */
  var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;

  /** Used to assign default `context` object properties. */
  var contextProps = [
    'Array', 'Buffer', 'DataView', 'Date', 'Error', 'Float32Array', 'Float64Array',
    'Function', 'Int8Array', 'Int16Array', 'Int32Array', 'Map', 'Math', 'Object',
    'Promise', 'RegExp', 'Set', 'String', 'Symbol', 'TypeError', 'Uint8Array',
    'Uint8ClampedArray', 'Uint16Array', 'Uint32Array', 'WeakMap',
    '_', 'clearTimeout', 'isFinite', 'parseInt', 'setTimeout'
  ];

  /** Used to make template sourceURLs easier to identify. */
  var templateCounter = -1;

  /** Used to identify `toStringTag` values of typed arrays. */
  var typedArrayTags = {};
  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
  typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
  typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
  typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
  typedArrayTags[uint32Tag] = true;
  typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
  typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
  typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
  typedArrayTags[errorTag] = typedArrayTags[funcTag] =
  typedArrayTags[mapTag] = typedArrayTags[numberTag] =
  typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
  typedArrayTags[setTag] = typedArrayTags[stringTag] =
  typedArrayTags[weakMapTag] = false;

  /** Used to identify `toStringTag` values supported by `_.clone`. */
  var cloneableTags = {};
  cloneableTags[argsTag] = cloneableTags[arrayTag] =
  cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
  cloneableTags[boolTag] = cloneableTags[dateTag] =
  cloneableTags[float32Tag] = cloneableTags[float64Tag] =
  cloneableTags[int8Tag] = cloneableTags[int16Tag] =
  cloneableTags[int32Tag] = cloneableTags[mapTag] =
  cloneableTags[numberTag] = cloneableTags[objectTag] =
  cloneableTags[regexpTag] = cloneableTags[setTag] =
  cloneableTags[stringTag] = cloneableTags[symbolTag] =
  cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
  cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
  cloneableTags[errorTag] = cloneableTags[funcTag] =
  cloneableTags[weakMapTag] = false;

  /** Used to map Latin Unicode letters to basic Latin letters. */
  var deburredLetters = {
    // Latin-1 Supplement block.
    '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
    '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
    '\xc7': 'C',  '\xe7': 'c',
    '\xd0': 'D',  '\xf0': 'd',
    '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
    '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
    '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
    '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
    '\xd1': 'N',  '\xf1': 'n',
    '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
    '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
    '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
    '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
    '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
    '\xc6': 'Ae', '\xe6': 'ae',
    '\xde': 'Th', '\xfe': 'th',
    '\xdf': 'ss',
    // Latin Extended-A block.
    '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
    '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
    '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
    '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
    '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
    '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
    '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
    '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
    '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
    '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
    '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
    '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
    '\u0134': 'J',  '\u0135': 'j',
    '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
    '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
    '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
    '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
    '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
    '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
    '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
    '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
    '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
    '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
    '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
    '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
    '\u0163': 't',  '\u0165': 't', '\u0167': 't',
    '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
    '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
    '\u0174': 'W',  '\u0175': 'w',
    '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
    '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
    '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
    '\u0132': 'IJ', '\u0133': 'ij',
    '\u0152': 'Oe', '\u0153': 'oe',
    '\u0149': "'n", '\u017f': 's'
  };

  /** Used to map characters to HTML entities. */
  var htmlEscapes = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;'
  };

  /** Used to map HTML entities to characters. */
  var htmlUnescapes = {
    '&amp;': '&',
    '&lt;': '<',
    '&gt;': '>',
    '&quot;': '"',
    '&#39;': "'"
  };

  /** Used to escape characters for inclusion in compiled string literals. */
  var stringEscapes = {
    '\\': '\\',
    "'": "'",
    '\n': 'n',
    '\r': 'r',
    '\u2028': 'u2028',
    '\u2029': 'u2029'
  };

  /** Built-in method references without a dependency on `root`. */
  var freeParseFloat = parseFloat,
      freeParseInt = parseInt;

  /** Detect free variable `global` from Node.js. */
  var freeGlobal = typeof commonjsGlobal == 'object' && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;

  /** Detect free variable `self`. */
  var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

  /** Used as a reference to the global object. */
  var root = freeGlobal || freeSelf || Function('return this')();

  /** Detect free variable `exports`. */
  var freeExports = exports && !exports.nodeType && exports;

  /** Detect free variable `module`. */
  var freeModule = freeExports && 'object' == 'object' && module && !module.nodeType && module;

  /** Detect the popular CommonJS extension `module.exports`. */
  var moduleExports = freeModule && freeModule.exports === freeExports;

  /** Detect free variable `process` from Node.js. */
  var freeProcess = moduleExports && freeGlobal.process;

  /** Used to access faster Node.js helpers. */
  var nodeUtil = (function() {
    try {
      // Use `util.types` for Node.js 10+.
      var types = freeModule && freeModule.require && freeModule.require('util').types;

      if (types) {
        return types;
      }

      // Legacy `process.binding('util')` for Node.js < 10.
      return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
  }());

  /* Node.js helper references. */
  var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer,
      nodeIsDate = nodeUtil && nodeUtil.isDate,
      nodeIsMap = nodeUtil && nodeUtil.isMap,
      nodeIsRegExp = nodeUtil && nodeUtil.isRegExp,
      nodeIsSet = nodeUtil && nodeUtil.isSet,
      nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

  /*--------------------------------------------------------------------------*/

  /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */
  function apply(func, thisArg, args) {
    switch (args.length) {
      case 0: return func.call(thisArg);
      case 1: return func.call(thisArg, args[0]);
      case 2: return func.call(thisArg, args[0], args[1]);
      case 3: return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
  }

  /**
   * A specialized version of `baseAggregator` for arrays.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} setter The function to set `accumulator` values.
   * @param {Function} iteratee The iteratee to transform keys.
   * @param {Object} accumulator The initial aggregated object.
   * @returns {Function} Returns `accumulator`.
   */
  function arrayAggregator(array, setter, iteratee, accumulator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      var value = array[index];
      setter(accumulator, value, iteratee(value), array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEach(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (iteratee(array[index], index, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.forEachRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEachRight(array, iteratee) {
    var length = array == null ? 0 : array.length;

    while (length--) {
      if (iteratee(array[length], length, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.every` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if all elements pass the predicate check,
   *  else `false`.
   */
  function arrayEvery(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (!predicate(array[index], index, array)) {
        return false;
      }
    }
    return true;
  }

  /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */
  function arrayFilter(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (predicate(value, index, array)) {
        result[resIndex++] = value;
      }
    }
    return result;
  }

  /**
   * A specialized version of `_.includes` for arrays without support for
   * specifying an index to search from.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludes(array, value) {
    var length = array == null ? 0 : array.length;
    return !!length && baseIndexOf(array, value, 0) > -1;
  }

  /**
   * This function is like `arrayIncludes` except that it accepts a comparator.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludesWith(array, value, comparator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (comparator(value, array[index])) {
        return true;
      }
    }
    return false;
  }

  /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */
  function arrayMap(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length,
        result = Array(length);

    while (++index < length) {
      result[index] = iteratee(array[index], index, array);
    }
    return result;
  }

  /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */
  function arrayPush(array, values) {
    var index = -1,
        length = values.length,
        offset = array.length;

    while (++index < length) {
      array[offset + index] = values[index];
    }
    return array;
  }

  /**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduce(array, iteratee, accumulator, initAccum) {
    var index = -1,
        length = array == null ? 0 : array.length;

    if (initAccum && length) {
      accumulator = array[++index];
    }
    while (++index < length) {
      accumulator = iteratee(accumulator, array[index], index, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.reduceRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the last element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduceRight(array, iteratee, accumulator, initAccum) {
    var length = array == null ? 0 : array.length;
    if (initAccum && length) {
      accumulator = array[--length];
    }
    while (length--) {
      accumulator = iteratee(accumulator, array[length], length, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */
  function arraySome(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (predicate(array[index], index, array)) {
        return true;
      }
    }
    return false;
  }

  /**
   * Gets the size of an ASCII `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  var asciiSize = baseProperty('length');

  /**
   * Converts an ASCII `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function asciiToArray(string) {
    return string.split('');
  }

  /**
   * Splits an ASCII `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function asciiWords(string) {
    return string.match(reAsciiWord) || [];
  }

  /**
   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
   * without support for iteratee shorthands, which iterates over `collection`
   * using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the found element or its key, else `undefined`.
   */
  function baseFindKey(collection, predicate, eachFunc) {
    var result;
    eachFunc(collection, function(value, key, collection) {
      if (predicate(value, key, collection)) {
        result = key;
        return false;
      }
    });
    return result;
  }

  /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length,
        index = fromIndex + (fromRight ? 1 : -1);

    while ((fromRight ? index-- : ++index < length)) {
      if (predicate(array[index], index, array)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOf(array, value, fromIndex) {
    return value === value
      ? strictIndexOf(array, value, fromIndex)
      : baseFindIndex(array, baseIsNaN, fromIndex);
  }

  /**
   * This function is like `baseIndexOf` except that it accepts a comparator.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOfWith(array, value, fromIndex, comparator) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (comparator(array[index], value)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.isNaN` without support for number objects.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   */
  function baseIsNaN(value) {
    return value !== value;
  }

  /**
   * The base implementation of `_.mean` and `_.meanBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the mean.
   */
  function baseMean(array, iteratee) {
    var length = array == null ? 0 : array.length;
    return length ? (baseSum(array, iteratee) / length) : NAN;
  }

  /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */
  function baseProperty(key) {
    return function(object) {
      return object == null ? undefined$1 : object[key];
    };
  }

  /**
   * The base implementation of `_.propertyOf` without support for deep paths.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Function} Returns the new accessor function.
   */
  function basePropertyOf(object) {
    return function(key) {
      return object == null ? undefined$1 : object[key];
    };
  }

  /**
   * The base implementation of `_.reduce` and `_.reduceRight`, without support
   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} accumulator The initial value.
   * @param {boolean} initAccum Specify using the first or last element of
   *  `collection` as the initial value.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the accumulated value.
   */
  function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
    eachFunc(collection, function(value, index, collection) {
      accumulator = initAccum
        ? (initAccum = false, value)
        : iteratee(accumulator, value, index, collection);
    });
    return accumulator;
  }

  /**
   * The base implementation of `_.sortBy` which uses `comparer` to define the
   * sort order of `array` and replaces criteria objects with their corresponding
   * values.
   *
   * @private
   * @param {Array} array The array to sort.
   * @param {Function} comparer The function to define sort order.
   * @returns {Array} Returns `array`.
   */
  function baseSortBy(array, comparer) {
    var length = array.length;

    array.sort(comparer);
    while (length--) {
      array[length] = array[length].value;
    }
    return array;
  }

  /**
   * The base implementation of `_.sum` and `_.sumBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the sum.
   */
  function baseSum(array, iteratee) {
    var result,
        index = -1,
        length = array.length;

    while (++index < length) {
      var current = iteratee(array[index]);
      if (current !== undefined$1) {
        result = result === undefined$1 ? current : (result + current);
      }
    }
    return result;
  }

  /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */
  function baseTimes(n, iteratee) {
    var index = -1,
        result = Array(n);

    while (++index < n) {
      result[index] = iteratee(index);
    }
    return result;
  }

  /**
   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
   * of key-value pairs for `object` corresponding to the property names of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the key-value pairs.
   */
  function baseToPairs(object, props) {
    return arrayMap(props, function(key) {
      return [key, object[key]];
    });
  }

  /**
   * The base implementation of `_.trim`.
   *
   * @private
   * @param {string} string The string to trim.
   * @returns {string} Returns the trimmed string.
   */
  function baseTrim(string) {
    return string
      ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '')
      : string;
  }

  /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */
  function baseUnary(func) {
    return function(value) {
      return func(value);
    };
  }

  /**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */
  function baseValues(object, props) {
    return arrayMap(props, function(key) {
      return object[key];
    });
  }

  /**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */
  function cacheHas(cache, key) {
    return cache.has(key);
  }

  /**
   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the first unmatched string symbol.
   */
  function charsStartIndex(strSymbols, chrSymbols) {
    var index = -1,
        length = strSymbols.length;

    while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the last unmatched string symbol.
   */
  function charsEndIndex(strSymbols, chrSymbols) {
    var index = strSymbols.length;

    while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Gets the number of `placeholder` occurrences in `array`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} placeholder The placeholder to search for.
   * @returns {number} Returns the placeholder count.
   */
  function countHolders(array, placeholder) {
    var length = array.length,
        result = 0;

    while (length--) {
      if (array[length] === placeholder) {
        ++result;
      }
    }
    return result;
  }

  /**
   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
   * letters to basic Latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */
  var deburrLetter = basePropertyOf(deburredLetters);

  /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  var escapeHtmlChar = basePropertyOf(htmlEscapes);

  /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  function escapeStringChar(chr) {
    return '\\' + stringEscapes[chr];
  }

  /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */
  function getValue(object, key) {
    return object == null ? undefined$1 : object[key];
  }

  /**
   * Checks if `string` contains Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
   */
  function hasUnicode(string) {
    return reHasUnicode.test(string);
  }

  /**
   * Checks if `string` contains a word composed of Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a word is found, else `false`.
   */
  function hasUnicodeWord(string) {
    return reHasUnicodeWord.test(string);
  }

  /**
   * Converts `iterator` to an array.
   *
   * @private
   * @param {Object} iterator The iterator to convert.
   * @returns {Array} Returns the converted array.
   */
  function iteratorToArray(iterator) {
    var data,
        result = [];

    while (!(data = iterator.next()).done) {
      result.push(data.value);
    }
    return result;
  }

  /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */
  function mapToArray(map) {
    var index = -1,
        result = Array(map.size);

    map.forEach(function(value, key) {
      result[++index] = [key, value];
    });
    return result;
  }

  /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */
  function overArg(func, transform) {
    return function(arg) {
      return func(transform(arg));
    };
  }

  /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */
  function replaceHolders(array, placeholder) {
    var index = -1,
        length = array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (value === placeholder || value === PLACEHOLDER) {
        array[index] = PLACEHOLDER;
        result[resIndex++] = index;
      }
    }
    return result;
  }

  /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */
  function setToArray(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = value;
    });
    return result;
  }

  /**
   * Converts `set` to its value-value pairs.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the value-value pairs.
   */
  function setToPairs(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = [value, value];
    });
    return result;
  }

  /**
   * A specialized version of `_.indexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictIndexOf(array, value, fromIndex) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (array[index] === value) {
        return index;
      }
    }
    return -1;
  }

  /**
   * A specialized version of `_.lastIndexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictLastIndexOf(array, value, fromIndex) {
    var index = fromIndex + 1;
    while (index--) {
      if (array[index] === value) {
        return index;
      }
    }
    return index;
  }

  /**
   * Gets the number of symbols in `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the string size.
   */
  function stringSize(string) {
    return hasUnicode(string)
      ? unicodeSize(string)
      : asciiSize(string);
  }

  /**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function stringToArray(string) {
    return hasUnicode(string)
      ? unicodeToArray(string)
      : asciiToArray(string);
  }

  /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
   * character of `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the index of the last non-whitespace character.
   */
  function trimmedEndIndex(string) {
    var index = string.length;

    while (index-- && reWhitespace.test(string.charAt(index))) {}
    return index;
  }

  /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */
  var unescapeHtmlChar = basePropertyOf(htmlUnescapes);

  /**
   * Gets the size of a Unicode `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  function unicodeSize(string) {
    var result = reUnicode.lastIndex = 0;
    while (reUnicode.test(string)) {
      ++result;
    }
    return result;
  }

  /**
   * Converts a Unicode `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function unicodeToArray(string) {
    return string.match(reUnicode) || [];
  }

  /**
   * Splits a Unicode `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function unicodeWords(string) {
    return string.match(reUnicodeWord) || [];
  }

  /*--------------------------------------------------------------------------*/

  /**
   * Create a new pristine `lodash` function using the `context` object.
   *
   * @static
   * @memberOf _
   * @since 1.1.0
   * @category Util
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // Create a suped-up `defer` in Node.js.
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */
  var runInContext = (function runInContext(context) {
    context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));

    /** Built-in constructor references. */
    var Array = context.Array,
        Date = context.Date,
        Error = context.Error,
        Function = context.Function,
        Math = context.Math,
        Object = context.Object,
        RegExp = context.RegExp,
        String = context.String,
        TypeError = context.TypeError;

    /** Used for built-in method references. */
    var arrayProto = Array.prototype,
        funcProto = Function.prototype,
        objectProto = Object.prototype;

    /** Used to detect overreaching core-js shims. */
    var coreJsData = context['__core-js_shared__'];

    /** Used to resolve the decompiled source of functions. */
    var funcToString = funcProto.toString;

    /** Used to check objects for own properties. */
    var hasOwnProperty = objectProto.hasOwnProperty;

    /** Used to generate unique IDs. */
    var idCounter = 0;

    /** Used to detect methods masquerading as native. */
    var maskSrcKey = (function() {
      var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
      return uid ? ('Symbol(src)_1.' + uid) : '';
    }());

    /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */
    var nativeObjectToString = objectProto.toString;

    /** Used to infer the `Object` constructor. */
    var objectCtorString = funcToString.call(Object);

    /** Used to restore the original `_` reference in `_.noConflict`. */
    var oldDash = root._;

    /** Used to detect if a method is native. */
    var reIsNative = RegExp('^' +
      funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
      .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
    );

    /** Built-in value references. */
    var Buffer = moduleExports ? context.Buffer : undefined$1,
        Symbol = context.Symbol,
        Uint8Array = context.Uint8Array,
        allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined$1,
        getPrototype = overArg(Object.getPrototypeOf, Object),
        objectCreate = Object.create,
        propertyIsEnumerable = objectProto.propertyIsEnumerable,
        splice = arrayProto.splice,
        spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined$1,
        symIterator = Symbol ? Symbol.iterator : undefined$1,
        symToStringTag = Symbol ? Symbol.toStringTag : undefined$1;

    var defineProperty = (function() {
      try {
        var func = getNative(Object, 'defineProperty');
        func({}, '', {});
        return func;
      } catch (e) {}
    }());

    /** Mocked built-ins. */
    var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout,
        ctxNow = Date && Date.now !== root.Date.now && Date.now,
        ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;

    /* Built-in method references for those with the same name as other `lodash` methods. */
    var nativeCeil = Math.ceil,
        nativeFloor = Math.floor,
        nativeGetSymbols = Object.getOwnPropertySymbols,
        nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined$1,
        nativeIsFinite = context.isFinite,
        nativeJoin = arrayProto.join,
        nativeKeys = overArg(Object.keys, Object),
        nativeMax = Math.max,
        nativeMin = Math.min,
        nativeNow = Date.now,
        nativeParseInt = context.parseInt,
        nativeRandom = Math.random,
        nativeReverse = arrayProto.reverse;

    /* Built-in method references that are verified to be native. */
    var DataView = getNative(context, 'DataView'),
        Map = getNative(context, 'Map'),
        Promise = getNative(context, 'Promise'),
        Set = getNative(context, 'Set'),
        WeakMap = getNative(context, 'WeakMap'),
        nativeCreate = getNative(Object, 'create');

    /** Used to store function metadata. */
    var metaMap = WeakMap && new WeakMap;

    /** Used to lookup unminified function names. */
    var realNames = {};

    /** Used to detect maps, sets, and weakmaps. */
    var dataViewCtorString = toSource(DataView),
        mapCtorString = toSource(Map),
        promiseCtorString = toSource(Promise),
        setCtorString = toSource(Set),
        weakMapCtorString = toSource(WeakMap);

    /** Used to convert symbols to primitives and strings. */
    var symbolProto = Symbol ? Symbol.prototype : undefined$1,
        symbolValueOf = symbolProto ? symbolProto.valueOf : undefined$1,
        symbolToString = symbolProto ? symbolProto.toString : undefined$1;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` object which wraps `value` to enable implicit method
     * chain sequences. Methods that operate on and return arrays, collections,
     * and functions can be chained together. Methods that retrieve a single value
     * or may return a primitive value will automatically end the chain sequence
     * and return the unwrapped value. Otherwise, the value must be unwrapped
     * with `_#value`.
     *
     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
     * enabled using `_.chain`.
     *
     * The execution of chained methods is lazy, that is, it's deferred until
     * `_#value` is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion.
     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
     * the creation of intermediate arrays and can greatly reduce the number of
     * iteratee executions. Sections of a chain sequence qualify for shortcut
     * fusion if the section is applied to an array and iteratees accept only
     * one argument. The heuristic for whether a section qualifies for shortcut
     * fusion is subject to change.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
     * `zipObject`, `zipObjectDeep`, and `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
     * `upperFirst`, `value`, and `words`
     *
     * @name _
     * @constructor
     * @category Seq
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // Returns an unwrapped value.
     * wrapped.reduce(_.add);
     * // => 6
     *
     * // Returns a wrapped value.
     * var squares = wrapped.map(square);
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */
    function lodash(value) {
      if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
        if (value instanceof LodashWrapper) {
          return value;
        }
        if (hasOwnProperty.call(value, '__wrapped__')) {
          return wrapperClone(value);
        }
      }
      return new LodashWrapper(value);
    }

    /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} proto The object to inherit from.
     * @returns {Object} Returns the new object.
     */
    var baseCreate = (function() {
      function object() {}
      return function(proto) {
        if (!isObject(proto)) {
          return {};
        }
        if (objectCreate) {
          return objectCreate(proto);
        }
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined$1;
        return result;
      };
    }());

    /**
     * The function whose prototype chain sequence wrappers inherit from.
     *
     * @private
     */
    function baseLodash() {
      // No operation performed.
    }

    /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable explicit method chain sequences.
     */
    function LodashWrapper(value, chainAll) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__chain__ = !!chainAll;
      this.__index__ = 0;
      this.__values__ = undefined$1;
    }

    /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
     * following template settings to use alternative delimiters.
     *
     * @static
     * @memberOf _
     * @type {Object}
     */
    lodash.templateSettings = {

      /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'escape': reEscape,

      /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'evaluate': reEvaluate,

      /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'interpolate': reInterpolate,

      /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type {string}
       */
      'variable': '',

      /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type {Object}
       */
      'imports': {

        /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type {Function}
         */
        '_': lodash
      }
    };

    // Ensure wrappers are instances of `baseLodash`.
    lodash.prototype = baseLodash.prototype;
    lodash.prototype.constructor = lodash;

    LodashWrapper.prototype = baseCreate(baseLodash.prototype);
    LodashWrapper.prototype.constructor = LodashWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @constructor
     * @param {*} value The value to wrap.
     */
    function LazyWrapper(value) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__dir__ = 1;
      this.__filtered__ = false;
      this.__iteratees__ = [];
      this.__takeCount__ = MAX_ARRAY_LENGTH;
      this.__views__ = [];
    }

    /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */
    function lazyClone() {
      var result = new LazyWrapper(this.__wrapped__);
      result.__actions__ = copyArray(this.__actions__);
      result.__dir__ = this.__dir__;
      result.__filtered__ = this.__filtered__;
      result.__iteratees__ = copyArray(this.__iteratees__);
      result.__takeCount__ = this.__takeCount__;
      result.__views__ = copyArray(this.__views__);
      return result;
    }

    /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */
    function lazyReverse() {
      if (this.__filtered__) {
        var result = new LazyWrapper(this);
        result.__dir__ = -1;
        result.__filtered__ = true;
      } else {
        result = this.clone();
        result.__dir__ *= -1;
      }
      return result;
    }

    /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */
    function lazyValue() {
      var array = this.__wrapped__.value(),
          dir = this.__dir__,
          isArr = isArray(array),
          isRight = dir < 0,
          arrLength = isArr ? array.length : 0,
          view = getView(0, arrLength, this.__views__),
          start = view.start,
          end = view.end,
          length = end - start,
          index = isRight ? end : (start - 1),
          iteratees = this.__iteratees__,
          iterLength = iteratees.length,
          resIndex = 0,
          takeCount = nativeMin(length, this.__takeCount__);

      if (!isArr || (!isRight && arrLength == length && takeCount == length)) {
        return baseWrapperValue(array, this.__actions__);
      }
      var result = [];

      outer:
      while (length-- && resIndex < takeCount) {
        index += dir;

        var iterIndex = -1,
            value = array[index];

        while (++iterIndex < iterLength) {
          var data = iteratees[iterIndex],
              iteratee = data.iteratee,
              type = data.type,
              computed = iteratee(value);

          if (type == LAZY_MAP_FLAG) {
            value = computed;
          } else if (!computed) {
            if (type == LAZY_FILTER_FLAG) {
              continue outer;
            } else {
              break outer;
            }
          }
        }
        result[resIndex++] = value;
      }
      return result;
    }

    // Ensure `LazyWrapper` is an instance of `baseLodash`.
    LazyWrapper.prototype = baseCreate(baseLodash.prototype);
    LazyWrapper.prototype.constructor = LazyWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Hash(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */
    function hashClear() {
      this.__data__ = nativeCreate ? nativeCreate(null) : {};
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function hashDelete(key) {
      var result = this.has(key) && delete this.__data__[key];
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function hashGet(key) {
      var data = this.__data__;
      if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined$1 : result;
      }
      return hasOwnProperty.call(data, key) ? data[key] : undefined$1;
    }

    /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function hashHas(key) {
      var data = this.__data__;
      return nativeCreate ? (data[key] !== undefined$1) : hasOwnProperty.call(data, key);
    }

    /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */
    function hashSet(key, value) {
      var data = this.__data__;
      this.size += this.has(key) ? 0 : 1;
      data[key] = (nativeCreate && value === undefined$1) ? HASH_UNDEFINED : value;
      return this;
    }

    // Add methods to `Hash`.
    Hash.prototype.clear = hashClear;
    Hash.prototype['delete'] = hashDelete;
    Hash.prototype.get = hashGet;
    Hash.prototype.has = hashHas;
    Hash.prototype.set = hashSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function ListCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */
    function listCacheClear() {
      this.__data__ = [];
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function listCacheDelete(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        return false;
      }
      var lastIndex = data.length - 1;
      if (index == lastIndex) {
        data.pop();
      } else {
        splice.call(data, index, 1);
      }
      --this.size;
      return true;
    }

    /**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function listCacheGet(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      return index < 0 ? undefined$1 : data[index][1];
    }

    /**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function listCacheHas(key) {
      return assocIndexOf(this.__data__, key) > -1;
    }

    /**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */
    function listCacheSet(key, value) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        ++this.size;
        data.push([key, value]);
      } else {
        data[index][1] = value;
      }
      return this;
    }

    // Add methods to `ListCache`.
    ListCache.prototype.clear = listCacheClear;
    ListCache.prototype['delete'] = listCacheDelete;
    ListCache.prototype.get = listCacheGet;
    ListCache.prototype.has = listCacheHas;
    ListCache.prototype.set = listCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function MapCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */
    function mapCacheClear() {
      this.size = 0;
      this.__data__ = {
        'hash': new Hash,
        'map': new (Map || ListCache),
        'string': new Hash
      };
    }

    /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function mapCacheDelete(key) {
      var result = getMapData(this, key)['delete'](key);
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function mapCacheGet(key) {
      return getMapData(this, key).get(key);
    }

    /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function mapCacheHas(key) {
      return getMapData(this, key).has(key);
    }

    /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */
    function mapCacheSet(key, value) {
      var data = getMapData(this, key),
          size = data.size;

      data.set(key, value);
      this.size += data.size == size ? 0 : 1;
      return this;
    }

    // Add methods to `MapCache`.
    MapCache.prototype.clear = mapCacheClear;
    MapCache.prototype['delete'] = mapCacheDelete;
    MapCache.prototype.get = mapCacheGet;
    MapCache.prototype.has = mapCacheHas;
    MapCache.prototype.set = mapCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     *
     * Creates an array cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */
    function SetCache(values) {
      var index = -1,
          length = values == null ? 0 : values.length;

      this.__data__ = new MapCache;
      while (++index < length) {
        this.add(values[index]);
      }
    }

    /**
     * Adds `value` to the array cache.
     *
     * @private
     * @name add
     * @memberOf SetCache
     * @alias push
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache instance.
     */
    function setCacheAdd(value) {
      this.__data__.set(value, HASH_UNDEFINED);
      return this;
    }

    /**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {number} Returns `true` if `value` is found, else `false`.
     */
    function setCacheHas(value) {
      return this.__data__.has(value);
    }

    // Add methods to `SetCache`.
    SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
    SetCache.prototype.has = setCacheHas;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Stack(entries) {
      var data = this.__data__ = new ListCache(entries);
      this.size = data.size;
    }

    /**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */
    function stackClear() {
      this.__data__ = new ListCache;
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function stackDelete(key) {
      var data = this.__data__,
          result = data['delete'](key);

      this.size = data.size;
      return result;
    }

    /**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function stackGet(key) {
      return this.__data__.get(key);
    }

    /**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function stackHas(key) {
      return this.__data__.has(key);
    }

    /**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */
    function stackSet(key, value) {
      var data = this.__data__;
      if (data instanceof ListCache) {
        var pairs = data.__data__;
        if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
          pairs.push([key, value]);
          this.size = ++data.size;
          return this;
        }
        data = this.__data__ = new MapCache(pairs);
      }
      data.set(key, value);
      this.size = data.size;
      return this;
    }

    // Add methods to `Stack`.
    Stack.prototype.clear = stackClear;
    Stack.prototype['delete'] = stackDelete;
    Stack.prototype.get = stackGet;
    Stack.prototype.has = stackHas;
    Stack.prototype.set = stackSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */
    function arrayLikeKeys(value, inherited) {
      var isArr = isArray(value),
          isArg = !isArr && isArguments(value),
          isBuff = !isArr && !isArg && isBuffer(value),
          isType = !isArr && !isArg && !isBuff && isTypedArray(value),
          skipIndexes = isArr || isArg || isBuff || isType,
          result = skipIndexes ? baseTimes(value.length, String) : [],
          length = result.length;

      for (var key in value) {
        if ((inherited || hasOwnProperty.call(value, key)) &&
            !(skipIndexes && (
               // Safari 9 has enumerable `arguments.length` in strict mode.
               key == 'length' ||
               // Node.js 0.10 has enumerable non-index properties on buffers.
               (isBuff && (key == 'offset' || key == 'parent')) ||
               // PhantomJS 2 has enumerable non-index properties on typed arrays.
               (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
               // Skip index properties.
               isIndex(key, length)
            ))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * A specialized version of `_.sample` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @returns {*} Returns the random element.
     */
    function arraySample(array) {
      var length = array.length;
      return length ? array[baseRandom(0, length - 1)] : undefined$1;
    }

    /**
     * A specialized version of `_.sampleSize` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function arraySampleSize(array, n) {
      return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
    }

    /**
     * A specialized version of `_.shuffle` for arrays.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function arrayShuffle(array) {
      return shuffleSelf(copyArray(array));
    }

    /**
     * This function is like `assignValue` except that it doesn't assign
     * `undefined` values.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignMergeValue(object, key, value) {
      if ((value !== undefined$1 && !eq(object[key], value)) ||
          (value === undefined$1 && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignValue(object, key, value) {
      var objValue = object[key];
      if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
          (value === undefined$1 && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */
    function assocIndexOf(array, key) {
      var length = array.length;
      while (length--) {
        if (eq(array[length][0], key)) {
          return length;
        }
      }
      return -1;
    }

    /**
     * Aggregates elements of `collection` on `accumulator` with keys transformed
     * by `iteratee` and values set by `setter`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseAggregator(collection, setter, iteratee, accumulator) {
      baseEach(collection, function(value, key, collection) {
        setter(accumulator, value, iteratee(value), collection);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.assign` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssign(object, source) {
      return object && copyObject(source, keys(source), object);
    }

    /**
     * The base implementation of `_.assignIn` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssignIn(object, source) {
      return object && copyObject(source, keysIn(source), object);
    }

    /**
     * The base implementation of `assignValue` and `assignMergeValue` without
     * value checks.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function baseAssignValue(object, key, value) {
      if (key == '__proto__' && defineProperty) {
        defineProperty(object, key, {
          'configurable': true,
          'enumerable': true,
          'value': value,
          'writable': true
        });
      } else {
        object[key] = value;
      }
    }

    /**
     * The base implementation of `_.at` without support for individual paths.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {string[]} paths The property paths to pick.
     * @returns {Array} Returns the picked elements.
     */
    function baseAt(object, paths) {
      var index = -1,
          length = paths.length,
          result = Array(length),
          skip = object == null;

      while (++index < length) {
        result[index] = skip ? undefined$1 : get(object, paths[index]);
      }
      return result;
    }

    /**
     * The base implementation of `_.clamp` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     */
    function baseClamp(number, lower, upper) {
      if (number === number) {
        if (upper !== undefined$1) {
          number = number <= upper ? number : upper;
        }
        if (lower !== undefined$1) {
          number = number >= lower ? number : lower;
        }
      }
      return number;
    }

    /**
     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
     * traversed objects.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Deep clone
     *  2 - Flatten inherited properties
     *  4 - Clone symbols
     * @param {Function} [customizer] The function to customize cloning.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The parent object of `value`.
     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
     * @returns {*} Returns the cloned value.
     */
    function baseClone(value, bitmask, customizer, key, object, stack) {
      var result,
          isDeep = bitmask & CLONE_DEEP_FLAG,
          isFlat = bitmask & CLONE_FLAT_FLAG,
          isFull = bitmask & CLONE_SYMBOLS_FLAG;

      if (customizer) {
        result = object ? customizer(value, key, object, stack) : customizer(value);
      }
      if (result !== undefined$1) {
        return result;
      }
      if (!isObject(value)) {
        return value;
      }
      var isArr = isArray(value);
      if (isArr) {
        result = initCloneArray(value);
        if (!isDeep) {
          return copyArray(value, result);
        }
      } else {
        var tag = getTag(value),
            isFunc = tag == funcTag || tag == genTag;

        if (isBuffer(value)) {
          return cloneBuffer(value, isDeep);
        }
        if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
          result = (isFlat || isFunc) ? {} : initCloneObject(value);
          if (!isDeep) {
            return isFlat
              ? copySymbolsIn(value, baseAssignIn(result, value))
              : copySymbols(value, baseAssign(result, value));
          }
        } else {
          if (!cloneableTags[tag]) {
            return object ? value : {};
          }
          result = initCloneByTag(value, tag, isDeep);
        }
      }
      // Check for circular references and return its corresponding clone.
      stack || (stack = new Stack);
      var stacked = stack.get(value);
      if (stacked) {
        return stacked;
      }
      stack.set(value, result);

      if (isSet(value)) {
        value.forEach(function(subValue) {
          result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
        });
      } else if (isMap(value)) {
        value.forEach(function(subValue, key) {
          result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
        });
      }

      var keysFunc = isFull
        ? (isFlat ? getAllKeysIn : getAllKeys)
        : (isFlat ? keysIn : keys);

      var props = isArr ? undefined$1 : keysFunc(value);
      arrayEach(props || value, function(subValue, key) {
        if (props) {
          key = subValue;
          subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
      });
      return result;
    }

    /**
     * The base implementation of `_.conforms` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     */
    function baseConforms(source) {
      var props = keys(source);
      return function(object) {
        return baseConformsTo(object, source, props);
      };
    }

    /**
     * The base implementation of `_.conformsTo` which accepts `props` to check.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     */
    function baseConformsTo(object, source, props) {
      var length = props.length;
      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (length--) {
        var key = props[length],
            predicate = source[key],
            value = object[key];

        if ((value === undefined$1 && !(key in object)) || !predicate(value)) {
          return false;
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.delay` and `_.defer` which accepts `args`
     * to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Array} args The arguments to provide to `func`.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    function baseDelay(func, wait, args) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return setTimeout(function() { func.apply(undefined$1, args); }, wait);
    }

    /**
     * The base implementation of methods like `_.difference` without support
     * for excluding multiple arrays or iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     */
    function baseDifference(array, values, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          isCommon = true,
          length = array.length,
          result = [],
          valuesLength = values.length;

      if (!length) {
        return result;
      }
      if (iteratee) {
        values = arrayMap(values, baseUnary(iteratee));
      }
      if (comparator) {
        includes = arrayIncludesWith;
        isCommon = false;
      }
      else if (values.length >= LARGE_ARRAY_SIZE) {
        includes = cacheHas;
        isCommon = false;
        values = new SetCache(values);
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee == null ? value : iteratee(value);

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var valuesIndex = valuesLength;
          while (valuesIndex--) {
            if (values[valuesIndex] === computed) {
              continue outer;
            }
          }
          result.push(value);
        }
        else if (!includes(values, computed, comparator)) {
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.forEach` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEach = createBaseEach(baseForOwn);

    /**
     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEachRight = createBaseEach(baseForOwnRight, true);

    /**
     * The base implementation of `_.every` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */
    function baseEvery(collection, predicate) {
      var result = true;
      baseEach(collection, function(value, index, collection) {
        result = !!predicate(value, index, collection);
        return result;
      });
      return result;
    }

    /**
     * The base implementation of methods like `_.max` and `_.min` which accepts a
     * `comparator` to determine the extremum value.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The iteratee invoked per iteration.
     * @param {Function} comparator The comparator used to compare values.
     * @returns {*} Returns the extremum value.
     */
    function baseExtremum(array, iteratee, comparator) {
      var index = -1,
          length = array.length;

      while (++index < length) {
        var value = array[index],
            current = iteratee(value);

        if (current != null && (computed === undefined$1
              ? (current === current && !isSymbol(current))
              : comparator(current, computed)
            )) {
          var computed = current,
              result = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */
    function baseFill(array, value, start, end) {
      var length = array.length;

      start = toInteger(start);
      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = (end === undefined$1 || end > length) ? length : toInteger(end);
      if (end < 0) {
        end += length;
      }
      end = start > end ? 0 : toLength(end);
      while (start < end) {
        array[start++] = value;
      }
      return array;
    }

    /**
     * The base implementation of `_.filter` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */
    function baseFilter(collection, predicate) {
      var result = [];
      baseEach(collection, function(value, index, collection) {
        if (predicate(value, index, collection)) {
          result.push(value);
        }
      });
      return result;
    }

    /**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {number} depth The maximum recursion depth.
     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */
    function baseFlatten(array, depth, predicate, isStrict, result) {
      var index = -1,
          length = array.length;

      predicate || (predicate = isFlattenable);
      result || (result = []);

      while (++index < length) {
        var value = array[index];
        if (depth > 0 && predicate(value)) {
          if (depth > 1) {
            // Recursively flatten arrays (susceptible to call stack limits).
            baseFlatten(value, depth - 1, predicate, isStrict, result);
          } else {
            arrayPush(result, value);
          }
        } else if (!isStrict) {
          result[result.length] = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `baseForOwn` which iterates over `object`
     * properties returned by `keysFunc` and invokes `iteratee` for each property.
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseFor = createBaseFor();

    /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseForRight = createBaseFor(true);

    /**
     * The base implementation of `_.forOwn` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwn(object, iteratee) {
      return object && baseFor(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwnRight(object, iteratee) {
      return object && baseForRight(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from `props`.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the function names.
     */
    function baseFunctions(object, props) {
      return arrayFilter(props, function(key) {
        return isFunction(object[key]);
      });
    }

    /**
     * The base implementation of `_.get` without support for default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @returns {*} Returns the resolved value.
     */
    function baseGet(object, path) {
      path = castPath(path, object);

      var index = 0,
          length = path.length;

      while (object != null && index < length) {
        object = object[toKey(path[index++])];
      }
      return (index && index == length) ? object : undefined$1;
    }

    /**
     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @param {Function} symbolsFunc The function to get the symbols of `object`.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function baseGetAllKeys(object, keysFunc, symbolsFunc) {
      var result = keysFunc(object);
      return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
    }

    /**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    function baseGetTag(value) {
      if (value == null) {
        return value === undefined$1 ? undefinedTag : nullTag;
      }
      return (symToStringTag && symToStringTag in Object(value))
        ? getRawTag(value)
        : objectToString(value);
    }

    /**
     * The base implementation of `_.gt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     */
    function baseGt(value, other) {
      return value > other;
    }

    /**
     * The base implementation of `_.has` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHas(object, key) {
      return object != null && hasOwnProperty.call(object, key);
    }

    /**
     * The base implementation of `_.hasIn` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHasIn(object, key) {
      return object != null && key in Object(object);
    }

    /**
     * The base implementation of `_.inRange` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to check.
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     */
    function baseInRange(number, start, end) {
      return number >= nativeMin(start, end) && number < nativeMax(start, end);
    }

    /**
     * The base implementation of methods like `_.intersection`, without support
     * for iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of shared values.
     */
    function baseIntersection(arrays, iteratee, comparator) {
      var includes = comparator ? arrayIncludesWith : arrayIncludes,
          length = arrays[0].length,
          othLength = arrays.length,
          othIndex = othLength,
          caches = Array(othLength),
          maxLength = Infinity,
          result = [];

      while (othIndex--) {
        var array = arrays[othIndex];
        if (othIndex && iteratee) {
          array = arrayMap(array, baseUnary(iteratee));
        }
        maxLength = nativeMin(array.length, maxLength);
        caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
          ? new SetCache(othIndex && array)
          : undefined$1;
      }
      array = arrays[0];

      var index = -1,
          seen = caches[0];

      outer:
      while (++index < length && result.length < maxLength) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (!(seen
              ? cacheHas(seen, computed)
              : includes(result, computed, comparator)
            )) {
          othIndex = othLength;
          while (--othIndex) {
            var cache = caches[othIndex];
            if (!(cache
                  ? cacheHas(cache, computed)
                  : includes(arrays[othIndex], computed, comparator))
                ) {
              continue outer;
            }
          }
          if (seen) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.invert` and `_.invertBy` which inverts
     * `object` with values transformed by `iteratee` and set by `setter`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform values.
     * @param {Object} accumulator The initial inverted object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseInverter(object, setter, iteratee, accumulator) {
      baseForOwn(object, function(value, key, object) {
        setter(accumulator, iteratee(value), key, object);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.invoke` without support for individual
     * method arguments.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */
    function baseInvoke(object, path, args) {
      path = castPath(path, object);
      object = parent(object, path);
      var func = object == null ? object : object[toKey(last(path))];
      return func == null ? undefined$1 : apply(func, object, args);
    }

    /**
     * The base implementation of `_.isArguments`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     */
    function baseIsArguments(value) {
      return isObjectLike(value) && baseGetTag(value) == argsTag;
    }

    /**
     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     */
    function baseIsArrayBuffer(value) {
      return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
    }

    /**
     * The base implementation of `_.isDate` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     */
    function baseIsDate(value) {
      return isObjectLike(value) && baseGetTag(value) == dateTag;
    }

    /**
     * The base implementation of `_.isEqual` which supports partial comparisons
     * and tracks traversed objects.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Unordered comparison
     *  2 - Partial comparison
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */
    function baseIsEqual(value, other, bitmask, customizer, stack) {
      if (value === other) {
        return true;
      }
      if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
        return value !== value && other !== other;
      }
      return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
    }

    /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
      var objIsArr = isArray(object),
          othIsArr = isArray(other),
          objTag = objIsArr ? arrayTag : getTag(object),
          othTag = othIsArr ? arrayTag : getTag(other);

      objTag = objTag == argsTag ? objectTag : objTag;
      othTag = othTag == argsTag ? objectTag : othTag;

      var objIsObj = objTag == objectTag,
          othIsObj = othTag == objectTag,
          isSameTag = objTag == othTag;

      if (isSameTag && isBuffer(object)) {
        if (!isBuffer(other)) {
          return false;
        }
        objIsArr = true;
        objIsObj = false;
      }
      if (isSameTag && !objIsObj) {
        stack || (stack = new Stack);
        return (objIsArr || isTypedArray(object))
          ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
          : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
      }
      if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
            othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

        if (objIsWrapped || othIsWrapped) {
          var objUnwrapped = objIsWrapped ? object.value() : object,
              othUnwrapped = othIsWrapped ? other.value() : other;

          stack || (stack = new Stack);
          return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
      }
      if (!isSameTag) {
        return false;
      }
      stack || (stack = new Stack);
      return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
    }

    /**
     * The base implementation of `_.isMap` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     */
    function baseIsMap(value) {
      return isObjectLike(value) && getTag(value) == mapTag;
    }

    /**
     * The base implementation of `_.isMatch` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Array} matchData The property names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */
    function baseIsMatch(object, source, matchData, customizer) {
      var index = matchData.length,
          length = index,
          noCustomizer = !customizer;

      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (index--) {
        var data = matchData[index];
        if ((noCustomizer && data[2])
              ? data[1] !== object[data[0]]
              : !(data[0] in object)
            ) {
          return false;
        }
      }
      while (++index < length) {
        data = matchData[index];
        var key = data[0],
            objValue = object[key],
            srcValue = data[1];

        if (noCustomizer && data[2]) {
          if (objValue === undefined$1 && !(key in object)) {
            return false;
          }
        } else {
          var stack = new Stack;
          if (customizer) {
            var result = customizer(objValue, srcValue, key, object, source, stack);
          }
          if (!(result === undefined$1
                ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
                : result
              )) {
            return false;
          }
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */
    function baseIsNative(value) {
      if (!isObject(value) || isMasked(value)) {
        return false;
      }
      var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
      return pattern.test(toSource(value));
    }

    /**
     * The base implementation of `_.isRegExp` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     */
    function baseIsRegExp(value) {
      return isObjectLike(value) && baseGetTag(value) == regexpTag;
    }

    /**
     * The base implementation of `_.isSet` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     */
    function baseIsSet(value) {
      return isObjectLike(value) && getTag(value) == setTag;
    }

    /**
     * The base implementation of `_.isTypedArray` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     */
    function baseIsTypedArray(value) {
      return isObjectLike(value) &&
        isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
    }

    /**
     * The base implementation of `_.iteratee`.
     *
     * @private
     * @param {*} [value=_.identity] The value to convert to an iteratee.
     * @returns {Function} Returns the iteratee.
     */
    function baseIteratee(value) {
      // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
      // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
      if (typeof value == 'function') {
        return value;
      }
      if (value == null) {
        return identity;
      }
      if (typeof value == 'object') {
        return isArray(value)
          ? baseMatchesProperty(value[0], value[1])
          : baseMatches(value);
      }
      return property(value);
    }

    /**
     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeys(object) {
      if (!isPrototype(object)) {
        return nativeKeys(object);
      }
      var result = [];
      for (var key in Object(object)) {
        if (hasOwnProperty.call(object, key) && key != 'constructor') {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeysIn(object) {
      if (!isObject(object)) {
        return nativeKeysIn(object);
      }
      var isProto = isPrototype(object),
          result = [];

      for (var key in object) {
        if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.lt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     */
    function baseLt(value, other) {
      return value < other;
    }

    /**
     * The base implementation of `_.map` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */
    function baseMap(collection, iteratee) {
      var index = -1,
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value, key, collection) {
        result[++index] = iteratee(value, key, collection);
      });
      return result;
    }

    /**
     * The base implementation of `_.matches` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatches(source) {
      var matchData = getMatchData(source);
      if (matchData.length == 1 && matchData[0][2]) {
        return matchesStrictComparable(matchData[0][0], matchData[0][1]);
      }
      return function(object) {
        return object === source || baseIsMatch(object, source, matchData);
      };
    }

    /**
     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatchesProperty(path, srcValue) {
      if (isKey(path) && isStrictComparable(srcValue)) {
        return matchesStrictComparable(toKey(path), srcValue);
      }
      return function(object) {
        var objValue = get(object, path);
        return (objValue === undefined$1 && objValue === srcValue)
          ? hasIn(object, path)
          : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
      };
    }

    /**
     * The base implementation of `_.merge` without support for multiple sources.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMerge(object, source, srcIndex, customizer, stack) {
      if (object === source) {
        return;
      }
      baseFor(source, function(srcValue, key) {
        stack || (stack = new Stack);
        if (isObject(srcValue)) {
          baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
        }
        else {
          var newValue = customizer
            ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
            : undefined$1;

          if (newValue === undefined$1) {
            newValue = srcValue;
          }
          assignMergeValue(object, key, newValue);
        }
      }, keysIn);
    }

    /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
      var objValue = safeGet(object, key),
          srcValue = safeGet(source, key),
          stacked = stack.get(srcValue);

      if (stacked) {
        assignMergeValue(object, key, stacked);
        return;
      }
      var newValue = customizer
        ? customizer(objValue, srcValue, (key + ''), object, source, stack)
        : undefined$1;

      var isCommon = newValue === undefined$1;

      if (isCommon) {
        var isArr = isArray(srcValue),
            isBuff = !isArr && isBuffer(srcValue),
            isTyped = !isArr && !isBuff && isTypedArray(srcValue);

        newValue = srcValue;
        if (isArr || isBuff || isTyped) {
          if (isArray(objValue)) {
            newValue = objValue;
          }
          else if (isArrayLikeObject(objValue)) {
            newValue = copyArray(objValue);
          }
          else if (isBuff) {
            isCommon = false;
            newValue = cloneBuffer(srcValue, true);
          }
          else if (isTyped) {
            isCommon = false;
            newValue = cloneTypedArray(srcValue, true);
          }
          else {
            newValue = [];
          }
        }
        else if (isPlainObject(srcValue) || isArguments(srcValue)) {
          newValue = objValue;
          if (isArguments(objValue)) {
            newValue = toPlainObject(objValue);
          }
          else if (!isObject(objValue) || isFunction(objValue)) {
            newValue = initCloneObject(srcValue);
          }
        }
        else {
          isCommon = false;
        }
      }
      if (isCommon) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, newValue);
        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
        stack['delete'](srcValue);
      }
      assignMergeValue(object, key, newValue);
    }

    /**
     * The base implementation of `_.nth` which doesn't coerce arguments.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {number} n The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     */
    function baseNth(array, n) {
      var length = array.length;
      if (!length) {
        return;
      }
      n += n < 0 ? length : 0;
      return isIndex(n, length) ? array[n] : undefined$1;
    }

    /**
     * The base implementation of `_.orderBy` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {string[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */
    function baseOrderBy(collection, iteratees, orders) {
      if (iteratees.length) {
        iteratees = arrayMap(iteratees, function(iteratee) {
          if (isArray(iteratee)) {
            return function(value) {
              return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
            }
          }
          return iteratee;
        });
      } else {
        iteratees = [identity];
      }

      var index = -1;
      iteratees = arrayMap(iteratees, baseUnary(getIteratee()));

      var result = baseMap(collection, function(value, key, collection) {
        var criteria = arrayMap(iteratees, function(iteratee) {
          return iteratee(value);
        });
        return { 'criteria': criteria, 'index': ++index, 'value': value };
      });

      return baseSortBy(result, function(object, other) {
        return compareMultiple(object, other, orders);
      });
    }

    /**
     * The base implementation of `_.pick` without support for individual
     * property identifiers.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @returns {Object} Returns the new object.
     */
    function basePick(object, paths) {
      return basePickBy(object, paths, function(value, path) {
        return hasIn(object, path);
      });
    }

    /**
     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @param {Function} predicate The function invoked per property.
     * @returns {Object} Returns the new object.
     */
    function basePickBy(object, paths, predicate) {
      var index = -1,
          length = paths.length,
          result = {};

      while (++index < length) {
        var path = paths[index],
            value = baseGet(object, path);

        if (predicate(value, path)) {
          baseSet(result, castPath(path, object), value);
        }
      }
      return result;
    }

    /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     */
    function basePropertyDeep(path) {
      return function(object) {
        return baseGet(object, path);
      };
    }

    /**
     * The base implementation of `_.pullAllBy` without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     */
    function basePullAll(array, values, iteratee, comparator) {
      var indexOf = comparator ? baseIndexOfWith : baseIndexOf,
          index = -1,
          length = values.length,
          seen = array;

      if (array === values) {
        values = copyArray(values);
      }
      if (iteratee) {
        seen = arrayMap(array, baseUnary(iteratee));
      }
      while (++index < length) {
        var fromIndex = 0,
            value = values[index],
            computed = iteratee ? iteratee(value) : value;

        while ((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1) {
          if (seen !== array) {
            splice.call(seen, fromIndex, 1);
          }
          splice.call(array, fromIndex, 1);
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.pullAt` without support for individual
     * indexes or capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */
    function basePullAt(array, indexes) {
      var length = array ? indexes.length : 0,
          lastIndex = length - 1;

      while (length--) {
        var index = indexes[length];
        if (length == lastIndex || index !== previous) {
          var previous = index;
          if (isIndex(index)) {
            splice.call(array, index, 1);
          } else {
            baseUnset(array, index);
          }
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.random` without support for returning
     * floating-point numbers.
     *
     * @private
     * @param {number} lower The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the random number.
     */
    function baseRandom(lower, upper) {
      return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
    }

    /**
     * The base implementation of `_.range` and `_.rangeRight` which doesn't
     * coerce arguments.
     *
     * @private
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @param {number} step The value to increment or decrement by.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the range of numbers.
     */
    function baseRange(start, end, step, fromRight) {
      var index = -1,
          length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
          result = Array(length);

      while (length--) {
        result[fromRight ? length : ++index] = start;
        start += step;
      }
      return result;
    }

    /**
     * The base implementation of `_.repeat` which doesn't coerce arguments.
     *
     * @private
     * @param {string} string The string to repeat.
     * @param {number} n The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     */
    function baseRepeat(string, n) {
      var result = '';
      if (!string || n < 1 || n > MAX_SAFE_INTEGER) {
        return result;
      }
      // Leverage the exponentiation by squaring algorithm for a faster repeat.
      // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
      do {
        if (n % 2) {
          result += string;
        }
        n = nativeFloor(n / 2);
        if (n) {
          string += string;
        }
      } while (n);

      return result;
    }

    /**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */
    function baseRest(func, start) {
      return setToString(overRest(func, start, identity), func + '');
    }

    /**
     * The base implementation of `_.sample`.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     */
    function baseSample(collection) {
      return arraySample(values(collection));
    }

    /**
     * The base implementation of `_.sampleSize` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function baseSampleSize(collection, n) {
      var array = values(collection);
      return shuffleSelf(array, baseClamp(n, 0, array.length));
    }

    /**
     * The base implementation of `_.set`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseSet(object, path, value, customizer) {
      if (!isObject(object)) {
        return object;
      }
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          lastIndex = length - 1,
          nested = object;

      while (nested != null && ++index < length) {
        var key = toKey(path[index]),
            newValue = value;

        if (key === '__proto__' || key === 'constructor' || key === 'prototype') {
          return object;
        }

        if (index != lastIndex) {
          var objValue = nested[key];
          newValue = customizer ? customizer(objValue, key, nested) : undefined$1;
          if (newValue === undefined$1) {
            newValue = isObject(objValue)
              ? objValue
              : (isIndex(path[index + 1]) ? [] : {});
          }
        }
        assignValue(nested, key, newValue);
        nested = nested[key];
      }
      return object;
    }

    /**
     * The base implementation of `setData` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var baseSetData = !metaMap ? identity : function(func, data) {
      metaMap.set(func, data);
      return func;
    };

    /**
     * The base implementation of `setToString` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var baseSetToString = !defineProperty ? identity : function(func, string) {
      return defineProperty(func, 'toString', {
        'configurable': true,
        'enumerable': false,
        'value': constant(string),
        'writable': true
      });
    };

    /**
     * The base implementation of `_.shuffle`.
     *
     * @private
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function baseShuffle(collection) {
      return shuffleSelf(values(collection));
    }

    /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseSlice(array, start, end) {
      var index = -1,
          length = array.length;

      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = end > length ? length : end;
      if (end < 0) {
        end += length;
      }
      length = start > end ? 0 : ((end - start) >>> 0);
      start >>>= 0;

      var result = Array(length);
      while (++index < length) {
        result[index] = array[index + start];
      }
      return result;
    }

    /**
     * The base implementation of `_.some` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */
    function baseSome(collection, predicate) {
      var result;

      baseEach(collection, function(value, index, collection) {
        result = predicate(value, index, collection);
        return !result;
      });
      return !!result;
    }

    /**
     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
     * performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndex(array, value, retHighest) {
      var low = 0,
          high = array == null ? low : array.length;

      if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
        while (low < high) {
          var mid = (low + high) >>> 1,
              computed = array[mid];

          if (computed !== null && !isSymbol(computed) &&
              (retHighest ? (computed <= value) : (computed < value))) {
            low = mid + 1;
          } else {
            high = mid;
          }
        }
        return high;
      }
      return baseSortedIndexBy(array, value, identity, retHighest);
    }

    /**
     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
     * which invokes `iteratee` for `value` and each element of `array` to compute
     * their sort ranking. The iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The iteratee invoked per element.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndexBy(array, value, iteratee, retHighest) {
      var low = 0,
          high = array == null ? 0 : array.length;
      if (high === 0) {
        return 0;
      }

      value = iteratee(value);
      var valIsNaN = value !== value,
          valIsNull = value === null,
          valIsSymbol = isSymbol(value),
          valIsUndefined = value === undefined$1;

      while (low < high) {
        var mid = nativeFloor((low + high) / 2),
            computed = iteratee(array[mid]),
            othIsDefined = computed !== undefined$1,
            othIsNull = computed === null,
            othIsReflexive = computed === computed,
            othIsSymbol = isSymbol(computed);

        if (valIsNaN) {
          var setLow = retHighest || othIsReflexive;
        } else if (valIsUndefined) {
          setLow = othIsReflexive && (retHighest || othIsDefined);
        } else if (valIsNull) {
          setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
        } else if (valIsSymbol) {
          setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
        } else if (othIsNull || othIsSymbol) {
          setLow = false;
        } else {
          setLow = retHighest ? (computed <= value) : (computed < value);
        }
        if (setLow) {
          low = mid + 1;
        } else {
          high = mid;
        }
      }
      return nativeMin(high, MAX_ARRAY_INDEX);
    }

    /**
     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseSortedUniq(array, iteratee) {
      var index = -1,
          length = array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        if (!index || !eq(computed, seen)) {
          var seen = computed;
          result[resIndex++] = value === 0 ? 0 : value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.toNumber` which doesn't ensure correct
     * conversions of binary, hexadecimal, or octal string values.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     */
    function baseToNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      return +value;
    }

    /**
     * The base implementation of `_.toString` which doesn't convert nullish
     * values to empty strings.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */
    function baseToString(value) {
      // Exit early for strings to avoid a performance hit in some environments.
      if (typeof value == 'string') {
        return value;
      }
      if (isArray(value)) {
        // Recursively convert values (susceptible to call stack limits).
        return arrayMap(value, baseToString) + '';
      }
      if (isSymbol(value)) {
        return symbolToString ? symbolToString.call(value) : '';
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseUniq(array, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          length = array.length,
          isCommon = true,
          result = [],
          seen = result;

      if (comparator) {
        isCommon = false;
        includes = arrayIncludesWith;
      }
      else if (length >= LARGE_ARRAY_SIZE) {
        var set = iteratee ? null : createSet(array);
        if (set) {
          return setToArray(set);
        }
        isCommon = false;
        includes = cacheHas;
        seen = new SetCache;
      }
      else {
        seen = iteratee ? [] : result;
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var seenIndex = seen.length;
          while (seenIndex--) {
            if (seen[seenIndex] === computed) {
              continue outer;
            }
          }
          if (iteratee) {
            seen.push(computed);
          }
          result.push(value);
        }
        else if (!includes(seen, computed, comparator)) {
          if (seen !== result) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.unset`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The property path to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     */
    function baseUnset(object, path) {
      path = castPath(path, object);
      object = parent(object, path);
      return object == null || delete object[toKey(last(path))];
    }

    /**
     * The base implementation of `_.update`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to update.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseUpdate(object, path, updater, customizer) {
      return baseSet(object, path, updater(baseGet(object, path)), customizer);
    }

    /**
     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
     * without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseWhile(array, predicate, isDrop, fromRight) {
      var length = array.length,
          index = fromRight ? length : -1;

      while ((fromRight ? index-- : ++index < length) &&
        predicate(array[index], index, array)) {}

      return isDrop
        ? baseSlice(array, (fromRight ? 0 : index), (fromRight ? index + 1 : length))
        : baseSlice(array, (fromRight ? index + 1 : 0), (fromRight ? length : index));
    }

    /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to perform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */
    function baseWrapperValue(value, actions) {
      var result = value;
      if (result instanceof LazyWrapper) {
        result = result.value();
      }
      return arrayReduce(actions, function(result, action) {
        return action.func.apply(action.thisArg, arrayPush([result], action.args));
      }, result);
    }

    /**
     * The base implementation of methods like `_.xor`, without support for
     * iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of values.
     */
    function baseXor(arrays, iteratee, comparator) {
      var length = arrays.length;
      if (length < 2) {
        return length ? baseUniq(arrays[0]) : [];
      }
      var index = -1,
          result = Array(length);

      while (++index < length) {
        var array = arrays[index],
            othIndex = -1;

        while (++othIndex < length) {
          if (othIndex != index) {
            result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
          }
        }
      }
      return baseUniq(baseFlatten(result, 1), iteratee, comparator);
    }

    /**
     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
     *
     * @private
     * @param {Array} props The property identifiers.
     * @param {Array} values The property values.
     * @param {Function} assignFunc The function to assign values.
     * @returns {Object} Returns the new object.
     */
    function baseZipObject(props, values, assignFunc) {
      var index = -1,
          length = props.length,
          valsLength = values.length,
          result = {};

      while (++index < length) {
        var value = index < valsLength ? values[index] : undefined$1;
        assignFunc(result, props[index], value);
      }
      return result;
    }

    /**
     * Casts `value` to an empty array if it's not an array like object.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Array|Object} Returns the cast array-like object.
     */
    function castArrayLikeObject(value) {
      return isArrayLikeObject(value) ? value : [];
    }

    /**
     * Casts `value` to `identity` if it's not a function.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Function} Returns cast function.
     */
    function castFunction(value) {
      return typeof value == 'function' ? value : identity;
    }

    /**
     * Casts `value` to a path array if it's not one.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {Object} [object] The object to query keys on.
     * @returns {Array} Returns the cast property path array.
     */
    function castPath(value, object) {
      if (isArray(value)) {
        return value;
      }
      return isKey(value, object) ? [value] : stringToPath(toString(value));
    }

    /**
     * A `baseRest` alias which can be replaced with `identity` by module
     * replacement plugins.
     *
     * @private
     * @type {Function}
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    var castRest = baseRest;

    /**
     * Casts `array` to a slice if it's needed.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {number} start The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the cast slice.
     */
    function castSlice(array, start, end) {
      var length = array.length;
      end = end === undefined$1 ? length : end;
      return (!start && end >= length) ? array : baseSlice(array, start, end);
    }

    /**
     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
     *
     * @private
     * @param {number|Object} id The timer id or timeout object of the timer to clear.
     */
    var clearTimeout = ctxClearTimeout || function(id) {
      return root.clearTimeout(id);
    };

    /**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */
    function cloneBuffer(buffer, isDeep) {
      if (isDeep) {
        return buffer.slice();
      }
      var length = buffer.length,
          result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

      buffer.copy(result);
      return result;
    }

    /**
     * Creates a clone of `arrayBuffer`.
     *
     * @private
     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */
    function cloneArrayBuffer(arrayBuffer) {
      var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
      new Uint8Array(result).set(new Uint8Array(arrayBuffer));
      return result;
    }

    /**
     * Creates a clone of `dataView`.
     *
     * @private
     * @param {Object} dataView The data view to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned data view.
     */
    function cloneDataView(dataView, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
      return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
    }

    /**
     * Creates a clone of `regexp`.
     *
     * @private
     * @param {Object} regexp The regexp to clone.
     * @returns {Object} Returns the cloned regexp.
     */
    function cloneRegExp(regexp) {
      var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
      result.lastIndex = regexp.lastIndex;
      return result;
    }

    /**
     * Creates a clone of the `symbol` object.
     *
     * @private
     * @param {Object} symbol The symbol object to clone.
     * @returns {Object} Returns the cloned symbol object.
     */
    function cloneSymbol(symbol) {
      return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
    }

    /**
     * Creates a clone of `typedArray`.
     *
     * @private
     * @param {Object} typedArray The typed array to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned typed array.
     */
    function cloneTypedArray(typedArray, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
      return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
    }

    /**
     * Compares values to sort them in ascending order.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {number} Returns the sort order indicator for `value`.
     */
    function compareAscending(value, other) {
      if (value !== other) {
        var valIsDefined = value !== undefined$1,
            valIsNull = value === null,
            valIsReflexive = value === value,
            valIsSymbol = isSymbol(value);

        var othIsDefined = other !== undefined$1,
            othIsNull = other === null,
            othIsReflexive = other === other,
            othIsSymbol = isSymbol(other);

        if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
            (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
            (valIsNull && othIsDefined && othIsReflexive) ||
            (!valIsDefined && othIsReflexive) ||
            !valIsReflexive) {
          return 1;
        }
        if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
            (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
            (othIsNull && valIsDefined && valIsReflexive) ||
            (!othIsDefined && valIsReflexive) ||
            !othIsReflexive) {
          return -1;
        }
      }
      return 0;
    }

    /**
     * Used by `_.orderBy` to compare multiple properties of a value to another
     * and stable sort them.
     *
     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
     * specify an order of "desc" for descending or "asc" for ascending sort order
     * of corresponding values.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {boolean[]|string[]} orders The order to sort by for each property.
     * @returns {number} Returns the sort order indicator for `object`.
     */
    function compareMultiple(object, other, orders) {
      var index = -1,
          objCriteria = object.criteria,
          othCriteria = other.criteria,
          length = objCriteria.length,
          ordersLength = orders.length;

      while (++index < length) {
        var result = compareAscending(objCriteria[index], othCriteria[index]);
        if (result) {
          if (index >= ordersLength) {
            return result;
          }
          var order = orders[index];
          return result * (order == 'desc' ? -1 : 1);
        }
      }
      // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
      // that causes it, under certain circumstances, to provide the same value for
      // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
      // for more details.
      //
      // This also ensures a stable sort in V8 and other engines.
      // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
      return object.index - other.index;
    }

    /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgs(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersLength = holders.length,
          leftIndex = -1,
          leftLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(leftLength + rangeLength),
          isUncurried = !isCurried;

      while (++leftIndex < leftLength) {
        result[leftIndex] = partials[leftIndex];
      }
      while (++argsIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[holders[argsIndex]] = args[argsIndex];
        }
      }
      while (rangeLength--) {
        result[leftIndex++] = args[argsIndex++];
      }
      return result;
    }

    /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgsRight(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersIndex = -1,
          holdersLength = holders.length,
          rightIndex = -1,
          rightLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(rangeLength + rightLength),
          isUncurried = !isCurried;

      while (++argsIndex < rangeLength) {
        result[argsIndex] = args[argsIndex];
      }
      var offset = argsIndex;
      while (++rightIndex < rightLength) {
        result[offset + rightIndex] = partials[rightIndex];
      }
      while (++holdersIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[offset + holders[holdersIndex]] = args[argsIndex++];
        }
      }
      return result;
    }

    /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */
    function copyArray(source, array) {
      var index = -1,
          length = source.length;

      array || (array = Array(length));
      while (++index < length) {
        array[index] = source[index];
      }
      return array;
    }

    /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property identifiers to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @param {Function} [customizer] The function to customize copied values.
     * @returns {Object} Returns `object`.
     */
    function copyObject(source, props, object, customizer) {
      var isNew = !object;
      object || (object = {});

      var index = -1,
          length = props.length;

      while (++index < length) {
        var key = props[index];

        var newValue = customizer
          ? customizer(object[key], source[key], key, object, source)
          : undefined$1;

        if (newValue === undefined$1) {
          newValue = source[key];
        }
        if (isNew) {
          baseAssignValue(object, key, newValue);
        } else {
          assignValue(object, key, newValue);
        }
      }
      return object;
    }

    /**
     * Copies own symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbols(source, object) {
      return copyObject(source, getSymbols(source), object);
    }

    /**
     * Copies own and inherited symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbolsIn(source, object) {
      return copyObject(source, getSymbolsIn(source), object);
    }

    /**
     * Creates a function like `_.groupBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} [initializer] The accumulator object initializer.
     * @returns {Function} Returns the new aggregator function.
     */
    function createAggregator(setter, initializer) {
      return function(collection, iteratee) {
        var func = isArray(collection) ? arrayAggregator : baseAggregator,
            accumulator = initializer ? initializer() : {};

        return func(collection, setter, getIteratee(iteratee, 2), accumulator);
      };
    }

    /**
     * Creates a function like `_.assign`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */
    function createAssigner(assigner) {
      return baseRest(function(object, sources) {
        var index = -1,
            length = sources.length,
            customizer = length > 1 ? sources[length - 1] : undefined$1,
            guard = length > 2 ? sources[2] : undefined$1;

        customizer = (assigner.length > 3 && typeof customizer == 'function')
          ? (length--, customizer)
          : undefined$1;

        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
          customizer = length < 3 ? undefined$1 : customizer;
          length = 1;
        }
        object = Object(object);
        while (++index < length) {
          var source = sources[index];
          if (source) {
            assigner(object, source, index, customizer);
          }
        }
        return object;
      });
    }

    /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseEach(eachFunc, fromRight) {
      return function(collection, iteratee) {
        if (collection == null) {
          return collection;
        }
        if (!isArrayLike(collection)) {
          return eachFunc(collection, iteratee);
        }
        var length = collection.length,
            index = fromRight ? length : -1,
            iterable = Object(collection);

        while ((fromRight ? index-- : ++index < length)) {
          if (iteratee(iterable[index], index, iterable) === false) {
            break;
          }
        }
        return collection;
      };
    }

    /**
     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseFor(fromRight) {
      return function(object, iteratee, keysFunc) {
        var index = -1,
            iterable = Object(object),
            props = keysFunc(object),
            length = props.length;

        while (length--) {
          var key = props[fromRight ? length : ++index];
          if (iteratee(iterable[key], key, iterable) === false) {
            break;
          }
        }
        return object;
      };
    }

    /**
     * Creates a function that wraps `func` to invoke it with the optional `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createBind(func, bitmask, thisArg) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return fn.apply(isBind ? thisArg : this, arguments);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.lowerFirst`.
     *
     * @private
     * @param {string} methodName The name of the `String` case method to use.
     * @returns {Function} Returns the new case function.
     */
    function createCaseFirst(methodName) {
      return function(string) {
        string = toString(string);

        var strSymbols = hasUnicode(string)
          ? stringToArray(string)
          : undefined$1;

        var chr = strSymbols
          ? strSymbols[0]
          : string.charAt(0);

        var trailing = strSymbols
          ? castSlice(strSymbols, 1).join('')
          : string.slice(1);

        return chr[methodName]() + trailing;
      };
    }

    /**
     * Creates a function like `_.camelCase`.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */
    function createCompounder(callback) {
      return function(string) {
        return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
      };
    }

    /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCtor(Ctor) {
      return function() {
        // Use a `switch` statement to work with class constructors. See
        // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
        // for more details.
        var args = arguments;
        switch (args.length) {
          case 0: return new Ctor;
          case 1: return new Ctor(args[0]);
          case 2: return new Ctor(args[0], args[1]);
          case 3: return new Ctor(args[0], args[1], args[2]);
          case 4: return new Ctor(args[0], args[1], args[2], args[3]);
          case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
          case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
          case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
        }
        var thisBinding = baseCreate(Ctor.prototype),
            result = Ctor.apply(thisBinding, args);

        // Mimic the constructor's `return` behavior.
        // See https://es5.github.io/#x13.2.2 for more details.
        return isObject(result) ? result : thisBinding;
      };
    }

    /**
     * Creates a function that wraps `func` to enable currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {number} arity The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCurry(func, bitmask, arity) {
      var Ctor = createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length,
            placeholder = getHolder(wrapper);

        while (index--) {
          args[index] = arguments[index];
        }
        var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
          ? []
          : replaceHolders(args, placeholder);

        length -= holders.length;
        if (length < arity) {
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, undefined$1,
            args, holders, undefined$1, undefined$1, arity - length);
        }
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return apply(fn, this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} findIndexFunc The function to find the collection index.
     * @returns {Function} Returns the new find function.
     */
    function createFind(findIndexFunc) {
      return function(collection, predicate, fromIndex) {
        var iterable = Object(collection);
        if (!isArrayLike(collection)) {
          var iteratee = getIteratee(predicate, 3);
          collection = keys(collection);
          predicate = function(key) { return iteratee(iterable[key], key, iterable); };
        }
        var index = findIndexFunc(collection, predicate, fromIndex);
        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined$1;
      };
    }

    /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */
    function createFlow(fromRight) {
      return flatRest(function(funcs) {
        var length = funcs.length,
            index = length,
            prereq = LodashWrapper.prototype.thru;

        if (fromRight) {
          funcs.reverse();
        }
        while (index--) {
          var func = funcs[index];
          if (typeof func != 'function') {
            throw new TypeError(FUNC_ERROR_TEXT);
          }
          if (prereq && !wrapper && getFuncName(func) == 'wrapper') {
            var wrapper = new LodashWrapper([], true);
          }
        }
        index = wrapper ? index : length;
        while (++index < length) {
          func = funcs[index];

          var funcName = getFuncName(func),
              data = funcName == 'wrapper' ? getData(func) : undefined$1;

          if (data && isLaziable(data[0]) &&
                data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) &&
                !data[4].length && data[9] == 1
              ) {
            wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
          } else {
            wrapper = (func.length == 1 && isLaziable(func))
              ? wrapper[funcName]()
              : wrapper.thru(func);
          }
        }
        return function() {
          var args = arguments,
              value = args[0];

          if (wrapper && args.length == 1 && isArray(value)) {
            return wrapper.plant(value).value();
          }
          var index = 0,
              result = length ? funcs[index].apply(this, args) : value;

          while (++index < length) {
            result = funcs[index].call(this, result);
          }
          return result;
        };
      });
    }

    /**
     * Creates a function that wraps `func` to invoke it with optional `this`
     * binding of `thisArg`, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided
     *  to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
      var isAry = bitmask & WRAP_ARY_FLAG,
          isBind = bitmask & WRAP_BIND_FLAG,
          isBindKey = bitmask & WRAP_BIND_KEY_FLAG,
          isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG),
          isFlip = bitmask & WRAP_FLIP_FLAG,
          Ctor = isBindKey ? undefined$1 : createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length;

        while (index--) {
          args[index] = arguments[index];
        }
        if (isCurried) {
          var placeholder = getHolder(wrapper),
              holdersCount = countHolders(args, placeholder);
        }
        if (partials) {
          args = composeArgs(args, partials, holders, isCurried);
        }
        if (partialsRight) {
          args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
        }
        length -= holdersCount;
        if (isCurried && length < arity) {
          var newHolders = replaceHolders(args, placeholder);
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, thisArg,
            args, newHolders, argPos, ary, arity - length
          );
        }
        var thisBinding = isBind ? thisArg : this,
            fn = isBindKey ? thisBinding[func] : func;

        length = args.length;
        if (argPos) {
          args = reorder(args, argPos);
        } else if (isFlip && length > 1) {
          args.reverse();
        }
        if (isAry && ary < length) {
          args.length = ary;
        }
        if (this && this !== root && this instanceof wrapper) {
          fn = Ctor || createCtor(fn);
        }
        return fn.apply(thisBinding, args);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.invertBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} toIteratee The function to resolve iteratees.
     * @returns {Function} Returns the new inverter function.
     */
    function createInverter(setter, toIteratee) {
      return function(object, iteratee) {
        return baseInverter(object, setter, toIteratee(iteratee), {});
      };
    }

    /**
     * Creates a function that performs a mathematical operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @param {number} [defaultValue] The value used for `undefined` arguments.
     * @returns {Function} Returns the new mathematical operation function.
     */
    function createMathOperation(operator, defaultValue) {
      return function(value, other) {
        var result;
        if (value === undefined$1 && other === undefined$1) {
          return defaultValue;
        }
        if (value !== undefined$1) {
          result = value;
        }
        if (other !== undefined$1) {
          if (result === undefined$1) {
            return other;
          }
          if (typeof value == 'string' || typeof other == 'string') {
            value = baseToString(value);
            other = baseToString(other);
          } else {
            value = baseToNumber(value);
            other = baseToNumber(other);
          }
          result = operator(value, other);
        }
        return result;
      };
    }

    /**
     * Creates a function like `_.over`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over iteratees.
     * @returns {Function} Returns the new over function.
     */
    function createOver(arrayFunc) {
      return flatRest(function(iteratees) {
        iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
        return baseRest(function(args) {
          var thisArg = this;
          return arrayFunc(iteratees, function(iteratee) {
            return apply(iteratee, thisArg, args);
          });
        });
      });
    }

    /**
     * Creates the padding for `string` based on `length`. The `chars` string
     * is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {number} length The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padding for `string`.
     */
    function createPadding(length, chars) {
      chars = chars === undefined$1 ? ' ' : baseToString(chars);

      var charsLength = chars.length;
      if (charsLength < 2) {
        return charsLength ? baseRepeat(chars, length) : chars;
      }
      var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
      return hasUnicode(chars)
        ? castSlice(stringToArray(result), 0, length).join('')
        : result.slice(0, length);
    }

    /**
     * Creates a function that wraps `func` to invoke it with the `this` binding
     * of `thisArg` and `partials` prepended to the arguments it receives.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to
     *  the new function.
     * @returns {Function} Returns the new wrapped function.
     */
    function createPartial(func, bitmask, thisArg, partials) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var argsIndex = -1,
            argsLength = arguments.length,
            leftIndex = -1,
            leftLength = partials.length,
            args = Array(leftLength + argsLength),
            fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;

        while (++leftIndex < leftLength) {
          args[leftIndex] = partials[leftIndex];
        }
        while (argsLength--) {
          args[leftIndex++] = arguments[++argsIndex];
        }
        return apply(fn, isBind ? thisArg : this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.range` or `_.rangeRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new range function.
     */
    function createRange(fromRight) {
      return function(start, end, step) {
        if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
          end = step = undefined$1;
        }
        // Ensure the sign of `-0` is preserved.
        start = toFinite(start);
        if (end === undefined$1) {
          end = start;
          start = 0;
        } else {
          end = toFinite(end);
        }
        step = step === undefined$1 ? (start < end ? 1 : -1) : toFinite(step);
        return baseRange(start, end, step, fromRight);
      };
    }

    /**
     * Creates a function that performs a relational operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @returns {Function} Returns the new relational operation function.
     */
    function createRelationalOperation(operator) {
      return function(value, other) {
        if (!(typeof value == 'string' && typeof other == 'string')) {
          value = toNumber(value);
          other = toNumber(other);
        }
        return operator(value, other);
      };
    }

    /**
     * Creates a function that wraps `func` to continue currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {Function} wrapFunc The function to create the `func` wrapper.
     * @param {*} placeholder The placeholder value.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
      var isCurry = bitmask & WRAP_CURRY_FLAG,
          newHolders = isCurry ? holders : undefined$1,
          newHoldersRight = isCurry ? undefined$1 : holders,
          newPartials = isCurry ? partials : undefined$1,
          newPartialsRight = isCurry ? undefined$1 : partials;

      bitmask |= (isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG);
      bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);

      if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
        bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
      }
      var newData = [
        func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
        newHoldersRight, argPos, ary, arity
      ];

      var result = wrapFunc.apply(undefined$1, newData);
      if (isLaziable(func)) {
        setData(result, newData);
      }
      result.placeholder = placeholder;
      return setWrapToString(result, func, bitmask);
    }

    /**
     * Creates a function like `_.round`.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */
    function createRound(methodName) {
      var func = Math[methodName];
      return function(number, precision) {
        number = toNumber(number);
        precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
        if (precision && nativeIsFinite(number)) {
          // Shift with exponential notation to avoid floating-point issues.
          // See [MDN](https://mdn.io/round#Examples) for more details.
          var pair = (toString(number) + 'e').split('e'),
              value = func(pair[0] + 'e' + (+pair[1] + precision));

          pair = (toString(value) + 'e').split('e');
          return +(pair[0] + 'e' + (+pair[1] - precision));
        }
        return func(number);
      };
    }

    /**
     * Creates a set object of `values`.
     *
     * @private
     * @param {Array} values The values to add to the set.
     * @returns {Object} Returns the new set.
     */
    var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
      return new Set(values);
    };

    /**
     * Creates a `_.toPairs` or `_.toPairsIn` function.
     *
     * @private
     * @param {Function} keysFunc The function to get the keys of a given object.
     * @returns {Function} Returns the new pairs function.
     */
    function createToPairs(keysFunc) {
      return function(object) {
        var tag = getTag(object);
        if (tag == mapTag) {
          return mapToArray(object);
        }
        if (tag == setTag) {
          return setToPairs(object);
        }
        return baseToPairs(object, keysFunc(object));
      };
    }

    /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags.
     *    1 - `_.bind`
     *    2 - `_.bindKey`
     *    4 - `_.curry` or `_.curryRight` of a bound function
     *    8 - `_.curry`
     *   16 - `_.curryRight`
     *   32 - `_.partial`
     *   64 - `_.partialRight`
     *  128 - `_.rearg`
     *  256 - `_.ary`
     *  512 - `_.flip`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
      var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
      if (!isBindKey && typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var length = partials ? partials.length : 0;
      if (!length) {
        bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
        partials = holders = undefined$1;
      }
      ary = ary === undefined$1 ? ary : nativeMax(toInteger(ary), 0);
      arity = arity === undefined$1 ? arity : toInteger(arity);
      length -= holders ? holders.length : 0;

      if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
        var partialsRight = partials,
            holdersRight = holders;

        partials = holders = undefined$1;
      }
      var data = isBindKey ? undefined$1 : getData(func);

      var newData = [
        func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
        argPos, ary, arity
      ];

      if (data) {
        mergeData(newData, data);
      }
      func = newData[0];
      bitmask = newData[1];
      thisArg = newData[2];
      partials = newData[3];
      holders = newData[4];
      arity = newData[9] = newData[9] === undefined$1
        ? (isBindKey ? 0 : func.length)
        : nativeMax(newData[9] - length, 0);

      if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
        bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
      }
      if (!bitmask || bitmask == WRAP_BIND_FLAG) {
        var result = createBind(func, bitmask, thisArg);
      } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
        result = createCurry(func, bitmask, arity);
      } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
        result = createPartial(func, bitmask, thisArg, partials);
      } else {
        result = createHybrid.apply(undefined$1, newData);
      }
      var setter = data ? baseSetData : setData;
      return setWrapToString(setter(result, newData), func, bitmask);
    }

    /**
     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
     * of source objects to the destination object for all destination properties
     * that resolve to `undefined`.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to assign.
     * @param {Object} object The parent object of `objValue`.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsAssignIn(objValue, srcValue, key, object) {
      if (objValue === undefined$1 ||
          (eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key))) {
        return srcValue;
      }
      return objValue;
    }

    /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
     * objects into destination objects that are passed thru.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to merge.
     * @param {Object} object The parent object of `objValue`.
     * @param {Object} source The parent object of `srcValue`.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
      if (isObject(objValue) && isObject(srcValue)) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, objValue);
        baseMerge(objValue, srcValue, undefined$1, customDefaultsMerge, stack);
        stack['delete'](srcValue);
      }
      return objValue;
    }

    /**
     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
     * objects.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {string} key The key of the property to inspect.
     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
     */
    function customOmitClone(value) {
      return isPlainObject(value) ? undefined$1 : value;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `array` and `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */
    function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          arrLength = array.length,
          othLength = other.length;

      if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
        return false;
      }
      // Check that cyclic values are equal.
      var arrStacked = stack.get(array);
      var othStacked = stack.get(other);
      if (arrStacked && othStacked) {
        return arrStacked == other && othStacked == array;
      }
      var index = -1,
          result = true,
          seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined$1;

      stack.set(array, other);
      stack.set(other, array);

      // Ignore non-index properties.
      while (++index < arrLength) {
        var arrValue = array[index],
            othValue = other[index];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, arrValue, index, other, array, stack)
            : customizer(arrValue, othValue, index, array, other, stack);
        }
        if (compared !== undefined$1) {
          if (compared) {
            continue;
          }
          result = false;
          break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
          if (!arraySome(other, function(othValue, othIndex) {
                if (!cacheHas(seen, othIndex) &&
                    (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                  return seen.push(othIndex);
                }
              })) {
            result = false;
            break;
          }
        } else if (!(
              arrValue === othValue ||
                equalFunc(arrValue, othValue, bitmask, customizer, stack)
            )) {
          result = false;
          break;
        }
      }
      stack['delete'](array);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
      switch (tag) {
        case dataViewTag:
          if ((object.byteLength != other.byteLength) ||
              (object.byteOffset != other.byteOffset)) {
            return false;
          }
          object = object.buffer;
          other = other.buffer;

        case arrayBufferTag:
          if ((object.byteLength != other.byteLength) ||
              !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
            return false;
          }
          return true;

        case boolTag:
        case dateTag:
        case numberTag:
          // Coerce booleans to `1` or `0` and dates to milliseconds.
          // Invalid dates are coerced to `NaN`.
          return eq(+object, +other);

        case errorTag:
          return object.name == other.name && object.message == other.message;

        case regexpTag:
        case stringTag:
          // Coerce regexes to strings and treat strings, primitives and objects,
          // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
          // for more details.
          return object == (other + '');

        case mapTag:
          var convert = mapToArray;

        case setTag:
          var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
          convert || (convert = setToArray);

          if (object.size != other.size && !isPartial) {
            return false;
          }
          // Assume cyclic values are equal.
          var stacked = stack.get(object);
          if (stacked) {
            return stacked == other;
          }
          bitmask |= COMPARE_UNORDERED_FLAG;

          // Recursively compare objects (susceptible to call stack limits).
          stack.set(object, other);
          var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
          stack['delete'](object);
          return result;

        case symbolTag:
          if (symbolValueOf) {
            return symbolValueOf.call(object) == symbolValueOf.call(other);
          }
      }
      return false;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          objProps = getAllKeys(object),
          objLength = objProps.length,
          othProps = getAllKeys(other),
          othLength = othProps.length;

      if (objLength != othLength && !isPartial) {
        return false;
      }
      var index = objLength;
      while (index--) {
        var key = objProps[index];
        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
          return false;
        }
      }
      // Check that cyclic values are equal.
      var objStacked = stack.get(object);
      var othStacked = stack.get(other);
      if (objStacked && othStacked) {
        return objStacked == other && othStacked == object;
      }
      var result = true;
      stack.set(object, other);
      stack.set(other, object);

      var skipCtor = isPartial;
      while (++index < objLength) {
        key = objProps[index];
        var objValue = object[key],
            othValue = other[key];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, objValue, key, other, object, stack)
            : customizer(objValue, othValue, key, object, other, stack);
        }
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined$1
              ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
              : compared
            )) {
          result = false;
          break;
        }
        skipCtor || (skipCtor = key == 'constructor');
      }
      if (result && !skipCtor) {
        var objCtor = object.constructor,
            othCtor = other.constructor;

        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor &&
            ('constructor' in object && 'constructor' in other) &&
            !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
              typeof othCtor == 'function' && othCtor instanceof othCtor)) {
          result = false;
        }
      }
      stack['delete'](object);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseRest` which flattens the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    function flatRest(func) {
      return setToString(overRest(func, undefined$1, flatten), func + '');
    }

    /**
     * Creates an array of own enumerable property names and symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeys(object) {
      return baseGetAllKeys(object, keys, getSymbols);
    }

    /**
     * Creates an array of own and inherited enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeysIn(object) {
      return baseGetAllKeys(object, keysIn, getSymbolsIn);
    }

    /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */
    var getData = !metaMap ? noop : function(func) {
      return metaMap.get(func);
    };

    /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */
    function getFuncName(func) {
      var result = (func.name + ''),
          array = realNames[result],
          length = hasOwnProperty.call(realNames, result) ? array.length : 0;

      while (length--) {
        var data = array[length],
            otherFunc = data.func;
        if (otherFunc == null || otherFunc == func) {
          return data.name;
        }
      }
      return result;
    }

    /**
     * Gets the argument placeholder value for `func`.
     *
     * @private
     * @param {Function} func The function to inspect.
     * @returns {*} Returns the placeholder value.
     */
    function getHolder(func) {
      var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
      return object.placeholder;
    }

    /**
     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
     * this function returns the custom method, otherwise it returns `baseIteratee`.
     * If arguments are provided, the chosen function is invoked with them and
     * its result is returned.
     *
     * @private
     * @param {*} [value] The value to convert to an iteratee.
     * @param {number} [arity] The arity of the created iteratee.
     * @returns {Function} Returns the chosen function or its result.
     */
    function getIteratee() {
      var result = lodash.iteratee || iteratee;
      result = result === iteratee ? baseIteratee : result;
      return arguments.length ? result(arguments[0], arguments[1]) : result;
    }

    /**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */
    function getMapData(map, key) {
      var data = map.__data__;
      return isKeyable(key)
        ? data[typeof key == 'string' ? 'string' : 'hash']
        : data.map;
    }

    /**
     * Gets the property names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */
    function getMatchData(object) {
      var result = keys(object),
          length = result.length;

      while (length--) {
        var key = result[length],
            value = object[key];

        result[length] = [key, value, isStrictComparable(value)];
      }
      return result;
    }

    /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */
    function getNative(object, key) {
      var value = getValue(object, key);
      return baseIsNative(value) ? value : undefined$1;
    }

    /**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */
    function getRawTag(value) {
      var isOwn = hasOwnProperty.call(value, symToStringTag),
          tag = value[symToStringTag];

      try {
        value[symToStringTag] = undefined$1;
        var unmasked = true;
      } catch (e) {}

      var result = nativeObjectToString.call(value);
      if (unmasked) {
        if (isOwn) {
          value[symToStringTag] = tag;
        } else {
          delete value[symToStringTag];
        }
      }
      return result;
    }

    /**
     * Creates an array of the own enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
      if (object == null) {
        return [];
      }
      object = Object(object);
      return arrayFilter(nativeGetSymbols(object), function(symbol) {
        return propertyIsEnumerable.call(object, symbol);
      });
    };

    /**
     * Creates an array of the own and inherited enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
      var result = [];
      while (object) {
        arrayPush(result, getSymbols(object));
        object = getPrototype(object);
      }
      return result;
    };

    /**
     * Gets the `toStringTag` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    var getTag = baseGetTag;

    // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
    if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
        (Map && getTag(new Map) != mapTag) ||
        (Promise && getTag(Promise.resolve()) != promiseTag) ||
        (Set && getTag(new Set) != setTag) ||
        (WeakMap && getTag(new WeakMap) != weakMapTag)) {
      getTag = function(value) {
        var result = baseGetTag(value),
            Ctor = result == objectTag ? value.constructor : undefined$1,
            ctorString = Ctor ? toSource(Ctor) : '';

        if (ctorString) {
          switch (ctorString) {
            case dataViewCtorString: return dataViewTag;
            case mapCtorString: return mapTag;
            case promiseCtorString: return promiseTag;
            case setCtorString: return setTag;
            case weakMapCtorString: return weakMapTag;
          }
        }
        return result;
      };
    }

    /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */
    function getView(start, end, transforms) {
      var index = -1,
          length = transforms.length;

      while (++index < length) {
        var data = transforms[index],
            size = data.size;

        switch (data.type) {
          case 'drop':      start += size; break;
          case 'dropRight': end -= size; break;
          case 'take':      end = nativeMin(end, start + size); break;
          case 'takeRight': start = nativeMax(start, end - size); break;
        }
      }
      return { 'start': start, 'end': end };
    }

    /**
     * Extracts wrapper details from the `source` body comment.
     *
     * @private
     * @param {string} source The source to inspect.
     * @returns {Array} Returns the wrapper details.
     */
    function getWrapDetails(source) {
      var match = source.match(reWrapDetails);
      return match ? match[1].split(reSplitDetails) : [];
    }

    /**
     * Checks if `path` exists on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @param {Function} hasFunc The function to check properties.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     */
    function hasPath(object, path, hasFunc) {
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          result = false;

      while (++index < length) {
        var key = toKey(path[index]);
        if (!(result = object != null && hasFunc(object, key))) {
          break;
        }
        object = object[key];
      }
      if (result || ++index != length) {
        return result;
      }
      length = object == null ? 0 : object.length;
      return !!length && isLength(length) && isIndex(key, length) &&
        (isArray(object) || isArguments(object));
    }

    /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */
    function initCloneArray(array) {
      var length = array.length,
          result = new array.constructor(length);

      // Add properties assigned by `RegExp#exec`.
      if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
        result.index = array.index;
        result.input = array.input;
      }
      return result;
    }

    /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneObject(object) {
      return (typeof object.constructor == 'function' && !isPrototype(object))
        ? baseCreate(getPrototype(object))
        : {};
    }

    /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneByTag(object, tag, isDeep) {
      var Ctor = object.constructor;
      switch (tag) {
        case arrayBufferTag:
          return cloneArrayBuffer(object);

        case boolTag:
        case dateTag:
          return new Ctor(+object);

        case dataViewTag:
          return cloneDataView(object, isDeep);

        case float32Tag: case float64Tag:
        case int8Tag: case int16Tag: case int32Tag:
        case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
          return cloneTypedArray(object, isDeep);

        case mapTag:
          return new Ctor;

        case numberTag:
        case stringTag:
          return new Ctor(object);

        case regexpTag:
          return cloneRegExp(object);

        case setTag:
          return new Ctor;

        case symbolTag:
          return cloneSymbol(object);
      }
    }

    /**
     * Inserts wrapper `details` in a comment at the top of the `source` body.
     *
     * @private
     * @param {string} source The source to modify.
     * @returns {Array} details The details to insert.
     * @returns {string} Returns the modified source.
     */
    function insertWrapDetails(source, details) {
      var length = details.length;
      if (!length) {
        return source;
      }
      var lastIndex = length - 1;
      details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
      details = details.join(length > 2 ? ', ' : ' ');
      return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
    }

    /**
     * Checks if `value` is a flattenable `arguments` object or array.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */
    function isFlattenable(value) {
      return isArray(value) || isArguments(value) ||
        !!(spreadableSymbol && value && value[spreadableSymbol]);
    }

    /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */
    function isIndex(value, length) {
      var type = typeof value;
      length = length == null ? MAX_SAFE_INTEGER : length;

      return !!length &&
        (type == 'number' ||
          (type != 'symbol' && reIsUint.test(value))) &&
            (value > -1 && value % 1 == 0 && value < length);
    }

    /**
     * Checks if the given arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
     *  else `false`.
     */
    function isIterateeCall(value, index, object) {
      if (!isObject(object)) {
        return false;
      }
      var type = typeof index;
      if (type == 'number'
            ? (isArrayLike(object) && isIndex(index, object.length))
            : (type == 'string' && index in object)
          ) {
        return eq(object[index], value);
      }
      return false;
    }

    /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */
    function isKey(value, object) {
      if (isArray(value)) {
        return false;
      }
      var type = typeof value;
      if (type == 'number' || type == 'symbol' || type == 'boolean' ||
          value == null || isSymbol(value)) {
        return true;
      }
      return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
        (object != null && value in Object(object));
    }

    /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */
    function isKeyable(value) {
      var type = typeof value;
      return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
        ? (value !== '__proto__')
        : (value === null);
    }

    /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
     *  else `false`.
     */
    function isLaziable(func) {
      var funcName = getFuncName(func),
          other = lodash[funcName];

      if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
        return false;
      }
      if (func === other) {
        return true;
      }
      var data = getData(other);
      return !!data && func === data[0];
    }

    /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */
    function isMasked(func) {
      return !!maskSrcKey && (maskSrcKey in func);
    }

    /**
     * Checks if `func` is capable of being masked.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
     */
    var isMaskable = coreJsData ? isFunction : stubFalse;

    /**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */
    function isPrototype(value) {
      var Ctor = value && value.constructor,
          proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

      return value === proto;
    }

    /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */
    function isStrictComparable(value) {
      return value === value && !isObject(value);
    }

    /**
     * A specialized version of `matchesProperty` for source values suitable
     * for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function matchesStrictComparable(key, srcValue) {
      return function(object) {
        if (object == null) {
          return false;
        }
        return object[key] === srcValue &&
          (srcValue !== undefined$1 || (key in Object(object)));
      };
    }

    /**
     * A specialized version of `_.memoize` which clears the memoized function's
     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
     *
     * @private
     * @param {Function} func The function to have its output memoized.
     * @returns {Function} Returns the new memoized function.
     */
    function memoizeCapped(func) {
      var result = memoize(func, function(key) {
        if (cache.size === MAX_MEMOIZE_SIZE) {
          cache.clear();
        }
        return key;
      });

      var cache = result.cache;
      return result;
    }

    /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers used to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and
     * `_.rearg` modify function arguments, making the order in which they are
     * executed important, preventing the merging of metadata. However, we make
     * an exception for a safe combined case where curried functions have `_.ary`
     * and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */
    function mergeData(data, source) {
      var bitmask = data[1],
          srcBitmask = source[1],
          newBitmask = bitmask | srcBitmask,
          isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);

      var isCombo =
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_CURRY_FLAG)) ||
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_REARG_FLAG) && (data[7].length <= source[8])) ||
        ((srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == WRAP_CURRY_FLAG));

      // Exit early if metadata can't be merged.
      if (!(isCommon || isCombo)) {
        return data;
      }
      // Use source `thisArg` if available.
      if (srcBitmask & WRAP_BIND_FLAG) {
        data[2] = source[2];
        // Set when currying a bound function.
        newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
      }
      // Compose partial arguments.
      var value = source[3];
      if (value) {
        var partials = data[3];
        data[3] = partials ? composeArgs(partials, value, source[4]) : value;
        data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
      }
      // Compose partial right arguments.
      value = source[5];
      if (value) {
        partials = data[5];
        data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
        data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
      }
      // Use source `argPos` if available.
      value = source[7];
      if (value) {
        data[7] = value;
      }
      // Use source `ary` if it's smaller.
      if (srcBitmask & WRAP_ARY_FLAG) {
        data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
      }
      // Use source `arity` if one is not provided.
      if (data[9] == null) {
        data[9] = source[9];
      }
      // Use source `func` and merge bitmasks.
      data[0] = source[0];
      data[1] = newBitmask;

      return data;
    }

    /**
     * This function is like
     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * except that it includes inherited enumerable properties.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function nativeKeysIn(object) {
      var result = [];
      if (object != null) {
        for (var key in Object(object)) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */
    function objectToString(value) {
      return nativeObjectToString.call(value);
    }

    /**
     * A specialized version of `baseRest` which transforms the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @param {Function} transform The rest array transform.
     * @returns {Function} Returns the new function.
     */
    function overRest(func, start, transform) {
      start = nativeMax(start === undefined$1 ? (func.length - 1) : start, 0);
      return function() {
        var args = arguments,
            index = -1,
            length = nativeMax(args.length - start, 0),
            array = Array(length);

        while (++index < length) {
          array[index] = args[start + index];
        }
        index = -1;
        var otherArgs = Array(start + 1);
        while (++index < start) {
          otherArgs[index] = args[index];
        }
        otherArgs[start] = transform(array);
        return apply(func, this, otherArgs);
      };
    }

    /**
     * Gets the parent value at `path` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path to get the parent value of.
     * @returns {*} Returns the parent value.
     */
    function parent(object, path) {
      return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
    }

    /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */
    function reorder(array, indexes) {
      var arrLength = array.length,
          length = nativeMin(indexes.length, arrLength),
          oldArray = copyArray(array);

      while (length--) {
        var index = indexes[length];
        array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined$1;
      }
      return array;
    }

    /**
     * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the property to get.
     * @returns {*} Returns the property value.
     */
    function safeGet(object, key) {
      if (key === 'constructor' && typeof object[key] === 'function') {
        return;
      }

      if (key == '__proto__') {
        return;
      }

      return object[key];
    }

    /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity
     * function to avoid garbage collection pauses in V8. See
     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var setData = shortOut(baseSetData);

    /**
     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    var setTimeout = ctxSetTimeout || function(func, wait) {
      return root.setTimeout(func, wait);
    };

    /**
     * Sets the `toString` method of `func` to return `string`.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var setToString = shortOut(baseSetToString);

    /**
     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
     * with wrapper details in a comment at the top of the source body.
     *
     * @private
     * @param {Function} wrapper The function to modify.
     * @param {Function} reference The reference function.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Function} Returns `wrapper`.
     */
    function setWrapToString(wrapper, reference, bitmask) {
      var source = (reference + '');
      return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
    }

    /**
     * Creates a function that'll short out and invoke `identity` instead
     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
     * milliseconds.
     *
     * @private
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new shortable function.
     */
    function shortOut(func) {
      var count = 0,
          lastCalled = 0;

      return function() {
        var stamp = nativeNow(),
            remaining = HOT_SPAN - (stamp - lastCalled);

        lastCalled = stamp;
        if (remaining > 0) {
          if (++count >= HOT_COUNT) {
            return arguments[0];
          }
        } else {
          count = 0;
        }
        return func.apply(undefined$1, arguments);
      };
    }

    /**
     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @param {number} [size=array.length] The size of `array`.
     * @returns {Array} Returns `array`.
     */
    function shuffleSelf(array, size) {
      var index = -1,
          length = array.length,
          lastIndex = length - 1;

      size = size === undefined$1 ? length : size;
      while (++index < size) {
        var rand = baseRandom(index, lastIndex),
            value = array[rand];

        array[rand] = array[index];
        array[index] = value;
      }
      array.length = size;
      return array;
    }

    /**
     * Converts `string` to a property path array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the property path array.
     */
    var stringToPath = memoizeCapped(function(string) {
      var result = [];
      if (string.charCodeAt(0) === 46 /* . */) {
        result.push('');
      }
      string.replace(rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
      });
      return result;
    });

    /**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */
    function toKey(value) {
      if (typeof value == 'string' || isSymbol(value)) {
        return value;
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to convert.
     * @returns {string} Returns the source code.
     */
    function toSource(func) {
      if (func != null) {
        try {
          return funcToString.call(func);
        } catch (e) {}
        try {
          return (func + '');
        } catch (e) {}
      }
      return '';
    }

    /**
     * Updates wrapper `details` based on `bitmask` flags.
     *
     * @private
     * @returns {Array} details The details to modify.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Array} Returns `details`.
     */
    function updateWrapDetails(details, bitmask) {
      arrayEach(wrapFlags, function(pair) {
        var value = '_.' + pair[0];
        if ((bitmask & pair[1]) && !arrayIncludes(details, value)) {
          details.push(value);
        }
      });
      return details.sort();
    }

    /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */
    function wrapperClone(wrapper) {
      if (wrapper instanceof LazyWrapper) {
        return wrapper.clone();
      }
      var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
      result.__actions__ = copyArray(wrapper.__actions__);
      result.__index__  = wrapper.__index__;
      result.__values__ = wrapper.__values__;
      return result;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of elements split into groups the length of `size`.
     * If `array` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the new array of chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */
    function chunk(array, size, guard) {
      if ((guard ? isIterateeCall(array, size, guard) : size === undefined$1)) {
        size = 1;
      } else {
        size = nativeMax(toInteger(size), 0);
      }
      var length = array == null ? 0 : array.length;
      if (!length || size < 1) {
        return [];
      }
      var index = 0,
          resIndex = 0,
          result = Array(nativeCeil(length / size));

      while (index < length) {
        result[resIndex++] = baseSlice(array, index, (index += size));
      }
      return result;
    }

    /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `""`, `undefined`, and `NaN` are falsey.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */
    function compact(array) {
      var index = -1,
          length = array == null ? 0 : array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index];
        if (value) {
          result[resIndex++] = value;
        }
      }
      return result;
    }

    /**
     * Creates a new array concatenating `array` with any additional arrays
     * and/or values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to concatenate.
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var other = _.concat(array, 2, [3], [[4]]);
     *
     * console.log(other);
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */
    function concat() {
      var length = arguments.length;
      if (!length) {
        return [];
      }
      var args = Array(length - 1),
          array = arguments[0],
          index = length;

      while (index--) {
        args[index - 1] = arguments[index];
      }
      return arrayPush(isArray(array) ? copyArray(array) : [array], baseFlatten(args, 1));
    }

    /**
     * Creates an array of `array` values not included in the other given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * **Note:** Unlike `_.pullAll`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.without, _.xor
     * @example
     *
     * _.difference([2, 1], [2, 3]);
     * // => [1]
     */
    var difference = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `iteratee` which
     * is invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var differenceBy = baseRest(function(array, values) {
      var iteratee = last(values);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined$1;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `comparator`
     * which is invoked to compare elements of `array` to `values`. The order and
     * references of result values are determined by the first array. The comparator
     * is invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     *
     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }]
     */
    var differenceWith = baseRest(function(array, values) {
      var comparator = last(values);
      if (isArrayLikeObject(comparator)) {
        comparator = undefined$1;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined$1, comparator)
        : [];
    });

    /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function drop(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined$1) ? 1 : toInteger(n);
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function dropRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined$1) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.dropRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropRightWhile(users, ['active', false]);
     * // => objects for ['barney']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropRightWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true, true)
        : [];
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.dropWhile(users, function(o) { return !o.active; });
     * // => objects for ['pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropWhile(users, ['active', false]);
     * // => objects for ['pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true)
        : [];
    }

    /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8, 10], '*', 1, 3);
     * // => [4, '*', '*', 10]
     */
    function fill(array, value, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
        start = 0;
        end = length;
      }
      return baseFill(array, value, start, end);
    }

    /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(o) { return o.user == 'barney'; });
     * // => 0
     *
     * // The `_.matches` iteratee shorthand.
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findIndex(users, ['active', false]);
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.findIndex(users, 'active');
     * // => 2
     */
    function findIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index);
    }

    /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
     * // => 2
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastIndex(users, ['active', false]);
     * // => 2
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastIndex(users, 'active');
     * // => 0
     */
    function findLastIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length - 1;
      if (fromIndex !== undefined$1) {
        index = toInteger(fromIndex);
        index = fromIndex < 0
          ? nativeMax(length + index, 0)
          : nativeMin(index, length - 1);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index, true);
    }

    /**
     * Flattens `array` a single level deep.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, [3, [4]], 5]]);
     * // => [1, 2, [3, [4]], 5]
     */
    function flatten(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, 1) : [];
    }

    /**
     * Recursively flattens `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, [3, [4]], 5]]);
     * // => [1, 2, 3, 4, 5]
     */
    function flattenDeep(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, INFINITY) : [];
    }

    /**
     * Recursively flatten `array` up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * var array = [1, [2, [3, [4]], 5]];
     *
     * _.flattenDepth(array, 1);
     * // => [1, 2, [3, [4]], 5]
     *
     * _.flattenDepth(array, 2);
     * // => [1, 2, 3, [4], 5]
     */
    function flattenDepth(array, depth) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      depth = depth === undefined$1 ? 1 : toInteger(depth);
      return baseFlatten(array, depth);
    }

    /**
     * The inverse of `_.toPairs`; this method returns an object composed
     * from key-value `pairs`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} pairs The key-value pairs.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.fromPairs([['a', 1], ['b', 2]]);
     * // => { 'a': 1, 'b': 2 }
     */
    function fromPairs(pairs) {
      var index = -1,
          length = pairs == null ? 0 : pairs.length,
          result = {};

      while (++index < length) {
        var pair = pairs[index];
        result[pair[0]] = pair[1];
      }
      return result;
    }

    /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias first
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.head([1, 2, 3]);
     * // => 1
     *
     * _.head([]);
     * // => undefined
     */
    function head(array) {
      return (array && array.length) ? array[0] : undefined$1;
    }

    /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it's used as the
     * offset from the end of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // Search from the `fromIndex`.
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     */
    function indexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseIndexOf(array, value, index);
    }

    /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */
    function initial(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 0, -1) : [];
    }

    /**
     * Creates an array of unique values that are included in all given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersection([2, 1], [2, 3]);
     * // => [2]
     */
    var intersection = baseRest(function(arrays) {
      var mapped = arrayMap(arrays, castArrayLikeObject);
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped)
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `iteratee`
     * which is invoked for each element of each `arrays` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [2.1]
     *
     * // The `_.property` iteratee shorthand.
     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }]
     */
    var intersectionBy = baseRest(function(arrays) {
      var iteratee = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      if (iteratee === last(mapped)) {
        iteratee = undefined$1;
      } else {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `comparator`
     * which is invoked to compare elements of `arrays`. The order and references
     * of result values are determined by the first array. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.intersectionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }]
     */
    var intersectionWith = baseRest(function(arrays) {
      var comparator = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      comparator = typeof comparator == 'function' ? comparator : undefined$1;
      if (comparator) {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, undefined$1, comparator)
        : [];
    });

    /**
     * Converts all elements in `array` into a string separated by `separator`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to convert.
     * @param {string} [separator=','] The element separator.
     * @returns {string} Returns the joined string.
     * @example
     *
     * _.join(['a', 'b', 'c'], '~');
     * // => 'a~b~c'
     */
    function join(array, separator) {
      return array == null ? '' : nativeJoin.call(array, separator);
    }

    /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */
    function last(array) {
      var length = array == null ? 0 : array.length;
      return length ? array[length - 1] : undefined$1;
    }

    /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // Search from the `fromIndex`.
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     */
    function lastIndexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length;
      if (fromIndex !== undefined$1) {
        index = toInteger(fromIndex);
        index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
      }
      return value === value
        ? strictLastIndexOf(array, value, index)
        : baseFindIndex(array, baseIsNaN, index, true);
    }

    /**
     * Gets the element at index `n` of `array`. If `n` is negative, the nth
     * element from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.11.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=0] The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     *
     * _.nth(array, 1);
     * // => 'b'
     *
     * _.nth(array, -2);
     * // => 'c';
     */
    function nth(array, n) {
      return (array && array.length) ? baseNth(array, toInteger(n)) : undefined$1;
    }

    /**
     * Removes all given values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
     * to remove elements from an array by predicate.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pull(array, 'a', 'c');
     * console.log(array);
     * // => ['b', 'b']
     */
    var pull = baseRest(pullAll);

    /**
     * This method is like `_.pull` except that it accepts an array of values to remove.
     *
     * **Note:** Unlike `_.difference`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pullAll(array, ['a', 'c']);
     * console.log(array);
     * // => ['b', 'b']
     */
    function pullAll(array, values) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values)
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `iteratee` which is
     * invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The iteratee is invoked with one argument: (value).
     *
     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
     *
     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
     * console.log(array);
     * // => [{ 'x': 2 }]
     */
    function pullAllBy(array, values, iteratee) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, getIteratee(iteratee, 2))
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `comparator` which
     * is invoked to compare elements of `array` to `values`. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
     *
     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
     * console.log(array);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
     */
    function pullAllWith(array, values, comparator) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, undefined$1, comparator)
        : array;
    }

    /**
     * Removes elements from `array` corresponding to `indexes` and returns an
     * array of removed elements.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     * var pulled = _.pullAt(array, [1, 3]);
     *
     * console.log(array);
     * // => ['a', 'c']
     *
     * console.log(pulled);
     * // => ['b', 'd']
     */
    var pullAt = flatRest(function(array, indexes) {
      var length = array == null ? 0 : array.length,
          result = baseAt(array, indexes);

      basePullAt(array, arrayMap(indexes, function(index) {
        return isIndex(index, length) ? +index : index;
      }).sort(compareAscending));

      return result;
    });

    /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is invoked
     * with three arguments: (value, index, array).
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
     * to pull elements from an array by value.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */
    function remove(array, predicate) {
      var result = [];
      if (!(array && array.length)) {
        return result;
      }
      var index = -1,
          indexes = [],
          length = array.length;

      predicate = getIteratee(predicate, 3);
      while (++index < length) {
        var value = array[index];
        if (predicate(value, index, array)) {
          result.push(value);
          indexes.push(index);
        }
      }
      basePullAt(array, indexes);
      return result;
    }

    /**
     * Reverses `array` so that the first element becomes the last, the second
     * element becomes the second to last, and so on.
     *
     * **Note:** This method mutates `array` and is based on
     * [`Array#reverse`](https://mdn.io/Array/reverse).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.reverse(array);
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function reverse(array) {
      return array == null ? array : nativeReverse.call(array);
    }

    /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of
     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
     * returned.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function slice(array, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
        start = 0;
        end = length;
      }
      else {
        start = start == null ? 0 : toInteger(start);
        end = end === undefined$1 ? length : toInteger(end);
      }
      return baseSlice(array, start, end);
    }

    /**
     * Uses a binary search to determine the lowest index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     */
    function sortedIndex(array, value) {
      return baseSortedIndex(array, value);
    }

    /**
     * This method is like `_.sortedIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
     * // => 0
     */
    function sortedIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
    }

    /**
     * This method is like `_.indexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
     * // => 1
     */
    function sortedIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value);
        if (index < length && eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
     * // => 4
     */
    function sortedLastIndex(array, value) {
      return baseSortedIndex(array, value, true);
    }

    /**
     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 1
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
     * // => 1
     */
    function sortedLastIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
    }

    /**
     * This method is like `_.lastIndexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
     * // => 3
     */
    function sortedLastIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value, true) - 1;
        if (eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.uniq` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniq([1, 1, 2]);
     * // => [1, 2]
     */
    function sortedUniq(array) {
      return (array && array.length)
        ? baseSortedUniq(array)
        : [];
    }

    /**
     * This method is like `_.uniqBy` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
     * // => [1.1, 2.3]
     */
    function sortedUniqBy(array, iteratee) {
      return (array && array.length)
        ? baseSortedUniq(array, getIteratee(iteratee, 2))
        : [];
    }

    /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.tail([1, 2, 3]);
     * // => [2, 3]
     */
    function tail(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 1, length) : [];
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */
    function take(array, n, guard) {
      if (!(array && array.length)) {
        return [];
      }
      n = (guard || n === undefined$1) ? 1 : toInteger(n);
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */
    function takeRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined$1) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.takeRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeRightWhile(users, ['active', false]);
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeRightWhile(users, 'active');
     * // => []
     */
    function takeRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), false, true)
        : [];
    }

    /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.takeWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeWhile(users, ['active', false]);
     * // => objects for ['barney', 'fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeWhile(users, 'active');
     * // => []
     */
    function takeWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3))
        : [];
    }

    /**
     * Creates an array of unique values, in order, from all given arrays using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([2], [1, 2]);
     * // => [2, 1]
     */
    var union = baseRest(function(arrays) {
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
    });

    /**
     * This method is like `_.union` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which uniqueness is computed. Result values are chosen from the first
     * array in which the value occurs. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    var unionBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined$1;
      }
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.union` except that it accepts `comparator` which
     * is invoked to compare elements of `arrays`. Result values are chosen from
     * the first array in which the value occurs. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.unionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var unionWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined$1;
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined$1, comparator);
    });

    /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurrence of each element
     * is kept. The order of result values is determined by the order they occur
     * in the array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     */
    function uniq(array) {
      return (array && array.length) ? baseUniq(array) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * uniqueness is computed. The order of result values is determined by the
     * order they occur in the array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    function uniqBy(array, iteratee) {
      return (array && array.length) ? baseUniq(array, getIteratee(iteratee, 2)) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `comparator` which
     * is invoked to compare elements of `array`. The order of result values is
     * determined by the order they occur in the array.The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.uniqWith(objects, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
     */
    function uniqWith(array, comparator) {
      comparator = typeof comparator == 'function' ? comparator : undefined$1;
      return (array && array.length) ? baseUniq(array, undefined$1, comparator) : [];
    }

    /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @since 1.2.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     *
     * _.unzip(zipped);
     * // => [['a', 'b'], [1, 2], [true, false]]
     */
    function unzip(array) {
      if (!(array && array.length)) {
        return [];
      }
      var length = 0;
      array = arrayFilter(array, function(group) {
        if (isArrayLikeObject(group)) {
          length = nativeMax(group.length, length);
          return true;
        }
      });
      return baseTimes(length, function(index) {
        return arrayMap(array, baseProperty(index));
      });
    }

    /**
     * This method is like `_.unzip` except that it accepts `iteratee` to specify
     * how regrouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  regrouped values.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */
    function unzipWith(array, iteratee) {
      if (!(array && array.length)) {
        return [];
      }
      var result = unzip(array);
      if (iteratee == null) {
        return result;
      }
      return arrayMap(result, function(group) {
        return apply(iteratee, undefined$1, group);
      });
    }

    /**
     * Creates an array excluding all given values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.pull`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.xor
     * @example
     *
     * _.without([2, 1, 2, 3], 1, 2);
     * // => [3]
     */
    var without = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, values)
        : [];
    });

    /**
     * Creates an array of unique values that is the
     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the given arrays. The order of result values is determined by the order
     * they occur in the arrays.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.without
     * @example
     *
     * _.xor([2, 1], [2, 3]);
     * // => [1, 3]
     */
    var xor = baseRest(function(arrays) {
      return baseXor(arrayFilter(arrays, isArrayLikeObject));
    });

    /**
     * This method is like `_.xor` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which by which they're compared. The order of result values is determined
     * by the order they occur in the arrays. The iteratee is invoked with one
     * argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2, 3.4]
     *
     * // The `_.property` iteratee shorthand.
     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var xorBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined$1;
      }
      return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.xor` except that it accepts `comparator` which is
     * invoked to compare elements of `arrays`. The order of result values is
     * determined by the order they occur in the arrays. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.xorWith(objects, others, _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var xorWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined$1;
      return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined$1, comparator);
    });

    /**
     * Creates an array of grouped elements, the first of which contains the
     * first elements of the given arrays, the second of which contains the
     * second elements of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     */
    var zip = baseRest(unzip);

    /**
     * This method is like `_.fromPairs` except that it accepts two arrays,
     * one of property identifiers and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 0.4.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject(['a', 'b'], [1, 2]);
     * // => { 'a': 1, 'b': 2 }
     */
    function zipObject(props, values) {
      return baseZipObject(props || [], values || [], assignValue);
    }

    /**
     * This method is like `_.zipObject` except that it supports property paths.
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
     */
    function zipObjectDeep(props, values) {
      return baseZipObject(props || [], values || [], baseSet);
    }

    /**
     * This method is like `_.zip` except that it accepts `iteratee` to specify
     * how grouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  grouped values.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
     *   return a + b + c;
     * });
     * // => [111, 222]
     */
    var zipWith = baseRest(function(arrays) {
      var length = arrays.length,
          iteratee = length > 1 ? arrays[length - 1] : undefined$1;

      iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined$1;
      return unzipWith(arrays, iteratee);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
     * chain sequences enabled. The result of such sequences must be unwrapped
     * with `_#value`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Seq
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _
     *   .chain(users)
     *   .sortBy('age')
     *   .map(function(o) {
     *     return o.user + ' is ' + o.age;
     *   })
     *   .head()
     *   .value();
     * // => 'pebbles is 1'
     */
    function chain(value) {
      var result = lodash(value);
      result.__chain__ = true;
      return result;
    }

    /**
     * This method invokes `interceptor` and returns `value`. The interceptor
     * is invoked with one argument; (value). The purpose of this method is to
     * "tap into" a method chain sequence in order to modify intermediate results.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    // Mutate input array.
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */
    function tap(value, interceptor) {
      interceptor(value);
      return value;
    }

    /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     * The purpose of this method is to "pass thru" values replacing intermediate
     * results in a method chain sequence.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */
    function thru(value, interceptor) {
      return interceptor(value);
    }

    /**
     * This method is the wrapper version of `_.at`.
     *
     * @name at
     * @memberOf _
     * @since 1.0.0
     * @category Seq
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _(object).at(['a[0].b.c', 'a[1]']).value();
     * // => [3, 4]
     */
    var wrapperAt = flatRest(function(paths) {
      var length = paths.length,
          start = length ? paths[0] : 0,
          value = this.__wrapped__,
          interceptor = function(object) { return baseAt(object, paths); };

      if (length > 1 || this.__actions__.length ||
          !(value instanceof LazyWrapper) || !isIndex(start)) {
        return this.thru(interceptor);
      }
      value = value.slice(start, +start + (length ? 1 : 0));
      value.__actions__.push({
        'func': thru,
        'args': [interceptor],
        'thisArg': undefined$1
      });
      return new LodashWrapper(value, this.__chain__).thru(function(array) {
        if (length && !array.length) {
          array.push(undefined$1);
        }
        return array;
      });
    });

    /**
     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
     *
     * @name chain
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // A sequence without explicit chaining.
     * _(users).head();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // A sequence with explicit chaining.
     * _(users)
     *   .chain()
     *   .head()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */
    function wrapperChain() {
      return chain(this);
    }

    /**
     * Executes the chain sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */
    function wrapperCommit() {
      return new LodashWrapper(this.value(), this.__chain__);
    }

    /**
     * Gets the next value on a wrapped object following the
     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
     *
     * @name next
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the next iterator value.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 1 }
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 2 }
     *
     * wrapped.next();
     * // => { 'done': true, 'value': undefined }
     */
    function wrapperNext() {
      if (this.__values__ === undefined$1) {
        this.__values__ = toArray(this.value());
      }
      var done = this.__index__ >= this.__values__.length,
          value = done ? undefined$1 : this.__values__[this.__index__++];

      return { 'done': done, 'value': value };
    }

    /**
     * Enables the wrapper to be iterable.
     *
     * @name Symbol.iterator
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the wrapper object.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped[Symbol.iterator]() === wrapped;
     * // => true
     *
     * Array.from(wrapped);
     * // => [1, 2]
     */
    function wrapperToIterator() {
      return this;
    }

    /**
     * Creates a clone of the chain sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @param {*} value The value to plant.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2]).map(square);
     * var other = wrapped.plant([3, 4]);
     *
     * other.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */
    function wrapperPlant(value) {
      var result,
          parent = this;

      while (parent instanceof baseLodash) {
        var clone = wrapperClone(parent);
        clone.__index__ = 0;
        clone.__values__ = undefined$1;
        if (result) {
          previous.__wrapped__ = clone;
        } else {
          result = clone;
        }
        var previous = clone;
        parent = parent.__wrapped__;
      }
      previous.__wrapped__ = value;
      return result;
    }

    /**
     * This method is the wrapper version of `_.reverse`.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function wrapperReverse() {
      var value = this.__wrapped__;
      if (value instanceof LazyWrapper) {
        var wrapped = value;
        if (this.__actions__.length) {
          wrapped = new LazyWrapper(this);
        }
        wrapped = wrapped.reverse();
        wrapped.__actions__.push({
          'func': thru,
          'args': [reverse],
          'thisArg': undefined$1
        });
        return new LodashWrapper(wrapped, this.__chain__);
      }
      return this.thru(reverse);
    }

    /**
     * Executes the chain sequence to resolve the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @since 0.1.0
     * @alias toJSON, valueOf
     * @category Seq
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */
    function wrapperValue() {
      return baseWrapperValue(this.__wrapped__, this.__actions__);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the number of times the key was returned by `iteratee`. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': 1, '6': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */
    var countBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        ++result[key];
      } else {
        baseAssignValue(result, key, 1);
      }
    });

    /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * Iteration is stopped once `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * **Note:** This method returns `true` for
     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
     * elements of empty collections.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.every(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.every(users, 'active');
     * // => false
     */
    function every(collection, predicate, guard) {
      var func = isArray(collection) ? arrayEvery : baseEvery;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined$1;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * **Note:** Unlike `_.remove`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.reject
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, { 'age': 36, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.filter(users, 'active');
     * // => objects for ['barney']
     *
     * // Combining several predicates using `_.overEvery` or `_.overSome`.
     * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
     * // => objects for ['fred', 'barney']
     */
    function filter(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.find(users, function(o) { return o.age < 40; });
     * // => object for 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.find(users, { 'age': 1, 'active': true });
     * // => object for 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.find(users, ['active', false]);
     * // => object for 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.find(users, 'active');
     * // => object for 'barney'
     */
    var find = createFind(findIndex);

    /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=collection.length-1] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */
    var findLast = createFind(findLastIndex);

    /**
     * Creates a flattened array of values by running each element in `collection`
     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
     * with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [n, n];
     * }
     *
     * _.flatMap([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMap(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), 1);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDeep([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMapDeep(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), INFINITY);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDepth([1, 2], duplicate, 2);
     * // => [[1, 1], [2, 2]]
     */
    function flatMapDepth(collection, iteratee, depth) {
      depth = depth === undefined$1 ? 1 : toInteger(depth);
      return baseFlatten(map(collection, iteratee), depth);
    }

    /**
     * Iterates over elements of `collection` and invokes `iteratee` for each element.
     * The iteratee is invoked with three arguments: (value, index|key, collection).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length"
     * property are iterated like arrays. To avoid this behavior use `_.forIn`
     * or `_.forOwn` for object iteration.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias each
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEachRight
     * @example
     *
     * _.forEach([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `1` then `2`.
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forEach(collection, iteratee) {
      var func = isArray(collection) ? arrayEach : baseEach;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @alias eachRight
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEach
     * @example
     *
     * _.forEachRight([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `2` then `1`.
     */
    function forEachRight(collection, iteratee) {
      var func = isArray(collection) ? arrayEachRight : baseEachRight;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The order of grouped values
     * is determined by the order they occur in `collection`. The corresponding
     * value of each key is an array of elements responsible for generating the
     * key. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': [4.2], '6': [6.1, 6.3] }
     *
     * // The `_.property` iteratee shorthand.
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */
    var groupBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        result[key].push(value);
      } else {
        baseAssignValue(result, key, [value]);
      }
    });

    /**
     * Checks if `value` is in `collection`. If `collection` is a string, it's
     * checked for a substring of `value`, otherwise
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * is used for equality comparisons. If `fromIndex` is negative, it's used as
     * the offset from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'a': 1, 'b': 2 }, 1);
     * // => true
     *
     * _.includes('abcd', 'bc');
     * // => true
     */
    function includes(collection, value, fromIndex, guard) {
      collection = isArrayLike(collection) ? collection : values(collection);
      fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;

      var length = collection.length;
      if (fromIndex < 0) {
        fromIndex = nativeMax(length + fromIndex, 0);
      }
      return isString(collection)
        ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
        : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
    }

    /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `path` is a function, it's invoked
     * for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke each method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invokeMap([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */
    var invokeMap = baseRest(function(collection, path, args) {
      var index = -1,
          isFunc = typeof path == 'function',
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value) {
        result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
      });
      return result;
    });

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the last element responsible for generating the key. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var array = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.keyBy(array, function(o) {
     *   return String.fromCharCode(o.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.keyBy(array, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     */
    var keyBy = createAggregator(function(result, value, key) {
      baseAssignValue(result, key, value);
    });

    /**
     * Creates an array of values by running each element in `collection` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * _.map([4, 8], square);
     * // => [16, 64]
     *
     * _.map({ 'a': 4, 'b': 8 }, square);
     * // => [16, 64] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */
    function map(collection, iteratee) {
      var func = isArray(collection) ? arrayMap : baseMap;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.sortBy` except that it allows specifying the sort
     * orders of the iteratees to sort by. If `orders` is unspecified, all values
     * are sorted in ascending order. Otherwise, specify an order of "desc" for
     * descending or "asc" for ascending sort order of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @param {string[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // Sort by `user` in ascending order and by `age` in descending order.
     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     */
    function orderBy(collection, iteratees, orders, guard) {
      if (collection == null) {
        return [];
      }
      if (!isArray(iteratees)) {
        iteratees = iteratees == null ? [] : [iteratees];
      }
      orders = guard ? undefined$1 : orders;
      if (!isArray(orders)) {
        orders = orders == null ? [] : [orders];
      }
      return baseOrderBy(collection, iteratees, orders);
    }

    /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, the second of which
     * contains elements `predicate` returns falsey for. The predicate is
     * invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * _.partition(users, function(o) { return o.active; });
     * // => objects for [['fred'], ['barney', 'pebbles']]
     *
     * // The `_.matches` iteratee shorthand.
     * _.partition(users, { 'age': 1, 'active': false });
     * // => objects for [['pebbles'], ['barney', 'fred']]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.partition(users, ['active', false]);
     * // => objects for [['barney', 'pebbles'], ['fred']]
     *
     * // The `_.property` iteratee shorthand.
     * _.partition(users, 'active');
     * // => objects for [['fred'], ['barney', 'pebbles']]
     */
    var partition = createAggregator(function(result, value, key) {
      result[key ? 0 : 1].push(value);
    }, function() { return [[], []]; });

    /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` thru `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not given, the first element of `collection` is used as the initial
     * value. The iteratee is invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
     * and `sortBy`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduceRight
     * @example
     *
     * _.reduce([1, 2], function(sum, n) {
     *   return sum + n;
     * }, 0);
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     *   return result;
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
     */
    function reduce(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduce : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
    }

    /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduce
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */
    function reduceRight(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduceRight : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
    }

    /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.filter
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * _.reject(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.reject(users, { 'age': 40, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.reject(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.reject(users, 'active');
     * // => objects for ['barney']
     */
    function reject(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, negate(getIteratee(predicate, 3)));
    }

    /**
     * Gets a random element from `collection`.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     */
    function sample(collection) {
      var func = isArray(collection) ? arraySample : baseSample;
      return func(collection);
    }

    /**
     * Gets `n` random elements at unique keys from `collection` up to the
     * size of `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @param {number} [n=1] The number of elements to sample.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the random elements.
     * @example
     *
     * _.sampleSize([1, 2, 3], 2);
     * // => [3, 1]
     *
     * _.sampleSize([1, 2, 3], 4);
     * // => [2, 3, 1]
     */
    function sampleSize(collection, n, guard) {
      if ((guard ? isIterateeCall(collection, n, guard) : n === undefined$1)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      var func = isArray(collection) ? arraySampleSize : baseSampleSize;
      return func(collection, n);
    }

    /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */
    function shuffle(collection) {
      var func = isArray(collection) ? arrayShuffle : baseShuffle;
      return func(collection);
    }

    /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable string keyed properties for objects.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the collection size.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */
    function size(collection) {
      if (collection == null) {
        return 0;
      }
      if (isArrayLike(collection)) {
        return isString(collection) ? stringSize(collection) : collection.length;
      }
      var tag = getTag(collection);
      if (tag == mapTag || tag == setTag) {
        return collection.size;
      }
      return baseKeys(collection).length;
    }

    /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * Iteration is stopped once `predicate` returns truthy. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.some(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.some(users, 'active');
     * // => true
     */
    function some(collection, predicate, guard) {
      var func = isArray(collection) ? arraySome : baseSome;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined$1;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection thru each iteratee. This method
     * performs a stable sort, that is, it preserves the original sort order of
     * equal elements. The iteratees are invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 30 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.sortBy(users, [function(o) { return o.user; }]);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
     *
     * _.sortBy(users, ['user', 'age']);
     * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
     */
    var sortBy = baseRest(function(collection, iteratees) {
      if (collection == null) {
        return [];
      }
      var length = iteratees.length;
      if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
        iteratees = [];
      } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
        iteratees = [iteratees[0]];
      }
      return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Gets the timestamp of the number of milliseconds that have elapsed since
     * the Unix epoch (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Date
     * @returns {number} Returns the timestamp.
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => Logs the number of milliseconds it took for the deferred invocation.
     */
    var now = ctxNow || function() {
      return root.Date.now();
    };

    /*------------------------------------------------------------------------*/

    /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it's called `n` or more times.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => Logs 'done saving!' after the two async saves have completed.
     */
    function after(n, func) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n < 1) {
          return func.apply(this, arguments);
        }
      };
    }

    /**
     * Creates a function that invokes `func`, with up to `n` arguments,
     * ignoring any additional arguments.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */
    function ary(func, n, guard) {
      n = guard ? undefined$1 : n;
      n = (func && n == null) ? func.length : n;
      return createWrap(func, WRAP_ARY_FLAG, undefined$1, undefined$1, undefined$1, undefined$1, n);
    }

    /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it's called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery(element).on('click', _.before(5, addContactToList));
     * // => Allows adding up to 4 contacts to the list.
     */
    function before(n, func) {
      var result;
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n > 0) {
          result = func.apply(this, arguments);
        }
        if (n <= 1) {
          func = undefined$1;
        }
        return result;
      };
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and `partials` prepended to the arguments it receives.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * function greet(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * }
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */
    var bind = baseRest(function(func, thisArg, partials) {
      var bitmask = WRAP_BIND_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bind));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(func, bitmask, thisArg, partials, holders);
    });

    /**
     * Creates a function that invokes the method at `object[key]` with `partials`
     * prepended to the arguments it receives.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist. See
     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Function
     * @param {Object} object The object to invoke the method on.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */
    var bindKey = baseRest(function(object, key, partials) {
      var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bindKey));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(key, bitmask, object, partials, holders);
    });

    /**
     * Creates a function that accepts arguments of `func` and either invokes
     * `func` returning its result, if at least `arity` number of arguments have
     * been provided, or returns a function that accepts the remaining `func`
     * arguments, and so on. The arity of `func` may be specified if `func.length`
     * is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */
    function curry(func, arity, guard) {
      arity = guard ? undefined$1 : arity;
      var result = createWrap(func, WRAP_CURRY_FLAG, undefined$1, undefined$1, undefined$1, undefined$1, undefined$1, arity);
      result.placeholder = curry.placeholder;
      return result;
    }

    /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */
    function curryRight(func, arity, guard) {
      arity = guard ? undefined$1 : arity;
      var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined$1, undefined$1, undefined$1, undefined$1, undefined$1, arity);
      result.placeholder = curryRight.placeholder;
      return result;
    }

    /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed `func` invocations and a `flush` method to immediately invoke them.
     * Provide `options` to indicate whether `func` should be invoked on the
     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
     * with the last arguments provided to the debounced function. Subsequent
     * calls to the debounced function return the result of the last `func`
     * invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the debounced function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=false]
     *  Specify invoking on the leading edge of the timeout.
     * @param {number} [options.maxWait]
     *  The maximum time `func` is allowed to be delayed before it's invoked.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // Avoid costly calculations while the window size is in flux.
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
     * jQuery(element).on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', debounced);
     *
     * // Cancel the trailing debounced invocation.
     * jQuery(window).on('popstate', debounced.cancel);
     */
    function debounce(func, wait, options) {
      var lastArgs,
          lastThis,
          maxWait,
          result,
          timerId,
          lastCallTime,
          lastInvokeTime = 0,
          leading = false,
          maxing = false,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      wait = toNumber(wait) || 0;
      if (isObject(options)) {
        leading = !!options.leading;
        maxing = 'maxWait' in options;
        maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }

      function invokeFunc(time) {
        var args = lastArgs,
            thisArg = lastThis;

        lastArgs = lastThis = undefined$1;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
      }

      function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
      }

      function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime,
            timeWaiting = wait - timeSinceLastCall;

        return maxing
          ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
          : timeWaiting;
      }

      function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime;

        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return (lastCallTime === undefined$1 || (timeSinceLastCall >= wait) ||
          (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
      }

      function timerExpired() {
        var time = now();
        if (shouldInvoke(time)) {
          return trailingEdge(time);
        }
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
      }

      function trailingEdge(time) {
        timerId = undefined$1;

        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) {
          return invokeFunc(time);
        }
        lastArgs = lastThis = undefined$1;
        return result;
      }

      function cancel() {
        if (timerId !== undefined$1) {
          clearTimeout(timerId);
        }
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined$1;
      }

      function flush() {
        return timerId === undefined$1 ? result : trailingEdge(now());
      }

      function debounced() {
        var time = now(),
            isInvoking = shouldInvoke(time);

        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;

        if (isInvoking) {
          if (timerId === undefined$1) {
            return leadingEdge(lastCallTime);
          }
          if (maxing) {
            // Handle invocations in a tight loop.
            clearTimeout(timerId);
            timerId = setTimeout(timerExpired, wait);
            return invokeFunc(lastCallTime);
          }
        }
        if (timerId === undefined$1) {
          timerId = setTimeout(timerExpired, wait);
        }
        return result;
      }
      debounced.cancel = cancel;
      debounced.flush = flush;
      return debounced;
    }

    /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // => Logs 'deferred' after one millisecond.
     */
    var defer = baseRest(function(func, args) {
      return baseDelay(func, 1, args);
    });

    /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => Logs 'later' after one second.
     */
    var delay = baseRest(function(func, wait, args) {
      return baseDelay(func, toNumber(wait) || 0, args);
    });

    /**
     * Creates a function that invokes `func` with arguments reversed.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to flip arguments for.
     * @returns {Function} Returns the new flipped function.
     * @example
     *
     * var flipped = _.flip(function() {
     *   return _.toArray(arguments);
     * });
     *
     * flipped('a', 'b', 'c', 'd');
     * // => ['d', 'c', 'b', 'a']
     */
    function flip(func) {
      return createWrap(func, WRAP_FLIP_FLAG);
    }

    /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided, it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the
     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoized function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */
    function memoize(func, resolver) {
      if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var memoized = function() {
        var args = arguments,
            key = resolver ? resolver.apply(this, args) : args[0],
            cache = memoized.cache;

        if (cache.has(key)) {
          return cache.get(key);
        }
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
      };
      memoized.cache = new (memoize.Cache || MapCache);
      return memoized;
    }

    // Expose `MapCache`.
    memoize.Cache = MapCache;

    /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new negated function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */
    function negate(predicate) {
      if (typeof predicate != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return function() {
        var args = arguments;
        switch (args.length) {
          case 0: return !predicate.call(this);
          case 1: return !predicate.call(this, args[0]);
          case 2: return !predicate.call(this, args[0], args[1]);
          case 3: return !predicate.call(this, args[0], args[1], args[2]);
        }
        return !predicate.apply(this, args);
      };
    }

    /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first invocation. The `func` is
     * invoked with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // => `createApplication` is invoked once
     */
    function once(func) {
      return before(2, func);
    }

    /**
     * Creates a function that invokes `func` with its arguments transformed.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms=[_.identity]]
     *  The argument transforms.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var func = _.overArgs(function(x, y) {
     *   return [x, y];
     * }, [square, doubled]);
     *
     * func(9, 3);
     * // => [81, 6]
     *
     * func(10, 5);
     * // => [100, 10]
     */
    var overArgs = castRest(function(func, transforms) {
      transforms = (transforms.length == 1 && isArray(transforms[0]))
        ? arrayMap(transforms[0], baseUnary(getIteratee()))
        : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));

      var funcsLength = transforms.length;
      return baseRest(function(args) {
        var index = -1,
            length = nativeMin(args.length, funcsLength);

        while (++index < length) {
          args[index] = transforms[index].call(this, args[index]);
        }
        return apply(func, this, args);
      });
    });

    /**
     * Creates a function that invokes `func` with `partials` prepended to the
     * arguments it receives. This method is like `_.bind` except it does **not**
     * alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 0.2.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // Partially applied with placeholders.
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */
    var partial = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partial));
      return createWrap(func, WRAP_PARTIAL_FLAG, undefined$1, partials, holders);
    });

    /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to the arguments it receives.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // Partially applied with placeholders.
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */
    var partialRight = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partialRight));
      return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined$1, partials, holders);
    });

    /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified `indexes` where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, [2, 0, 1]);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     */
    var rearg = flatRest(function(func, indexes) {
      return createWrap(func, WRAP_REARG_FLAG, undefined$1, undefined$1, undefined$1, indexes);
    });

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as
     * an array.
     *
     * **Note:** This method is based on the
     * [rest parameter](https://mdn.io/rest_parameters).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.rest(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */
    function rest(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start === undefined$1 ? start : toInteger(start);
      return baseRest(func, start);
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * create function and an array of arguments much like
     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
     *
     * **Note:** This method is based on the
     * [spread operator](https://mdn.io/spread_operator).
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @param {number} [start=0] The start position of the spread.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */
    function spread(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start == null ? 0 : nativeMax(toInteger(start), 0);
      return baseRest(function(args) {
        var array = args[start],
            otherArgs = castSlice(args, 0, start);

        if (array) {
          arrayPush(otherArgs, array);
        }
        return apply(func, this, otherArgs);
      });
    }

    /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed `func` invocations and a `flush` method to
     * immediately invoke them. Provide `options` to indicate whether `func`
     * should be invoked on the leading and/or trailing edge of the `wait`
     * timeout. The `func` is invoked with the last arguments provided to the
     * throttled function. Subsequent calls to the throttled function return the
     * result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the throttled function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=true]
     *  Specify invoking on the leading edge of the timeout.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // Avoid excessively updating the position while scrolling.
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
     * jQuery(element).on('click', throttled);
     *
     * // Cancel the trailing throttled invocation.
     * jQuery(window).on('popstate', throttled.cancel);
     */
    function throttle(func, wait, options) {
      var leading = true,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      if (isObject(options)) {
        leading = 'leading' in options ? !!options.leading : leading;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }
      return debounce(func, wait, {
        'leading': leading,
        'maxWait': wait,
        'trailing': trailing
      });
    }

    /**
     * Creates a function that accepts up to one argument, ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.unary(parseInt));
     * // => [6, 8, 10]
     */
    function unary(func) {
      return ary(func, 1);
    }

    /**
     * Creates a function that provides `value` to `wrapper` as its first
     * argument. Any additional arguments provided to the function are appended
     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
     * binding of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} [wrapper=identity] The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */
    function wrap(value, wrapper) {
      return partial(castFunction(wrapper), value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Casts `value` as an array if it's not one.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Lang
     * @param {*} value The value to inspect.
     * @returns {Array} Returns the cast array.
     * @example
     *
     * _.castArray(1);
     * // => [1]
     *
     * _.castArray({ 'a': 1 });
     * // => [{ 'a': 1 }]
     *
     * _.castArray('abc');
     * // => ['abc']
     *
     * _.castArray(null);
     * // => [null]
     *
     * _.castArray(undefined);
     * // => [undefined]
     *
     * _.castArray();
     * // => []
     *
     * var array = [1, 2, 3];
     * console.log(_.castArray(array) === array);
     * // => true
     */
    function castArray() {
      if (!arguments.length) {
        return [];
      }
      var value = arguments[0];
      return isArray(value) ? value : [value];
    }

    /**
     * Creates a shallow clone of `value`.
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
     * and supports cloning arrays, array buffers, booleans, date objects, maps,
     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
     * arrays. The own enumerable properties of `arguments` objects are cloned
     * as plain objects. An empty object is returned for uncloneable values such
     * as error objects, functions, DOM nodes, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to clone.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeep
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var shallow = _.clone(objects);
     * console.log(shallow[0] === objects[0]);
     * // => true
     */
    function clone(value) {
      return baseClone(value, CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.clone` except that it accepts `customizer` which
     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
     * cloning is handled by the method instead. The `customizer` is invoked with
     * up to four arguments; (value [, index|key, object, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeepWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * }
     *
     * var el = _.cloneWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 0
     */
    function cloneWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined$1;
      return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * This method is like `_.clone` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @returns {*} Returns the deep cloned value.
     * @see _.clone
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var deep = _.cloneDeep(objects);
     * console.log(deep[0] === objects[0]);
     * // => false
     */
    function cloneDeep(value) {
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.cloneWith` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the deep cloned value.
     * @see _.cloneWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * }
     *
     * var el = _.cloneDeepWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 20
     */
    function cloneDeepWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined$1;
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * Checks if `object` conforms to `source` by invoking the predicate
     * properties of `source` with the corresponding property values of `object`.
     *
     * **Note:** This method is equivalent to `_.conforms` when `source` is
     * partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
     * // => true
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
     * // => false
     */
    function conformsTo(object, source) {
      return source == null || baseConformsTo(object, source, keys(source));
    }

    /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */
    function eq(value, other) {
      return value === other || (value !== value && other !== other);
    }

    /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     * @see _.lt
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */
    var gt = createRelationalOperation(baseGt);

    /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to
     *  `other`, else `false`.
     * @see _.lte
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */
    var gte = createRelationalOperation(function(value, other) {
      return value >= other;
    });

    /**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */
    var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
      return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
        !propertyIsEnumerable.call(value, 'callee');
    };

    /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */
    var isArray = Array.isArray;

    /**
     * Checks if `value` is classified as an `ArrayBuffer` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     * @example
     *
     * _.isArrayBuffer(new ArrayBuffer(2));
     * // => true
     *
     * _.isArrayBuffer(new Array(2));
     * // => false
     */
    var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;

    /**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */
    function isArrayLike(value) {
      return value != null && isLength(value.length) && !isFunction(value);
    }

    /**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */
    function isArrayLikeObject(value) {
      return isObjectLike(value) && isArrayLike(value);
    }

    /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */
    function isBoolean(value) {
      return value === true || value === false ||
        (isObjectLike(value) && baseGetTag(value) == boolTag);
    }

    /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */
    var isBuffer = nativeIsBuffer || stubFalse;

    /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */
    var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;

    /**
     * Checks if `value` is likely a DOM element.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */
    function isElement(value) {
      return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
    }

    /**
     * Checks if `value` is an empty object, collection, map, or set.
     *
     * Objects are considered empty if they have no own enumerable string keyed
     * properties.
     *
     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
     * jQuery-like collections are considered empty if they have a `length` of `0`.
     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */
    function isEmpty(value) {
      if (value == null) {
        return true;
      }
      if (isArrayLike(value) &&
          (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
            isBuffer(value) || isTypedArray(value) || isArguments(value))) {
        return !value.length;
      }
      var tag = getTag(value);
      if (tag == mapTag || tag == setTag) {
        return !value.size;
      }
      if (isPrototype(value)) {
        return !baseKeys(value).length;
      }
      for (var key in value) {
        if (hasOwnProperty.call(value, key)) {
          return false;
        }
      }
      return true;
    }

    /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent.
     *
     * **Note:** This method supports comparing arrays, array buffers, booleans,
     * date objects, error objects, maps, numbers, `Object` objects, regexes,
     * sets, strings, symbols, and typed arrays. `Object` objects are compared
     * by their own, not inherited, enumerable properties. Functions and DOM
     * nodes are compared by strict equality, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.isEqual(object, other);
     * // => true
     *
     * object === other;
     * // => false
     */
    function isEqual(value, other) {
      return baseIsEqual(value, other);
    }

    /**
     * This method is like `_.isEqual` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with up to
     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, othValue) {
     *   if (isGreeting(objValue) && isGreeting(othValue)) {
     *     return true;
     *   }
     * }
     *
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqualWith(array, other, customizer);
     * // => true
     */
    function isEqualWith(value, other, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined$1;
      var result = customizer ? customizer(value, other) : undefined$1;
      return result === undefined$1 ? baseIsEqual(value, other, undefined$1, customizer) : !!result;
    }

    /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */
    function isError(value) {
      if (!isObjectLike(value)) {
        return false;
      }
      var tag = baseGetTag(value);
      return tag == errorTag || tag == domExcTag ||
        (typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value));
    }

    /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on
     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(3);
     * // => true
     *
     * _.isFinite(Number.MIN_VALUE);
     * // => true
     *
     * _.isFinite(Infinity);
     * // => false
     *
     * _.isFinite('3');
     * // => false
     */
    function isFinite(value) {
      return typeof value == 'number' && nativeIsFinite(value);
    }

    /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */
    function isFunction(value) {
      if (!isObject(value)) {
        return false;
      }
      // The use of `Object#toString` avoids issues with the `typeof` operator
      // in Safari 9 which returns 'object' for typed arrays and other constructors.
      var tag = baseGetTag(value);
      return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
    }

    /**
     * Checks if `value` is an integer.
     *
     * **Note:** This method is based on
     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
     * @example
     *
     * _.isInteger(3);
     * // => true
     *
     * _.isInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isInteger(Infinity);
     * // => false
     *
     * _.isInteger('3');
     * // => false
     */
    function isInteger(value) {
      return typeof value == 'number' && value == toInteger(value);
    }

    /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */
    function isLength(value) {
      return typeof value == 'number' &&
        value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */
    function isObject(value) {
      var type = typeof value;
      return value != null && (type == 'object' || type == 'function');
    }

    /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */
    function isObjectLike(value) {
      return value != null && typeof value == 'object';
    }

    /**
     * Checks if `value` is classified as a `Map` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     * @example
     *
     * _.isMap(new Map);
     * // => true
     *
     * _.isMap(new WeakMap);
     * // => false
     */
    var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;

    /**
     * Performs a partial deep comparison between `object` and `source` to
     * determine if `object` contains equivalent property values.
     *
     * **Note:** This method is equivalent to `_.matches` when `source` is
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.isMatch(object, { 'b': 2 });
     * // => true
     *
     * _.isMatch(object, { 'b': 1 });
     * // => false
     */
    function isMatch(object, source) {
      return object === source || baseIsMatch(object, source, getMatchData(source));
    }

    /**
     * This method is like `_.isMatch` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with five
     * arguments: (objValue, srcValue, index|key, object, source).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, srcValue) {
     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
     *     return true;
     *   }
     * }
     *
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatchWith(object, source, customizer);
     * // => true
     */
    function isMatchWith(object, source, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined$1;
      return baseIsMatch(object, source, getMatchData(source), customizer);
    }

    /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is based on
     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
     * `undefined` and other non-number values.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */
    function isNaN(value) {
      // An `NaN` primitive is the only value that is not equal to itself.
      // Perform the `toStringTag` check first to avoid errors with some
      // ActiveX objects in IE.
      return isNumber(value) && value != +value;
    }

    /**
     * Checks if `value` is a pristine native function.
     *
     * **Note:** This method can't reliably detect native functions in the presence
     * of the core-js package because core-js circumvents this kind of detection.
     * Despite multiple requests, the core-js maintainer has made it clear: any
     * attempt to fix the detection will be obstructed. As a result, we're left
     * with little choice but to throw an error. Unfortunately, this also affects
     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
     * which rely on core-js.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */
    function isNative(value) {
      if (isMaskable(value)) {
        throw new Error(CORE_ERROR_TEXT);
      }
      return baseIsNative(value);
    }

    /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */
    function isNull(value) {
      return value === null;
    }

    /**
     * Checks if `value` is `null` or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
     * @example
     *
     * _.isNil(null);
     * // => true
     *
     * _.isNil(void 0);
     * // => true
     *
     * _.isNil(NaN);
     * // => false
     */
    function isNil(value) {
      return value == null;
    }

    /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
     * classified as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
     * @example
     *
     * _.isNumber(3);
     * // => true
     *
     * _.isNumber(Number.MIN_VALUE);
     * // => true
     *
     * _.isNumber(Infinity);
     * // => true
     *
     * _.isNumber('3');
     * // => false
     */
    function isNumber(value) {
      return typeof value == 'number' ||
        (isObjectLike(value) && baseGetTag(value) == numberTag);
    }

    /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * @static
     * @memberOf _
     * @since 0.8.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */
    function isPlainObject(value) {
      if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
        return false;
      }
      var proto = getPrototype(value);
      if (proto === null) {
        return true;
      }
      var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
      return typeof Ctor == 'function' && Ctor instanceof Ctor &&
        funcToString.call(Ctor) == objectCtorString;
    }

    /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */
    var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;

    /**
     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
     * double precision number which isn't the result of a rounded unsafe integer.
     *
     * **Note:** This method is based on
     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
     * @example
     *
     * _.isSafeInteger(3);
     * // => true
     *
     * _.isSafeInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isSafeInteger(Infinity);
     * // => false
     *
     * _.isSafeInteger('3');
     * // => false
     */
    function isSafeInteger(value) {
      return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is classified as a `Set` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     * @example
     *
     * _.isSet(new Set);
     * // => true
     *
     * _.isSet(new WeakSet);
     * // => false
     */
    var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;

    /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */
    function isString(value) {
      return typeof value == 'string' ||
        (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
    }

    /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */
    function isSymbol(value) {
      return typeof value == 'symbol' ||
        (isObjectLike(value) && baseGetTag(value) == symbolTag);
    }

    /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */
    var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

    /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */
    function isUndefined(value) {
      return value === undefined$1;
    }

    /**
     * Checks if `value` is classified as a `WeakMap` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
     * @example
     *
     * _.isWeakMap(new WeakMap);
     * // => true
     *
     * _.isWeakMap(new Map);
     * // => false
     */
    function isWeakMap(value) {
      return isObjectLike(value) && getTag(value) == weakMapTag;
    }

    /**
     * Checks if `value` is classified as a `WeakSet` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
     * @example
     *
     * _.isWeakSet(new WeakSet);
     * // => true
     *
     * _.isWeakSet(new Set);
     * // => false
     */
    function isWeakSet(value) {
      return isObjectLike(value) && baseGetTag(value) == weakSetTag;
    }

    /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     * @see _.gt
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */
    var lt = createRelationalOperation(baseLt);

    /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to
     *  `other`, else `false`.
     * @see _.gte
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */
    var lte = createRelationalOperation(function(value, other) {
      return value <= other;
    });

    /**
     * Converts `value` to an array.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * _.toArray({ 'a': 1, 'b': 2 });
     * // => [1, 2]
     *
     * _.toArray('abc');
     * // => ['a', 'b', 'c']
     *
     * _.toArray(1);
     * // => []
     *
     * _.toArray(null);
     * // => []
     */
    function toArray(value) {
      if (!value) {
        return [];
      }
      if (isArrayLike(value)) {
        return isString(value) ? stringToArray(value) : copyArray(value);
      }
      if (symIterator && value[symIterator]) {
        return iteratorToArray(value[symIterator]());
      }
      var tag = getTag(value),
          func = tag == mapTag ? mapToArray : (tag == setTag ? setToArray : values);

      return func(value);
    }

    /**
     * Converts `value` to a finite number.
     *
     * @static
     * @memberOf _
     * @since 4.12.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted number.
     * @example
     *
     * _.toFinite(3.2);
     * // => 3.2
     *
     * _.toFinite(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toFinite(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toFinite('3.2');
     * // => 3.2
     */
    function toFinite(value) {
      if (!value) {
        return value === 0 ? value : 0;
      }
      value = toNumber(value);
      if (value === INFINITY || value === -INFINITY) {
        var sign = (value < 0 ? -1 : 1);
        return sign * MAX_INTEGER;
      }
      return value === value ? value : 0;
    }

    /**
     * Converts `value` to an integer.
     *
     * **Note:** This method is loosely based on
     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toInteger(3.2);
     * // => 3
     *
     * _.toInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toInteger(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toInteger('3.2');
     * // => 3
     */
    function toInteger(value) {
      var result = toFinite(value),
          remainder = result % 1;

      return result === result ? (remainder ? result - remainder : result) : 0;
    }

    /**
     * Converts `value` to an integer suitable for use as the length of an
     * array-like object.
     *
     * **Note:** This method is based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toLength(3.2);
     * // => 3
     *
     * _.toLength(Number.MIN_VALUE);
     * // => 0
     *
     * _.toLength(Infinity);
     * // => 4294967295
     *
     * _.toLength('3.2');
     * // => 3
     */
    function toLength(value) {
      return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
    }

    /**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */
    function toNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      if (isObject(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = isObject(other) ? (other + '') : other;
      }
      if (typeof value != 'string') {
        return value === 0 ? value : +value;
      }
      value = baseTrim(value);
      var isBinary = reIsBinary.test(value);
      return (isBinary || reIsOctal.test(value))
        ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
        : (reIsBadHex.test(value) ? NAN : +value);
    }

    /**
     * Converts `value` to a plain object flattening inherited enumerable string
     * keyed properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */
    function toPlainObject(value) {
      return copyObject(value, keysIn(value));
    }

    /**
     * Converts `value` to a safe integer. A safe integer can be compared and
     * represented correctly.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toSafeInteger(3.2);
     * // => 3
     *
     * _.toSafeInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toSafeInteger(Infinity);
     * // => 9007199254740991
     *
     * _.toSafeInteger('3.2');
     * // => 3
     */
    function toSafeInteger(value) {
      return value
        ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER)
        : (value === 0 ? value : 0);
    }

    /**
     * Converts `value` to a string. An empty string is returned for `null`
     * and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */
    function toString(value) {
      return value == null ? '' : baseToString(value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Assigns own enumerable string keyed properties of source objects to the
     * destination object. Source objects are applied from left to right.
     * Subsequent sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object` and is loosely based on
     * [`Object.assign`](https://mdn.io/Object/assign).
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assignIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assign({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'c': 3 }
     */
    var assign = createAssigner(function(object, source) {
      if (isPrototype(source) || isArrayLike(source)) {
        copyObject(source, keys(source), object);
        return;
      }
      for (var key in source) {
        if (hasOwnProperty.call(source, key)) {
          assignValue(object, key, source[key]);
        }
      }
    });

    /**
     * This method is like `_.assign` except that it iterates over own and
     * inherited source properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assign
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
     */
    var assignIn = createAssigner(function(object, source) {
      copyObject(source, keysIn(source), object);
    });

    /**
     * This method is like `_.assignIn` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extendWith
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignInWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keysIn(source), object, customizer);
    });

    /**
     * This method is like `_.assign` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignInWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keys(source), object, customizer);
    });

    /**
     * Creates an array of values corresponding to `paths` of `object`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Array} Returns the picked values.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _.at(object, ['a[0].b.c', 'a[1]']);
     * // => [3, 4]
     */
    var at = flatRest(baseAt);

    /**
     * Creates an object that inherits from the `prototype` object. If a
     * `properties` object is given, its own enumerable string keyed properties
     * are assigned to the created object.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */
    function create(prototype, properties) {
      var result = baseCreate(prototype);
      return properties == null ? result : baseAssign(result, properties);
    }

    /**
     * Assigns own and inherited enumerable string keyed properties of source
     * objects to the destination object for all destination properties that
     * resolve to `undefined`. Source objects are applied from left to right.
     * Once a property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaultsDeep
     * @example
     *
     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var defaults = baseRest(function(object, sources) {
      object = Object(object);

      var index = -1;
      var length = sources.length;
      var guard = length > 2 ? sources[2] : undefined$1;

      if (guard && isIterateeCall(sources[0], sources[1], guard)) {
        length = 1;
      }

      while (++index < length) {
        var source = sources[index];
        var props = keysIn(source);
        var propsIndex = -1;
        var propsLength = props.length;

        while (++propsIndex < propsLength) {
          var key = props[propsIndex];
          var value = object[key];

          if (value === undefined$1 ||
              (eq(value, objectProto[key]) && !hasOwnProperty.call(object, key))) {
            object[key] = source[key];
          }
        }
      }

      return object;
    });

    /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaults
     * @example
     *
     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
     * // => { 'a': { 'b': 2, 'c': 3 } }
     */
    var defaultsDeep = baseRest(function(args) {
      args.push(undefined$1, customDefaultsMerge);
      return apply(mergeWith, undefined$1, args);
    });

    /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(o) { return o.age < 40; });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // The `_.matches` iteratee shorthand.
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findKey(users, 'active');
     * // => 'barney'
     */
    function findKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
    }

    /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(o) { return o.age < 40; });
     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */
    function findLastKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
    }

    /**
     * Iterates over own and inherited enumerable string keyed properties of an
     * object and invokes `iteratee` for each property. The iteratee is invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forInRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
     */
    function forIn(object, iteratee) {
      return object == null
        ? object
        : baseFor(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
     */
    function forInRight(object, iteratee) {
      return object == null
        ? object
        : baseForRight(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * Iterates over own enumerable string keyed properties of an object and
     * invokes `iteratee` for each property. The iteratee is invoked with three
     * arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwnRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forOwn(object, iteratee) {
      return object && baseForOwn(object, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
     */
    function forOwnRight(object, iteratee) {
      return object && baseForOwnRight(object, getIteratee(iteratee, 3));
    }

    /**
     * Creates an array of function property names from own enumerable properties
     * of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functionsIn
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functions(new Foo);
     * // => ['a', 'b']
     */
    function functions(object) {
      return object == null ? [] : baseFunctions(object, keys(object));
    }

    /**
     * Creates an array of function property names from own and inherited
     * enumerable properties of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functions
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functionsIn(new Foo);
     * // => ['a', 'b', 'c']
     */
    function functionsIn(object) {
      return object == null ? [] : baseFunctions(object, keysIn(object));
    }

    /**
     * Gets the value at `path` of `object`. If the resolved value is
     * `undefined`, the `defaultValue` is returned in its place.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */
    function get(object, path, defaultValue) {
      var result = object == null ? undefined$1 : baseGet(object, path);
      return result === undefined$1 ? defaultValue : result;
    }

    /**
     * Checks if `path` is a direct property of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': 2 } };
     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b');
     * // => true
     *
     * _.has(object, ['a', 'b']);
     * // => true
     *
     * _.has(other, 'a');
     * // => false
     */
    function has(object, path) {
      return object != null && hasPath(object, path, baseHas);
    }

    /**
     * Checks if `path` is a direct or inherited property of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.hasIn(object, 'a');
     * // => true
     *
     * _.hasIn(object, 'a.b');
     * // => true
     *
     * _.hasIn(object, ['a', 'b']);
     * // => true
     *
     * _.hasIn(object, 'b');
     * // => false
     */
    function hasIn(object, path) {
      return object != null && hasPath(object, path, baseHasIn);
    }

    /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite
     * property assignments of previous values.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Object
     * @param {Object} object The object to invert.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     */
    var invert = createInverter(function(result, value, key) {
      if (value != null &&
          typeof value.toString != 'function') {
        value = nativeObjectToString.call(value);
      }

      result[value] = key;
    }, constant(identity));

    /**
     * This method is like `_.invert` except that the inverted object is generated
     * from the results of running each element of `object` thru `iteratee`. The
     * corresponding inverted value of each inverted key is an array of keys
     * responsible for generating the inverted value. The iteratee is invoked
     * with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Object
     * @param {Object} object The object to invert.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invertBy(object);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     *
     * _.invertBy(object, function(value) {
     *   return 'group' + value;
     * });
     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
     */
    var invertBy = createInverter(function(result, value, key) {
      if (value != null &&
          typeof value.toString != 'function') {
        value = nativeObjectToString.call(value);
      }

      if (hasOwnProperty.call(result, value)) {
        result[value].push(key);
      } else {
        result[value] = [key];
      }
    }, getIteratee);

    /**
     * Invokes the method at `path` of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
     *
     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
     * // => [2, 3]
     */
    var invoke = baseRest(baseInvoke);

    /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */
    function keys(object) {
      return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
    }

    /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */
    function keysIn(object) {
      return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
    }

    /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
     * with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapValues
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */
    function mapKeys(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, iteratee(value, key, object), value);
      });
      return result;
    }

    /**
     * Creates an object with the same keys as `object` and values generated
     * by running each own enumerable string keyed property of `object` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapKeys
     * @example
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * _.mapValues(users, function(o) { return o.age; });
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     *
     * // The `_.property` iteratee shorthand.
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */
    function mapValues(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, key, iteratee(value, key, object));
      });
      return result;
    }

    /**
     * This method is like `_.assign` except that it recursively merges own and
     * inherited enumerable string keyed properties of source objects into the
     * destination object. Source properties that resolve to `undefined` are
     * skipped if a destination value exists. Array and plain object properties
     * are merged recursively. Other objects and value types are overridden by
     * assignment. Source objects are applied from left to right. Subsequent
     * sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {
     *   'a': [{ 'b': 2 }, { 'd': 4 }]
     * };
     *
     * var other = {
     *   'a': [{ 'c': 3 }, { 'e': 5 }]
     * };
     *
     * _.merge(object, other);
     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
     */
    var merge = createAssigner(function(object, source, srcIndex) {
      baseMerge(object, source, srcIndex);
    });

    /**
     * This method is like `_.merge` except that it accepts `customizer` which
     * is invoked to produce the merged values of the destination and source
     * properties. If `customizer` returns `undefined`, merging is handled by the
     * method instead. The `customizer` is invoked with six arguments:
     * (objValue, srcValue, key, object, source, stack).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   if (_.isArray(objValue)) {
     *     return objValue.concat(srcValue);
     *   }
     * }
     *
     * var object = { 'a': [1], 'b': [2] };
     * var other = { 'a': [3], 'b': [4] };
     *
     * _.mergeWith(object, other, customizer);
     * // => { 'a': [1, 3], 'b': [2, 4] }
     */
    var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
      baseMerge(object, source, srcIndex, customizer);
    });

    /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable property paths of `object` that are not omitted.
     *
     * **Note:** This method is considerably slower than `_.pick`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to omit.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omit(object, ['a', 'c']);
     * // => { 'b': '2' }
     */
    var omit = flatRest(function(object, paths) {
      var result = {};
      if (object == null) {
        return result;
      }
      var isDeep = false;
      paths = arrayMap(paths, function(path) {
        path = castPath(path, object);
        isDeep || (isDeep = path.length > 1);
        return path;
      });
      copyObject(object, getAllKeysIn(object), result);
      if (isDeep) {
        result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
      }
      var length = paths.length;
      while (length--) {
        baseUnset(result, paths[length]);
      }
      return result;
    });

    /**
     * The opposite of `_.pickBy`; this method creates an object composed of
     * the own and inherited enumerable string keyed properties of `object` that
     * `predicate` doesn't return truthy for. The predicate is invoked with two
     * arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omitBy(object, _.isNumber);
     * // => { 'b': '2' }
     */
    function omitBy(object, predicate) {
      return pickBy(object, negate(getIteratee(predicate)));
    }

    /**
     * Creates an object composed of the picked `object` properties.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pick(object, ['a', 'c']);
     * // => { 'a': 1, 'c': 3 }
     */
    var pick = flatRest(function(object, paths) {
      return object == null ? {} : basePick(object, paths);
    });

    /**
     * Creates an object composed of the `object` properties `predicate` returns
     * truthy for. The predicate is invoked with two arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pickBy(object, _.isNumber);
     * // => { 'a': 1, 'c': 3 }
     */
    function pickBy(object, predicate) {
      if (object == null) {
        return {};
      }
      var props = arrayMap(getAllKeysIn(object), function(prop) {
        return [prop];
      });
      predicate = getIteratee(predicate);
      return basePickBy(object, props, function(value, path) {
        return predicate(value, path[0]);
      });
    }

    /**
     * This method is like `_.get` except that if the resolved value is a
     * function it's invoked with the `this` binding of its parent object and
     * its result is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a[0].b.c3', 'default');
     * // => 'default'
     *
     * _.result(object, 'a[0].b.c3', _.constant('default'));
     * // => 'default'
     */
    function result(object, path, defaultValue) {
      path = castPath(path, object);

      var index = -1,
          length = path.length;

      // Ensure the loop is entered when path is empty.
      if (!length) {
        length = 1;
        object = undefined$1;
      }
      while (++index < length) {
        var value = object == null ? undefined$1 : object[toKey(path[index])];
        if (value === undefined$1) {
          index = length;
          value = defaultValue;
        }
        object = isFunction(value) ? value.call(object) : value;
      }
      return object;
    }

    /**
     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
     * it's created. Arrays are created for missing index properties while objects
     * are created for all other missing properties. Use `_.setWith` to customize
     * `path` creation.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, ['x', '0', 'y', 'z'], 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */
    function set(object, path, value) {
      return object == null ? object : baseSet(object, path, value);
    }

    /**
     * This method is like `_.set` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.setWith(object, '[0][1]', 'a', Object);
     * // => { '0': { '1': 'a' } }
     */
    function setWith(object, path, value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined$1;
      return object == null ? object : baseSet(object, path, value, customizer);
    }

    /**
     * Creates an array of own enumerable string keyed-value pairs for `object`
     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
     * entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entries
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairs(new Foo);
     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
     */
    var toPairs = createToPairs(keys);

    /**
     * Creates an array of own and inherited enumerable string keyed-value pairs
     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
     * or set, its entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entriesIn
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairsIn(new Foo);
     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
     */
    var toPairsIn = createToPairs(keysIn);

    /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own
     * enumerable string keyed properties thru `iteratee`, with each invocation
     * potentially mutating the `accumulator` object. If `accumulator` is not
     * provided, a new object with the same `[[Prototype]]` will be used. The
     * iteratee is invoked with four arguments: (accumulator, value, key, object).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * }, []);
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */
    function transform(object, iteratee, accumulator) {
      var isArr = isArray(object),
          isArrLike = isArr || isBuffer(object) || isTypedArray(object);

      iteratee = getIteratee(iteratee, 4);
      if (accumulator == null) {
        var Ctor = object && object.constructor;
        if (isArrLike) {
          accumulator = isArr ? new Ctor : [];
        }
        else if (isObject(object)) {
          accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
        }
        else {
          accumulator = {};
        }
      }
      (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
        return iteratee(accumulator, value, index, object);
      });
      return accumulator;
    }

    /**
     * Removes the property at `path` of `object`.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
     * _.unset(object, 'a[0].b.c');
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     *
     * _.unset(object, ['a', '0', 'b', 'c']);
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     */
    function unset(object, path) {
      return object == null ? true : baseUnset(object, path);
    }

    /**
     * This method is like `_.set` except that accepts `updater` to produce the
     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
     * is invoked with one argument: (value).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
     * console.log(object.a[0].b.c);
     * // => 9
     *
     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
     * console.log(object.x[0].y.z);
     * // => 0
     */
    function update(object, path, updater) {
      return object == null ? object : baseUpdate(object, path, castFunction(updater));
    }

    /**
     * This method is like `_.update` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
     * // => { '0': { '1': 'a' } }
     */
    function updateWith(object, path, updater, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined$1;
      return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
    }

    /**
     * Creates an array of the own enumerable string keyed property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */
    function values(object) {
      return object == null ? [] : baseValues(object, keys(object));
    }

    /**
     * Creates an array of the own and inherited enumerable string keyed property
     * values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */
    function valuesIn(object) {
      return object == null ? [] : baseValues(object, keysIn(object));
    }

    /*------------------------------------------------------------------------*/

    /**
     * Clamps `number` within the inclusive `lower` and `upper` bounds.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Number
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     * @example
     *
     * _.clamp(-10, -5, 5);
     * // => -5
     *
     * _.clamp(10, -5, 5);
     * // => 5
     */
    function clamp(number, lower, upper) {
      if (upper === undefined$1) {
        upper = lower;
        lower = undefined$1;
      }
      if (upper !== undefined$1) {
        upper = toNumber(upper);
        upper = upper === upper ? upper : 0;
      }
      if (lower !== undefined$1) {
        lower = toNumber(lower);
        lower = lower === lower ? lower : 0;
      }
      return baseClamp(toNumber(number), lower, upper);
    }

    /**
     * Checks if `n` is between `start` and up to, but not including, `end`. If
     * `end` is not specified, it's set to `start` with `start` then set to `0`.
     * If `start` is greater than `end` the params are swapped to support
     * negative ranges.
     *
     * @static
     * @memberOf _
     * @since 3.3.0
     * @category Number
     * @param {number} number The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     * @see _.range, _.rangeRight
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     *
     * _.inRange(-3, -2, -6);
     * // => true
     */
    function inRange(number, start, end) {
      start = toFinite(start);
      if (end === undefined$1) {
        end = start;
        start = 0;
      } else {
        end = toFinite(end);
      }
      number = toNumber(number);
      return baseInRange(number, start, end);
    }

    /**
     * Produces a random number between the inclusive `lower` and `upper` bounds.
     * If only one argument is provided a number between `0` and the given number
     * is returned. If `floating` is `true`, or either `lower` or `upper` are
     * floats, a floating-point number is returned instead of an integer.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Number
     * @param {number} [lower=0] The lower bound.
     * @param {number} [upper=1] The upper bound.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */
    function random(lower, upper, floating) {
      if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) {
        upper = floating = undefined$1;
      }
      if (floating === undefined$1) {
        if (typeof upper == 'boolean') {
          floating = upper;
          upper = undefined$1;
        }
        else if (typeof lower == 'boolean') {
          floating = lower;
          lower = undefined$1;
        }
      }
      if (lower === undefined$1 && upper === undefined$1) {
        lower = 0;
        upper = 1;
      }
      else {
        lower = toFinite(lower);
        if (upper === undefined$1) {
          upper = lower;
          lower = 0;
        } else {
          upper = toFinite(upper);
        }
      }
      if (lower > upper) {
        var temp = lower;
        lower = upper;
        upper = temp;
      }
      if (floating || lower % 1 || upper % 1) {
        var rand = nativeRandom();
        return nativeMin(lower + (rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1)))), upper);
      }
      return baseRandom(lower, upper);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar--');
     * // => 'fooBar'
     *
     * _.camelCase('__FOO_BAR__');
     * // => 'fooBar'
     */
    var camelCase = createCompounder(function(result, word, index) {
      word = word.toLowerCase();
      return result + (index ? capitalize(word) : word);
    });

    /**
     * Converts the first character of `string` to upper case and the remaining
     * to lower case.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('FRED');
     * // => 'Fred'
     */
    function capitalize(string) {
      return upperFirst(toString(string).toLowerCase());
    }

    /**
     * Deburrs `string` by converting
     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
     * letters to basic Latin letters and removing
     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */
    function deburr(string) {
      string = toString(string);
      return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
    }

    /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search up to.
     * @returns {boolean} Returns `true` if `string` ends with `target`,
     *  else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */
    function endsWith(string, target, position) {
      string = toString(string);
      target = baseToString(target);

      var length = string.length;
      position = position === undefined$1
        ? length
        : baseClamp(toInteger(position), 0, length);

      var end = position;
      position -= target.length;
      return position >= 0 && string.slice(position, end) == target;
    }

    /**
     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
     * corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional
     * characters use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value. See
     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * When working with HTML you should always
     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
     * XSS vectors.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */
    function escape(string) {
      string = toString(string);
      return (string && reHasUnescapedHtml.test(string))
        ? string.replace(reUnescapedHtml, escapeHtmlChar)
        : string;
    }

    /**
     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https://lodash\.com/\)'
     */
    function escapeRegExp(string) {
      string = toString(string);
      return (string && reHasRegExpChar.test(string))
        ? string.replace(reRegExpChar, '\\$&')
        : string;
    }

    /**
     * Converts `string` to
     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__FOO_BAR__');
     * // => 'foo-bar'
     */
    var kebabCase = createCompounder(function(result, word, index) {
      return result + (index ? '-' : '') + word.toLowerCase();
    });

    /**
     * Converts `string`, as space separated words, to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.lowerCase('--Foo-Bar--');
     * // => 'foo bar'
     *
     * _.lowerCase('fooBar');
     * // => 'foo bar'
     *
     * _.lowerCase('__FOO_BAR__');
     * // => 'foo bar'
     */
    var lowerCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toLowerCase();
    });

    /**
     * Converts the first character of `string` to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.lowerFirst('Fred');
     * // => 'fred'
     *
     * _.lowerFirst('FRED');
     * // => 'fRED'
     */
    var lowerFirst = createCaseFirst('toLowerCase');

    /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */
    function pad(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      if (!length || strLength >= length) {
        return string;
      }
      var mid = (length - strLength) / 2;
      return (
        createPadding(nativeFloor(mid), chars) +
        string +
        createPadding(nativeCeil(mid), chars)
      );
    }

    /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padEnd('abc', 6);
     * // => 'abc   '
     *
     * _.padEnd('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padEnd('abc', 3);
     * // => 'abc'
     */
    function padEnd(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (string + createPadding(length - strLength, chars))
        : string;
    }

    /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padStart('abc', 6);
     * // => '   abc'
     *
     * _.padStart('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padStart('abc', 3);
     * // => 'abc'
     */
    function padStart(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (createPadding(length - strLength, chars) + string)
        : string;
    }

    /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
     * hexadecimal, in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the
     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix=10] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */
    function parseInt(string, radix, guard) {
      if (guard || radix == null) {
        radix = 0;
      } else if (radix) {
        radix = +radix;
      }
      return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
    }

    /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=1] The number of times to repeat the string.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */
    function repeat(string, n, guard) {
      if ((guard ? isIterateeCall(string, n, guard) : n === undefined$1)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      return baseRepeat(toString(string), n);
    }

    /**
     * Replaces matches for `pattern` in `string` with `replacement`.
     *
     * **Note:** This method is based on
     * [`String#replace`](https://mdn.io/String/replace).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to modify.
     * @param {RegExp|string} pattern The pattern to replace.
     * @param {Function|string} replacement The match replacement.
     * @returns {string} Returns the modified string.
     * @example
     *
     * _.replace('Hi Fred', 'Fred', 'Barney');
     * // => 'Hi Barney'
     */
    function replace() {
      var args = arguments,
          string = toString(args[0]);

      return args.length < 3 ? string : string.replace(args[1], args[2]);
    }

    /**
     * Converts `string` to
     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--FOO-BAR--');
     * // => 'foo_bar'
     */
    var snakeCase = createCompounder(function(result, word, index) {
      return result + (index ? '_' : '') + word.toLowerCase();
    });

    /**
     * Splits `string` by `separator`.
     *
     * **Note:** This method is based on
     * [`String#split`](https://mdn.io/String/split).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to split.
     * @param {RegExp|string} separator The separator pattern to split by.
     * @param {number} [limit] The length to truncate results to.
     * @returns {Array} Returns the string segments.
     * @example
     *
     * _.split('a-b-c', '-', 2);
     * // => ['a', 'b']
     */
    function split(string, separator, limit) {
      if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) {
        separator = limit = undefined$1;
      }
      limit = limit === undefined$1 ? MAX_ARRAY_LENGTH : limit >>> 0;
      if (!limit) {
        return [];
      }
      string = toString(string);
      if (string && (
            typeof separator == 'string' ||
            (separator != null && !isRegExp(separator))
          )) {
        separator = baseToString(separator);
        if (!separator && hasUnicode(string)) {
          return castSlice(stringToArray(string), 0, limit);
        }
      }
      return string.split(separator, limit);
    }

    /**
     * Converts `string` to
     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @since 3.1.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar--');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__FOO_BAR__');
     * // => 'FOO BAR'
     */
    var startCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + upperFirst(word);
    });

    /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`,
     *  else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */
    function startsWith(string, target, position) {
      string = toString(string);
      position = position == null
        ? 0
        : baseClamp(toInteger(position), 0, string.length);

      target = baseToString(target);
      return string.slice(position, position + target.length) == target;
    }

    /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is given, it takes precedence over `_.templateSettings` values.
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options={}] The options object.
     * @param {RegExp} [options.escape=_.templateSettings.escape]
     *  The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
     *  The "evaluate" delimiter.
     * @param {Object} [options.imports=_.templateSettings.imports]
     *  An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
     *  The "interpolate" delimiter.
     * @param {string} [options.sourceURL='lodash.templateSources[n]']
     *  The sourceURL of the compiled template.
     * @param {string} [options.variable='obj']
     *  The data object variable name.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // Use the "interpolate" delimiter to create a compiled template.
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // Use the HTML "escape" delimiter to escape data property values.
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the internal `print` function in "evaluate" delimiters.
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // Use the ES template literal delimiter as an "interpolate" delimiter.
     * // Disable support by replacing the "interpolate" delimiter.
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // Use backslashes to treat delimiters as plain text.
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // Use the `imports` option to import `jQuery` as `jq`.
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
     *
     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // Use custom template delimiters.
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // Use the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and stack traces.
     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */
    function template(string, options, guard) {
      // Based on John Resig's `tmpl` implementation
      // (http://ejohn.org/blog/javascript-micro-templating/)
      // and Laura Doktorova's doT.js (https://github.com/olado/doT).
      var settings = lodash.templateSettings;

      if (guard && isIterateeCall(string, options, guard)) {
        options = undefined$1;
      }
      string = toString(string);
      options = assignInWith({}, options, settings, customDefaultsAssignIn);

      var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn),
          importsKeys = keys(imports),
          importsValues = baseValues(imports, importsKeys);

      var isEscaping,
          isEvaluating,
          index = 0,
          interpolate = options.interpolate || reNoMatch,
          source = "__p += '";

      // Compile the regexp to match each delimiter.
      var reDelimiters = RegExp(
        (options.escape || reNoMatch).source + '|' +
        interpolate.source + '|' +
        (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' +
        (options.evaluate || reNoMatch).source + '|$'
      , 'g');

      // Use a sourceURL for easier debugging.
      // The sourceURL gets injected into the source that's eval-ed, so be careful
      // to normalize all kinds of whitespace, so e.g. newlines (and unicode versions of it) can't sneak in
      // and escape the comment, thus injecting code that gets evaled.
      var sourceURL = '//# sourceURL=' +
        (hasOwnProperty.call(options, 'sourceURL')
          ? (options.sourceURL + '').replace(/\s/g, ' ')
          : ('lodash.templateSources[' + (++templateCounter) + ']')
        ) + '\n';

      string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
        interpolateValue || (interpolateValue = esTemplateValue);

        // Escape characters that can't be included in string literals.
        source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);

        // Replace delimiters with snippets.
        if (escapeValue) {
          isEscaping = true;
          source += "' +\n__e(" + escapeValue + ") +\n'";
        }
        if (evaluateValue) {
          isEvaluating = true;
          source += "';\n" + evaluateValue + ";\n__p += '";
        }
        if (interpolateValue) {
          source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
        }
        index = offset + match.length;

        // The JS engine embedded in Adobe products needs `match` returned in
        // order to produce the correct `offset` value.
        return match;
      });

      source += "';\n";

      // If `variable` is not specified wrap a with-statement around the generated
      // code to add the data object to the top of the scope chain.
      var variable = hasOwnProperty.call(options, 'variable') && options.variable;
      if (!variable) {
        source = 'with (obj) {\n' + source + '\n}\n';
      }
      // Throw an error if a forbidden character was found in `variable`, to prevent
      // potential command injection attacks.
      else if (reForbiddenIdentifierChars.test(variable)) {
        throw new Error(INVALID_TEMPL_VAR_ERROR_TEXT);
      }

      // Cleanup code by stripping empty strings.
      source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source)
        .replace(reEmptyStringMiddle, '$1')
        .replace(reEmptyStringTrailing, '$1;');

      // Frame code as the function body.
      source = 'function(' + (variable || 'obj') + ') {\n' +
        (variable
          ? ''
          : 'obj || (obj = {});\n'
        ) +
        "var __t, __p = ''" +
        (isEscaping
           ? ', __e = _.escape'
           : ''
        ) +
        (isEvaluating
          ? ', __j = Array.prototype.join;\n' +
            "function print() { __p += __j.call(arguments, '') }\n"
          : ';\n'
        ) +
        source +
        'return __p\n}';

      var result = attempt(function() {
        return Function(importsKeys, sourceURL + 'return ' + source)
          .apply(undefined$1, importsValues);
      });

      // Provide the compiled function's source by its `toString` method or
      // the `source` property as a convenience for inlining compiled templates.
      result.source = source;
      if (isError(result)) {
        throw result;
      }
      return result;
    }

    /**
     * Converts `string`, as a whole, to lower case just like
     * [String#toLowerCase](https://mdn.io/toLowerCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.toLower('--Foo-Bar--');
     * // => '--foo-bar--'
     *
     * _.toLower('fooBar');
     * // => 'foobar'
     *
     * _.toLower('__FOO_BAR__');
     * // => '__foo_bar__'
     */
    function toLower(value) {
      return toString(value).toLowerCase();
    }

    /**
     * Converts `string`, as a whole, to upper case just like
     * [String#toUpperCase](https://mdn.io/toUpperCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.toUpper('--foo-bar--');
     * // => '--FOO-BAR--'
     *
     * _.toUpper('fooBar');
     * // => 'FOOBAR'
     *
     * _.toUpper('__foo_bar__');
     * // => '__FOO_BAR__'
     */
    function toUpper(value) {
      return toString(value).toUpperCase();
    }

    /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */
    function trim(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined$1)) {
        return baseTrim(string);
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          chrSymbols = stringToArray(chars),
          start = charsStartIndex(strSymbols, chrSymbols),
          end = charsEndIndex(strSymbols, chrSymbols) + 1;

      return castSlice(strSymbols, start, end).join('');
    }

    /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimEnd('  abc  ');
     * // => '  abc'
     *
     * _.trimEnd('-_-abc-_-', '_-');
     * // => '-_-abc'
     */
    function trimEnd(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined$1)) {
        return string.slice(0, trimmedEndIndex(string) + 1);
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;

      return castSlice(strSymbols, 0, end).join('');
    }

    /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimStart('  abc  ');
     * // => 'abc  '
     *
     * _.trimStart('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */
    function trimStart(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined$1)) {
        return string.replace(reTrimStart, '');
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          start = charsStartIndex(strSymbols, stringToArray(chars));

      return castSlice(strSymbols, start).join('');
    }

    /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object} [options={}] The options object.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.truncate('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */
    function truncate(string, options) {
      var length = DEFAULT_TRUNC_LENGTH,
          omission = DEFAULT_TRUNC_OMISSION;

      if (isObject(options)) {
        var separator = 'separator' in options ? options.separator : separator;
        length = 'length' in options ? toInteger(options.length) : length;
        omission = 'omission' in options ? baseToString(options.omission) : omission;
      }
      string = toString(string);

      var strLength = string.length;
      if (hasUnicode(string)) {
        var strSymbols = stringToArray(string);
        strLength = strSymbols.length;
      }
      if (length >= strLength) {
        return string;
      }
      var end = length - stringSize(omission);
      if (end < 1) {
        return omission;
      }
      var result = strSymbols
        ? castSlice(strSymbols, 0, end).join('')
        : string.slice(0, end);

      if (separator === undefined$1) {
        return result + omission;
      }
      if (strSymbols) {
        end += (result.length - end);
      }
      if (isRegExp(separator)) {
        if (string.slice(end).search(separator)) {
          var match,
              substring = result;

          if (!separator.global) {
            separator = RegExp(separator.source, toString(reFlags.exec(separator)) + 'g');
          }
          separator.lastIndex = 0;
          while ((match = separator.exec(substring))) {
            var newEnd = match.index;
          }
          result = result.slice(0, newEnd === undefined$1 ? end : newEnd);
        }
      } else if (string.indexOf(baseToString(separator), end) != end) {
        var index = result.lastIndexOf(separator);
        if (index > -1) {
          result = result.slice(0, index);
        }
      }
      return result + omission;
    }

    /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
     * their corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional
     * HTML entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @since 0.6.0
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */
    function unescape(string) {
      string = toString(string);
      return (string && reHasEscapedHtml.test(string))
        ? string.replace(reEscapedHtml, unescapeHtmlChar)
        : string;
    }

    /**
     * Converts `string`, as space separated words, to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.upperCase('--foo-bar');
     * // => 'FOO BAR'
     *
     * _.upperCase('fooBar');
     * // => 'FOO BAR'
     *
     * _.upperCase('__foo_bar__');
     * // => 'FOO BAR'
     */
    var upperCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toUpperCase();
    });

    /**
     * Converts the first character of `string` to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.upperFirst('fred');
     * // => 'Fred'
     *
     * _.upperFirst('FRED');
     * // => 'FRED'
     */
    var upperFirst = createCaseFirst('toUpperCase');

    /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */
    function words(string, pattern, guard) {
      string = toString(string);
      pattern = guard ? undefined$1 : pattern;

      if (pattern === undefined$1) {
        return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
      }
      return string.match(pattern) || [];
    }

    /*------------------------------------------------------------------------*/

    /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Function} func The function to attempt.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // Avoid throwing errors for invalid selectors.
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */
    var attempt = baseRest(function(func, args) {
      try {
        return apply(func, undefined$1, args);
      } catch (e) {
        return isError(e) ? e : new Error(e);
      }
    });

    /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method.
     *
     * **Note:** This method doesn't set the "length" property of bound functions.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} methodNames The object method names to bind.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'click': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view, ['click']);
     * jQuery(element).on('click', view.click);
     * // => Logs 'clicked docs' when clicked.
     */
    var bindAll = flatRest(function(object, methodNames) {
      arrayEach(methodNames, function(key) {
        key = toKey(key);
        baseAssignValue(object, key, bind(object[key], object));
      });
      return object;
    });

    /**
     * Creates a function that iterates over `pairs` and invokes the corresponding
     * function of the first predicate to return truthy. The predicate-function
     * pairs are invoked with the `this` binding and arguments of the created
     * function.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Array} pairs The predicate-function pairs.
     * @returns {Function} Returns the new composite function.
     * @example
     *
     * var func = _.cond([
     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
     *   [_.stubTrue,                      _.constant('no match')]
     * ]);
     *
     * func({ 'a': 1, 'b': 2 });
     * // => 'matches A'
     *
     * func({ 'a': 0, 'b': 1 });
     * // => 'matches B'
     *
     * func({ 'a': '1', 'b': '2' });
     * // => 'no match'
     */
    function cond(pairs) {
      var length = pairs == null ? 0 : pairs.length,
          toIteratee = getIteratee();

      pairs = !length ? [] : arrayMap(pairs, function(pair) {
        if (typeof pair[1] != 'function') {
          throw new TypeError(FUNC_ERROR_TEXT);
        }
        return [toIteratee(pair[0]), pair[1]];
      });

      return baseRest(function(args) {
        var index = -1;
        while (++index < length) {
          var pair = pairs[index];
          if (apply(pair[0], this, args)) {
            return apply(pair[1], this, args);
          }
        }
      });
    }

    /**
     * Creates a function that invokes the predicate properties of `source` with
     * the corresponding property values of a given object, returning `true` if
     * all predicates return truthy, else `false`.
     *
     * **Note:** The created function is equivalent to `_.conformsTo` with
     * `source` partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 2, 'b': 1 },
     *   { 'a': 1, 'b': 2 }
     * ];
     *
     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
     * // => [{ 'a': 1, 'b': 2 }]
     */
    function conforms(source) {
      return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */
    function constant(value) {
      return function() {
        return value;
      };
    }

    /**
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Util
     * @param {*} value The value to check.
     * @param {*} defaultValue The default value.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * _.defaultTo(1, 10);
     * // => 1
     *
     * _.defaultTo(undefined, 10);
     * // => 10
     */
    function defaultTo(value, defaultValue) {
      return (value == null || value !== value) ? defaultValue : value;
    }

    /**
     * Creates a function that returns the result of invoking the given functions
     * with the `this` binding of the created function, where each successive
     * invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flowRight
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow([_.add, square]);
     * addSquare(1, 2);
     * // => 9
     */
    var flow = createFlow();

    /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the given functions from right to left.
     *
     * @static
     * @since 3.0.0
     * @memberOf _
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flow
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight([square, _.add]);
     * addSquare(1, 2);
     * // => 9
     */
    var flowRight = createFlow(true);

    /**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */
    function identity(value) {
      return value;
    }

    /**
     * Creates a function that invokes `func` with the arguments of the created
     * function. If `func` is a property name, the created function returns the
     * property value for a given element. If `func` is an array or object, the
     * created function returns `true` for elements that contain the equivalent
     * source properties, otherwise it returns `false`.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Util
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, _.iteratee(['user', 'fred']));
     * // => [{ 'user': 'fred', 'age': 40 }]
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, _.iteratee('user'));
     * // => ['barney', 'fred']
     *
     * // Create custom iteratee shorthands.
     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
     *     return func.test(string);
     *   };
     * });
     *
     * _.filter(['abc', 'def'], /ef/);
     * // => ['def']
     */
    function iteratee(func) {
      return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between a given
     * object and `source`, returning `true` if the given object has equivalent
     * property values, else `false`.
     *
     * **Note:** The created function is equivalent to `_.isMatch` with `source`
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matches({ 'a': 1 }), _.matches({ 'a': 4 })]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */
    function matches(source) {
      return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between the
     * value at `path` of a given object to `srcValue`, returning `true` if the
     * object value is equivalent, else `false`.
     *
     * **Note:** Partial comparisons will match empty array and empty object
     * `srcValue` values against any array or object value, respectively. See
     * `_.isEqual` for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.find(objects, _.matchesProperty('a', 4));
     * // => { 'a': 4, 'b': 5, 'c': 6 }
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matchesProperty('a', 1), _.matchesProperty('a', 4)]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */
    function matchesProperty(path, srcValue) {
      return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that invokes the method at `path` of a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': _.constant(2) } },
     *   { 'a': { 'b': _.constant(1) } }
     * ];
     *
     * _.map(objects, _.method('a.b'));
     * // => [2, 1]
     *
     * _.map(objects, _.method(['a', 'b']));
     * // => [2, 1]
     */
    var method = baseRest(function(path, args) {
      return function(object) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path of `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */
    var methodOf = baseRest(function(object, args) {
      return function(path) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * Adds all own enumerable string keyed function properties of a source
     * object to the destination object. If `object` is a function, then methods
     * are added to its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */
    function mixin(object, source, options) {
      var props = keys(source),
          methodNames = baseFunctions(source, props);

      if (options == null &&
          !(isObject(source) && (methodNames.length || !props.length))) {
        options = source;
        source = object;
        object = this;
        methodNames = baseFunctions(source, keys(source));
      }
      var chain = !(isObject(options) && 'chain' in options) || !!options.chain,
          isFunc = isFunction(object);

      arrayEach(methodNames, function(methodName) {
        var func = source[methodName];
        object[methodName] = func;
        if (isFunc) {
          object.prototype[methodName] = function() {
            var chainAll = this.__chain__;
            if (chain || chainAll) {
              var result = object(this.__wrapped__),
                  actions = result.__actions__ = copyArray(this.__actions__);

              actions.push({ 'func': func, 'args': arguments, 'thisArg': object });
              result.__chain__ = chainAll;
              return result;
            }
            return func.apply(object, arrayPush([this.value()], arguments));
          };
        }
      });

      return object;
    }

    /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */
    function noConflict() {
      if (root._ === this) {
        root._ = oldDash;
      }
      return this;
    }

    /**
     * This method returns `undefined`.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Util
     * @example
     *
     * _.times(2, _.noop);
     * // => [undefined, undefined]
     */
    function noop() {
      // No operation performed.
    }

    /**
     * Creates a function that gets the argument at index `n`. If `n` is negative,
     * the nth argument from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [n=0] The index of the argument to return.
     * @returns {Function} Returns the new pass-thru function.
     * @example
     *
     * var func = _.nthArg(1);
     * func('a', 'b', 'c', 'd');
     * // => 'b'
     *
     * var func = _.nthArg(-2);
     * func('a', 'b', 'c', 'd');
     * // => 'c'
     */
    function nthArg(n) {
      n = toInteger(n);
      return baseRest(function(args) {
        return baseNth(args, n);
      });
    }

    /**
     * Creates a function that invokes `iteratees` with the arguments it receives
     * and returns their results.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.over([Math.max, Math.min]);
     *
     * func(1, 2, 3, 4);
     * // => [4, 1]
     */
    var over = createOver(arrayMap);

    /**
     * Creates a function that checks if **all** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overEvery([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => false
     *
     * func(NaN);
     * // => false
     */
    var overEvery = createOver(arrayEvery);

    /**
     * Creates a function that checks if **any** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overSome([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => true
     *
     * func(NaN);
     * // => false
     *
     * var matchesFunc = _.overSome([{ 'a': 1 }, { 'a': 2 }])
     * var matchesPropertyFunc = _.overSome([['a', 1], ['a', 2]])
     */
    var overSome = createOver(arraySome);

    /**
     * Creates a function that returns the value at `path` of a given object.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': 2 } },
     *   { 'a': { 'b': 1 } }
     * ];
     *
     * _.map(objects, _.property('a.b'));
     * // => [2, 1]
     *
     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
     * // => [1, 2]
     */
    function property(path) {
      return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
    }

    /**
     * The opposite of `_.property`; this method creates a function that returns
     * the value at a given path of `object`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */
    function propertyOf(object) {
      return function(path) {
        return object == null ? undefined$1 : baseGet(object, path);
      };
    }

    /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
     * `start` is specified without an `end` or `step`. If `end` is not specified,
     * it's set to `start` with `start` then set to `0`.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.rangeRight
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(-4);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */
    var range = createRange();

    /**
     * This method is like `_.range` except that it populates values in
     * descending order.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.range
     * @example
     *
     * _.rangeRight(4);
     * // => [3, 2, 1, 0]
     *
     * _.rangeRight(-4);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 5);
     * // => [4, 3, 2, 1]
     *
     * _.rangeRight(0, 20, 5);
     * // => [15, 10, 5, 0]
     *
     * _.rangeRight(0, -4, -1);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.rangeRight(0);
     * // => []
     */
    var rangeRight = createRange(true);

    /**
     * This method returns a new empty array.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Array} Returns the new empty array.
     * @example
     *
     * var arrays = _.times(2, _.stubArray);
     *
     * console.log(arrays);
     * // => [[], []]
     *
     * console.log(arrays[0] === arrays[1]);
     * // => false
     */
    function stubArray() {
      return [];
    }

    /**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */
    function stubFalse() {
      return false;
    }

    /**
     * This method returns a new empty object.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Object} Returns the new empty object.
     * @example
     *
     * var objects = _.times(2, _.stubObject);
     *
     * console.log(objects);
     * // => [{}, {}]
     *
     * console.log(objects[0] === objects[1]);
     * // => false
     */
    function stubObject() {
      return {};
    }

    /**
     * This method returns an empty string.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {string} Returns the empty string.
     * @example
     *
     * _.times(2, _.stubString);
     * // => ['', '']
     */
    function stubString() {
      return '';
    }

    /**
     * This method returns `true`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `true`.
     * @example
     *
     * _.times(2, _.stubTrue);
     * // => [true, true]
     */
    function stubTrue() {
      return true;
    }

    /**
     * Invokes the iteratee `n` times, returning an array of the results of
     * each invocation. The iteratee is invoked with one argument; (index).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.times(3, String);
     * // => ['0', '1', '2']
     *
     *  _.times(4, _.constant(0));
     * // => [0, 0, 0, 0]
     */
    function times(n, iteratee) {
      n = toInteger(n);
      if (n < 1 || n > MAX_SAFE_INTEGER) {
        return [];
      }
      var index = MAX_ARRAY_LENGTH,
          length = nativeMin(n, MAX_ARRAY_LENGTH);

      iteratee = getIteratee(iteratee);
      n -= MAX_ARRAY_LENGTH;

      var result = baseTimes(length, iteratee);
      while (++index < n) {
        iteratee(index);
      }
      return result;
    }

    /**
     * Converts `value` to a property path array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {*} value The value to convert.
     * @returns {Array} Returns the new property path array.
     * @example
     *
     * _.toPath('a.b.c');
     * // => ['a', 'b', 'c']
     *
     * _.toPath('a[0].b.c');
     * // => ['a', '0', 'b', 'c']
     */
    function toPath(value) {
      if (isArray(value)) {
        return arrayMap(value, toKey);
      }
      return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value)));
    }

    /**
     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {string} [prefix=''] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */
    function uniqueId(prefix) {
      var id = ++idCounter;
      return toString(prefix) + id;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {number} augend The first number in an addition.
     * @param {number} addend The second number in an addition.
     * @returns {number} Returns the total.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */
    var add = createMathOperation(function(augend, addend) {
      return augend + addend;
    }, 0);

    /**
     * Computes `number` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */
    var ceil = createRound('ceil');

    /**
     * Divide two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} dividend The first number in a division.
     * @param {number} divisor The second number in a division.
     * @returns {number} Returns the quotient.
     * @example
     *
     * _.divide(6, 4);
     * // => 1.5
     */
    var divide = createMathOperation(function(dividend, divisor) {
      return dividend / divisor;
    }, 1);

    /**
     * Computes `number` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */
    var floor = createRound('floor');

    /**
     * Computes the maximum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => undefined
     */
    function max(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseGt)
        : undefined$1;
    }

    /**
     * This method is like `_.max` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.maxBy(objects, function(o) { return o.n; });
     * // => { 'n': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.maxBy(objects, 'n');
     * // => { 'n': 2 }
     */
    function maxBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseGt)
        : undefined$1;
    }

    /**
     * Computes the mean of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the mean.
     * @example
     *
     * _.mean([4, 2, 8, 6]);
     * // => 5
     */
    function mean(array) {
      return baseMean(array, identity);
    }

    /**
     * This method is like `_.mean` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be averaged.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the mean.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.meanBy(objects, function(o) { return o.n; });
     * // => 5
     *
     * // The `_.property` iteratee shorthand.
     * _.meanBy(objects, 'n');
     * // => 5
     */
    function meanBy(array, iteratee) {
      return baseMean(array, getIteratee(iteratee, 2));
    }

    /**
     * Computes the minimum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => undefined
     */
    function min(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseLt)
        : undefined$1;
    }

    /**
     * This method is like `_.min` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.minBy(objects, function(o) { return o.n; });
     * // => { 'n': 1 }
     *
     * // The `_.property` iteratee shorthand.
     * _.minBy(objects, 'n');
     * // => { 'n': 1 }
     */
    function minBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseLt)
        : undefined$1;
    }

    /**
     * Multiply two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} multiplier The first number in a multiplication.
     * @param {number} multiplicand The second number in a multiplication.
     * @returns {number} Returns the product.
     * @example
     *
     * _.multiply(6, 4);
     * // => 24
     */
    var multiply = createMathOperation(function(multiplier, multiplicand) {
      return multiplier * multiplicand;
    }, 1);

    /**
     * Computes `number` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */
    var round = createRound('round');

    /**
     * Subtract two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {number} minuend The first number in a subtraction.
     * @param {number} subtrahend The second number in a subtraction.
     * @returns {number} Returns the difference.
     * @example
     *
     * _.subtract(6, 4);
     * // => 2
     */
    var subtract = createMathOperation(function(minuend, subtrahend) {
      return minuend - subtrahend;
    }, 0);

    /**
     * Computes the sum of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 2, 8, 6]);
     * // => 20
     */
    function sum(array) {
      return (array && array.length)
        ? baseSum(array, identity)
        : 0;
    }

    /**
     * This method is like `_.sum` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be summed.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the sum.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.sumBy(objects, function(o) { return o.n; });
     * // => 20
     *
     * // The `_.property` iteratee shorthand.
     * _.sumBy(objects, 'n');
     * // => 20
     */
    function sumBy(array, iteratee) {
      return (array && array.length)
        ? baseSum(array, getIteratee(iteratee, 2))
        : 0;
    }

    /*------------------------------------------------------------------------*/

    // Add methods that return wrapped values in chain sequences.
    lodash.after = after;
    lodash.ary = ary;
    lodash.assign = assign;
    lodash.assignIn = assignIn;
    lodash.assignInWith = assignInWith;
    lodash.assignWith = assignWith;
    lodash.at = at;
    lodash.before = before;
    lodash.bind = bind;
    lodash.bindAll = bindAll;
    lodash.bindKey = bindKey;
    lodash.castArray = castArray;
    lodash.chain = chain;
    lodash.chunk = chunk;
    lodash.compact = compact;
    lodash.concat = concat;
    lodash.cond = cond;
    lodash.conforms = conforms;
    lodash.constant = constant;
    lodash.countBy = countBy;
    lodash.create = create;
    lodash.curry = curry;
    lodash.curryRight = curryRight;
    lodash.debounce = debounce;
    lodash.defaults = defaults;
    lodash.defaultsDeep = defaultsDeep;
    lodash.defer = defer;
    lodash.delay = delay;
    lodash.difference = difference;
    lodash.differenceBy = differenceBy;
    lodash.differenceWith = differenceWith;
    lodash.drop = drop;
    lodash.dropRight = dropRight;
    lodash.dropRightWhile = dropRightWhile;
    lodash.dropWhile = dropWhile;
    lodash.fill = fill;
    lodash.filter = filter;
    lodash.flatMap = flatMap;
    lodash.flatMapDeep = flatMapDeep;
    lodash.flatMapDepth = flatMapDepth;
    lodash.flatten = flatten;
    lodash.flattenDeep = flattenDeep;
    lodash.flattenDepth = flattenDepth;
    lodash.flip = flip;
    lodash.flow = flow;
    lodash.flowRight = flowRight;
    lodash.fromPairs = fromPairs;
    lodash.functions = functions;
    lodash.functionsIn = functionsIn;
    lodash.groupBy = groupBy;
    lodash.initial = initial;
    lodash.intersection = intersection;
    lodash.intersectionBy = intersectionBy;
    lodash.intersectionWith = intersectionWith;
    lodash.invert = invert;
    lodash.invertBy = invertBy;
    lodash.invokeMap = invokeMap;
    lodash.iteratee = iteratee;
    lodash.keyBy = keyBy;
    lodash.keys = keys;
    lodash.keysIn = keysIn;
    lodash.map = map;
    lodash.mapKeys = mapKeys;
    lodash.mapValues = mapValues;
    lodash.matches = matches;
    lodash.matchesProperty = matchesProperty;
    lodash.memoize = memoize;
    lodash.merge = merge;
    lodash.mergeWith = mergeWith;
    lodash.method = method;
    lodash.methodOf = methodOf;
    lodash.mixin = mixin;
    lodash.negate = negate;
    lodash.nthArg = nthArg;
    lodash.omit = omit;
    lodash.omitBy = omitBy;
    lodash.once = once;
    lodash.orderBy = orderBy;
    lodash.over = over;
    lodash.overArgs = overArgs;
    lodash.overEvery = overEvery;
    lodash.overSome = overSome;
    lodash.partial = partial;
    lodash.partialRight = partialRight;
    lodash.partition = partition;
    lodash.pick = pick;
    lodash.pickBy = pickBy;
    lodash.property = property;
    lodash.propertyOf = propertyOf;
    lodash.pull = pull;
    lodash.pullAll = pullAll;
    lodash.pullAllBy = pullAllBy;
    lodash.pullAllWith = pullAllWith;
    lodash.pullAt = pullAt;
    lodash.range = range;
    lodash.rangeRight = rangeRight;
    lodash.rearg = rearg;
    lodash.reject = reject;
    lodash.remove = remove;
    lodash.rest = rest;
    lodash.reverse = reverse;
    lodash.sampleSize = sampleSize;
    lodash.set = set;
    lodash.setWith = setWith;
    lodash.shuffle = shuffle;
    lodash.slice = slice;
    lodash.sortBy = sortBy;
    lodash.sortedUniq = sortedUniq;
    lodash.sortedUniqBy = sortedUniqBy;
    lodash.split = split;
    lodash.spread = spread;
    lodash.tail = tail;
    lodash.take = take;
    lodash.takeRight = takeRight;
    lodash.takeRightWhile = takeRightWhile;
    lodash.takeWhile = takeWhile;
    lodash.tap = tap;
    lodash.throttle = throttle;
    lodash.thru = thru;
    lodash.toArray = toArray;
    lodash.toPairs = toPairs;
    lodash.toPairsIn = toPairsIn;
    lodash.toPath = toPath;
    lodash.toPlainObject = toPlainObject;
    lodash.transform = transform;
    lodash.unary = unary;
    lodash.union = union;
    lodash.unionBy = unionBy;
    lodash.unionWith = unionWith;
    lodash.uniq = uniq;
    lodash.uniqBy = uniqBy;
    lodash.uniqWith = uniqWith;
    lodash.unset = unset;
    lodash.unzip = unzip;
    lodash.unzipWith = unzipWith;
    lodash.update = update;
    lodash.updateWith = updateWith;
    lodash.values = values;
    lodash.valuesIn = valuesIn;
    lodash.without = without;
    lodash.words = words;
    lodash.wrap = wrap;
    lodash.xor = xor;
    lodash.xorBy = xorBy;
    lodash.xorWith = xorWith;
    lodash.zip = zip;
    lodash.zipObject = zipObject;
    lodash.zipObjectDeep = zipObjectDeep;
    lodash.zipWith = zipWith;

    // Add aliases.
    lodash.entries = toPairs;
    lodash.entriesIn = toPairsIn;
    lodash.extend = assignIn;
    lodash.extendWith = assignInWith;

    // Add methods to `lodash.prototype`.
    mixin(lodash, lodash);

    /*------------------------------------------------------------------------*/

    // Add methods that return unwrapped values in chain sequences.
    lodash.add = add;
    lodash.attempt = attempt;
    lodash.camelCase = camelCase;
    lodash.capitalize = capitalize;
    lodash.ceil = ceil;
    lodash.clamp = clamp;
    lodash.clone = clone;
    lodash.cloneDeep = cloneDeep;
    lodash.cloneDeepWith = cloneDeepWith;
    lodash.cloneWith = cloneWith;
    lodash.conformsTo = conformsTo;
    lodash.deburr = deburr;
    lodash.defaultTo = defaultTo;
    lodash.divide = divide;
    lodash.endsWith = endsWith;
    lodash.eq = eq;
    lodash.escape = escape;
    lodash.escapeRegExp = escapeRegExp;
    lodash.every = every;
    lodash.find = find;
    lodash.findIndex = findIndex;
    lodash.findKey = findKey;
    lodash.findLast = findLast;
    lodash.findLastIndex = findLastIndex;
    lodash.findLastKey = findLastKey;
    lodash.floor = floor;
    lodash.forEach = forEach;
    lodash.forEachRight = forEachRight;
    lodash.forIn = forIn;
    lodash.forInRight = forInRight;
    lodash.forOwn = forOwn;
    lodash.forOwnRight = forOwnRight;
    lodash.get = get;
    lodash.gt = gt;
    lodash.gte = gte;
    lodash.has = has;
    lodash.hasIn = hasIn;
    lodash.head = head;
    lodash.identity = identity;
    lodash.includes = includes;
    lodash.indexOf = indexOf;
    lodash.inRange = inRange;
    lodash.invoke = invoke;
    lodash.isArguments = isArguments;
    lodash.isArray = isArray;
    lodash.isArrayBuffer = isArrayBuffer;
    lodash.isArrayLike = isArrayLike;
    lodash.isArrayLikeObject = isArrayLikeObject;
    lodash.isBoolean = isBoolean;
    lodash.isBuffer = isBuffer;
    lodash.isDate = isDate;
    lodash.isElement = isElement;
    lodash.isEmpty = isEmpty;
    lodash.isEqual = isEqual;
    lodash.isEqualWith = isEqualWith;
    lodash.isError = isError;
    lodash.isFinite = isFinite;
    lodash.isFunction = isFunction;
    lodash.isInteger = isInteger;
    lodash.isLength = isLength;
    lodash.isMap = isMap;
    lodash.isMatch = isMatch;
    lodash.isMatchWith = isMatchWith;
    lodash.isNaN = isNaN;
    lodash.isNative = isNative;
    lodash.isNil = isNil;
    lodash.isNull = isNull;
    lodash.isNumber = isNumber;
    lodash.isObject = isObject;
    lodash.isObjectLike = isObjectLike;
    lodash.isPlainObject = isPlainObject;
    lodash.isRegExp = isRegExp;
    lodash.isSafeInteger = isSafeInteger;
    lodash.isSet = isSet;
    lodash.isString = isString;
    lodash.isSymbol = isSymbol;
    lodash.isTypedArray = isTypedArray;
    lodash.isUndefined = isUndefined;
    lodash.isWeakMap = isWeakMap;
    lodash.isWeakSet = isWeakSet;
    lodash.join = join;
    lodash.kebabCase = kebabCase;
    lodash.last = last;
    lodash.lastIndexOf = lastIndexOf;
    lodash.lowerCase = lowerCase;
    lodash.lowerFirst = lowerFirst;
    lodash.lt = lt;
    lodash.lte = lte;
    lodash.max = max;
    lodash.maxBy = maxBy;
    lodash.mean = mean;
    lodash.meanBy = meanBy;
    lodash.min = min;
    lodash.minBy = minBy;
    lodash.stubArray = stubArray;
    lodash.stubFalse = stubFalse;
    lodash.stubObject = stubObject;
    lodash.stubString = stubString;
    lodash.stubTrue = stubTrue;
    lodash.multiply = multiply;
    lodash.nth = nth;
    lodash.noConflict = noConflict;
    lodash.noop = noop;
    lodash.now = now;
    lodash.pad = pad;
    lodash.padEnd = padEnd;
    lodash.padStart = padStart;
    lodash.parseInt = parseInt;
    lodash.random = random;
    lodash.reduce = reduce;
    lodash.reduceRight = reduceRight;
    lodash.repeat = repeat;
    lodash.replace = replace;
    lodash.result = result;
    lodash.round = round;
    lodash.runInContext = runInContext;
    lodash.sample = sample;
    lodash.size = size;
    lodash.snakeCase = snakeCase;
    lodash.some = some;
    lodash.sortedIndex = sortedIndex;
    lodash.sortedIndexBy = sortedIndexBy;
    lodash.sortedIndexOf = sortedIndexOf;
    lodash.sortedLastIndex = sortedLastIndex;
    lodash.sortedLastIndexBy = sortedLastIndexBy;
    lodash.sortedLastIndexOf = sortedLastIndexOf;
    lodash.startCase = startCase;
    lodash.startsWith = startsWith;
    lodash.subtract = subtract;
    lodash.sum = sum;
    lodash.sumBy = sumBy;
    lodash.template = template;
    lodash.times = times;
    lodash.toFinite = toFinite;
    lodash.toInteger = toInteger;
    lodash.toLength = toLength;
    lodash.toLower = toLower;
    lodash.toNumber = toNumber;
    lodash.toSafeInteger = toSafeInteger;
    lodash.toString = toString;
    lodash.toUpper = toUpper;
    lodash.trim = trim;
    lodash.trimEnd = trimEnd;
    lodash.trimStart = trimStart;
    lodash.truncate = truncate;
    lodash.unescape = unescape;
    lodash.uniqueId = uniqueId;
    lodash.upperCase = upperCase;
    lodash.upperFirst = upperFirst;

    // Add aliases.
    lodash.each = forEach;
    lodash.eachRight = forEachRight;
    lodash.first = head;

    mixin(lodash, (function() {
      var source = {};
      baseForOwn(lodash, function(func, methodName) {
        if (!hasOwnProperty.call(lodash.prototype, methodName)) {
          source[methodName] = func;
        }
      });
      return source;
    }()), { 'chain': false });

    /*------------------------------------------------------------------------*/

    /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type {string}
     */
    lodash.VERSION = VERSION;

    // Assign default placeholders.
    arrayEach(['bind', 'bindKey', 'curry', 'curryRight', 'partial', 'partialRight'], function(methodName) {
      lodash[methodName].placeholder = lodash;
    });

    // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
    arrayEach(['drop', 'take'], function(methodName, index) {
      LazyWrapper.prototype[methodName] = function(n) {
        n = n === undefined$1 ? 1 : nativeMax(toInteger(n), 0);

        var result = (this.__filtered__ && !index)
          ? new LazyWrapper(this)
          : this.clone();

        if (result.__filtered__) {
          result.__takeCount__ = nativeMin(n, result.__takeCount__);
        } else {
          result.__views__.push({
            'size': nativeMin(n, MAX_ARRAY_LENGTH),
            'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
          });
        }
        return result;
      };

      LazyWrapper.prototype[methodName + 'Right'] = function(n) {
        return this.reverse()[methodName](n).reverse();
      };
    });

    // Add `LazyWrapper` methods that accept an `iteratee` value.
    arrayEach(['filter', 'map', 'takeWhile'], function(methodName, index) {
      var type = index + 1,
          isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;

      LazyWrapper.prototype[methodName] = function(iteratee) {
        var result = this.clone();
        result.__iteratees__.push({
          'iteratee': getIteratee(iteratee, 3),
          'type': type
        });
        result.__filtered__ = result.__filtered__ || isFilter;
        return result;
      };
    });

    // Add `LazyWrapper` methods for `_.head` and `_.last`.
    arrayEach(['head', 'last'], function(methodName, index) {
      var takeName = 'take' + (index ? 'Right' : '');

      LazyWrapper.prototype[methodName] = function() {
        return this[takeName](1).value()[0];
      };
    });

    // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
    arrayEach(['initial', 'tail'], function(methodName, index) {
      var dropName = 'drop' + (index ? '' : 'Right');

      LazyWrapper.prototype[methodName] = function() {
        return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
      };
    });

    LazyWrapper.prototype.compact = function() {
      return this.filter(identity);
    };

    LazyWrapper.prototype.find = function(predicate) {
      return this.filter(predicate).head();
    };

    LazyWrapper.prototype.findLast = function(predicate) {
      return this.reverse().find(predicate);
    };

    LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
      if (typeof path == 'function') {
        return new LazyWrapper(this);
      }
      return this.map(function(value) {
        return baseInvoke(value, path, args);
      });
    });

    LazyWrapper.prototype.reject = function(predicate) {
      return this.filter(negate(getIteratee(predicate)));
    };

    LazyWrapper.prototype.slice = function(start, end) {
      start = toInteger(start);

      var result = this;
      if (result.__filtered__ && (start > 0 || end < 0)) {
        return new LazyWrapper(result);
      }
      if (start < 0) {
        result = result.takeRight(-start);
      } else if (start) {
        result = result.drop(start);
      }
      if (end !== undefined$1) {
        end = toInteger(end);
        result = end < 0 ? result.dropRight(-end) : result.take(end - start);
      }
      return result;
    };

    LazyWrapper.prototype.takeRightWhile = function(predicate) {
      return this.reverse().takeWhile(predicate).reverse();
    };

    LazyWrapper.prototype.toArray = function() {
      return this.take(MAX_ARRAY_LENGTH);
    };

    // Add `LazyWrapper` methods to `lodash.prototype`.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName),
          isTaker = /^(?:head|last)$/.test(methodName),
          lodashFunc = lodash[isTaker ? ('take' + (methodName == 'last' ? 'Right' : '')) : methodName],
          retUnwrapped = isTaker || /^find/.test(methodName);

      if (!lodashFunc) {
        return;
      }
      lodash.prototype[methodName] = function() {
        var value = this.__wrapped__,
            args = isTaker ? [1] : arguments,
            isLazy = value instanceof LazyWrapper,
            iteratee = args[0],
            useLazy = isLazy || isArray(value);

        var interceptor = function(value) {
          var result = lodashFunc.apply(lodash, arrayPush([value], args));
          return (isTaker && chainAll) ? result[0] : result;
        };

        if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) {
          // Avoid lazy use if the iteratee has a "length" value other than `1`.
          isLazy = useLazy = false;
        }
        var chainAll = this.__chain__,
            isHybrid = !!this.__actions__.length,
            isUnwrapped = retUnwrapped && !chainAll,
            onlyLazy = isLazy && !isHybrid;

        if (!retUnwrapped && useLazy) {
          value = onlyLazy ? value : new LazyWrapper(this);
          var result = func.apply(value, args);
          result.__actions__.push({ 'func': thru, 'args': [interceptor], 'thisArg': undefined$1 });
          return new LodashWrapper(result, chainAll);
        }
        if (isUnwrapped && onlyLazy) {
          return func.apply(this, args);
        }
        result = this.thru(interceptor);
        return isUnwrapped ? (isTaker ? result.value()[0] : result.value()) : result;
      };
    });

    // Add `Array` methods to `lodash.prototype`.
    arrayEach(['pop', 'push', 'shift', 'sort', 'splice', 'unshift'], function(methodName) {
      var func = arrayProto[methodName],
          chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru',
          retUnwrapped = /^(?:pop|shift)$/.test(methodName);

      lodash.prototype[methodName] = function() {
        var args = arguments;
        if (retUnwrapped && !this.__chain__) {
          var value = this.value();
          return func.apply(isArray(value) ? value : [], args);
        }
        return this[chainName](function(value) {
          return func.apply(isArray(value) ? value : [], args);
        });
      };
    });

    // Map minified method names to their real names.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var lodashFunc = lodash[methodName];
      if (lodashFunc) {
        var key = lodashFunc.name + '';
        if (!hasOwnProperty.call(realNames, key)) {
          realNames[key] = [];
        }
        realNames[key].push({ 'name': methodName, 'func': lodashFunc });
      }
    });

    realNames[createHybrid(undefined$1, WRAP_BIND_KEY_FLAG).name] = [{
      'name': 'wrapper',
      'func': undefined$1
    }];

    // Add methods to `LazyWrapper`.
    LazyWrapper.prototype.clone = lazyClone;
    LazyWrapper.prototype.reverse = lazyReverse;
    LazyWrapper.prototype.value = lazyValue;

    // Add chain sequence methods to the `lodash` wrapper.
    lodash.prototype.at = wrapperAt;
    lodash.prototype.chain = wrapperChain;
    lodash.prototype.commit = wrapperCommit;
    lodash.prototype.next = wrapperNext;
    lodash.prototype.plant = wrapperPlant;
    lodash.prototype.reverse = wrapperReverse;
    lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;

    // Add lazy aliases.
    lodash.prototype.first = lodash.prototype.head;

    if (symIterator) {
      lodash.prototype[symIterator] = wrapperToIterator;
    }
    return lodash;
  });

  /*--------------------------------------------------------------------------*/

  // Export lodash.
  var _ = runInContext();

  // Some AMD build optimizers, like r.js, check for condition patterns like:
  if (freeModule) {
    // Export for Node.js.
    (freeModule.exports = _)._ = _;
    // Export for CommonJS support.
    freeExports._ = _;
  }
  else {
    // Export to the global object.
    root._ = _;
  }
}.call(commonjsGlobal));
});

var Action$2;
(function (Action) {
  Action[Action["NewOutput"] = 0] = "NewOutput";
  Action[Action["ProducerCompute"] = 1] = "ProducerCompute";
})(Action$2 || (Action$2 = {}));

let gCount = 0;
function createAsyncControl() {
  return {
    cancel: false,
    count: ++gCount
  };
}

//
const Log$8 = Logger; // needed for jest
// (version optimisation)
// if the previous output is different to the current output the version would have changed
function isModified(_ref) {
  let {
    previous,
    current
  } = _ref;
  if (!previous) return true;
  return current.some((version, index) => version !== previous[index]);
}
/*
the separation between GraphTask and ProducerTask allows:
- to seperate the predecessors/successors mechanism from the output computation
- to rebuild a TaskGraph with different predecessors/successors while keeping current output values
*/
class ProducerTask {
  // ignore version optimisation when true
  get key() {
    return this.impl.key;
  }
  get label() {
    return this.impl.label;
  }
  get output() {
    return this._output;
  }
  get computedCount() {
    return this._computedCount;
  }
  get version() {
    return this._version;
  }
  get computing() {
    return this._computing;
  }
  get priority() {
    return this.impl.priority;
  }
  get forceCompute() {
    return this._forceCompute;
  }
  set forceCompute(val) {
    this._forceCompute = val;
  }
  constructor(impl, dispatch) {
    this.impl = void 0;
    this.dispatch = void 0;
    this._output = null;
    this._version = 0;
    this.predecessors = [];
    this.predecessorVersions = null;
    // remains null until the first successful compute
    this._computedCount = 0;
    this._computing = false;
    this._forceCompute = false;
    this.control = null;
    this.impl = impl;
    this.dispatch = dispatch;
  }
  declarePredecessors() {
    return this.impl.declarePredecessors();
  }
  onPredecessors(predecessorTasks) {
    var _this = this;
    // onPredecessors() is called each time the graph is rebuilt
    for (const predecessor of predecessorTasks) {
      if (!(predecessor instanceof ProducerTask)) {
        (function () {
          {
            const formattedMessage = Log$8.formatMessage(Category.Producer, Log$8.Level.Error, "ProducerTask.onPredecessors() key[" + _this.key + "] predecessor[" + predecessor.key + "] is not a Producer");
            console.log(formattedMessage);
            Log$8.log(formattedMessage);
            throw new Error(formattedMessage);
          }
        })();
      }
    }
    const predecessors = predecessorTasks;
    let clearVersions = true;
    const {
      predecessorVersions
    } = this;
    if (predecessorVersions /* the task has already been computed */ && predecessors.length === predecessorVersions.length) {
      const oldOutputs = predecessorVersions.map(_ref2 => {
        let {
          output
        } = _ref2;
        return output;
      });
      const newOutputs = predecessors.map(_ref3 => {
        let {
          output
        } = _ref3;
        return output;
      });
      const sameOutputs = oldOutputs.every((output, index) => lodash.isEqual(output, newOutputs[index]));
      if (sameOutputs) {
        clearVersions = false;
      }
    }
    if (clearVersions) {
      // if predecessor outputs have changed a compute must be triggered
      this.predecessorVersions = null;
    } else {
      // otherwise update the predecessor versions
      this.predecessorVersions = predecessors.map(_ref4 => {
        let {
          version,
          output
        } = _ref4;
        return {
          version,
          output
        };
      });
    }
    (function () {
      if (Log$8.categories[Category.Producer] >= Level.Debug) {
        const formattedMessage = Log$8.formatMessage(Category.Producer, Level.Debug, "ProducerTask.onPredecessors() key[" + _this.key + "] clearVersions[" + clearVersions + "] oldPredecessorVersions[" + JSON.stringify(predecessorVersions) + "] newPredecessorVersions[" + JSON.stringify(_this.predecessorVersions) + "]");
        console.log(formattedMessage);
        return Log$8.log(formattedMessage);
      }
    })();
    this.predecessors = predecessors;
  }
  execute(onExecuted, predecessorTasks, scheduler) {
    var _this2 = this;
    const {
      key,
      dispatch,
      predecessors,
      forceCompute
    } = this;
    if (this.control) {
      return function () {
        {
          const formattedMessage = Log$8.formatMessage(Category.Producer, Log$8.Level.Error, "ProducerTask.execute() key[" + key + "] invalid state");
          console.log(formattedMessage);
          Log$8.log(formattedMessage);
          throw new Error(formattedMessage);
        }
      }();
    }
    const control = createAsyncControl();
    (function () {
      if (Log$8.categories[Category.Producer] >= Level.Debug) {
        const formattedMessage = Log$8.formatMessage(Category.Producer, Level.Debug, "ProducerTask.execute() key[" + key + "] start predecessors[" + predecessors.map(_ref5 => {
          let {
            key,
            version,
            output
          } = _ref5;
          return JSON.stringify({
            key,
            version,
            output
          });
        }) + "] predecessorVersions[" + (_this2.predecessorVersions ? _this2.predecessorVersions.map(_ref6 => {
          let {
            version
          } = _ref6;
          return version;
        }) : null) + "] output[" + JSON.stringify(_this2.output) + "]");
        console.log(formattedMessage);
        return Log$8.log(formattedMessage);
      }
    })();
    const predecessorVersions = predecessors.map(_ref7 => {
      let {
        version,
        output
      } = _ref7;
      return {
        version,
        output
      };
    });
    const versions = {
      previous: this.predecessorVersions ? this.predecessorVersions.map(_ref8 => {
        let {
          version
        } = _ref8;
        return version;
      }) : null,
      current: predecessorVersions.map(_ref9 => {
        let {
          version
        } = _ref9;
        return version;
      })
    };
    const compute = isModified(versions) || forceCompute;
    if (!compute) {
      onExecuted();
      return;
    }
    //
    const predecessorOutputs = predecessors.map(predecessor => predecessor.output);
    this._computing = true;
    this.control = control;
    dispatch({
      type: Action$2.ProducerCompute,
      key,
      computing: true
    }); // can call cancel()
    if (control.cancel) return;
    const onComputed = (output, ignoreOutput) => {
      if (control.cancel) {
        // otherwise it would continue the traversal of the canceled graph
        return function () {
          {
            const formattedMessage = Log$8.formatMessage(Category.Producer, Log$8.Level.Error, "ProducerTask.execute() key[" + key + "] onComputed() called after cancel");
            console.log(formattedMessage);
            Log$8.log(formattedMessage);
            throw new Error(formattedMessage);
          }
        }();
      }
      this.onComputed(onExecuted, control, output, ignoreOutput, predecessorVersions);
      this.forceCompute = false;
    };
    this.impl.compute(onComputed, predecessorOutputs, this.output, versions, scheduler);
  }
  onComputed(onExecuted, control, output, ignoreOutput, predecessorVersions) {
    var _this3 = this;
    const {
      key,
      dispatch
    } = this;
    (function () {
      if (Log$8.categories[Category.Producer] >= Level.Debug) {
        const formattedMessage = Log$8.formatMessage(Category.Producer, Level.Debug, "ProducerTask.execute() key[" + key + "] stop version[" + _this3.version + "] current output[" + JSON.stringify(_this3.output) + "] computed output[" + JSON.stringify(output) + "]");
        console.log(formattedMessage);
        return Log$8.log(formattedMessage);
      }
    })();
    if (!ignoreOutput) {
      this.onOutput(output); // calls dispatch() which can call cancel()
      this.predecessorVersions = predecessorVersions;
    }
    ++this._computedCount;
    this._computing = false;
    dispatch({
      type: Action$2.ProducerCompute,
      key,
      computing: false
    }); // can call cancel()
    if (control.cancel) return;
    this.control = null;
    onExecuted();
  }
  cancel() {
    const {
      key,
      dispatch
    } = this;
    if (this._computing) {
      this._computing = false;
      dispatch({
        type: Action$2.ProducerCompute,
        key,
        computing: false
      });
    }
    if (this.control) {
      (function () {
        if (Log$8.categories[Category.Producer] >= Level.Debug) {
          const formattedMessage = Log$8.formatMessage(Category.Producer, Level.Debug, "ProducerTask.cancel() key[" + key + "]");
          console.log(formattedMessage);
          return Log$8.log(formattedMessage);
        }
      })();
      this.control.cancel = true;
      this.control = null;
      this.impl.cancel();
    }
  }
  onOutput(output) {
    var _this4 = this;
    const {
      key,
      dispatch
    } = this;
    // lodash needed because JSON.stringify() is not stable (version optimisation)
    const modified = lodash.isEqual(this.output, output) ? false : true;
    (function () {
      if (Log$8.categories[Category.Producer] >= Level.Debug) {
        const formattedMessage = Log$8.formatMessage(Category.Producer, Level.Debug, "ProducerTask.onOutput() key[" + key + "] modified[" + modified + "] version[" + _this4.version + "] output[" + JSON.stringify(output) + "]");
        console.log(formattedMessage);
        return Log$8.log(formattedMessage);
      }
    })();
    if (modified) {
      this._output = output;
      ++this._version; // (version optimisation)
      dispatch({
        type: Action$2.NewOutput,
        key,
        output
      }); // can call cancel(). it is handled by the caller
    }
    return modified;
  }
  toJson() {
    return this.impl.toJson();
  }
  // OPTIM: only call this method if you understand what you are doing
  updateProducer(producer) {
    const {
      key
    } = this;
    (function () {
      if (Log$8.categories[Category.Producer] >= Level.Debug) {
        const formattedMessage = Log$8.formatMessage(Category.Producer, Level.Debug, "ProducerTask.updateProducer() key[" + key + "]");
        console.log(formattedMessage);
        return Log$8.log(formattedMessage);
      }
    })();
    const oldKeys = this.declarePredecessors();
    const newKeys = producer.declarePredecessors();
    if (oldKeys.length !== newKeys.length || oldKeys.some((key, index) => key !== newKeys[index])) {
      (function () {
        {
          const formattedMessage = Log$8.formatMessage(Category.Producer, Log$8.Level.Error, "ProducerTask.updateProducer() key[" + key + "] invalid producer oldKeys[" + JSON.stringify(oldKeys) + "] newKeys[" + JSON.stringify(newKeys) + "]");
          console.log(formattedMessage);
          Log$8.log(formattedMessage);
          throw new Error(formattedMessage);
        }
      })();
    }
    this.impl = producer;
  }
  // OPTIM: only call this method if you understand what you are doing
  updateOutput(newOutput) {
    const {
      key,
      _output: oldOutput
    } = this;
    (function () {
      if (Log$8.categories[Category.Producer] >= Level.Debug) {
        const formattedMessage = Log$8.formatMessage(Category.Producer, Level.Debug, "ProducerTask.updateOutput() key[" + key + "] oldOutput[" + JSON.stringify(oldOutput) + "] newOutput[" + JSON.stringify(newOutput) + "]");
        console.log(formattedMessage);
        return Log$8.log(formattedMessage);
      }
    })();
    this._output = newOutput;
  }
}

//
const Log$7 = Logger; // needed for jest
class SimpleProducerTaskDictionary {
  constructor(dico, dispatch) {
    this.dico = void 0;
    this.dispatch = void 0;
    this.tasks = new Map();
    this.dico = dico;
    this.dispatch = dispatch;
  }
  get(key) {
    let task = this.tasks.get(key);
    if (!task) {
      const producer = this.dico.get(key);
      if (!producer) {
        return function () {
          {
            const formattedMessage = Log$7.formatMessage(Category.Task, Log$7.Level.Error, "SimpleProducerTaskDictionary.get() missing key[" + key + "]");
            console.log(formattedMessage);
            Log$7.log(formattedMessage);
            throw new Error(formattedMessage);
          }
        }();
      }
      task = new ProducerTask(producer, this.dispatch);
      this.tasks.set(key, task);
    }
    return task;
  }
  remove(key) {
    const task = this.tasks.get(key);
    if (!task) {
      return function () {
        {
          const formattedMessage = Log$7.formatMessage(Category.Task, Log$7.Level.Error, "SimpleProducerTaskDictionary.remove() key[" + key + "] does not exist");
          console.log(formattedMessage);
          Log$7.log(formattedMessage);
          throw new Error(formattedMessage);
        }
      }();
    }
    (function () {
      if (Log$7.categories[Category.Task] >= Level.Debug) {
        const formattedMessage = Log$7.formatMessage(Category.Task, Level.Debug, "SimpleProducerTaskDictionary.remove() key[" + key + "]");
        console.log(formattedMessage);
        return Log$7.log(formattedMessage);
      }
    })();
    this.dico.remove(key);
    this.tasks.delete(key);
  }
  forEach(cb) {
    this.tasks.forEach(cb);
  }
  toArray() {
    return Array.from(this.tasks.values());
  }
}

//
const Log$6 = Logger; // needed for jest
function toString(tasks) {
  return JSON.stringify(tasks.map(_ref => {
    let {
      key,
      priority
    } = _ref;
    return {
      key,
      priority
    };
  }));
}
function stableSort(arr, compare) {
  return arr.map((item, index) => ({
    item,
    index
  })).sort((a, b) => compare(a.item, b.item) || a.index - b.index).map(_ref2 => {
    let {
      item
    } = _ref2;
    return item;
  });
}
class SimpleScheduler {
  constructor() {
    this.queue = [];
    this.running = false;
  }
  enqueue(tasks) {
    var _this = this;
    (function () {
      if (Log$6.categories[Category.Task] >= Level.Debug) {
        const formattedMessage = Log$6.formatMessage(Category.Task, Level.Debug, "Scheduler.enqueue() tasks[" + toString(tasks) + "] queue[" + toString(_this.queue) + "]");
        console.log(formattedMessage);
        return Log$6.log(formattedMessage);
      }
    })();
    this.queue.push(...tasks);
    this.queue = stableSort(this.queue, (a, b) => a.priority - b.priority);
    if (!this.running) {
      this.run();
    }
  }
  run() {
    // create as many setTimeout() as possible to leave CPU to the browser
    setTimeout(() => {
      const task = this.queue.shift();
      if (!task) return;
      (function () {
        if (Log$6.categories[Category.Task] >= Level.Debug) {
          const formattedMessage = Log$6.formatMessage(Category.Task, Level.Debug, "Scheduler.run() execute task[" + task.key + "]");
          console.log(formattedMessage);
          return Log$6.log(formattedMessage);
        }
      })();
      task.execute(this);
      if (this.queue.length) {
        this.run();
      } else {
        this.running = false;
      }
    }, 0);
  }
  cancel(tasks) {
    this.queue = this.queue.filter(task => !tasks.includes(task));
  }
}

function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
function _objectWithoutPropertiesLoose(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (-1 !== e.indexOf(n)) continue;
    t[n] = r[n];
  }
  return t;
}

/**
 * Authorization server response validation error.
 *
 * Unable to verify the validity of the request by matching
 * the "state" parameter sent with the authorization request
 * to the "state" parameter received in authorization server
 * response.
 *
 * This error may indicate a cross-site request forgery (CSRF)
 * attack or a misconfiguration of the authorization server.
 *
 * See: https://tools.ietf.org/html/rfc6749#section-10.12
 */
var ERR_STATE_MISMATCH$1 = 'state_mismatch';
var ERR_STATE_MISMATCH_DESCRIPTION$1 = "\n  This error may indicate a cross-site request forgery (CSRF)\n  attack or a misconfiguration of the authorization server.\n";
/**
 * Authorization server response validation error.
 *
 * SGWTConnect does not support the access token type
 * received from the authorization server.
 */
var ERR_UNSUPPORTED_TOKEN_TYPE$1 = 'unsupported_token_type';
var ERR_UNSUPPORTED_TOKEN_TYPE_DESCRIPTION$1 = "\n  SGWTConnect does not support the access token type\n  received from the authorization server.\n";
/**
 * SGWTConnect unauthorized error.
 *
 * Occurs when SGWTConnect is unable to perform an action
 * because it is currently unauthorized to do so.
 */
var ERR_UNAUTHORIZED$1 = 'unauthorized';
var ERR_UNAUTHORIZED_DESCRIPTION$1 = "\n  SGWTConnect is unable to perform an action\n  because it is currently unauthorized to do so.\n";
/**
 * SGWTConnect renewal error.
 *
 * Occurs when SGWTConnect does not receive a response
 * from the authorization server while renewing the token.
 */
var ERR_RENEW_TIMEOUT$1 = 'renew_timeout';
var ERR_RENEW_TIMEOUT_DESCRIPTION$1 = "\n  SGWTConnect did not receive a response\n  from the authorization server while\n  renewing the token.\n";
//
// OAuth 2.0 errors are listed below.
// See: https://tools.ietf.org/html/rfc6749#section-4.2.2.1
// --------------------
/**
 * Authorization server error response.
 *
 * The request is missing a required parameter, includes an
 * unsupported parameter value, includes a parameter more
 * than once, or is otherwise malformed.
 *
 * See: https://tools.ietf.org/html/rfc6749#section-4.2.2.1
 */
var ERR_INVALID_REQUEST$1 = 'invalid_request';
var ERR_INVALID_REQUEST_DESCRIPTION$1 = "\n  The configuration may be malformed.\n  Double check all configuration options.\n";
/**
 * Authorization server error response.
 *
 * The client is not authorized to request an access token
 * using this method.
 *
 * See: https://tools.ietf.org/html/rfc6749#section-4.2.2.1
 */
var ERR_UNAUTHORIZED_CLIENT$1 = 'unauthorized_client';
var ERR_UNAUTHORIZED_CLIENT_DESCRIPTION$1 = "\n  The client is not authorized to request an access token\n  using this method.\n";
/**
 * Authorization server error response.
 *
 * The resource owner or authorization server denied the request.
 *
 * See: https://tools.ietf.org/html/rfc6749#section-4.2.2.1
 */
var ERR_ACCESS_DENIED$1 = 'access_denied';
var ERR_ACCESS_DENIED_DESCRIPTION$1 = "\n  The resource owner or authorization server denied the request.\n";
/**
 * Authorization server error response.
 *
 * The authorization server does not support obtaining an
 * access token using this method.
 *
 * See: https://tools.ietf.org/html/rfc6749#section-4.2.2.1
 */
var ERR_UNSUPPORTED_RESPONSE_TYPE$1 = 'unsupported_response_type';
var ERR_UNSUPPORTED_RESPONSE_TYPE_DESCRIPTION$1 = "\n  The authorization server does not support obtaining an\n  access token using this method.\n\n  Double-check the \"response_type\" configuration option.\n";
/**
 * Authorization server error response.
 *
 * The requested scope is invalid, unknown, or malformed.
 *
 * See: https://tools.ietf.org/html/rfc6749#section-4.2.2.1
 */
var ERR_INVALID_SCOPE$1 = 'invalid_scope';
var ERR_INVALID_SCOPE_DESCRIPTION$1 = "\n  The requested scope is invalid, unknown, or malformed.\n";
/**
 * Authorization server error response.
 *
 * The authorization server encountered an unexpected
 * condition that prevented it from fulfilling the request.
 * (This error code is needed because a 500 Internal Server
 * Error HTTP status code cannot be returned to the client
 * via an HTTP redirect.)
 *
 * See: https://tools.ietf.org/html/rfc6749#section-4.2.2.1
 */
var ERR_SERVER_ERROR$1 = 'server_error';
var ERR_SERVER_ERROR_DESCRIPTION$1 = "\n  The authorization server encountered an unexpected\n  condition that prevented it from fulfilling the request.\n\n  Please try again in a few minutes.\n";
/**
 * Authorization server error response.
 *
 * The authorization server is currently unable to handle
 * the request due to a temporary overloading or maintenance
 * of the server. (This error code is needed because a 503
 * Service Unavailable HTTP status code cannot be returned
 * to the client via an HTTP redirect.)
 *
 * See: https://tools.ietf.org/html/rfc6749#section-4.2.2.1
 */
var ERR_TEMPORARILY_UNAVAILABLE$1 = 'temporarily_unavailable';
var ERR_TEMPORARILY_UNAVAILABLE_DESCRIPTION$1 = "\n  The authorization server is currently unable to handle\n  the request due to a temporary overloading or maintenance\n  of the server.\n\n  Please try again in a few minutes.\n";
//
// OpenID Connect 1.0 errors are listed below.
// See: http://openid.net/specs/openid-connect-core-1_0.html#AuthError
// --------------------
/**
 * OpenID Connect authentication error response.
 *
 * The Authorization Server requires End-User interaction
 * of some form to proceed. This error MAY be returned
 * when the prompt parameter value in the Authentication Request
 * is none, but the Authentication Request cannot be completed
 * without displaying a user interface for End-User interaction.
 *
 * See: http://openid.net/specs/openid-connect-core-1_0.html#AuthError
 */
var ERR_INTERACTION_REQUIRED$1 = 'interaction_required';
var ERR_INTERACTION_REQUIRED_DESCRIPTION$1 = "\n  The Authorization Server requires End-User interaction\n  of some form to proceed.\n";
/**
 * OpenID Connect authentication error response.
 *
 * The Authorization Server requires End-User authentication.
 * This error MAY be returned when the prompt parameter value in the
 * Authentication Request is none, but the Authentication Request
 * cannot be completed without displaying a user interface for
 * End-User authentication.
 *
 * See: http://openid.net/specs/openid-connect-core-1_0.html#AuthError
 */
var ERR_LOGIN_REQUIRED$1 = 'login_required';
var ERR_LOGIN_REQUIRED_DESCRIPTION$1 = "\n  The Authorization Server requires End-User authentication.\n";
/**
 * OpenID Connect authentication error response.
 *
 * The End-User is REQUIRED to select a session at the Authorization Server.
 * The End-User MAY be authenticated at the Authorization Server with
 * different associated accounts, but the End-User did not select a session.
 * This error MAY be returned when the prompt parameter value in the
 * Authentication Request is none, but the Authentication Request
 * cannot be completed without displaying a user interface to prompt
 * for a session to use.
 *
 * See: http://openid.net/specs/openid-connect-core-1_0.html#AuthError
 */
var ERR_ACCOUNT_SELECTION_REQUIRED$1 = 'account_selection_required';
var ERR_ACCOUNT_SELECTION_REQUIRED_DESCRIPTION$1 = "\n  The End-User is REQUIRED to select a session at the Authorization Server.\n  The End-User MAY be authenticated at the Authorization Server with\n  different associated accounts, but the End-User did not select a session.\n";
/**
 * OpenID Connect authentication error response.
 *
 * The Authorization Server requires End-User consent.
 * This error MAY be returned when the prompt parameter value in the
 * Authentication Request is none, but the Authentication Request
 * cannot be completed without displaying a user interface for
 * End-User consent.
 *
 * See: http://openid.net/specs/openid-connect-core-1_0.html#AuthError
 */
var ERR_CONSENT_REQUIRED$1 = 'consent_required';
var ERR_CONSENT_REQUIRED_DESCRIPTION$1 = "\n  The Authorization Server requires End-User consent.\n";
/**
 * OpenID Connect authentication error response.
 *
 * The request_uri in the Authorization Request returns an error
 * or contains invalid data.
 *
 * See: http://openid.net/specs/openid-connect-core-1_0.html#AuthError
 */
var ERR_INVALID_REQUEST_URI$1 = 'invalid_request_uri';
var ERR_INVALID_REQUEST_URI_DESCRIPTION$1 = "\n  The request_uri in the Authorization Request returns an error\n  or contains invalid data.\n\n  This is probably a bug in SGWTConnect.\n";
/**
 * OpenID Connect authentication error response.
 *
 * The request parameter contains an invalid Request Object.
 *
 * See: http://openid.net/specs/openid-connect-core-1_0.html#AuthError
 */
var ERR_INVALID_REQUEST_OBJECT$1 = 'invalid_request_object';
var ERR_INVALID_REQUEST_OBJECT_DESCRIPTION$1 = "\n  The request parameter contains an invalid Request Object.\n\n  This is probably a bug in SGWTConnect.\n";
/**
 * OpenID Connect authentication error response.
 *
 * The OpenID Provider does not support use of the `request` parameter defined in
 * [Section 6](http://openid.net/specs/openid-connect-core-1_0.html#JWTRequests).
 *
 * See: http://openid.net/specs/openid-connect-core-1_0.html#AuthError
 */
var ERR_REQUEST_NOT_SUPPORTED$1 = 'request_not_supported';
var ERR_REQUEST_NOT_SUPPORTED_DESCRIPTION$1 = "\n  The OpenID Provider does not support use of the \"request\" parameter.\n";
/**
 * OpenID Connect authentication error response.
 *
 * The OpenID Provider does not support use of the `request_uri` parameter defined in
 * [Section 6](http://openid.net/specs/openid-connect-core-1_0.html#JWTRequests).
 *
 * See: http://openid.net/specs/openid-connect-core-1_0.html#AuthError
 */
var ERR_REQUEST_URI_NOT_SUPPORTED$1 = 'request_uri_not_supported';
var ERR_REQUEST_URI_NOT_SUPPORTED_DESCRIPTION$1 = "\n  The OpenID Provider does not support use of the \"request_uri\" parameter.\n";
/**
 * OpenID Connect authentication error response.
 *
 * The OpenID Provider does not support use of the `registration` parameter defined in
 * [Section 7.2.1](http://openid.net/specs/openid-connect-core-1_0.html#RegistrationParameter).
 *
 * See: http://openid.net/specs/openid-connect-core-1_0.html#AuthError
 */
var ERR_REGISTRATION_NOT_SUPPORTED$1 = 'registration_not_supported';
var ERR_REGISTRATION_NOT_SUPPORTED_DESCRIPTION$1 = "\n  The OpenID Provider does not support use of the \"registration\" parameter.\n";
//
// OpenID Connect 1.0 Session Management errors are listed below.
// See: https://openid.net/specs/openid-connect-session-1_0.html
// --------------------
/**
 * Indicates that an HTTP request to obtain
 * the OpenID Provider Discovery Metadata has failed.
 */
var ERR_FAILED_TO_FETCH_OPENID_METADATA$1 = 'failed_to_obtain_openid_metadata';
var ERR_FAILED_TO_FETCH_OPENID_METADATA_DESCRIPTION$1 = "\n  Failed to obtain OpenID Provider Metadata.\n";
/**
 * Indicates that there was a error parsing
 * the OpenID Provider Discovery Metadata response.
 */
var ERR_FAILED_TO_PARSE_OPENID_METADATA$1 = 'failed_to_parse_openid_metadata';
var ERR_FAILED_TO_PARSE_OPENID_METADATA_DESCRIPTION$1 = "\n  Failed to parse OpenID Provider Discovery Metadata.\n";
/**
 * Indicates that there was an error validating
 * the OpenID Provider Discovery Metadata response.
 */
var ERR_FAILED_TO_VALIDATE_OPENID_METADATA$1 = 'failed_to_validate_openid_metadata';
var ERR_FAILED_TO_VALIDATE_OPENID_METADATA_DESCRIPTION$1 = "\n  Failed to validate OpenID Provider Discovery Metadata.\n";
/**
 * Indicates that the OpenID OP iframe received
 * a syntactically malformed message.
 *
 * See: https://openid.net/specs/openid-connect-session-1_0.html#OPiframe
 */
var ERR_OPENID_CHECK_SESSION_ERROR$1 = 'check_session_error';
var ERR_OPENID_CHECK_SESSION_ERROR_DESCRIPTION$1 = "\n  Client ID and origin URL cannot be determined or are syntactically invalid.\n";
//
// OpenID UserInfo Endpoint.
// See: https://openid.net/specs/openid-connect-core-1_0.html#UserInfo
// --------------------
/**
 * Indicates that an HTTP request to obtain
 * the OpenID UserInfo Claims has failed.
 */
var ERR_FAILED_TO_FETCH_OPENID_CLAIMS$1 = 'failed_to_obtain_openid_claims';
var ERR_FAILED_TO_FETCH_OPENID_CLAIMS_DESCRIPTION$1 = "\n  Failed to obtain OpenID UserInfo Claims.\n";
/**
 * Indicates that there was a error parsing
 * the OpenID UserInfo Claims response.
 */
var ERR_FAILED_TO_PARSE_OPENID_CLAIMS$1 = 'failed_to_parse_openid_claims';
var ERR_FAILED_TO_PARSE_OPENID_CLAIMS_DESCRIPTION$1 = "\n  Failed to parse OpenID UserInfo Claims.\n";
/**
 * Indicates that there was an error validating
 * the OpenID UserInfo Claims response.
 */
var ERR_FAILED_TO_VALIDATE_OPENID_CLAIMS$1 = 'failed_to_validate_openid_claims';
var ERR_FAILED_TO_VALIDATE_OPENID_CLAIMS_DESCRIPTION$1 = "\n  Failed to validate OpenID UserInfo Claims.\n";


var SGWTConnectErrorList$1 = /*#__PURE__*/Object.defineProperty({
	ERR_STATE_MISMATCH: ERR_STATE_MISMATCH$1,
	ERR_STATE_MISMATCH_DESCRIPTION: ERR_STATE_MISMATCH_DESCRIPTION$1,
	ERR_UNSUPPORTED_TOKEN_TYPE: ERR_UNSUPPORTED_TOKEN_TYPE$1,
	ERR_UNSUPPORTED_TOKEN_TYPE_DESCRIPTION: ERR_UNSUPPORTED_TOKEN_TYPE_DESCRIPTION$1,
	ERR_UNAUTHORIZED: ERR_UNAUTHORIZED$1,
	ERR_UNAUTHORIZED_DESCRIPTION: ERR_UNAUTHORIZED_DESCRIPTION$1,
	ERR_RENEW_TIMEOUT: ERR_RENEW_TIMEOUT$1,
	ERR_RENEW_TIMEOUT_DESCRIPTION: ERR_RENEW_TIMEOUT_DESCRIPTION$1,
	ERR_INVALID_REQUEST: ERR_INVALID_REQUEST$1,
	ERR_INVALID_REQUEST_DESCRIPTION: ERR_INVALID_REQUEST_DESCRIPTION$1,
	ERR_UNAUTHORIZED_CLIENT: ERR_UNAUTHORIZED_CLIENT$1,
	ERR_UNAUTHORIZED_CLIENT_DESCRIPTION: ERR_UNAUTHORIZED_CLIENT_DESCRIPTION$1,
	ERR_ACCESS_DENIED: ERR_ACCESS_DENIED$1,
	ERR_ACCESS_DENIED_DESCRIPTION: ERR_ACCESS_DENIED_DESCRIPTION$1,
	ERR_UNSUPPORTED_RESPONSE_TYPE: ERR_UNSUPPORTED_RESPONSE_TYPE$1,
	ERR_UNSUPPORTED_RESPONSE_TYPE_DESCRIPTION: ERR_UNSUPPORTED_RESPONSE_TYPE_DESCRIPTION$1,
	ERR_INVALID_SCOPE: ERR_INVALID_SCOPE$1,
	ERR_INVALID_SCOPE_DESCRIPTION: ERR_INVALID_SCOPE_DESCRIPTION$1,
	ERR_SERVER_ERROR: ERR_SERVER_ERROR$1,
	ERR_SERVER_ERROR_DESCRIPTION: ERR_SERVER_ERROR_DESCRIPTION$1,
	ERR_TEMPORARILY_UNAVAILABLE: ERR_TEMPORARILY_UNAVAILABLE$1,
	ERR_TEMPORARILY_UNAVAILABLE_DESCRIPTION: ERR_TEMPORARILY_UNAVAILABLE_DESCRIPTION$1,
	ERR_INTERACTION_REQUIRED: ERR_INTERACTION_REQUIRED$1,
	ERR_INTERACTION_REQUIRED_DESCRIPTION: ERR_INTERACTION_REQUIRED_DESCRIPTION$1,
	ERR_LOGIN_REQUIRED: ERR_LOGIN_REQUIRED$1,
	ERR_LOGIN_REQUIRED_DESCRIPTION: ERR_LOGIN_REQUIRED_DESCRIPTION$1,
	ERR_ACCOUNT_SELECTION_REQUIRED: ERR_ACCOUNT_SELECTION_REQUIRED$1,
	ERR_ACCOUNT_SELECTION_REQUIRED_DESCRIPTION: ERR_ACCOUNT_SELECTION_REQUIRED_DESCRIPTION$1,
	ERR_CONSENT_REQUIRED: ERR_CONSENT_REQUIRED$1,
	ERR_CONSENT_REQUIRED_DESCRIPTION: ERR_CONSENT_REQUIRED_DESCRIPTION$1,
	ERR_INVALID_REQUEST_URI: ERR_INVALID_REQUEST_URI$1,
	ERR_INVALID_REQUEST_URI_DESCRIPTION: ERR_INVALID_REQUEST_URI_DESCRIPTION$1,
	ERR_INVALID_REQUEST_OBJECT: ERR_INVALID_REQUEST_OBJECT$1,
	ERR_INVALID_REQUEST_OBJECT_DESCRIPTION: ERR_INVALID_REQUEST_OBJECT_DESCRIPTION$1,
	ERR_REQUEST_NOT_SUPPORTED: ERR_REQUEST_NOT_SUPPORTED$1,
	ERR_REQUEST_NOT_SUPPORTED_DESCRIPTION: ERR_REQUEST_NOT_SUPPORTED_DESCRIPTION$1,
	ERR_REQUEST_URI_NOT_SUPPORTED: ERR_REQUEST_URI_NOT_SUPPORTED$1,
	ERR_REQUEST_URI_NOT_SUPPORTED_DESCRIPTION: ERR_REQUEST_URI_NOT_SUPPORTED_DESCRIPTION$1,
	ERR_REGISTRATION_NOT_SUPPORTED: ERR_REGISTRATION_NOT_SUPPORTED$1,
	ERR_REGISTRATION_NOT_SUPPORTED_DESCRIPTION: ERR_REGISTRATION_NOT_SUPPORTED_DESCRIPTION$1,
	ERR_FAILED_TO_FETCH_OPENID_METADATA: ERR_FAILED_TO_FETCH_OPENID_METADATA$1,
	ERR_FAILED_TO_FETCH_OPENID_METADATA_DESCRIPTION: ERR_FAILED_TO_FETCH_OPENID_METADATA_DESCRIPTION$1,
	ERR_FAILED_TO_PARSE_OPENID_METADATA: ERR_FAILED_TO_PARSE_OPENID_METADATA$1,
	ERR_FAILED_TO_PARSE_OPENID_METADATA_DESCRIPTION: ERR_FAILED_TO_PARSE_OPENID_METADATA_DESCRIPTION$1,
	ERR_FAILED_TO_VALIDATE_OPENID_METADATA: ERR_FAILED_TO_VALIDATE_OPENID_METADATA$1,
	ERR_FAILED_TO_VALIDATE_OPENID_METADATA_DESCRIPTION: ERR_FAILED_TO_VALIDATE_OPENID_METADATA_DESCRIPTION$1,
	ERR_OPENID_CHECK_SESSION_ERROR: ERR_OPENID_CHECK_SESSION_ERROR$1,
	ERR_OPENID_CHECK_SESSION_ERROR_DESCRIPTION: ERR_OPENID_CHECK_SESSION_ERROR_DESCRIPTION$1,
	ERR_FAILED_TO_FETCH_OPENID_CLAIMS: ERR_FAILED_TO_FETCH_OPENID_CLAIMS$1,
	ERR_FAILED_TO_FETCH_OPENID_CLAIMS_DESCRIPTION: ERR_FAILED_TO_FETCH_OPENID_CLAIMS_DESCRIPTION$1,
	ERR_FAILED_TO_PARSE_OPENID_CLAIMS: ERR_FAILED_TO_PARSE_OPENID_CLAIMS$1,
	ERR_FAILED_TO_PARSE_OPENID_CLAIMS_DESCRIPTION: ERR_FAILED_TO_PARSE_OPENID_CLAIMS_DESCRIPTION$1,
	ERR_FAILED_TO_VALIDATE_OPENID_CLAIMS: ERR_FAILED_TO_VALIDATE_OPENID_CLAIMS$1,
	ERR_FAILED_TO_VALIDATE_OPENID_CLAIMS_DESCRIPTION: ERR_FAILED_TO_VALIDATE_OPENID_CLAIMS_DESCRIPTION$1
}, '__esModule', {value: true});

var __extends$3 = (commonjsGlobal && commonjsGlobal.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();


/**
 * SGWTConnect error.
 *
 * The purpose of this class is to differentiate custom SGWTConnect
 * errors from errors originated in other modules.
 */
var SGWTConnectError$1 = /** @class */ (function (_super) {
    __extends$3(SGWTConnectError, _super);
    function SGWTConnectError(code) {
        var _this = this;
        var errorListKey = "ERR_" + code.toUpperCase() + "_DESCRIPTION";
        var description = SGWTConnectErrorList$1[errorListKey];
        _this = _super.call(this, "SGWTConnectError " + code.toUpperCase() + " " + description) || this;
        // Calling `super` in TypeScript 2.1 and 2.2 breaks the
        // prototype chain, so we need to restore it here to
        // enable instanceof checks
        // See: https://github.com/Microsoft/TypeScript/wiki/Breaking-Changes#typescript-21
        Object.setPrototypeOf(_this, SGWTConnectError.prototype);
        // We use the same approach as NodeJS errors by exposing
        // a `code` property (e.g. "state_mismatch") on error
        // instances:
        _this.code = code;
        return _this;
    }
    return SGWTConnectError;
}(Error));
var SGWTConnectError_2$1 = SGWTConnectError$1;


var SGWTConnectError_1$1 = /*#__PURE__*/Object.defineProperty({
	SGWTConnectError: SGWTConnectError_2$1
}, '__esModule', {value: true});

/**
 * The authorization token has been discarded.
 */
var EVENT_AUTH_DISCARDED$1 = 'authorizationDiscarded';
/**
 * The authorization token has expired.
 */
var EVENT_AUTH_EXPIRED$1 = 'authorizationExpired';
/**
 * Error has occurred while renewing the token.
 */
var EVENT_AUTH_RENEW_ERROR$1 = 'renewAuthorizationError';
/**
 * The current token has been successfully renewed.
 */
var EVENT_AUTH_RENEW_SUCCESS$1 = 'renewAuthorizationSuccess';
/**
 * Error has occurred while fetching the OpenID Metadata.
 */
var EVENT_OPENID_METADATA_FETCH_ERROR$1 = 'OpenIDMetadataFetchError';
/**
 * Indicates that the OpenID session has changed.
 */
var EVENT_OPENID_SESSION_CHANGED$1 = 'OpenIDCheckSessionChanged';
/**
 * Indicates that the OpenID session has not changed.
 */
var EVENT_OPENID_SESSION_UNCHANGED$1 = 'OpenIDCheckSessionUnchanged';
/**
 * Error has occurred while fetching the OpenID Metadata.
 */
var EVENT_OPENID_CHECK_SESSION_ERROR$1 = 'OpenIDCheckSessionError';


var SGWTConnectEventList$1 = /*#__PURE__*/Object.defineProperty({
	EVENT_AUTH_DISCARDED: EVENT_AUTH_DISCARDED$1,
	EVENT_AUTH_EXPIRED: EVENT_AUTH_EXPIRED$1,
	EVENT_AUTH_RENEW_ERROR: EVENT_AUTH_RENEW_ERROR$1,
	EVENT_AUTH_RENEW_SUCCESS: EVENT_AUTH_RENEW_SUCCESS$1,
	EVENT_OPENID_METADATA_FETCH_ERROR: EVENT_OPENID_METADATA_FETCH_ERROR$1,
	EVENT_OPENID_SESSION_CHANGED: EVENT_OPENID_SESSION_CHANGED$1,
	EVENT_OPENID_SESSION_UNCHANGED: EVENT_OPENID_SESSION_UNCHANGED$1,
	EVENT_OPENID_CHECK_SESSION_ERROR: EVENT_OPENID_CHECK_SESSION_ERROR$1
}, '__esModule', {value: true});

/**
 * Generates a cryptographically strong random value.
 */
function generateCryptoStrongRandomValue$1() {
    var crypto = window.crypto || window.msCrypto;
    var randomValues = crypto.getRandomValues(new Uint32Array(5));
    // IE supports neither TypedArray methods nor Array.from,
    // so we have to use a for loop here if we want this script
    // to be injectable before polyfills:
    var base36RandomValue = '';
    for (var i = 0; i < randomValues.length; i += 1) { // tslint:disable-line:prefer-for-of
        base36RandomValue += randomValues[i].toString(36);
    }
    return base36RandomValue;
}
var generateCryptoStrongRandomValue_1$1 = generateCryptoStrongRandomValue$1;
/**
 * Normalizes the authorization endpoint by stripping /oauth2/* suffixes.
 */
function normalizeAuthorizationEndpoint$1(authorization_endpoint) {
    return authorization_endpoint
        .replace(/(\/oauth2\/authorize|\/userinfo)?\/?$/, '');
}
var normalizeAuthorizationEndpoint_1$1 = normalizeAuthorizationEndpoint$1;
/**
 * Generates an OAuth2/OpenID-compliant authorization URI.
 */
function generateAuthorizationUri$1(config, state, options) {
    return normalizeAuthorizationEndpoint$1(config.authorization_endpoint) +
        '/oauth2/authorize' +
        '?client_id=' + encodeURIComponent(config.client_id) +
        '&redirect_uri=' + encodeURIComponent(config.redirect_uri) +
        '&response_type=' + encodeURIComponent(config.response_type) +
        '&scope=' + encodeURIComponent(config.scope) +
        '&nonce=' + encodeURIComponent(generateCryptoStrongRandomValue$1()) +
        '&state=' + encodeURIComponent(state) +
        '&acr_values=' + encodeURIComponent(config.acr_values) +
        (options && options.prompt ? '&prompt=' + options.prompt : '') +
        (options && options.id_token_hint ? '&id_token_hint=' + options.id_token_hint : '');
}
var generateAuthorizationUri_1$1 = generateAuthorizationUri$1;


var SGWTConnectAuthorizationUri$1 = /*#__PURE__*/Object.defineProperty({
	generateCryptoStrongRandomValue: generateCryptoStrongRandomValue_1$1,
	normalizeAuthorizationEndpoint: normalizeAuthorizationEndpoint_1$1,
	generateAuthorizationUri: generateAuthorizationUri_1$1
}, '__esModule', {value: true});

/**
 * Determines whether the checked scope is listed in the actual scope.
 */
function isScopeListed$1(checkedScope, actualScope) {
    var checkedScopeList = checkedScope.trim().toLowerCase().split(/\s+/);
    var actualScopeList = actualScope.trim().toLowerCase().split(/\s+/);
    return checkedScopeList.every(function (scope) { return actualScopeList.indexOf(scope) !== -1; });
}
var isScopeListed_2$1 = isScopeListed$1;


var isScopeListed_1$1 = /*#__PURE__*/Object.defineProperty({
	isScopeListed: isScopeListed_2$1
}, '__esModule', {value: true});

/**
 * Normalizes a URL by lowercasing it, adding the trailing slash,
 * and removing the default ports (:80 for http and :443 for https).
 * @param url URL to normalize.
 * @example
 *   normalizeUrl('HTTP://EXAMPLE.COM') === 'http://example.com/'
 *   normalizeUrl('http://example.com:80') === 'http://example.com/'
 *   normalizeUrl('https://example.com:443') === 'https://example.com/'
 */
function normalizeUrl$1(url) {
    // Using HTMLAnchorElement hack because Internet Explorer
    // doesn't support the Window.URL API:
    var a = document.createElement('a');
    a.href = url;
    return a.href;
}
var normalizeUrl_2$1 = normalizeUrl$1;


var normalizeUrl_1$1 = /*#__PURE__*/Object.defineProperty({
	normalizeUrl: normalizeUrl_2$1
}, '__esModule', {value: true});

/**
 * Creates an object from a string of query parameters.
 */
function parseQueryParametersString$1(queryParametersString) {
    var queryParametersRegex = /([^&=]+)=([^&]*)/g;
    var queryParameters = {};
    var keyValuePair;
    // tslint:disable-next-line:no-conditional-assignment
    while (keyValuePair = queryParametersRegex.exec(queryParametersString)) {
        var key = decodeURIComponent(keyValuePair[1]);
        var value = decodeURIComponent(keyValuePair[2]);
        queryParameters[key] = value;
    }
    return queryParameters;
}
/**
 * Parses an authorization server response.
 */
function parseOAuth2Fragment$1(fragment) {
    return parseQueryParametersString$1(fragment.replace(/^#/, ''));
}
var parseOAuth2Fragment_1$1 = parseOAuth2Fragment$1;
/**
 * Normalizes a parsed authorization server response.
 */
function normalizeAuthServerResponse$1(authServerResponse) {
    if (authServerResponse.error) {
        var authError = {
            error: authServerResponse.error,
            error_description: authServerResponse.error_description,
            state: authServerResponse.state
        };
        return authError;
    }
    var expiresIn = parseInt(authServerResponse.expires_in, 10) * 1000;
    var authSuccess = {
        access_token: authServerResponse.access_token,
        expires_in: expiresIn,
        expires_at: Date.now() + expiresIn,
        id_token: authServerResponse.id_token,
        scope: authServerResponse.scope,
        state: authServerResponse.state,
        token_type: authServerResponse.token_type,
        session_state: authServerResponse.session_state
    };
    return authSuccess;
}
var normalizeAuthServerResponse_1$1 = normalizeAuthServerResponse$1;


var SGWTConnectServerResponse$1 = /*#__PURE__*/Object.defineProperty({
	parseOAuth2Fragment: parseOAuth2Fragment_1$1,
	normalizeAuthServerResponse: normalizeAuthServerResponse_1$1
}, '__esModule', {value: true});

/**
 * Generates a redirect URI.
 *
 * Given the origin "https://example.com":
 *  - "" -> "https://example.com"
 *  - "/redirect" -> "https://example.com/redirect"
 *  - "https://example.com" -> "https://example.com"
 */
function generateRedirectUri$1(location, redirectUri) {
    var origin = location.protocol + "//" + location.host;
    // Support empty or unspecified redirect_uri
    // by using the current origin instead:
    // "" => "https://example.com"
    if (!redirectUri) {
        return origin;
    }
    // Support URIs relative to origin, for example:
    // "/redirect" => "https://example.com/redirect"
    if (redirectUri.charAt(0) === '/') {
        return "" + origin + redirectUri;
    }
    // Otherwise use the redirect_uri as provided.
    // Note that we're not trying to normalize it
    // because it will be compared as is on the
    // authorization server.
    return redirectUri;
}
var generateRedirectUri_1$1 = generateRedirectUri$1;
/**
 * Determines if the current page has been redirected using OAuth2 protocol.
 */
function isOnRedirectUri$1(config, location) {
    //
    // Step 1: validate the fragment
    // --------------------
    var authEndpointResponse = SGWTConnectServerResponse$1.parseOAuth2Fragment(location.hash);
    // Ensure that the fragment has at least the "state" parameter,
    // otherwise this is not a valid OAuth2 fragment:
    if (!authEndpointResponse.hasOwnProperty('state')) {
        return false;
    }
    var hasRequestedAccessToken = isScopeListed_1$1.isScopeListed('token', config.response_type);
    var hasRequestedIdToken = isScopeListed_1$1.isScopeListed('id_token', config.response_type);
    var hasReceivedAccessToken = authEndpointResponse.hasOwnProperty('access_token');
    var hasReceivedIdToken = authEndpointResponse.hasOwnProperty('id_token');
    var hasReceivedError = authEndpointResponse.hasOwnProperty('error');
    if (hasRequestedAccessToken) {
        if (!hasReceivedAccessToken && !hasReceivedError) {
            return false;
        }
    }
    if (hasRequestedIdToken) {
        if (!hasReceivedIdToken && !hasReceivedError) {
            return false;
        }
    }
    //
    // Step 2: validate the href without fragment
    // --------------------
    // Remove the fragment from the current location and normalize it
    // to avoid infinite redirects due to non-strictly equal URIs:
    var currentUri = normalizeUrl_1$1.normalizeUrl(location.href.replace(location.hash, ''));
    // Compare to normalized redirect URI assuming that
    // it has no fragment (as per specification):
    return currentUri === normalizeUrl_1$1.normalizeUrl(config.redirect_uri);
}
var isOnRedirectUri_1$1 = isOnRedirectUri$1;


var SGWTConnectRedirectUri$1 = /*#__PURE__*/Object.defineProperty({
	generateRedirectUri: generateRedirectUri_1$1,
	isOnRedirectUri: isOnRedirectUri_1$1
}, '__esModule', {value: true});

var __assign$3 = (commonjsGlobal && commonjsGlobal.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};



/**
 * Normalizes the configuration by adding default fields,
 * and normalizing existing fields.
 * @param config Configuration object to normalize.
 */
function normalizeConfiguration$1(config, location) {
    return __assign$3({}, config, { response_type: config.response_type || 'id_token token', acr_values: config.acr_values || 'L2', 
        // Normalize the authorization endpoint by stripping some
        // extraneous suffixes that users may add:
        authorization_endpoint: SGWTConnectAuthorizationUri$1.normalizeAuthorizationEndpoint(config.authorization_endpoint), 
        // API consumers may:
        //  - specify a redirect_uri relative to origin
        //    in this case we prefix it with origin
        //  - not specify a redirect_uri at all
        //    in this case we define it for them, as it is mandatory
        redirect_uri: SGWTConnectRedirectUri$1.generateRedirectUri(location, config.redirect_uri) }, config.post_logout_redirect_uri
        ? { post_logout_redirect_uri: SGWTConnectRedirectUri$1.generateRedirectUri(location, config.post_logout_redirect_uri) }
        : {});
}
var normalizeConfiguration_1$1 = normalizeConfiguration$1;


var SGWTConnectConfiguration$1 = /*#__PURE__*/Object.defineProperty({
	normalizeConfiguration: normalizeConfiguration_1$1
}, '__esModule', {value: true});

/**
 * SGWTConnect data storage.
 *
 * Has the following features:
 *  - Automatic parsing of stringified data.
 *  - Prefixing of keys of stored data.
 */
var SGWTConnectStorage$1 = /** @class */ (function () {
    function SGWTConnectStorage(hash) {
        if (hash === void 0) { hash = ''; }
        this.hash = hash;
        this.baseStorageKey = 'SGWTConnectStorage';
    }
    Object.defineProperty(SGWTConnectStorage.prototype, "storageKey", {
        get: function () {
            return this.hash ? this.baseStorageKey + "." + this.hash : this.baseStorageKey;
        },
        enumerable: true,
        configurable: true
    });
    SGWTConnectStorage.prototype.getItem = function (key) {
        var item = localStorage.getItem(this.storageKey + "." + key);
        return item === null ? null : JSON.parse(item);
    };
    SGWTConnectStorage.prototype.setItem = function (key, value) {
        localStorage.setItem(this.storageKey + "." + key, JSON.stringify(value));
    };
    SGWTConnectStorage.prototype.removeItem = function (key) {
        localStorage.removeItem(this.storageKey + "." + key);
    };
    SGWTConnectStorage.prototype.clearBy = function (satisfiesCondition) {
        for (var i = 0; i < localStorage.length; i += 1) {
            var key = localStorage.key(i);
            if (key && key.indexOf(this.baseStorageKey) !== -1) {
                var value = localStorage.getItem(key);
                var parsedValue = value === null ? null : JSON.parse(value);
                if (satisfiesCondition(parsedValue, key)) {
                    localStorage.removeItem(key);
                }
            }
        }
    };
    return SGWTConnectStorage;
}());
var SGWTConnectStorage_2$1 = SGWTConnectStorage$1;


var SGWTConnectStorage_1$1 = /*#__PURE__*/Object.defineProperty({
	SGWTConnectStorage: SGWTConnectStorage_2$1
}, '__esModule', {value: true});

// Copyright Joyent, Inc. and other Node contributors.

var R = typeof Reflect === 'object' ? Reflect : null;
var ReflectApply = R && typeof R.apply === 'function'
  ? R.apply
  : function ReflectApply(target, receiver, args) {
    return Function.prototype.apply.call(target, receiver, args);
  };

var ReflectOwnKeys;
if (R && typeof R.ownKeys === 'function') {
  ReflectOwnKeys = R.ownKeys;
} else if (Object.getOwnPropertySymbols) {
  ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target)
      .concat(Object.getOwnPropertySymbols(target));
  };
} else {
  ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target);
  };
}

function ProcessEmitWarning(warning) {
  if (console && console.warn) console.warn(warning);
}

var NumberIsNaN = Number.isNaN || function NumberIsNaN(value) {
  return value !== value;
};

function EventEmitter() {
  EventEmitter.init.call(this);
}
var events = EventEmitter;

// Backwards-compat with node 0.10.x
EventEmitter.EventEmitter = EventEmitter;

EventEmitter.prototype._events = undefined;
EventEmitter.prototype._eventsCount = 0;
EventEmitter.prototype._maxListeners = undefined;

// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
var defaultMaxListeners = 10;

Object.defineProperty(EventEmitter, 'defaultMaxListeners', {
  enumerable: true,
  get: function() {
    return defaultMaxListeners;
  },
  set: function(arg) {
    if (typeof arg !== 'number' || arg < 0 || NumberIsNaN(arg)) {
      throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + arg + '.');
    }
    defaultMaxListeners = arg;
  }
});

EventEmitter.init = function() {

  if (this._events === undefined ||
      this._events === Object.getPrototypeOf(this)._events) {
    this._events = Object.create(null);
    this._eventsCount = 0;
  }

  this._maxListeners = this._maxListeners || undefined;
};

// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
  if (typeof n !== 'number' || n < 0 || NumberIsNaN(n)) {
    throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + n + '.');
  }
  this._maxListeners = n;
  return this;
};

function $getMaxListeners(that) {
  if (that._maxListeners === undefined)
    return EventEmitter.defaultMaxListeners;
  return that._maxListeners;
}

EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
  return $getMaxListeners(this);
};

EventEmitter.prototype.emit = function emit(type) {
  var args = [];
  for (var i = 1; i < arguments.length; i++) args.push(arguments[i]);
  var doError = (type === 'error');

  var events = this._events;
  if (events !== undefined)
    doError = (doError && events.error === undefined);
  else if (!doError)
    return false;

  // If there is no 'error' event listener then throw.
  if (doError) {
    var er;
    if (args.length > 0)
      er = args[0];
    if (er instanceof Error) {
      // Note: The comments on the `throw` lines are intentional, they show
      // up in Node's output if this results in an unhandled exception.
      throw er; // Unhandled 'error' event
    }
    // At least give some kind of context to the user
    var err = new Error('Unhandled error.' + (er ? ' (' + er.message + ')' : ''));
    err.context = er;
    throw err; // Unhandled 'error' event
  }

  var handler = events[type];

  if (handler === undefined)
    return false;

  if (typeof handler === 'function') {
    ReflectApply(handler, this, args);
  } else {
    var len = handler.length;
    var listeners = arrayClone(handler, len);
    for (var i = 0; i < len; ++i)
      ReflectApply(listeners[i], this, args);
  }

  return true;
};

function _addListener(target, type, listener, prepend) {
  var m;
  var events;
  var existing;

  if (typeof listener !== 'function') {
    throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
  }

  events = target._events;
  if (events === undefined) {
    events = target._events = Object.create(null);
    target._eventsCount = 0;
  } else {
    // To avoid recursion in the case that type === "newListener"! Before
    // adding it to the listeners, first emit "newListener".
    if (events.newListener !== undefined) {
      target.emit('newListener', type,
                  listener.listener ? listener.listener : listener);

      // Re-assign `events` because a newListener handler could have caused the
      // this._events to be assigned to a new object
      events = target._events;
    }
    existing = events[type];
  }

  if (existing === undefined) {
    // Optimize the case of one listener. Don't need the extra array object.
    existing = events[type] = listener;
    ++target._eventsCount;
  } else {
    if (typeof existing === 'function') {
      // Adding the second element, need to change to array.
      existing = events[type] =
        prepend ? [listener, existing] : [existing, listener];
      // If we've already got an array, just append.
    } else if (prepend) {
      existing.unshift(listener);
    } else {
      existing.push(listener);
    }

    // Check for listener leak
    m = $getMaxListeners(target);
    if (m > 0 && existing.length > m && !existing.warned) {
      existing.warned = true;
      // No error code for this since it is a Warning
      // eslint-disable-next-line no-restricted-syntax
      var w = new Error('Possible EventEmitter memory leak detected. ' +
                          existing.length + ' ' + String(type) + ' listeners ' +
                          'added. Use emitter.setMaxListeners() to ' +
                          'increase limit');
      w.name = 'MaxListenersExceededWarning';
      w.emitter = target;
      w.type = type;
      w.count = existing.length;
      ProcessEmitWarning(w);
    }
  }

  return target;
}

EventEmitter.prototype.addListener = function addListener(type, listener) {
  return _addListener(this, type, listener, false);
};

EventEmitter.prototype.on = EventEmitter.prototype.addListener;

EventEmitter.prototype.prependListener =
    function prependListener(type, listener) {
      return _addListener(this, type, listener, true);
    };

function onceWrapper() {
  var args = [];
  for (var i = 0; i < arguments.length; i++) args.push(arguments[i]);
  if (!this.fired) {
    this.target.removeListener(this.type, this.wrapFn);
    this.fired = true;
    ReflectApply(this.listener, this.target, args);
  }
}

function _onceWrap(target, type, listener) {
  var state = { fired: false, wrapFn: undefined, target: target, type: type, listener: listener };
  var wrapped = onceWrapper.bind(state);
  wrapped.listener = listener;
  state.wrapFn = wrapped;
  return wrapped;
}

EventEmitter.prototype.once = function once(type, listener) {
  if (typeof listener !== 'function') {
    throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
  }
  this.on(type, _onceWrap(this, type, listener));
  return this;
};

EventEmitter.prototype.prependOnceListener =
    function prependOnceListener(type, listener) {
      if (typeof listener !== 'function') {
        throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
      }
      this.prependListener(type, _onceWrap(this, type, listener));
      return this;
    };

// Emits a 'removeListener' event if and only if the listener was removed.
EventEmitter.prototype.removeListener =
    function removeListener(type, listener) {
      var list, events, position, i, originalListener;

      if (typeof listener !== 'function') {
        throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
      }

      events = this._events;
      if (events === undefined)
        return this;

      list = events[type];
      if (list === undefined)
        return this;

      if (list === listener || list.listener === listener) {
        if (--this._eventsCount === 0)
          this._events = Object.create(null);
        else {
          delete events[type];
          if (events.removeListener)
            this.emit('removeListener', type, list.listener || listener);
        }
      } else if (typeof list !== 'function') {
        position = -1;

        for (i = list.length - 1; i >= 0; i--) {
          if (list[i] === listener || list[i].listener === listener) {
            originalListener = list[i].listener;
            position = i;
            break;
          }
        }

        if (position < 0)
          return this;

        if (position === 0)
          list.shift();
        else {
          spliceOne(list, position);
        }

        if (list.length === 1)
          events[type] = list[0];

        if (events.removeListener !== undefined)
          this.emit('removeListener', type, originalListener || listener);
      }

      return this;
    };

EventEmitter.prototype.off = EventEmitter.prototype.removeListener;

EventEmitter.prototype.removeAllListeners =
    function removeAllListeners(type) {
      var listeners, events, i;

      events = this._events;
      if (events === undefined)
        return this;

      // not listening for removeListener, no need to emit
      if (events.removeListener === undefined) {
        if (arguments.length === 0) {
          this._events = Object.create(null);
          this._eventsCount = 0;
        } else if (events[type] !== undefined) {
          if (--this._eventsCount === 0)
            this._events = Object.create(null);
          else
            delete events[type];
        }
        return this;
      }

      // emit removeListener for all listeners on all events
      if (arguments.length === 0) {
        var keys = Object.keys(events);
        var key;
        for (i = 0; i < keys.length; ++i) {
          key = keys[i];
          if (key === 'removeListener') continue;
          this.removeAllListeners(key);
        }
        this.removeAllListeners('removeListener');
        this._events = Object.create(null);
        this._eventsCount = 0;
        return this;
      }

      listeners = events[type];

      if (typeof listeners === 'function') {
        this.removeListener(type, listeners);
      } else if (listeners !== undefined) {
        // LIFO order
        for (i = listeners.length - 1; i >= 0; i--) {
          this.removeListener(type, listeners[i]);
        }
      }

      return this;
    };

function _listeners(target, type, unwrap) {
  var events = target._events;

  if (events === undefined)
    return [];

  var evlistener = events[type];
  if (evlistener === undefined)
    return [];

  if (typeof evlistener === 'function')
    return unwrap ? [evlistener.listener || evlistener] : [evlistener];

  return unwrap ?
    unwrapListeners(evlistener) : arrayClone(evlistener, evlistener.length);
}

EventEmitter.prototype.listeners = function listeners(type) {
  return _listeners(this, type, true);
};

EventEmitter.prototype.rawListeners = function rawListeners(type) {
  return _listeners(this, type, false);
};

EventEmitter.listenerCount = function(emitter, type) {
  if (typeof emitter.listenerCount === 'function') {
    return emitter.listenerCount(type);
  } else {
    return listenerCount.call(emitter, type);
  }
};

EventEmitter.prototype.listenerCount = listenerCount;
function listenerCount(type) {
  var events = this._events;

  if (events !== undefined) {
    var evlistener = events[type];

    if (typeof evlistener === 'function') {
      return 1;
    } else if (evlistener !== undefined) {
      return evlistener.length;
    }
  }

  return 0;
}

EventEmitter.prototype.eventNames = function eventNames() {
  return this._eventsCount > 0 ? ReflectOwnKeys(this._events) : [];
};

function arrayClone(arr, n) {
  var copy = new Array(n);
  for (var i = 0; i < n; ++i)
    copy[i] = arr[i];
  return copy;
}

function spliceOne(list, index) {
  for (; index + 1 < list.length; index++)
    list[index] = list[index + 1];
  list.pop();
}

function unwrapListeners(arr) {
  var ret = new Array(arr.length);
  for (var i = 0; i < ret.length; ++i) {
    ret[i] = arr[i].listener || arr[i];
  }
  return ret;
}

/**
 * Determines whether two valid URLs are of the same origin.
 *
 * There is no URL normalization, thus
 * `isSameOrigin('http://localhost', 'localhost')` is `false`.
 */
function isSameOrigin$1(urlA, urlB) {
    // Using HTMLAnchorElement hack because Internet Explorer
    // doesn't support the Window.URL API:
    var a = document.createElement('a');
    a.href = urlA;
    var protocolA = a.protocol, hostA = a.host;
    a.href = urlB;
    var protocolB = a.protocol, hostB = a.host;
    // Internet Explorer doesn't implement HTMLAnchorElement.origin,
    // so we consider origin to be the same when their protocols,
    // hostnames, and ports match exactly. Note that HTMLAnchorElement
    // normalizes the URL (lowercases it, removes trailing slash) and
    // HTMLAnchorElement.host value already includes the port, for ex:
    // "HTTP://Example.com:8080/foo"
    //   - protocol: "http:"
    //   - host: "example.com:8080"
    return protocolA === protocolB && hostA === hostB;
}
var isSameOrigin_2$1 = isSameOrigin$1;


var isSameOrigin_1$1 = /*#__PURE__*/Object.defineProperty({
	isSameOrigin: isSameOrigin_2$1
}, '__esModule', {value: true});

/**
 * Determines whether the given value is an object.
 * @param value A value to check.
 */
function isObject$1(value) {
    return value !== null && typeof value === 'object';
}
var isObject_2$1 = isObject$1;


var isObject_1$1 = /*#__PURE__*/Object.defineProperty({
	isObject: isObject_2$1
}, '__esModule', {value: true});

/**
 * Fetches OpenID Claims from the OpenID Provider's "userinfo" endpoint.
 * @param authorizationEndpoint OpenID Provider's "userinfo" endpoint URL.
 * @param authorizationHeader OpenID Provider's "userinfo" endpoint URL.
 * @param callback Called with Claims or error upon request completion.
 */
function fetchOpenIDUserInfo$1(authorizationEndpoint, authorizationHeader, callback) {
    var xhr = new XMLHttpRequest();
    xhr.open('GET', authorizationEndpoint + "/oauth2/userinfo");
    xhr.setRequestHeader('Accept', 'application/json');
    xhr.setRequestHeader('Authorization', authorizationHeader);
    xhr.addEventListener('load', function handleOpenIDUserInfoLoad() {
        if (xhr.status === 200) {
            var openIDUserInfo = void 0;
            try {
                openIDUserInfo = JSON.parse(xhr.responseText);
            }
            catch (_a) {
                callback(new SGWTConnectError_1$1.SGWTConnectError(SGWTConnectErrorList$1.ERR_FAILED_TO_PARSE_OPENID_CLAIMS));
                return;
            }
            if (isValidOpenIDClaims$1(openIDUserInfo)) {
                callback(null, openIDUserInfo);
            }
            else {
                callback(new SGWTConnectError_1$1.SGWTConnectError(SGWTConnectErrorList$1.ERR_FAILED_TO_VALIDATE_OPENID_CLAIMS));
            }
        }
        else {
            callback(new SGWTConnectError_1$1.SGWTConnectError(SGWTConnectErrorList$1.ERR_FAILED_TO_FETCH_OPENID_CLAIMS));
        }
    });
    xhr.send();
}
var fetchOpenIDUserInfo_1$1 = fetchOpenIDUserInfo$1;
/**
 * Determines whether the given OpenID Configuration is valid.
 * @param openIDUserInfo JSON-parsed value obtained from the Discovery API.
 */
function isValidOpenIDClaims$1(openIDUserInfo) {
    return isObject_1$1.isObject(openIDUserInfo) &&
        typeof openIDUserInfo.sub === 'string' &&
        typeof openIDUserInfo.name === 'string' &&
        typeof openIDUserInfo.locale === 'string';
}


var SGWTConnectOpenIDUserInfo$1 = /*#__PURE__*/Object.defineProperty({
	fetchOpenIDUserInfo: fetchOpenIDUserInfo_1$1
}, '__esModule', {value: true});

var SGWTConnectCore_1$1 = createCommonjsModule(function (module, exports) {
var __extends = (commonjsGlobal && commonjsGlobal.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });









exports.SGWTConnectRenewalFrameAttribute = 'data-sgwt-connect-renewal-frame';
exports.SGWTConnectCheckSesssionFrameAttribute = 'data-sgwt-connect-check-session-frame';
/**
 * Main API of SGWTConnect.
 */
var SGWTConnectCore = /** @class */ (function (_super) {
    __extends(SGWTConnectCore, _super);
    function SGWTConnectCore(config, storage, fetchOpenIDMetadata) {
        var _this = _super.call(this) || this;
        _this.config = config;
        _this.storage = storage;
        _this.tokenExpirationTimer = null;
        _this.periodicalRenewalTimer = null;
        _this.periodicalRenewalBackoff = 1000;
        _this.periodicalRenewalTimeout = 30000;
        _this.openIDCheckSessionTimerInterval = 3000;
        if (_this.isAuthorized()) {
            _this.restartTokenExpirationTimer();
        }
        if (fetchOpenIDMetadata && _this.hasRequestedScope('openid')) {
            fetchOpenIDMetadata(function (maybeOpenIDMetadata) {
                if (maybeOpenIDMetadata instanceof Error) {
                    _this.emit(SGWTConnectEventList$1.EVENT_OPENID_METADATA_FETCH_ERROR, maybeOpenIDMetadata);
                }
                else {
                    _this.openIDMetadata = maybeOpenIDMetadata;
                    _this.enableOpenIDSessionManagement();
                }
            });
        }
        return _this;
    }
    //
    // Public
    // --------------------
    /**
     * Initiates the authorization process.
     *
     * Redirects to the authorization endpoint unless the
     * authorization has already been granted.
     */
    SGWTConnectCore.prototype.requestAuthorization = function () {
        // Check if the user is currently signed in to prevent
        // unnecessary sign-in redirects on application load:
        if (this.isAuthorized()) {
            return this
                .restartTokenExpirationTimer()
                .enablePeriodicalRenewal();
        }
        // At this point the token may not exist, has expired
        // or the authorization server has responded with an
        // error. In any case we clear the current authorization
        // response:
        this.storage.removeItem('AUTH');
        // Cross-Site Request Forgery (CSRF) protection:
        var state = SGWTConnectAuthorizationUri$1.generateCryptoStrongRandomValue();
        this.storage.setItem(state + ".STATE", state);
        // Remember the current URL, we will need to return
        // the user here after authorization is completed:
        this.storage.setItem(state + ".RETURN_URL", location.href);
        // Initiate the authorization process by redirecting
        // the current page to the authorization endpoint:
        location.replace(SGWTConnectAuthorizationUri$1.generateAuthorizationUri(this.config, state));
        return this;
    };
    /**
     * Clears the local authorization data and redirects
     * to end_session_endpoint if OpenID is enabled and
     * has loaded the relevant metadata.
     */
    SGWTConnectCore.prototype.discardAuthorization = function () {
        // Redirect is only possible if OpenID Metadata was
        // successfully retrieved from the "well-known" endpoint:
        if (this.openIDMetadata) {
            // Obtain the parameters required for the logout request:
            // https://openid.net/specs/openid-connect-session-1_0.html#RPLogout
            var id_token_hint = this.getIdToken();
            var post_logout_redirect_uri = this.config.post_logout_redirect_uri;
            var end_session_endpoint = this.openIDMetadata.end_session_endpoint;
            // Generate the end session URL:
            var endSessionURL_1 = end_session_endpoint + "?id_token_hint=" + id_token_hint +
                (post_logout_redirect_uri ? "&post_logout_redirect_uri=" + post_logout_redirect_uri : '');
            // Schedule termination of the OpenID session:
            this.once(SGWTConnectEventList$1.EVENT_AUTH_DISCARDED, function () {
                window.location.replace(endSessionURL_1);
            });
        }
        // Discard the authorization data which will trigger
        // EVENT_AUTH_DISCARDED that we subscribed to above:
        return this.discardAuthorizationLocally();
    };
    /**
     * Initiates a silent renewal of the token.
     *
     * Because the renewal is transparent to the user, we
     * discourage usage of this method before calling `requestAuthorization`
     * as this will not display the authorization approval
     * interface.
     */
    SGWTConnectCore.prototype.renewAuthorization = function (callback) {
        return this.requestAuthorizationWithoutPrompt({}, callback);
    };
    /**
     * Determines if the authorization has been granted.
     *
     * The state of having authorization is determined by the presence
     * of a non-expired access_token. This method does not tell
     * whether the authorization has been revoked or not,
     * or whether the granted scopes are identical to the
     * requested ones.
     */
    SGWTConnectCore.prototype.isAuthorized = function () {
        var authorization = this.storage.getItem('AUTH');
        return Boolean(authorization && authorization.access_token) &&
            authorization.expires_at > Date.now();
    };
    /**
     * Returns the authorization error or null if there is none.
     */
    SGWTConnectCore.prototype.getAuthorizationError = function () {
        var authorization = this.storage.getItem('AUTH');
        return (authorization && authorization.error) ?
            new SGWTConnectError_1$1.SGWTConnectError(authorization.error) :
            null;
    };
    /**
     * Generates an "Authorization" HTTP header value.
     *
     * Call this method and use the return value as Authorization header
     * value every time you make an HTTP request to your backend API.
     *
     *    const authHttpHeader = sgwtConnect.getAuthorizationHeader();
     *    if (authHttpHeader) {
     *      headers.set('Authorization', authHttpHeader);
     *    }
     *
     * Currently only the "Bearer" token type is supported.
     */
    SGWTConnectCore.prototype.getAuthorizationHeader = function () {
        var authorization = this.storage.getItem('AUTH');
        if (!this.isAuthorized()) {
            return null;
        }
        if (authorization.token_type && authorization.token_type.toLowerCase() === 'bearer') {
            return "Bearer " + authorization.access_token;
        }
        throw new SGWTConnectError_1$1.SGWTConnectError(SGWTConnectErrorList$1.ERR_UNSUPPORTED_TOKEN_TYPE);
    };
    /**
     * Returns the scope granted by the authorization server as a space-delimited string.
     */
    SGWTConnectCore.prototype.getGrantedScope = function () {
        // Make sure that the authorization request was successful:
        if (!this.isAuthorized()) {
            return null;
        }
        // Scope is part of authorization server response:
        var authorization = this.storage.getItem('AUTH');
        // Return the scope as is (e.g. "profile openid mail").
        // We leave it up to developer to parse and compare to
        // the requested scope. Also note that the scope
        // may not be returned in the authorization response
        // if it is identical to the scope requested by
        // the client.
        return typeof authorization.scope === 'undefined' ?
            this.config.scope :
            authorization.scope;
    };
    /**
     * Determines whether the given scope has been granted.
     *
     *    sgwtConnect.hasGrantedScope('profile openid');
     */
    SGWTConnectCore.prototype.hasGrantedScope = function (checkedScope) {
        var grantedScope = this.getGrantedScope();
        if (typeof grantedScope !== 'string') {
            return false;
        }
        return isScopeListed_1$1.isScopeListed(checkedScope, grantedScope);
    };
    /**
     * Obtains the user's ID Token in the form of JWT (JSON Web Token).
     *
     * Use this method to pass user identity to your backend.
     *
     * Calling this method is only useful if the "scope" parameter
     * used to make the authorization request included the "openid"
     * value.
     *
     * See http://openid.net/specs/openid-connect-core-1_0.html#IDToken
     * See https://tools.ietf.org/html/rfc7519
     */
    SGWTConnectCore.prototype.getIdToken = function () {
        // Make sure that the authorization request was successful:
        if (!this.isAuthorized()) {
            return null;
        }
        // Obtain the authorization server response:
        var authorization = this.storage.getItem('AUTH');
        // It is possible that the response_type parameter did not
        // include the "id_token" value while performing an authorization
        // request, so there's no id_token in the current token:
        if (!authorization.id_token) {
            return null;
        }
        // Return the id_token as is so that it can be passed to
        // backend for validation:
        return authorization.id_token;
    };
    /**
     * Obtains basic user information from ID Token claims.
     *
     * Use this method to obtain user id, name, email, etc.
     * without calling the /userinfo endpoint.
     *
     * Calling this method is only useful if the "scope" parameter
     * used to make the authorization request included the "openid"
     * (and optionally "email", "profile", etc.) value.
     *
     * See http://openid.net/specs/openid-connect-core-1_0.html#IDToken
     */
    SGWTConnectCore.prototype.getIdTokenClaims = function () {
        var idToken = this.getIdToken();
        // The ID Token could be missing in the following cases:
        //  1. Authorization not requested
        //  2. Authorization not granted
        //  3. id_token not requested in the authorization request
        //  4. id_token not granted in the authorization response
        if (idToken === null) {
            return null;
        }
        // The id_token conforms to an industry standard (IETF RFC 7519)
        // and contains three parts (header, body, signature) separated
        // by "." (dot) character:
        var idTokenParts = idToken.split('.');
        // The body is the second part (at index 1) containing identity
        // claims about the user:
        var idTokenBody = idTokenParts[1];
        // The id_token body is a base64url encoded JSON structure:
        return JSON.parse(atob(idTokenBody));
    };
    /**
     * Fetches UserInfo Claims from the authorization server.
     *
     * Use this method to obtain user name, email, etc. if
     * you're not requesting id_token or if the id_token
     * does not contain these values.
     *
     * See https://openid.net/specs/openid-connect-core-1_0.html#UserInfo
     */
    SGWTConnectCore.prototype.fetchUserInfo = function (callback) {
        var authorizationHeader = this.getAuthorizationHeader();
        if (authorizationHeader) {
            SGWTConnectOpenIDUserInfo$1.fetchOpenIDUserInfo(this.config.authorization_endpoint, authorizationHeader, callback);
        }
        else {
            callback(new SGWTConnectError_1$1.SGWTConnectError(SGWTConnectErrorList$1.ERR_UNAUTHORIZED));
        }
        return this;
    };
    /**
     * Enables silent periodical renewal of the token.
     *
     * Call this method after checking the result of isAuthorized,
     * because it assumes that the authorization request has been
     * performed successfully.
     */
    SGWTConnectCore.prototype.enablePeriodicalRenewal = function () {
        var _this = this;
        // Make sure that we don't have two renewal timers
        // running at the same time:
        if (this.periodicalRenewalTimer !== null) {
            return this;
        }
        // Whenever renewal succeeds (manual or periodical)
        // we need to restart the timer in order to do reduce
        // the number of requests to the authorization endpoint:
        this.addListener(SGWTConnectEventList$1.EVENT_AUTH_RENEW_SUCCESS, this.restartRenewalTimer);
        // Start the initial timer. We're using setTimeout to be able
        // to adjust the duration depending on renew success/error:
        this.periodicalRenewalTimer = window.setTimeout(function () {
            _this.renewResiliently();
        }, this.getRenewalTimeout());
        return this;
    };
    /**
     * Disables silent periodical renewal of the token.
     */
    SGWTConnectCore.prototype.disablePeriodicalRenewal = function () {
        // Make sure that the backoff delay is reset so that next time
        // we start the periodical renewal, it is back to default value:
        this.resetRenewalBackoff();
        // Stop restarting periodical renewal on renew success:
        this.removeListener(SGWTConnectEventList$1.EVENT_AUTH_RENEW_SUCCESS, this.restartRenewalTimer);
        // Clear the current timeout:
        if (typeof this.periodicalRenewalTimer === 'number') {
            window.clearTimeout(this.periodicalRenewalTimer);
            this.periodicalRenewalTimer = null;
        }
        return this;
    };
    //
    // Private
    // --------------------
    /**
     * Discards the local authorization data,
     * cancels all running timers,
     * and emits `EVENT_AUTH_DISCARDED` event.
     */
    SGWTConnectCore.prototype.discardAuthorizationLocally = function () {
        // The authorization is discarded, so it no longer
        // makes sense to do periodical renewal or maintain
        // the expiration timer:
        this.disablePeriodicalRenewal();
        this.clearTokenExpirationTimer();
        if (this.openIDMetadata) {
            // OpenID Session Management is no longer needed:
            this.disableOpenIDSessionManagement();
        }
        // Actually discard the authorization data:
        this.storage.removeItem('AUTH');
        // Notify the interested parties:
        this.emit(SGWTConnectEventList$1.EVENT_AUTH_DISCARDED);
        return this;
    };
    /**
     * Initiates a silent renewal of the token
     * with additional options that are not available
     * in the public API.
     */
    SGWTConnectCore.prototype.requestAuthorizationWithoutPrompt = function (_a, callback) {
        var _this = this;
        var id_token_hint = _a.id_token_hint;
        // Cross-Site Request Forgery (CSRF) protection:
        var state = SGWTConnectAuthorizationUri$1.generateCryptoStrongRandomValue();
        // Generate the complete authorization endpoint URL
        // where id_token_hint is used to validate session
        // after receiving a "changed" event from OpenID
        // Session Management frame:
        var authorizationEndpoint = id_token_hint
            ? SGWTConnectAuthorizationUri$1.generateAuthorizationUri(this.config, state, { prompt: 'none', id_token_hint: id_token_hint })
            : SGWTConnectAuthorizationUri$1.generateAuthorizationUri(this.config, state, { prompt: 'none' });
        // Because OAuth2 protocol insists on providing access_token
        // in the fragment, we're unable to use XMLHttpRequest as it
        // transparently follows all redirects and the fragment is lost.
        // To solve this issue we use an iframe which gives us access
        // to window.location containing the access_token in its fragment.
        var iframe = document.createElement('iframe');
        // When both of these flags are set to true, then it is safe
        // to remove the iframe from the DOM
        //  1. we must not remove the iframe before it emits the "load"
        //     event because in flight resources may get canceled causing
        //     some browsers to remove them even from the top-level window
        //  2. we must wait for the message from iframe because it may
        //     be emitted after(!) "load" event; removing the iframe from
        //     the DOM will cancel the message in flight
        var isIframeLoaded = false;
        var isMessageReceivedFromIframe = false;
        // Iframe timeout in case it does not message or does not load:
        var iframeTimeoutTimer;
        // The redirect_uri may point to another domain preventing
        // the iframe from accessing the storage to set the token,
        // so it will message the top-level window using cross-origin
        // messaging protocol with window.postMessage. This function
        // securely handles the received message:
        var iframeMessageHandler = function (event) {
            // Make sure that the event comes from the renewal iframe:
            if (event.source !== iframe.contentWindow) {
                return;
            }
            // Make sure that the event comes from redirect_uri page:
            if (!isSameOrigin_1$1.isSameOrigin(event.origin, _this.config.redirect_uri)) {
                return;
            }
            // Third party scripts use the same API to send messages,
            // so make sure we're dealing with our own event:
            if (!event.data || typeof event.data !== 'object') {
                return;
            }
            if (event.data.type !== 'SGWTConnectFragment') {
                return;
            }
            // All event validity checks have passed; we consider
            // the event as genuine and can flag it as received
            // so that the "load" event handler knows about it:
            isMessageReceivedFromIframe = true;
            // We expect a single message, so the listener is no longer needed:
            window.removeEventListener('message', iframeMessageHandler);
            // We have received a message from the iframe,
            // the timeout no longer makes sense:
            window.clearTimeout(iframeTimeoutTimer);
            // We can remove the iframe if it has already loaded:
            if (isIframeLoaded) {
                document.body.removeChild(iframe);
            }
            // Extract the authorization server response from the message:
            var authorization = SGWTConnectServerResponse$1.normalizeAuthServerResponse(SGWTConnectServerResponse$1.parseOAuth2Fragment(event.data.fragment));
            // Cross-Site Request Forgery (CSRF) protection:
            if (authorization.state !== state) {
                var error = new SGWTConnectError_1$1.SGWTConnectError(SGWTConnectErrorList$1.ERR_STATE_MISMATCH);
                _this.emit(SGWTConnectEventList$1.EVENT_AUTH_RENEW_ERROR, error);
                if (callback) {
                    callback(error);
                }
                return;
            }
            // Notify the subscribers about renewal completion:
            var errorCode = authorization.error;
            if (errorCode) {
                // Notify the API consumer about the authorization failure:
                var error = new SGWTConnectError_1$1.SGWTConnectError(errorCode);
                _this.emit(SGWTConnectEventList$1.EVENT_AUTH_RENEW_ERROR, error);
                if (callback) {
                    callback(error);
                }
            }
            else {
                // Persist the authorization server response prior to emitting
                // events and calling the completion callback so that the token
                // is available to the completion event handlers:
                _this.storage.setItem('AUTH', authorization);
                // The authorization data has been updated, which means that
                // the expiration time has changed, so we need to restart
                // the expiration timer:
                _this.restartTokenExpirationTimer();
                // Although rare, the authorization state might be initiated
                // by calling renewAuthorization instead of requestAuthorization;
                // in this case we need to enable OpenID Session Management
                // on "renewal" success:
                _this.enableOpenIDSessionManagement();
                // Notify the API consumer about the authorization success:
                _this.emit(SGWTConnectEventList$1.EVENT_AUTH_RENEW_SUCCESS);
                if (callback) {
                    callback(null);
                }
            }
        };
        // Securely handles the "load" event of the renewal iframe
        // by removing event listeners and the iframe itself;
        // also emits an error event in case no message was
        // received from the iframe before "load" event:
        var iframeLoadHandler = function (event) {
            // Make sure the event is genuine:
            if (!event.isTrusted) {
                return;
            }
            // We consider this event as genuine and can flag it as received
            // so that the iframe message event handler knows about it:
            isIframeLoaded = true;
            // The "load" event can only happen once, so the listener
            // is no longer needed:
            iframe.removeEventListener('load', iframeLoadHandler);
            // We can remove the iframe from the DOM if we have already
            // received the message from it:
            if (isMessageReceivedFromIframe) {
                document.body.removeChild(iframe);
            }
        };
        // Expecting the iframe to send us a message
        // from the redirect_uri page using cross-origin
        // messaging protocol with window.postMessage:
        window.addEventListener('message', iframeMessageHandler);
        // We need to listen to the "load" event because
        // we expect the iframe to load completely
        // before removing it from the DOM, otherwise
        // canceled resource requests may destroy already
        // loaded resources from the top-level window:
        iframe.addEventListener('load', iframeLoadHandler);
        // The iframe may never load or fail to send the message due to
        // changes in network, server failure, or some other error,
        // but we still need to emit+callback, so we use a timeout:
        iframeTimeoutTimer = window.setTimeout(function () {
            window.clearTimeout(iframeTimeoutTimer);
            // Cleanup event listeners:
            iframe.removeEventListener('load', iframeLoadHandler);
            window.removeEventListener('message', iframeMessageHandler);
            // Cleanup the DOM:
            document.body.removeChild(iframe);
            // Notify the API consumer about the renewal failure:
            var error = new SGWTConnectError_1$1.SGWTConnectError(SGWTConnectErrorList$1.ERR_RENEW_TIMEOUT);
            _this.emit(SGWTConnectEventList$1.EVENT_AUTH_RENEW_ERROR, error);
            if (callback) {
                callback(error);
            }
        }, this.periodicalRenewalTimeout);
        // Provide a way for setupSGWTConnect factory to figure out
        // whether the redirect is part of silent renewal or not:
        iframe.setAttribute(exports.SGWTConnectRenewalFrameAttribute, '');
        iframe.style.display = 'none';
        iframe.setAttribute('src', authorizationEndpoint);
        this.appendElementToDocumentWhenLoaded(iframe);
        return this;
    };
    /**
     * Ensures that DOM is loaded and appends the element to document body.
     * @param element Element to append to document body.
     */
    SGWTConnectCore.prototype.appendElementToDocumentWhenLoaded = function (element) {
        if (document.body) {
            document.body.appendChild(element);
        }
        else {
            var appendElementAndRemoveListener_1 = function () {
                window.removeEventListener('DOMContentLoaded', appendElementAndRemoveListener_1);
                document.body.appendChild(element);
            };
            window.addEventListener('DOMContentLoaded', appendElementAndRemoveListener_1);
        }
    };
    /**
     * Determines whether the given scope has been requested.
     *
     *    this.hasRequestedScope('profile openid');
     */
    SGWTConnectCore.prototype.hasRequestedScope = function (checkedScope) {
        return isScopeListed_1$1.isScopeListed(checkedScope, this.config.scope);
    };
    /**
     * Resets the periodical renewal backoff delay.
     */
    SGWTConnectCore.prototype.resetRenewalBackoff = function () {
        this.periodicalRenewalBackoff = 1000;
        return this;
    };
    /**
     * Increments the periodical renewal backoff delay.
     *
     * Used to reduce authorization server load when periodical
     * renewals fail for some reason.
     */
    SGWTConnectCore.prototype.incrementRenewalBackoff = function () {
        this.periodicalRenewalBackoff *= 2;
        return this;
    };
    /**
     * Clears the token expiration timer.
     */
    SGWTConnectCore.prototype.clearTokenExpirationTimer = function () {
        if (typeof this.tokenExpirationTimer === 'number') {
            window.clearTimeout(this.tokenExpirationTimer);
            this.tokenExpirationTimer = null;
        }
        return this;
    };
    /**
     * Clears the existing token expiration timer and starts a new one.
     */
    SGWTConnectCore.prototype.restartTokenExpirationTimer = function () {
        var _this = this;
        // Ensure that there is only one timer at all times:
        this.clearTokenExpirationTimer();
        // Assuming that the client is currently authorized:
        var authorization = this.storage.getItem('AUTH');
        var timeUntilTokenExpiration = authorization.expires_at - Date.now();
        this.tokenExpirationTimer = window.setTimeout(function () {
            _this.emit(SGWTConnectEventList$1.EVENT_AUTH_EXPIRED);
        }, timeUntilTokenExpiration);
        return this;
    };
    /**
     * Obtains the timeout (in ms) until token renewal.
     */
    SGWTConnectCore.prototype.getRenewalTimeout = function () {
        var authorization = this.storage.getItem('AUTH');
        // Temporary workaround for the authorization endpoint issue,
        // revert to `- authorization.expires_in / 4` when possible:
        var renewalTime = authorization.expires_at - authorization.expires_in * 0.6;
        var renewalTimePositive = Math.max(renewalTime - Date.now(), 0);
        // The timeout should never be bigger than 2147483647, since setTimeout uses
        // a 32 bits number (cf. https://stackoverflow.com/a/3468650/26457)
        // When the token has an extremely long TTL such as 100 days, this timeout should
        // not exceed this 2147483647 value.
        return Math.min(renewalTimePositive, 2147483647);
    };
    /**
     * Renews the authorization token resiliently.
     *
     * When doing periodical renewal we must be resilient
     * on authorization failures and never abort the timer.
     * Even in case of an error we restart the timer,
     * but with an incrementally increasing interval
     * to avoid network saturation.
     */
    SGWTConnectCore.prototype.renewResiliently = function () {
        var _this = this;
        return this.renewAuthorization(function (error) {
            if (error) {
                _this.periodicalRenewalTimer = window.setTimeout(function () {
                    _this.renewResiliently();
                }, _this.periodicalRenewalBackoff);
                _this.incrementRenewalBackoff();
            }
            else {
                _this.resetRenewalBackoff();
            }
        });
    };
    /**
     * Restarts an existing renewal timer.
     */
    SGWTConnectCore.prototype.restartRenewalTimer = function () {
        var _this = this;
        // Do not attempt to restart a non-existing timer:
        if (this.periodicalRenewalTimer === null) {
            return this;
        }
        // Every time the renewal is restarted we should reset
        // the renewal backoff delay:
        this.resetRenewalBackoff();
        // Cancel the current renewal timeout:
        window.clearTimeout(this.periodicalRenewalTimer);
        // Restart the renewal timer:
        this.periodicalRenewalTimer = window.setTimeout(function () {
            return _this.renewResiliently();
        }, this.getRenewalTimeout());
        return this;
    };
    /**
     * Enables OpenID session management if not previously enabled.
     */
    SGWTConnectCore.prototype.enableOpenIDSessionManagement = function () {
        var _this = this;
        // Make sure that the session management has not already been enabled:
        if (this.openIDCheckSessionIframe && this.openIDCheckSessionIframe.parentNode) {
            return this;
        }
        // Make sure that OpenID has actually been configured:
        if (!this.openIDMetadata || !this.hasRequestedScope('openid')) {
            return this;
        }
        // Enabling session management only makes sense
        // if the authorization has already been granted:
        if (!this.isAuthorized()) {
            return this;
        }
        // To check OpenID session we will be polling an iframe
        // loaded from check_session_iframe as recommended by
        // https://openid.net/specs/openid-connect-session-1_0.html#ChangeNotification
        this.openIDCheckSessionIframe = document.createElement('iframe');
        this.openIDCheckSessionIframe.style.display = 'none';
        this.openIDCheckSessionIframe.setAttribute(exports.SGWTConnectCheckSesssionFrameAttribute, '');
        // Expecting the iframe to send us a message using
        // messaging protocol with window.postMessage:
        window.addEventListener('message', this.handleOpenIDCheckSessionMessage.bind(this));
        // Securely handles the "load" event of the OpenID check_session_iframe:
        var checkSessionIframeLoadHandler = function (event) {
            // Make sure the event is genuine:
            if (!event.isTrusted) {
                return;
            }
            // Make sure that the iframe still exists:
            if (!_this.openIDCheckSessionIframe) {
                return;
            }
            // The "load" event can only happen once,
            // so the listener is no longer needed:
            _this.openIDCheckSessionIframe.removeEventListener('load', checkSessionIframeLoadHandler);
            // Start polling:
            _this.restartOpenIDSessionValidationTimer();
        };
        this.openIDCheckSessionIframe.addEventListener('load', checkSessionIframeLoadHandler);
        this.openIDCheckSessionIframe.setAttribute('src', this.openIDMetadata.check_session_iframe);
        this.appendElementToDocumentWhenLoaded(this.openIDCheckSessionIframe);
        return this;
    };
    /**
     * Disables OpenID session management.
     */
    SGWTConnectCore.prototype.disableOpenIDSessionManagement = function () {
        // Stop listening to messages:
        window.removeEventListener('message', this.handleOpenIDCheckSessionMessage);
        // Stop polling the check_session_iframe:
        if (typeof this.openIDCheckSessionTimerId === 'number') {
            window.clearTimeout(this.openIDCheckSessionTimerId);
            this.openIDCheckSessionTimerId = undefined;
        }
        // Remove the iframe:
        if (this.openIDCheckSessionIframe) {
            document.body.removeChild(this.openIDCheckSessionIframe);
            this.openIDCheckSessionIframe = undefined;
        }
        return this;
    };
    /**
     * Restarts OpenID session validation timer.
     */
    SGWTConnectCore.prototype.restartOpenIDSessionValidationTimer = function () {
        // There should be only one OpenID session validation timer:
        window.clearTimeout(this.openIDCheckSessionTimerId);
        // Schedule a new timer:
        this.openIDCheckSessionTimerId = window.setTimeout(this.validateOpenIDSession.bind(this), this.openIDCheckSessionTimerInterval);
    };
    /**
     * Validates the existing OpenID session.
     */
    SGWTConnectCore.prototype.validateOpenIDSession = function () {
        var _this = this;
        if (this.isAuthorized()) {
            // The current authorization state retrieved from the storage
            // indicates that the session is valid, however it might be
            // terminated already at the authorization server.
            // To validate the session, we need to send a message
            // to the check_session iframe, but before that we make sure
            // that we have metadata and that the check_session iframe
            // still exists in the DOM.
            if (!this.openIDMetadata) {
                return;
            }
            if (this.openIDCheckSessionIframe && this.openIDCheckSessionIframe.contentWindow) {
                var authorization = this.storage.getItem('AUTH');
                this.openIDCheckSessionIframe.contentWindow.postMessage(this.config.client_id + " " + authorization.session_state, this.openIDMetadata.check_session_iframe);
                this.restartOpenIDSessionValidationTimer();
            }
            else {
                // In case the check_session iframe no longer exists,
                // we try to recreate it be re-enabling session management:
                this.enableOpenIDSessionManagement();
            }
        }
        else {
            // In case the authorization state is lost (storage cleared)
            // we attempt a silent authorization renewal. If the session
            // is still valid on the authorization server, the renewal
            // should succeed and we just restart the timer; otherwise
            // we treat it as loss of authorization and act accordingly.
            this.renewAuthorization(function (error) {
                if (error) {
                    _this.discardAuthorizationLocally();
                }
                else {
                    _this.restartOpenIDSessionValidationTimer();
                }
            });
        }
    };
    /**
     * Securely handles events from check_session_iframe.
     * @param event MessageEvent
     */
    SGWTConnectCore.prototype.handleOpenIDCheckSessionMessage = function (event) {
        var _this = this;
        // Sanity checks:
        if (!this.openIDCheckSessionIframe || !this.openIDMetadata) {
            return;
        }
        // Make sure that the event comes from the check_session_iframe:
        if (event.source !== this.openIDCheckSessionIframe.contentWindow) {
            return;
        }
        if (!isSameOrigin_1$1.isSameOrigin(event.origin, this.openIDMetadata.check_session_iframe)) {
            return;
        }
        // Expecting event.data to be either "unchanged", "changed", or "error".
        // See https://openid.net/specs/openid-connect-session-1_0.html#RPiframe
        if (event.data === 'unchanged') {
            // Session has not changed, so we only notify
            // (mostly for logging and testing purposes):
            this.emit(SGWTConnectEventList$1.EVENT_OPENID_SESSION_UNCHANGED);
        }
        else if (event.data === 'changed') {
            this.emit(SGWTConnectEventList$1.EVENT_OPENID_SESSION_CHANGED);
            // Perform re-authentication with prompt=none
            // sending the old id_token as id_token_hint:
            var prevIdToken = this.getIdToken();
            var prevIdTokenClaims_1 = this.getIdTokenClaims();
            this.requestAuthorizationWithoutPrompt({ id_token_hint: prevIdToken }, function (error) {
                if (!error) {
                    // If we receive a new ID Token for the same user
                    // then we simply update the values
                    var nextIdTokenClaims = _this.getIdTokenClaims();
                    if (nextIdTokenClaims && prevIdTokenClaims_1 && nextIdTokenClaims.sub === prevIdTokenClaims_1.sub) {
                        return;
                    }
                }
                // In other cases, such as error response,
                // or absence of ID Token, or it was delivered
                // for another user, we discard authorization:
                _this.discardAuthorizationLocally();
            });
        }
        else if (event.data === 'error') {
            // In case of communication error with check_session_iframe
            // we notify the user and wait for fallback to periodical
            // renewal to check the session validity:
            this.emit(SGWTConnectEventList$1.EVENT_OPENID_CHECK_SESSION_ERROR, new SGWTConnectError_1$1.SGWTConnectError(SGWTConnectErrorList$1.ERR_OPENID_CHECK_SESSION_ERROR));
        }
    };
    return SGWTConnectCore;
}(events.EventEmitter));
exports.SGWTConnectCore = SGWTConnectCore;

});

/* tslint:disable no-bitwise */

/**
 * Generates a lossy hash of an object.
 *
 * Typed implementation of MD5 in JavaScript by Joseph's Myers.
 * This function is not intended to be crypto-secure.
 * @see http://www.myersdaily.org/joseph/javascript/md5-text.html
 */
function hash$1(obj) {
    return hex$1(md51$1(
    // Keys are sorted to ensure that ordering of keys
    // does not affect the hashing result:
    Object.keys(obj).sort()
        .reduce(function (acc, key) { return acc + key + ':' + obj[key] + '|'; }, '|')));
}
var hash_1$1 = hash$1;
var hexChr$1 = '0123456789abcdef'.split('');
function rhex$1(n) {
    var s = '';
    for (var i = 0; i < 4; i += 1) {
        s += hexChr$1[(n >> (i * 8 + 4)) & 0x0F]
            + hexChr$1[(n >> (i * 8)) & 0x0F];
    }
    return s;
}
function hex$1(x) {
    var h = '';
    for (var _i = 0, x_1 = x; _i < x_1.length; _i++) {
        var n = x_1[_i];
        h += rhex$1(n);
    }
    return h;
}
function md5cycle$1(x, k) {
    var a = x[0];
    var b = x[1];
    var c = x[2];
    var d = x[3];
    a = ff$1(a, b, c, d, k[0], 7, -680876936);
    d = ff$1(d, a, b, c, k[1], 12, -389564586);
    c = ff$1(c, d, a, b, k[2], 17, 606105819);
    b = ff$1(b, c, d, a, k[3], 22, -1044525330);
    a = ff$1(a, b, c, d, k[4], 7, -176418897);
    d = ff$1(d, a, b, c, k[5], 12, 1200080426);
    c = ff$1(c, d, a, b, k[6], 17, -1473231341);
    b = ff$1(b, c, d, a, k[7], 22, -45705983);
    a = ff$1(a, b, c, d, k[8], 7, 1770035416);
    d = ff$1(d, a, b, c, k[9], 12, -1958414417);
    c = ff$1(c, d, a, b, k[10], 17, -42063);
    b = ff$1(b, c, d, a, k[11], 22, -1990404162);
    a = ff$1(a, b, c, d, k[12], 7, 1804603682);
    d = ff$1(d, a, b, c, k[13], 12, -40341101);
    c = ff$1(c, d, a, b, k[14], 17, -1502002290);
    b = ff$1(b, c, d, a, k[15], 22, 1236535329);
    a = gg$1(a, b, c, d, k[1], 5, -165796510);
    d = gg$1(d, a, b, c, k[6], 9, -1069501632);
    c = gg$1(c, d, a, b, k[11], 14, 643717713);
    b = gg$1(b, c, d, a, k[0], 20, -373897302);
    a = gg$1(a, b, c, d, k[5], 5, -701558691);
    d = gg$1(d, a, b, c, k[10], 9, 38016083);
    c = gg$1(c, d, a, b, k[15], 14, -660478335);
    b = gg$1(b, c, d, a, k[4], 20, -405537848);
    a = gg$1(a, b, c, d, k[9], 5, 568446438);
    d = gg$1(d, a, b, c, k[14], 9, -1019803690);
    c = gg$1(c, d, a, b, k[3], 14, -187363961);
    b = gg$1(b, c, d, a, k[8], 20, 1163531501);
    a = gg$1(a, b, c, d, k[13], 5, -1444681467);
    d = gg$1(d, a, b, c, k[2], 9, -51403784);
    c = gg$1(c, d, a, b, k[7], 14, 1735328473);
    b = gg$1(b, c, d, a, k[12], 20, -1926607734);
    a = hh$1(a, b, c, d, k[5], 4, -378558);
    d = hh$1(d, a, b, c, k[8], 11, -2022574463);
    c = hh$1(c, d, a, b, k[11], 16, 1839030562);
    b = hh$1(b, c, d, a, k[14], 23, -35309556);
    a = hh$1(a, b, c, d, k[1], 4, -1530992060);
    d = hh$1(d, a, b, c, k[4], 11, 1272893353);
    c = hh$1(c, d, a, b, k[7], 16, -155497632);
    b = hh$1(b, c, d, a, k[10], 23, -1094730640);
    a = hh$1(a, b, c, d, k[13], 4, 681279174);
    d = hh$1(d, a, b, c, k[0], 11, -358537222);
    c = hh$1(c, d, a, b, k[3], 16, -722521979);
    b = hh$1(b, c, d, a, k[6], 23, 76029189);
    a = hh$1(a, b, c, d, k[9], 4, -640364487);
    d = hh$1(d, a, b, c, k[12], 11, -421815835);
    c = hh$1(c, d, a, b, k[15], 16, 530742520);
    b = hh$1(b, c, d, a, k[2], 23, -995338651);
    a = ii$1(a, b, c, d, k[0], 6, -198630844);
    d = ii$1(d, a, b, c, k[7], 10, 1126891415);
    c = ii$1(c, d, a, b, k[14], 15, -1416354905);
    b = ii$1(b, c, d, a, k[5], 21, -57434055);
    a = ii$1(a, b, c, d, k[12], 6, 1700485571);
    d = ii$1(d, a, b, c, k[3], 10, -1894986606);
    c = ii$1(c, d, a, b, k[10], 15, -1051523);
    b = ii$1(b, c, d, a, k[1], 21, -2054922799);
    a = ii$1(a, b, c, d, k[8], 6, 1873313359);
    d = ii$1(d, a, b, c, k[15], 10, -30611744);
    c = ii$1(c, d, a, b, k[6], 15, -1560198380);
    b = ii$1(b, c, d, a, k[13], 21, 1309151649);
    a = ii$1(a, b, c, d, k[4], 6, -145523070);
    d = ii$1(d, a, b, c, k[11], 10, -1120210379);
    c = ii$1(c, d, a, b, k[2], 15, 718787259);
    b = ii$1(b, c, d, a, k[9], 21, -343485551);
    x[0] = add32$1(a, x[0]);
    x[1] = add32$1(b, x[1]);
    x[2] = add32$1(c, x[2]);
    x[3] = add32$1(d, x[3]);
}
function cmn$1(q, a, b, x, s, t) {
    a = add32$1(add32$1(a, q), add32$1(x, t));
    return add32$1((a << s) | (a >>> (32 - s)), b);
}
function add32$1(a, b) {
    return (a + b) & 0xFFFFFFFF;
}
function ff$1(a, b, c, d, x, s, t) {
    return cmn$1((b & c) | ((~b) & d), a, b, x, s, t);
}
function gg$1(a, b, c, d, x, s, t) {
    return cmn$1((b & d) | (c & (~d)), a, b, x, s, t);
}
function hh$1(a, b, c, d, x, s, t) {
    return cmn$1(b ^ c ^ d, a, b, x, s, t);
}
function ii$1(a, b, c, d, x, s, t) {
    return cmn$1(c ^ (b | (~d)), a, b, x, s, t);
}
function md51$1(s) {
    var n = s.length;
    var state = [1732584193, -271733879, -1732584194, 271733878];
    var tail = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
    var i;
    for (i = 64; i <= s.length; i += 64) {
        md5cycle$1(state, md5blk$1(s.substring(i - 64, i)));
    }
    s = s.substring(i - 64);
    for (i = 0; i < s.length; i += 1) {
        tail[i >> 2] |= s.charCodeAt(i) << ((i % 4) << 3);
    }
    tail[i >> 2] |= 0x80 << ((i % 4) << 3);
    if (i > 55) {
        md5cycle$1(state, tail);
        for (i = 0; i < 16; i += 1) {
            tail[i] = 0;
        }
    }
    tail[14] = n * 8;
    md5cycle$1(state, tail);
    return state;
}
function md5blk$1(s) {
    var md5blks = [];
    for (var i = 0; i < 64; i += 4) {
        md5blks[i >> 2] = s.charCodeAt(i)
            + (s.charCodeAt(i + 1) << 8)
            + (s.charCodeAt(i + 2) << 16)
            + (s.charCodeAt(i + 3) << 24);
    }
    return md5blks;
}


var SGWTConnectHash$1 = /*#__PURE__*/Object.defineProperty({
	hash: hash_1$1
}, '__esModule', {value: true});

var __extends$2 = (commonjsGlobal && commonjsGlobal.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();


/**
 * Alternative implementation of SGWTConnectCore.
 *
 * This class should only be instantiated and used
 * when the user is on redirect_uri or in an iframe.
 * See explanation in setupSGWTConnect.ts
 */
var SGWTConnectNoop$1 = /** @class */ (function (_super) {
    __extends$2(SGWTConnectNoop, _super);
    function SGWTConnectNoop() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Noop.
     */
    SGWTConnectNoop.prototype.requestAuthorization = function () {
        return this;
    };
    /**
     * Noop.
     */
    SGWTConnectNoop.prototype.discardAuthorization = function () {
        return this;
    };
    /**
     * Noop.
     */
    SGWTConnectNoop.prototype.renewAuthorization = function () {
        return this;
    };
    /**
     * Noop.
     */
    SGWTConnectNoop.prototype.isAuthorized = function () {
        return false;
    };
    /**
     * Noop.
     */
    SGWTConnectNoop.prototype.getAuthorizationError = function () {
        return null;
    };
    /**
     * Noop.
     */
    SGWTConnectNoop.prototype.getAuthorizationHeader = function () {
        return null;
    };
    /**
     * Noop.
     */
    SGWTConnectNoop.prototype.getGrantedScope = function () {
        return null;
    };
    /**
     * Noop.
     */
    SGWTConnectNoop.prototype.hasGrantedScope = function () {
        return false;
    };
    /**
     * Noop.
     */
    SGWTConnectNoop.prototype.getIdToken = function () {
        return null;
    };
    /**
     * Noop.
     */
    SGWTConnectNoop.prototype.getIdTokenClaims = function () {
        return null;
    };
    /**
     * Noop.
     */
    SGWTConnectNoop.prototype.enablePeriodicalRenewal = function () {
        return this;
    };
    /**
     * Noop.
     */
    SGWTConnectNoop.prototype.disablePeriodicalRenewal = function () {
        return this;
    };
    return SGWTConnectNoop;
}(SGWTConnectCore_1$1.SGWTConnectCore));
var SGWTConnectNoop_2$1 = SGWTConnectNoop$1;


var SGWTConnectNoop_1$1 = /*#__PURE__*/Object.defineProperty({
	SGWTConnectNoop: SGWTConnectNoop_2$1
}, '__esModule', {value: true});

/**
 * Generates a function that upon invocation asynchronously
 * fetches OpenID Metadata from the OpenID Provider.
 * @param authorization_endpoint OpenID Provider's endpoint URL.
 */
function createOpenIDMetadataFetcher$1(authorization_endpoint) {
    return function fetchOpenIDMetadata(callback) {
        var xhr = new XMLHttpRequest();
        xhr.open('GET', authorization_endpoint + "/oauth2/.well-known/openid-configuration");
        xhr.setRequestHeader('Accept', 'application/json');
        xhr.addEventListener('load', function onOpenIDMetadataLoad() {
            if (xhr.status === 200) {
                var openIDMetadata = void 0;
                try {
                    openIDMetadata = JSON.parse(xhr.responseText);
                }
                catch (_a) {
                    callback(new SGWTConnectError_1$1.SGWTConnectError(SGWTConnectErrorList$1.ERR_FAILED_TO_PARSE_OPENID_METADATA));
                    return;
                }
                if (isValidOpenIDMetadata$1(openIDMetadata)) {
                    callback(openIDMetadata);
                }
                else {
                    callback(new SGWTConnectError_1$1.SGWTConnectError(SGWTConnectErrorList$1.ERR_FAILED_TO_VALIDATE_OPENID_METADATA));
                }
            }
            else {
                callback(new SGWTConnectError_1$1.SGWTConnectError(SGWTConnectErrorList$1.ERR_FAILED_TO_FETCH_OPENID_METADATA));
            }
        });
        xhr.send();
    };
}
var createOpenIDMetadataFetcher_1$1 = createOpenIDMetadataFetcher$1;
/**
 * Determines whether the given OpenID Configuration is valid.
 * @param openIDMetadata JSON-parsed value obtained from the Discovery API.
 */
function isValidOpenIDMetadata$1(openIDMetadata) {
    return isObject_1$1.isObject(openIDMetadata) &&
        typeof openIDMetadata.check_session_iframe === 'string' &&
        typeof openIDMetadata.end_session_endpoint === 'string';
}


var SGWTConnectOpenIDMetadata$1 = /*#__PURE__*/Object.defineProperty({
	createOpenIDMetadataFetcher: createOpenIDMetadataFetcher_1$1
}, '__esModule', {value: true});

/**
 * SGWTConnect instance factory.
 *
 * Determines the execution environment (top-level window or iframe),
 * instantiates the relevant SGWTConnect class with the given configuration,
 * and handles authorization redirects in the top-level window.
 */
function setupSGWTConnect$1(userConfig) {
    var config = SGWTConnectConfiguration$1.normalizeConfiguration(userConfig, location);
    // Ensure that the stored token and other data have been obtained
    // using the current configuration options (note that we're not
    // using JSON.stringify here because it will generate different
    // results for identical configurations with different ordering
    // of keys in them):
    var storage = new SGWTConnectStorage_1$1.SGWTConnectStorage(SGWTConnectHash$1.hash(config));
    // Check if we're currently on the redirect_uri page:
    if (SGWTConnectRedirectUri$1.isOnRedirectUri(config, location)) {
        // Check if we are currently in a silent renewal iframe:
        if (window.frameElement && window.frameElement.hasAttribute(SGWTConnectCore_1$1.SGWTConnectRenewalFrameAttribute)) {
            // We only message the top-level window if the iframe's URI
            // matches the redirect URI exactly (without the fragment):
            window.parent.postMessage({
                type: 'SGWTConnectFragment',
                fragment: location.hash
            }, config.redirect_uri);
            // Because we are currently on the redirect_uri page, we must not
            // return the fully-functional API as this may result in undesired
            // behavior and infinite reload, but we still need to return a
            // compliant API to prevent JS runtime errors on the page, so we
            // return a dummy API where most methods are noop:
            return new SGWTConnectNoop_1$1.SGWTConnectNoop(config, storage);
        }
        // We are currently doing a hard redirect.
        // Extract the authorization server response from the current URL fragment:
        var authorization = SGWTConnectServerResponse$1.normalizeAuthServerResponse(SGWTConnectServerResponse$1.parseOAuth2Fragment(window.location.hash));
        var stateInResponse = authorization.state;
        // Cross-Site Request Forgery (CSRF) protection:
        var stateInStore = storage.getItem(stateInResponse + ".STATE");
        if (stateInResponse === stateInStore) {
            // Persist the authorization server response prior to emitting
            // events and calling the completion callback so that the token
            // is available to the completion event handlers (note that
            // the server response might be a failed one):
            storage.setItem('AUTH', authorization);
        }
        else if (stateInStore) {
            // The "state" parameter failed to match; it may be dangerous
            // to keep the received server response, so we replace it
            // with a custom "state_mismatch" error response:
            var authError = {
                error: SGWTConnectErrorList$1.ERR_STATE_MISMATCH
            };
            storage.setItem('AUTH', authError);
        }
        // We are currently on the "redirect_uri", but the user most
        // probably initiated the authorization process from another
        // URI, so we need to redirect them back there (or to home
        // page if RETURN_URL has been cleared):
        var returnUrl = storage.getItem(stateInResponse + ".RETURN_URL") ||
            window.location.protocol + "//" + window.location.host;
        // location.replace doesn't reload the page if only the fragment
        // has changed, so we need the following workaround to force
        // the page reload, but also to set the fragment of the returnUrl:
        if (returnUrl.indexOf('#') !== -1 && location.href.split('#')[0] === returnUrl.split('#')[0]) {
            window.location.hash = returnUrl.split('#')[1];
            window.location.reload(true);
        }
        else {
            window.location.replace(returnUrl);
        }
        // Because we are currently on the redirect_uri page, we must not
        // return the fully-functional API as this may result in undesired
        // behavior and infinite reload, but we still need to return a
        // compliant API to prevent JS runtime errors on the page, so we
        // return a dummy API where most methods are noop:
        return new SGWTConnectNoop_1$1.SGWTConnectNoop(config, storage);
    }
    // We are NOT on the redirect_uri page, do we have authorization?:
    var auth = storage.getItem('AUTH');
    // Clean up the storage of values needed during redirects:
    if (auth) {
        storage.removeItem(auth.state + ".STATE");
        storage.removeItem(auth.state + ".RETURN_URL");
    }
    // Clean up the storage of the expired tokens:
    storage.clearBy(function (value, key) {
        return key.indexOf('AUTH') !== -1 && value.expires_at < Date.now();
    });
    // At this point we know that this code is running in the top-level window,
    // (not in iframe) so we can instantiate a fully-functional API:
    var sgwtConnect = isScopeListed_1$1.isScopeListed('openid', config.scope)
        ? new SGWTConnectCore_1$1.SGWTConnectCore(config, storage, SGWTConnectOpenIDMetadata$1.createOpenIDMetadataFetcher(config.authorization_endpoint))
        : new SGWTConnectCore_1$1.SGWTConnectCore(config, storage);
    // Checking if the authorization has been explicitly granted:
    if (sgwtConnect.isAuthorized()) {
        // The user-friendly behavior is to have periodical renewal enabled by default:
        return sgwtConnect.enablePeriodicalRenewal();
    }
    // Checking if the authorization has been explicitly denied:
    if (auth && auth.error) {
        if (auth.markedForDeletion) {
            storage.removeItem('AUTH');
        }
        else {
            auth.markedForDeletion = true;
            storage.setItem('AUTH', auth);
        }
    }
    return sgwtConnect;
}
var setupSGWTConnect_2$1 = setupSGWTConnect$1;


var setupSGWTConnect_1$1 = /*#__PURE__*/Object.defineProperty({
	setupSGWTConnect: setupSGWTConnect_2$1
}, '__esModule', {value: true});

var dist$3 = createCommonjsModule(function (module, exports) {
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @module SGWTConnectCore
 * @description
 * Entry point for all public APIs and interfaces of the @sgwt/connect-core package.
 */
__export(SGWTConnectErrorList$1);
__export(SGWTConnectError_1$1);
__export(SGWTConnectEventList$1);
__export(SGWTConnectConfiguration$1);
__export(SGWTConnectStorage_1$1);
__export(SGWTConnectCore_1$1);
__export(setupSGWTConnect_1$1);

});

var utils$1 = createCommonjsModule(function (module, exports) {
var __assign = (commonjsGlobal && commonjsGlobal.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (commonjsGlobal && commonjsGlobal.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
// Topics on SG Widgets bus
exports.BUS_ACCESS_TOKEN = 'sg-connect.access-token';
exports.BUS_ACCESS_TOKEN_EXPIRATION = 'sg-connect.access-token.expiration';
exports.BUS_USER_CONNECTION = 'sg-connect.user-connection';
exports.BUS_USER_INFO = 'sg-connect.user-info';
exports.BUS_GRANTED_SCOPE = 'sg-connect.granted-scope';
/**
 * Log a message if the debug attribute is set...
 */
exports.logMessage = function (msg) {
    if (window.SGWT_CONNECT_DELEGATION_LOG) {
        console.log("[SgwtConnect | SG Dashboard] [" + new Date().toISOString() + "] " + msg); // tslint:disable-line
    }
};
/**
 * Check if an object is null, undefined or empty.
 */
exports.isEmpty = function (obj) { return !obj || Object.keys(obj).length === 0; };
/**
 * Get the Widget bus.
 */
var getBus = function () { return window.SGWTWidgetConfiguration.bus; };
/**
 * Get the value for a given topic from the Widgets bus.
 */
exports.getBusValue = function (topic) { return getBus().dangerouslyGetCurrentValue(topic); };
/**
 * Publis a value for a given topic in the Widgets bus, if the value is different from the one already present.
 */
exports.publishOnBus = function (topic, value) {
    var current = exports.getBusValue(topic);
    // Publish only a new value...
    if (value !== current) {
        getBus().publish(topic, value);
    }
};
/**
 * Wait until a condition is true. Check every `interval` ms, with a maximum timeout of `timeout` ms.
 * Once the condition is true, the Promise is resolved to `true`.
 * If the timeout is reached, the Promise is resolved to `false`.
 */
function waitUntil(condition, interval, timeout) {
    return __awaiter(this, void 0, void 0, function () {
        var remaining;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    remaining = timeout;
                    return [4 /*yield*/, new Promise(function (resolve) {
                            var intervalId = setInterval(function () {
                                if (condition()) {
                                    resolve(true);
                                    clearInterval(intervalId);
                                }
                                remaining -= interval;
                                if (remaining <= 0) {
                                    resolve(false);
                                    clearInterval(intervalId);
                                }
                            }, interval);
                        })];
                case 1: return [2 /*return*/, _a.sent()];
            }
        });
    });
}
exports.waitUntil = waitUntil;
/**
 * Fetch user info. We cannot use `sgwtConnect.fetchUserInfo` directly because
 * it will uses its own SG Connect token, and not the delegation token.
 * Some information (mainly `user_authorizations`) can change.
 */
function fetchUserInfo(authorizationEndpoint, delegationToken) {
    var userInfo = exports.getBusValue(exports.BUS_USER_INFO);
    // Check if the userInfo in the Bus has already been retrieved, with the Delegation token
    // (`__delegation` property is used for that).
    if (exports.isEmpty(userInfo) || typeof userInfo.__delegation === 'undefined') {
        exports.logMessage('No UserInfo, or not retrieved with the Delegation token, so starting to fetch the UserInfo.');
        fetch(authorizationEndpoint + "/oauth2/userinfo", {
            method: 'GET',
            mode: 'cors',
            headers: {
                Authorization: delegationToken,
                'Content-Type': 'application/json'
            }
        })
            .then(function (response) { return response.json(); })
            .then(function (claims) {
            exports.publishOnBus(exports.BUS_USER_INFO, __assign({}, claims, { __delegation: true }));
        })
            .catch(function (e) {
            console.error('Could not retrieve UserInfo from OAuth2', e);
        });
    }
}
exports.fetchUserInfo = fetchUserInfo;

});

var __assign$2 = (commonjsGlobal && commonjsGlobal.__assign) || function () {
    __assign$2 = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign$2.apply(this, arguments);
};
var __awaiter$1 = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator$1 = (commonjsGlobal && commonjsGlobal.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var _this$1 = commonjsGlobal;



/**
 * Get a new token from the current one by calling a Delegation endpoint. With a list of asked scopes
 */
var getDelegationToken$1 = function (delegationEndpoint, token, scopes) { return __awaiter$1(_this$1, void 0, void 0, function () {
    return __generator$1(this, function (_a) {
        utils$1.logMessage("get delegation token from token " + token + ".");
        if (token === null) {
            throw new Error('Cannot get a delegation token without a valid access token.');
        }
        return [2 /*return*/, fetch(delegationEndpoint, {
                method: 'POST',
                mode: 'cors',
                headers: {
                    Authorization: token,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ scopes: scopes })
            })
                .then(function (response) { return response.json(); })
                .then(function (response) {
                utils$1.logMessage("New delegation token retrieved \"" + response.access_token + "\"");
                if (response.access_token === undefined || response.access_token === null) {
                    throw new Error('ERROR, access_token is null or undefined');
                }
                var delegationToken = "Bearer " + response.access_token;
                utils$1.publishOnBus(utils$1.BUS_ACCESS_TOKEN, delegationToken);
                utils$1.publishOnBus(utils$1.BUS_GRANTED_SCOPE, response.scope);
                var expiration = Date.now() + (response.expires_in * 1000);
                utils$1.publishOnBus(utils$1.BUS_ACCESS_TOKEN_EXPIRATION, expiration);
                return delegationToken;
            })
                .catch(function (e) {
                console.error('Cannot retrieve a delegation token', e);
                throw e;
            })];
    });
}); };
/**
 * Check if we have, in the bus, a valid delegation token...
 */
var hasValidDelegationToken$1 = function () {
    var token = utils$1.getBusValue(utils$1.BUS_ACCESS_TOKEN);
    if (!token) {
        return false;
    }
    // We have a token in the bus, we check its expiration date...
    var expiration = utils$1.getBusValue(utils$1.BUS_ACCESS_TOKEN_EXPIRATION);
    return expiration && Date.now() < parseInt(expiration, 10);
};
/**
 * Setup the sgwtConnect library with delegation of token feature.
 */
function setupSGWTConnectWithDelegation$2(config) {
    var _this = this;
    var userConfig = __assign$2({}, config, { 
        // Normalize the URL endpoint (remove '/oauth2/authorize' or '/userinfo' at the end).
        authorization_endpoint: config.authorization_endpoint.replace(/(\/oauth2\/authorize|\/userinfo)?\/?$/, '') });
    var requestInProgress = false;
    var delegationError = null;
    window.SGWT_CONNECT_DELEGATION_LOG = typeof userConfig.debug !== 'undefined' && userConfig.debug;
    // First of all, we setup the sgwtConnect library.
    utils$1.logMessage('Setup SGWT Connect Delegation library');
    var sgwtConnect = dist$3.setupSGWTConnect(userConfig);
    // Then, we put it in the `window` object (required by some widget for example).
    window.sgwtConnect = __assign$2({}, sgwtConnect, { 
        // We mock the `getAuthorizationHeader()` function in case a widget tries to access it directly...
        getAuthorizationHeader: function () { return utils$1.getBusValue(utils$1.BUS_ACCESS_TOKEN); }, 
        // We also mock the old getJWTClaims function...
        getJWTClaims: function () { return sgwtConnect.getIdTokenClaims(); } });
    // We check if the user is authorized, and publish information regarding the user...
    if (!sgwtConnect.isAuthorized()) {
        sgwtConnect.isAuthorizedAsync = function () { return __awaiter$1(_this, void 0, void 0, function () { return __generator$1(this, function (_a) {
            return [2 /*return*/, false];
        }); }); };
        sgwtConnect.getAuthorizationDelegationError = function () { return sgwtConnect.getAuthorizationError(); };
        return sgwtConnect;
    }
    // Check if we have a valid delegation token in the bus to avoid making a new call to the delegation endpoint.
    if (!hasValidDelegationToken$1()) {
        // No token, or an expired one...
        utils$1.logMessage('no valid delegation token found, calling the delegation endpoint...');
        requestInProgress = true;
        delegationError = null;
        getDelegationToken$1(userConfig.delegation_endpoint, sgwtConnect.getAuthorizationHeader(), userConfig.scope.split(' '))
            .then(function (delegationToken) {
            requestInProgress = false;
            // Fetch UserInfo
            utils$1.fetchUserInfo(userConfig.authorization_endpoint, delegationToken);
        })
            .catch(function (e) {
            delegationError = e;
        });
    }
    // Publish user connection information...
    utils$1.publishOnBus(utils$1.BUS_USER_CONNECTION, {
        connected: true,
        claims: sgwtConnect.getIdTokenClaims()
    });
    // Make sure the token renewal process is started!
    utils$1.logMessage('enable periodical token renewal.');
    sgwtConnect.enablePeriodicalRenewal();
    // The authorization has been discarded, we clear the bus.
    sgwtConnect.on(dist$3.EVENT_AUTH_DISCARDED, function () {
        utils$1.logMessage('Authorization has been discarded, cleaning the Widget bus...');
        utils$1.publishOnBus(utils$1.BUS_ACCESS_TOKEN, undefined);
        utils$1.publishOnBus(utils$1.BUS_ACCESS_TOKEN_EXPIRATION, undefined);
        utils$1.publishOnBus(utils$1.BUS_USER_CONNECTION, undefined);
        utils$1.publishOnBus(utils$1.BUS_USER_INFO, undefined);
        utils$1.publishOnBus(utils$1.BUS_GRANTED_SCOPE, undefined);
    });
    sgwtConnect.on(dist$3.EVENT_AUTH_RENEW_SUCCESS, function () {
        utils$1.logMessage('Token has been renewed, calling the delegation endpoint...');
        requestInProgress = true;
        delegationError = null;
        var scopeBusValue = utils$1.getBusValue(utils$1.BUS_GRANTED_SCOPE);
        var scopeToAsk = scopeBusValue !== null ? scopeBusValue.split(' ') : userConfig.scope.split(' '); // handle case if token is renewed but the delegation endpoint was not called first
        getDelegationToken$1(userConfig.delegation_endpoint, sgwtConnect.getAuthorizationHeader(), scopeToAsk)
            .then(function () { requestInProgress = false; })
            .catch(function (e) {
            delegationError = e;
        });
    });
    sgwtConnect.isAuthorizedAsync = function () { return __awaiter$1(_this, void 0, void 0, function () {
        var requestFinished, hasToken;
        return __generator$1(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!sgwtConnect.isAuthorized()) {
                        // Case 1: the user is not authorized => KO
                        return [2 /*return*/, false];
                    }
                    if (hasValidDelegationToken$1()) {
                        // Case 2: we have a valid delegation token => OK
                        return [2 /*return*/, true];
                    }
                    if (!requestInProgress) return [3 /*break*/, 2];
                    // Case 3.a: a request is in progress, so we wait for it to finish (or reach a 30s timeout)...
                    utils$1.logMessage('We do not have a valid delegation token, but a request is in progress...');
                    return [4 /*yield*/, utils$1.waitUntil(function () { return !requestInProgress; }, 100, 30000)];
                case 1:
                    requestFinished = _a.sent();
                    hasToken = hasValidDelegationToken$1();
                    utils$1.logMessage("The request " + (requestFinished ? 'has finished' : 'reached a 30s timeout') + ". Do we have a delegation token? " + hasToken);
                    return [2 /*return*/, hasToken];
                case 2:
                    // Case 3.b: a request is not in progress, so we launch one!
                    utils$1.logMessage('We do not have a valid delegation token, no request is currently in progress...');
                    delegationError = null;
                    requestInProgress = true;
                    return [2 /*return*/, getDelegationToken$1(userConfig.delegation_endpoint, sgwtConnect.getAuthorizationHeader(), userConfig.scope.split(' '))
                            .then(function (delegationToken) {
                            requestInProgress = false;
                            // Fetch UserInfo
                            utils$1.fetchUserInfo(userConfig.authorization_endpoint, delegationToken);
                            return hasValidDelegationToken$1();
                        })
                            .catch(function (e) {
                            delegationError = e;
                            requestInProgress = false;
                            return false;
                        })];
            }
        });
    }); };
    sgwtConnect.getAuthorizationDelegationError = function () {
        if (sgwtConnect.getAuthorizationError()) {
            return sgwtConnect.getAuthorizationError();
        }
        return delegationError;
    };
    return sgwtConnect;
}
var setupSGWTConnectWithDelegation_2$1 = setupSGWTConnectWithDelegation$2;


var setupSGWTConnectWithDelegation_1$1 = /*#__PURE__*/Object.defineProperty({
	setupSGWTConnectWithDelegation: setupSGWTConnectWithDelegation_2$1
}, '__esModule', {value: true});

var dist$2 = createCommonjsModule(function (module, exports) {
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @module SGWTConnectCoreDelegation
 * @description
 * Entry point for the SGWT Connect core with Delegation feature.
 */
__export(setupSGWTConnectWithDelegation_1$1);
__export(utils$1);

});

/**
 * Authorization server response validation error.
 *
 * Unable to verify the validity of the request by matching
 * the "state" parameter sent with the authorization request
 * to the "state" parameter received in authorization server
 * response.
 *
 * This error may indicate a cross-site request forgery (CSRF)
 * attack or a misconfiguration of the authorization server.
 *
 * See: https://tools.ietf.org/html/rfc6749#section-10.12
 */
var ERR_STATE_MISMATCH = 'state_mismatch';
var ERR_STATE_MISMATCH_DESCRIPTION = "\n  This error may indicate a cross-site request forgery (CSRF)\n  attack or a misconfiguration of the authorization server.\n";
/**
 * Authorization server response validation error.
 *
 * SGWTConnect does not support the access token type
 * received from the authorization server.
 */
var ERR_UNSUPPORTED_TOKEN_TYPE = 'unsupported_token_type';
var ERR_UNSUPPORTED_TOKEN_TYPE_DESCRIPTION = "\n  SGWTConnect does not support the access token type\n  received from the authorization server.\n";
/**
 * SGWTConnect unauthorized error.
 *
 * Occurs when SGWTConnect is unable to perform an action
 * because it is currently unauthorized to do so.
 */
var ERR_UNAUTHORIZED = 'unauthorized';
var ERR_UNAUTHORIZED_DESCRIPTION = "\n  SGWTConnect is unable to perform an action\n  because it is currently unauthorized to do so.\n";
/**
 * SGWTConnect renewal error.
 *
 * Occurs when SGWTConnect does not receive a response
 * from the authorization server while renewing the token.
 */
var ERR_RENEW_TIMEOUT = 'renew_timeout';
var ERR_RENEW_TIMEOUT_DESCRIPTION = "\n  SGWTConnect did not receive a response\n  from the authorization server while\n  renewing the token.\n";
//
// OAuth 2.0 errors are listed below.
// See: https://tools.ietf.org/html/rfc6749#section-4.2.2.1
// --------------------
/**
 * Authorization server error response.
 *
 * The request is missing a required parameter, includes an
 * unsupported parameter value, includes a parameter more
 * than once, or is otherwise malformed.
 *
 * See: https://tools.ietf.org/html/rfc6749#section-4.2.2.1
 */
var ERR_INVALID_REQUEST = 'invalid_request';
var ERR_INVALID_REQUEST_DESCRIPTION = "\n  The configuration may be malformed.\n  Double check all configuration options.\n";
/**
 * Authorization server error response.
 *
 * The client is not authorized to request an access token
 * using this method.
 *
 * See: https://tools.ietf.org/html/rfc6749#section-4.2.2.1
 */
var ERR_UNAUTHORIZED_CLIENT = 'unauthorized_client';
var ERR_UNAUTHORIZED_CLIENT_DESCRIPTION = "\n  The client is not authorized to request an access token\n  using this method.\n";
/**
 * Authorization server error response.
 *
 * The resource owner or authorization server denied the request.
 *
 * See: https://tools.ietf.org/html/rfc6749#section-4.2.2.1
 */
var ERR_ACCESS_DENIED = 'access_denied';
var ERR_ACCESS_DENIED_DESCRIPTION = "\n  The resource owner or authorization server denied the request.\n";
/**
 * Authorization server error response.
 *
 * The authorization server does not support obtaining an
 * access token using this method.
 *
 * See: https://tools.ietf.org/html/rfc6749#section-4.2.2.1
 */
var ERR_UNSUPPORTED_RESPONSE_TYPE = 'unsupported_response_type';
var ERR_UNSUPPORTED_RESPONSE_TYPE_DESCRIPTION = "\n  The authorization server does not support obtaining an\n  access token using this method.\n\n  Double-check the \"response_type\" configuration option.\n";
/**
 * Authorization server error response.
 *
 * The requested scope is invalid, unknown, or malformed.
 *
 * See: https://tools.ietf.org/html/rfc6749#section-4.2.2.1
 */
var ERR_INVALID_SCOPE = 'invalid_scope';
var ERR_INVALID_SCOPE_DESCRIPTION = "\n  The requested scope is invalid, unknown, or malformed.\n";
/**
 * Authorization server error response.
 *
 * The authorization server encountered an unexpected
 * condition that prevented it from fulfilling the request.
 * (This error code is needed because a 500 Internal Server
 * Error HTTP status code cannot be returned to the client
 * via an HTTP redirect.)
 *
 * See: https://tools.ietf.org/html/rfc6749#section-4.2.2.1
 */
var ERR_SERVER_ERROR = 'server_error';
var ERR_SERVER_ERROR_DESCRIPTION = "\n  The authorization server encountered an unexpected\n  condition that prevented it from fulfilling the request.\n\n  Please try again in a few minutes.\n";
/**
 * Authorization server error response.
 *
 * The authorization server is currently unable to handle
 * the request due to a temporary overloading or maintenance
 * of the server. (This error code is needed because a 503
 * Service Unavailable HTTP status code cannot be returned
 * to the client via an HTTP redirect.)
 *
 * See: https://tools.ietf.org/html/rfc6749#section-4.2.2.1
 */
var ERR_TEMPORARILY_UNAVAILABLE = 'temporarily_unavailable';
var ERR_TEMPORARILY_UNAVAILABLE_DESCRIPTION = "\n  The authorization server is currently unable to handle\n  the request due to a temporary overloading or maintenance\n  of the server.\n\n  Please try again in a few minutes.\n";
//
// OpenID Connect 1.0 errors are listed below.
// See: http://openid.net/specs/openid-connect-core-1_0.html#AuthError
// --------------------
/**
 * OpenID Connect authentication error response.
 *
 * The Authorization Server requires End-User interaction
 * of some form to proceed. This error MAY be returned
 * when the prompt parameter value in the Authentication Request
 * is none, but the Authentication Request cannot be completed
 * without displaying a user interface for End-User interaction.
 *
 * See: http://openid.net/specs/openid-connect-core-1_0.html#AuthError
 */
var ERR_INTERACTION_REQUIRED = 'interaction_required';
var ERR_INTERACTION_REQUIRED_DESCRIPTION = "\n  The Authorization Server requires End-User interaction\n  of some form to proceed.\n";
/**
 * OpenID Connect authentication error response.
 *
 * The Authorization Server requires End-User authentication.
 * This error MAY be returned when the prompt parameter value in the
 * Authentication Request is none, but the Authentication Request
 * cannot be completed without displaying a user interface for
 * End-User authentication.
 *
 * See: http://openid.net/specs/openid-connect-core-1_0.html#AuthError
 */
var ERR_LOGIN_REQUIRED = 'login_required';
var ERR_LOGIN_REQUIRED_DESCRIPTION = "\n  The Authorization Server requires End-User authentication.\n";
/**
 * OpenID Connect authentication error response.
 *
 * The End-User is REQUIRED to select a session at the Authorization Server.
 * The End-User MAY be authenticated at the Authorization Server with
 * different associated accounts, but the End-User did not select a session.
 * This error MAY be returned when the prompt parameter value in the
 * Authentication Request is none, but the Authentication Request
 * cannot be completed without displaying a user interface to prompt
 * for a session to use.
 *
 * See: http://openid.net/specs/openid-connect-core-1_0.html#AuthError
 */
var ERR_ACCOUNT_SELECTION_REQUIRED = 'account_selection_required';
var ERR_ACCOUNT_SELECTION_REQUIRED_DESCRIPTION = "\n  The End-User is REQUIRED to select a session at the Authorization Server.\n  The End-User MAY be authenticated at the Authorization Server with\n  different associated accounts, but the End-User did not select a session.\n";
/**
 * OpenID Connect authentication error response.
 *
 * The Authorization Server requires End-User consent.
 * This error MAY be returned when the prompt parameter value in the
 * Authentication Request is none, but the Authentication Request
 * cannot be completed without displaying a user interface for
 * End-User consent.
 *
 * See: http://openid.net/specs/openid-connect-core-1_0.html#AuthError
 */
var ERR_CONSENT_REQUIRED = 'consent_required';
var ERR_CONSENT_REQUIRED_DESCRIPTION = "\n  The Authorization Server requires End-User consent.\n";
/**
 * OpenID Connect authentication error response.
 *
 * The request_uri in the Authorization Request returns an error
 * or contains invalid data.
 *
 * See: http://openid.net/specs/openid-connect-core-1_0.html#AuthError
 */
var ERR_INVALID_REQUEST_URI = 'invalid_request_uri';
var ERR_INVALID_REQUEST_URI_DESCRIPTION = "\n  The request_uri in the Authorization Request returns an error\n  or contains invalid data.\n\n  This is probably a bug in SGWTConnect.\n";
/**
 * OpenID Connect authentication error response.
 *
 * The request parameter contains an invalid Request Object.
 *
 * See: http://openid.net/specs/openid-connect-core-1_0.html#AuthError
 */
var ERR_INVALID_REQUEST_OBJECT = 'invalid_request_object';
var ERR_INVALID_REQUEST_OBJECT_DESCRIPTION = "\n  The request parameter contains an invalid Request Object.\n\n  This is probably a bug in SGWTConnect.\n";
/**
 * OpenID Connect authentication error response.
 *
 * The OpenID Provider does not support use of the `request` parameter defined in
 * [Section 6](http://openid.net/specs/openid-connect-core-1_0.html#JWTRequests).
 *
 * See: http://openid.net/specs/openid-connect-core-1_0.html#AuthError
 */
var ERR_REQUEST_NOT_SUPPORTED = 'request_not_supported';
var ERR_REQUEST_NOT_SUPPORTED_DESCRIPTION = "\n  The OpenID Provider does not support use of the \"request\" parameter.\n";
/**
 * OpenID Connect authentication error response.
 *
 * The OpenID Provider does not support use of the `request_uri` parameter defined in
 * [Section 6](http://openid.net/specs/openid-connect-core-1_0.html#JWTRequests).
 *
 * See: http://openid.net/specs/openid-connect-core-1_0.html#AuthError
 */
var ERR_REQUEST_URI_NOT_SUPPORTED = 'request_uri_not_supported';
var ERR_REQUEST_URI_NOT_SUPPORTED_DESCRIPTION = "\n  The OpenID Provider does not support use of the \"request_uri\" parameter.\n";
/**
 * OpenID Connect authentication error response.
 *
 * The OpenID Provider does not support use of the `registration` parameter defined in
 * [Section 7.2.1](http://openid.net/specs/openid-connect-core-1_0.html#RegistrationParameter).
 *
 * See: http://openid.net/specs/openid-connect-core-1_0.html#AuthError
 */
var ERR_REGISTRATION_NOT_SUPPORTED = 'registration_not_supported';
var ERR_REGISTRATION_NOT_SUPPORTED_DESCRIPTION = "\n  The OpenID Provider does not support use of the \"registration\" parameter.\n";
//
// OpenID Connect 1.0 Session Management errors are listed below.
// See: https://openid.net/specs/openid-connect-session-1_0.html
// --------------------
/**
 * Indicates that an HTTP request to obtain
 * the OpenID Provider Discovery Metadata has failed.
 */
var ERR_FAILED_TO_FETCH_OPENID_METADATA = 'failed_to_obtain_openid_metadata';
var ERR_FAILED_TO_FETCH_OPENID_METADATA_DESCRIPTION = "\n  Failed to obtain OpenID Provider Metadata.\n";
/**
 * Indicates that there was a error parsing
 * the OpenID Provider Discovery Metadata response.
 */
var ERR_FAILED_TO_PARSE_OPENID_METADATA = 'failed_to_parse_openid_metadata';
var ERR_FAILED_TO_PARSE_OPENID_METADATA_DESCRIPTION = "\n  Failed to parse OpenID Provider Discovery Metadata.\n";
/**
 * Indicates that there was an error validating
 * the OpenID Provider Discovery Metadata response.
 */
var ERR_FAILED_TO_VALIDATE_OPENID_METADATA = 'failed_to_validate_openid_metadata';
var ERR_FAILED_TO_VALIDATE_OPENID_METADATA_DESCRIPTION = "\n  Failed to validate OpenID Provider Discovery Metadata.\n";
/**
 * Indicates that the OpenID OP iframe received
 * a syntactically malformed message.
 *
 * See: https://openid.net/specs/openid-connect-session-1_0.html#OPiframe
 */
var ERR_OPENID_CHECK_SESSION_ERROR = 'check_session_error';
var ERR_OPENID_CHECK_SESSION_ERROR_DESCRIPTION = "\n  Client ID and origin URL cannot be determined or are syntactically invalid.\n";
//
// OpenID UserInfo Endpoint.
// See: https://openid.net/specs/openid-connect-core-1_0.html#UserInfo
// --------------------
/**
 * Indicates that an HTTP request to obtain
 * the OpenID UserInfo Claims has failed.
 */
var ERR_FAILED_TO_FETCH_OPENID_CLAIMS = 'failed_to_obtain_openid_claims';
var ERR_FAILED_TO_FETCH_OPENID_CLAIMS_DESCRIPTION = "\n  Failed to obtain OpenID UserInfo Claims.\n";
/**
 * Indicates that there was a error parsing
 * the OpenID UserInfo Claims response.
 */
var ERR_FAILED_TO_PARSE_OPENID_CLAIMS = 'failed_to_parse_openid_claims';
var ERR_FAILED_TO_PARSE_OPENID_CLAIMS_DESCRIPTION = "\n  Failed to parse OpenID UserInfo Claims.\n";
/**
 * Indicates that there was an error validating
 * the OpenID UserInfo Claims response.
 */
var ERR_FAILED_TO_VALIDATE_OPENID_CLAIMS = 'failed_to_validate_openid_claims';
var ERR_FAILED_TO_VALIDATE_OPENID_CLAIMS_DESCRIPTION = "\n  Failed to validate OpenID UserInfo Claims.\n";


var SGWTConnectErrorList = /*#__PURE__*/Object.defineProperty({
	ERR_STATE_MISMATCH: ERR_STATE_MISMATCH,
	ERR_STATE_MISMATCH_DESCRIPTION: ERR_STATE_MISMATCH_DESCRIPTION,
	ERR_UNSUPPORTED_TOKEN_TYPE: ERR_UNSUPPORTED_TOKEN_TYPE,
	ERR_UNSUPPORTED_TOKEN_TYPE_DESCRIPTION: ERR_UNSUPPORTED_TOKEN_TYPE_DESCRIPTION,
	ERR_UNAUTHORIZED: ERR_UNAUTHORIZED,
	ERR_UNAUTHORIZED_DESCRIPTION: ERR_UNAUTHORIZED_DESCRIPTION,
	ERR_RENEW_TIMEOUT: ERR_RENEW_TIMEOUT,
	ERR_RENEW_TIMEOUT_DESCRIPTION: ERR_RENEW_TIMEOUT_DESCRIPTION,
	ERR_INVALID_REQUEST: ERR_INVALID_REQUEST,
	ERR_INVALID_REQUEST_DESCRIPTION: ERR_INVALID_REQUEST_DESCRIPTION,
	ERR_UNAUTHORIZED_CLIENT: ERR_UNAUTHORIZED_CLIENT,
	ERR_UNAUTHORIZED_CLIENT_DESCRIPTION: ERR_UNAUTHORIZED_CLIENT_DESCRIPTION,
	ERR_ACCESS_DENIED: ERR_ACCESS_DENIED,
	ERR_ACCESS_DENIED_DESCRIPTION: ERR_ACCESS_DENIED_DESCRIPTION,
	ERR_UNSUPPORTED_RESPONSE_TYPE: ERR_UNSUPPORTED_RESPONSE_TYPE,
	ERR_UNSUPPORTED_RESPONSE_TYPE_DESCRIPTION: ERR_UNSUPPORTED_RESPONSE_TYPE_DESCRIPTION,
	ERR_INVALID_SCOPE: ERR_INVALID_SCOPE,
	ERR_INVALID_SCOPE_DESCRIPTION: ERR_INVALID_SCOPE_DESCRIPTION,
	ERR_SERVER_ERROR: ERR_SERVER_ERROR,
	ERR_SERVER_ERROR_DESCRIPTION: ERR_SERVER_ERROR_DESCRIPTION,
	ERR_TEMPORARILY_UNAVAILABLE: ERR_TEMPORARILY_UNAVAILABLE,
	ERR_TEMPORARILY_UNAVAILABLE_DESCRIPTION: ERR_TEMPORARILY_UNAVAILABLE_DESCRIPTION,
	ERR_INTERACTION_REQUIRED: ERR_INTERACTION_REQUIRED,
	ERR_INTERACTION_REQUIRED_DESCRIPTION: ERR_INTERACTION_REQUIRED_DESCRIPTION,
	ERR_LOGIN_REQUIRED: ERR_LOGIN_REQUIRED,
	ERR_LOGIN_REQUIRED_DESCRIPTION: ERR_LOGIN_REQUIRED_DESCRIPTION,
	ERR_ACCOUNT_SELECTION_REQUIRED: ERR_ACCOUNT_SELECTION_REQUIRED,
	ERR_ACCOUNT_SELECTION_REQUIRED_DESCRIPTION: ERR_ACCOUNT_SELECTION_REQUIRED_DESCRIPTION,
	ERR_CONSENT_REQUIRED: ERR_CONSENT_REQUIRED,
	ERR_CONSENT_REQUIRED_DESCRIPTION: ERR_CONSENT_REQUIRED_DESCRIPTION,
	ERR_INVALID_REQUEST_URI: ERR_INVALID_REQUEST_URI,
	ERR_INVALID_REQUEST_URI_DESCRIPTION: ERR_INVALID_REQUEST_URI_DESCRIPTION,
	ERR_INVALID_REQUEST_OBJECT: ERR_INVALID_REQUEST_OBJECT,
	ERR_INVALID_REQUEST_OBJECT_DESCRIPTION: ERR_INVALID_REQUEST_OBJECT_DESCRIPTION,
	ERR_REQUEST_NOT_SUPPORTED: ERR_REQUEST_NOT_SUPPORTED,
	ERR_REQUEST_NOT_SUPPORTED_DESCRIPTION: ERR_REQUEST_NOT_SUPPORTED_DESCRIPTION,
	ERR_REQUEST_URI_NOT_SUPPORTED: ERR_REQUEST_URI_NOT_SUPPORTED,
	ERR_REQUEST_URI_NOT_SUPPORTED_DESCRIPTION: ERR_REQUEST_URI_NOT_SUPPORTED_DESCRIPTION,
	ERR_REGISTRATION_NOT_SUPPORTED: ERR_REGISTRATION_NOT_SUPPORTED,
	ERR_REGISTRATION_NOT_SUPPORTED_DESCRIPTION: ERR_REGISTRATION_NOT_SUPPORTED_DESCRIPTION,
	ERR_FAILED_TO_FETCH_OPENID_METADATA: ERR_FAILED_TO_FETCH_OPENID_METADATA,
	ERR_FAILED_TO_FETCH_OPENID_METADATA_DESCRIPTION: ERR_FAILED_TO_FETCH_OPENID_METADATA_DESCRIPTION,
	ERR_FAILED_TO_PARSE_OPENID_METADATA: ERR_FAILED_TO_PARSE_OPENID_METADATA,
	ERR_FAILED_TO_PARSE_OPENID_METADATA_DESCRIPTION: ERR_FAILED_TO_PARSE_OPENID_METADATA_DESCRIPTION,
	ERR_FAILED_TO_VALIDATE_OPENID_METADATA: ERR_FAILED_TO_VALIDATE_OPENID_METADATA,
	ERR_FAILED_TO_VALIDATE_OPENID_METADATA_DESCRIPTION: ERR_FAILED_TO_VALIDATE_OPENID_METADATA_DESCRIPTION,
	ERR_OPENID_CHECK_SESSION_ERROR: ERR_OPENID_CHECK_SESSION_ERROR,
	ERR_OPENID_CHECK_SESSION_ERROR_DESCRIPTION: ERR_OPENID_CHECK_SESSION_ERROR_DESCRIPTION,
	ERR_FAILED_TO_FETCH_OPENID_CLAIMS: ERR_FAILED_TO_FETCH_OPENID_CLAIMS,
	ERR_FAILED_TO_FETCH_OPENID_CLAIMS_DESCRIPTION: ERR_FAILED_TO_FETCH_OPENID_CLAIMS_DESCRIPTION,
	ERR_FAILED_TO_PARSE_OPENID_CLAIMS: ERR_FAILED_TO_PARSE_OPENID_CLAIMS,
	ERR_FAILED_TO_PARSE_OPENID_CLAIMS_DESCRIPTION: ERR_FAILED_TO_PARSE_OPENID_CLAIMS_DESCRIPTION,
	ERR_FAILED_TO_VALIDATE_OPENID_CLAIMS: ERR_FAILED_TO_VALIDATE_OPENID_CLAIMS,
	ERR_FAILED_TO_VALIDATE_OPENID_CLAIMS_DESCRIPTION: ERR_FAILED_TO_VALIDATE_OPENID_CLAIMS_DESCRIPTION
}, '__esModule', {value: true});

var __extends$1 = (commonjsGlobal && commonjsGlobal.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();


/**
 * SGWTConnect error.
 *
 * The purpose of this class is to differentiate custom SGWTConnect
 * errors from errors originated in other modules.
 */
var SGWTConnectError = /** @class */ (function (_super) {
    __extends$1(SGWTConnectError, _super);
    function SGWTConnectError(code) {
        var _this = this;
        var errorListKey = "ERR_" + code.toUpperCase() + "_DESCRIPTION";
        var description = SGWTConnectErrorList[errorListKey];
        _this = _super.call(this, "SGWTConnectError " + code.toUpperCase() + " " + description) || this;
        // Calling `super` in TypeScript 2.1 and 2.2 breaks the
        // prototype chain, so we need to restore it here to
        // enable instanceof checks
        // See: https://github.com/Microsoft/TypeScript/wiki/Breaking-Changes#typescript-21
        Object.setPrototypeOf(_this, SGWTConnectError.prototype);
        // We use the same approach as NodeJS errors by exposing
        // a `code` property (e.g. "state_mismatch") on error
        // instances:
        _this.code = code;
        return _this;
    }
    return SGWTConnectError;
}(Error));
var SGWTConnectError_2 = SGWTConnectError;


var SGWTConnectError_1 = /*#__PURE__*/Object.defineProperty({
	SGWTConnectError: SGWTConnectError_2
}, '__esModule', {value: true});

/**
 * The authorization token has been discarded.
 */
var EVENT_AUTH_DISCARDED = 'authorizationDiscarded';
/**
 * The authorization token has expired.
 */
var EVENT_AUTH_EXPIRED = 'authorizationExpired';
/**
 * Error has occurred while renewing the token.
 */
var EVENT_AUTH_RENEW_ERROR = 'renewAuthorizationError';
/**
 * The current token has been successfully renewed.
 */
var EVENT_AUTH_RENEW_SUCCESS = 'renewAuthorizationSuccess';
/**
 * Error has occurred while fetching the OpenID Metadata.
 */
var EVENT_OPENID_METADATA_FETCH_ERROR = 'OpenIDMetadataFetchError';
/**
 * Indicates that the OpenID session has changed.
 */
var EVENT_OPENID_SESSION_CHANGED = 'OpenIDCheckSessionChanged';
/**
 * Indicates that the OpenID session has not changed.
 */
var EVENT_OPENID_SESSION_UNCHANGED = 'OpenIDCheckSessionUnchanged';
/**
 * Error has occurred while fetching the OpenID Metadata.
 */
var EVENT_OPENID_CHECK_SESSION_ERROR = 'OpenIDCheckSessionError';


var SGWTConnectEventList = /*#__PURE__*/Object.defineProperty({
	EVENT_AUTH_DISCARDED: EVENT_AUTH_DISCARDED,
	EVENT_AUTH_EXPIRED: EVENT_AUTH_EXPIRED,
	EVENT_AUTH_RENEW_ERROR: EVENT_AUTH_RENEW_ERROR,
	EVENT_AUTH_RENEW_SUCCESS: EVENT_AUTH_RENEW_SUCCESS,
	EVENT_OPENID_METADATA_FETCH_ERROR: EVENT_OPENID_METADATA_FETCH_ERROR,
	EVENT_OPENID_SESSION_CHANGED: EVENT_OPENID_SESSION_CHANGED,
	EVENT_OPENID_SESSION_UNCHANGED: EVENT_OPENID_SESSION_UNCHANGED,
	EVENT_OPENID_CHECK_SESSION_ERROR: EVENT_OPENID_CHECK_SESSION_ERROR
}, '__esModule', {value: true});

/**
 * Generates a cryptographically strong random value.
 */
function generateCryptoStrongRandomValue() {
    var crypto = window.crypto || window.msCrypto;
    var randomValues = crypto.getRandomValues(new Uint32Array(5));
    // IE supports neither TypedArray methods nor Array.from,
    // so we have to use a for loop here if we want this script
    // to be injectable before polyfills:
    var base36RandomValue = '';
    for (var i = 0; i < randomValues.length; i += 1) { // tslint:disable-line:prefer-for-of
        base36RandomValue += randomValues[i].toString(36);
    }
    return base36RandomValue;
}
var generateCryptoStrongRandomValue_1 = generateCryptoStrongRandomValue;
/**
 * Normalizes the authorization endpoint by stripping /oauth2/* suffixes.
 */
function normalizeAuthorizationEndpoint(authorization_endpoint) {
    return authorization_endpoint
        .replace(/(\/oauth2\/authorize|\/userinfo)?\/?$/, '');
}
var normalizeAuthorizationEndpoint_1 = normalizeAuthorizationEndpoint;
/**
 * Generates an OAuth2/OpenID-compliant authorization URI.
 */
function generateAuthorizationUri(config, state, options) {
    return normalizeAuthorizationEndpoint(config.authorization_endpoint) +
        '/oauth2/authorize' +
        '?client_id=' + encodeURIComponent(config.client_id) +
        '&redirect_uri=' + encodeURIComponent(config.redirect_uri) +
        '&response_type=' + encodeURIComponent(config.response_type) +
        '&scope=' + encodeURIComponent(config.scope) +
        '&nonce=' + encodeURIComponent(generateCryptoStrongRandomValue()) +
        '&state=' + encodeURIComponent(state) +
        '&acr_values=' + encodeURIComponent(config.acr_values) +
        (options && options.prompt ? '&prompt=' + options.prompt : '') +
        (options && options.id_token_hint ? '&id_token_hint=' + options.id_token_hint : '');
}
var generateAuthorizationUri_1 = generateAuthorizationUri;


var SGWTConnectAuthorizationUri = /*#__PURE__*/Object.defineProperty({
	generateCryptoStrongRandomValue: generateCryptoStrongRandomValue_1,
	normalizeAuthorizationEndpoint: normalizeAuthorizationEndpoint_1,
	generateAuthorizationUri: generateAuthorizationUri_1
}, '__esModule', {value: true});

/**
 * Determines whether the checked scope is listed in the actual scope.
 */
function isScopeListed(checkedScope, actualScope) {
    var checkedScopeList = checkedScope.trim().toLowerCase().split(/\s+/);
    var actualScopeList = actualScope.trim().toLowerCase().split(/\s+/);
    return checkedScopeList.every(function (scope) { return actualScopeList.indexOf(scope) !== -1; });
}
var isScopeListed_2 = isScopeListed;


var isScopeListed_1 = /*#__PURE__*/Object.defineProperty({
	isScopeListed: isScopeListed_2
}, '__esModule', {value: true});

/**
 * Normalizes a URL by lowercasing it, adding the trailing slash,
 * and removing the default ports (:80 for http and :443 for https).
 * @param url URL to normalize.
 * @example
 *   normalizeUrl('HTTP://EXAMPLE.COM') === 'http://example.com/'
 *   normalizeUrl('http://example.com:80') === 'http://example.com/'
 *   normalizeUrl('https://example.com:443') === 'https://example.com/'
 */
function normalizeUrl(url) {
    // Using HTMLAnchorElement hack because Internet Explorer
    // doesn't support the Window.URL API:
    var a = document.createElement('a');
    a.href = url;
    return a.href;
}
var normalizeUrl_2 = normalizeUrl;


var normalizeUrl_1 = /*#__PURE__*/Object.defineProperty({
	normalizeUrl: normalizeUrl_2
}, '__esModule', {value: true});

/**
 * Creates an object from a string of query parameters.
 */
function parseQueryParametersString(queryParametersString) {
    var queryParametersRegex = /([^&=]+)=([^&]*)/g;
    var queryParameters = {};
    var keyValuePair;
    // tslint:disable-next-line:no-conditional-assignment
    while (keyValuePair = queryParametersRegex.exec(queryParametersString)) {
        var key = decodeURIComponent(keyValuePair[1]);
        var value = decodeURIComponent(keyValuePair[2]);
        queryParameters[key] = value;
    }
    return queryParameters;
}
/**
 * Parses an authorization server response.
 */
function parseOAuth2Fragment(fragment) {
    return parseQueryParametersString(fragment.replace(/^#/, ''));
}
var parseOAuth2Fragment_1 = parseOAuth2Fragment;
/**
 * Normalizes a parsed authorization server response.
 */
function normalizeAuthServerResponse(authServerResponse) {
    if (authServerResponse.error) {
        var authError = {
            error: authServerResponse.error,
            error_description: authServerResponse.error_description,
            state: authServerResponse.state
        };
        return authError;
    }
    var expiresIn = parseInt(authServerResponse.expires_in, 10) * 1000;
    var authSuccess = {
        access_token: authServerResponse.access_token,
        expires_in: expiresIn,
        expires_at: Date.now() + expiresIn,
        id_token: authServerResponse.id_token,
        scope: authServerResponse.scope,
        state: authServerResponse.state,
        token_type: authServerResponse.token_type,
        session_state: authServerResponse.session_state
    };
    return authSuccess;
}
var normalizeAuthServerResponse_1 = normalizeAuthServerResponse;


var SGWTConnectServerResponse = /*#__PURE__*/Object.defineProperty({
	parseOAuth2Fragment: parseOAuth2Fragment_1,
	normalizeAuthServerResponse: normalizeAuthServerResponse_1
}, '__esModule', {value: true});

/**
 * Generates a redirect URI.
 *
 * Given the origin "https://example.com":
 *  - "" -> "https://example.com"
 *  - "/redirect" -> "https://example.com/redirect"
 *  - "https://example.com" -> "https://example.com"
 */
function generateRedirectUri(location, redirectUri) {
    var origin = location.protocol + "//" + location.host;
    // Support empty or unspecified redirect_uri
    // by using the current origin instead:
    // "" => "https://example.com"
    if (!redirectUri) {
        return origin;
    }
    // Support URIs relative to origin, for example:
    // "/redirect" => "https://example.com/redirect"
    if (redirectUri.charAt(0) === '/') {
        return "" + origin + redirectUri;
    }
    // Otherwise use the redirect_uri as provided.
    // Note that we're not trying to normalize it
    // because it will be compared as is on the
    // authorization server.
    return redirectUri;
}
var generateRedirectUri_1 = generateRedirectUri;
/**
 * Determines if the current page has been redirected using OAuth2 protocol.
 */
function isOnRedirectUri(config, location) {
    //
    // Step 1: validate the fragment
    // --------------------
    var authEndpointResponse = SGWTConnectServerResponse.parseOAuth2Fragment(location.hash);
    // Ensure that the fragment has at least the "state" parameter,
    // otherwise this is not a valid OAuth2 fragment:
    if (!authEndpointResponse.hasOwnProperty('state')) {
        return false;
    }
    var hasRequestedAccessToken = isScopeListed_1.isScopeListed('token', config.response_type);
    var hasRequestedIdToken = isScopeListed_1.isScopeListed('id_token', config.response_type);
    var hasReceivedAccessToken = authEndpointResponse.hasOwnProperty('access_token');
    var hasReceivedIdToken = authEndpointResponse.hasOwnProperty('id_token');
    var hasReceivedError = authEndpointResponse.hasOwnProperty('error');
    if (hasRequestedAccessToken) {
        if (!hasReceivedAccessToken && !hasReceivedError) {
            return false;
        }
    }
    if (hasRequestedIdToken) {
        if (!hasReceivedIdToken && !hasReceivedError) {
            return false;
        }
    }
    //
    // Step 2: validate the href without fragment
    // --------------------
    // Remove the fragment from the current location and normalize it
    // to avoid infinite redirects due to non-strictly equal URIs:
    var currentUri = normalizeUrl_1.normalizeUrl(location.href.replace(location.hash, ''));
    // Compare to normalized redirect URI assuming that
    // it has no fragment (as per specification):
    return currentUri === normalizeUrl_1.normalizeUrl(config.redirect_uri);
}
var isOnRedirectUri_1 = isOnRedirectUri;


var SGWTConnectRedirectUri = /*#__PURE__*/Object.defineProperty({
	generateRedirectUri: generateRedirectUri_1,
	isOnRedirectUri: isOnRedirectUri_1
}, '__esModule', {value: true});

var __assign$1 = (commonjsGlobal && commonjsGlobal.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};



/**
 * Normalizes the configuration by adding default fields,
 * and normalizing existing fields.
 * @param config Configuration object to normalize.
 */
function normalizeConfiguration(config, location) {
    return __assign$1({}, config, { response_type: config.response_type || 'id_token token', acr_values: config.acr_values || 'L2', 
        // Normalize the authorization endpoint by stripping some
        // extraneous suffixes that users may add:
        authorization_endpoint: SGWTConnectAuthorizationUri.normalizeAuthorizationEndpoint(config.authorization_endpoint), 
        // API consumers may:
        //  - specify a redirect_uri relative to origin
        //    in this case we prefix it with origin
        //  - not specify a redirect_uri at all
        //    in this case we define it for them, as it is mandatory
        redirect_uri: SGWTConnectRedirectUri.generateRedirectUri(location, config.redirect_uri) }, config.post_logout_redirect_uri
        ? { post_logout_redirect_uri: SGWTConnectRedirectUri.generateRedirectUri(location, config.post_logout_redirect_uri) }
        : {});
}
var normalizeConfiguration_1 = normalizeConfiguration;


var SGWTConnectConfiguration = /*#__PURE__*/Object.defineProperty({
	normalizeConfiguration: normalizeConfiguration_1
}, '__esModule', {value: true});

/**
 * SGWTConnect data storage.
 *
 * Has the following features:
 *  - Automatic parsing of stringified data.
 *  - Prefixing of keys of stored data.
 */
var SGWTConnectStorage = /** @class */ (function () {
    function SGWTConnectStorage(hash) {
        if (hash === void 0) { hash = ''; }
        this.hash = hash;
        this.baseStorageKey = 'SGWTConnectStorage';
    }
    Object.defineProperty(SGWTConnectStorage.prototype, "storageKey", {
        get: function () {
            return this.hash ? this.baseStorageKey + "." + this.hash : this.baseStorageKey;
        },
        enumerable: true,
        configurable: true
    });
    SGWTConnectStorage.prototype.getItem = function (key) {
        var item = localStorage.getItem(this.storageKey + "." + key);
        return item === null ? null : JSON.parse(item);
    };
    SGWTConnectStorage.prototype.setItem = function (key, value) {
        localStorage.setItem(this.storageKey + "." + key, JSON.stringify(value));
    };
    SGWTConnectStorage.prototype.removeItem = function (key) {
        localStorage.removeItem(this.storageKey + "." + key);
    };
    SGWTConnectStorage.prototype.clearBy = function (satisfiesCondition) {
        for (var i = 0; i < localStorage.length; i += 1) {
            var key = localStorage.key(i);
            if (key && key.indexOf(this.baseStorageKey) !== -1) {
                var value = localStorage.getItem(key);
                var parsedValue = value === null ? null : JSON.parse(value);
                if (satisfiesCondition(parsedValue, key)) {
                    localStorage.removeItem(key);
                }
            }
        }
    };
    return SGWTConnectStorage;
}());
var SGWTConnectStorage_2 = SGWTConnectStorage;


var SGWTConnectStorage_1 = /*#__PURE__*/Object.defineProperty({
	SGWTConnectStorage: SGWTConnectStorage_2
}, '__esModule', {value: true});

/**
 * Determines whether two valid URLs are of the same origin.
 *
 * There is no URL normalization, thus
 * `isSameOrigin('http://localhost', 'localhost')` is `false`.
 */
function isSameOrigin(urlA, urlB) {
    // Using HTMLAnchorElement hack because Internet Explorer
    // doesn't support the Window.URL API:
    var a = document.createElement('a');
    a.href = urlA;
    var protocolA = a.protocol, hostA = a.host;
    a.href = urlB;
    var protocolB = a.protocol, hostB = a.host;
    // Internet Explorer doesn't implement HTMLAnchorElement.origin,
    // so we consider origin to be the same when their protocols,
    // hostnames, and ports match exactly. Note that HTMLAnchorElement
    // normalizes the URL (lowercases it, removes trailing slash) and
    // HTMLAnchorElement.host value already includes the port, for ex:
    // "HTTP://Example.com:8080/foo"
    //   - protocol: "http:"
    //   - host: "example.com:8080"
    return protocolA === protocolB && hostA === hostB;
}
var isSameOrigin_2 = isSameOrigin;


var isSameOrigin_1 = /*#__PURE__*/Object.defineProperty({
	isSameOrigin: isSameOrigin_2
}, '__esModule', {value: true});

/**
 * Determines whether the given value is an object.
 * @param value A value to check.
 */
function isObject(value) {
    return value !== null && typeof value === 'object';
}
var isObject_2 = isObject;


var isObject_1 = /*#__PURE__*/Object.defineProperty({
	isObject: isObject_2
}, '__esModule', {value: true});

/**
 * Fetches OpenID Claims from the OpenID Provider's "userinfo" endpoint.
 * @param authorizationEndpoint OpenID Provider's "userinfo" endpoint URL.
 * @param authorizationHeader OpenID Provider's "userinfo" endpoint URL.
 * @param callback Called with Claims or error upon request completion.
 */
function fetchOpenIDUserInfo(authorizationEndpoint, authorizationHeader, callback) {
    var xhr = new XMLHttpRequest();
    xhr.open('GET', authorizationEndpoint + "/oauth2/userinfo");
    xhr.setRequestHeader('Accept', 'application/json');
    xhr.setRequestHeader('Authorization', authorizationHeader);
    xhr.addEventListener('load', function handleOpenIDUserInfoLoad() {
        if (xhr.status === 200) {
            var openIDUserInfo = void 0;
            try {
                openIDUserInfo = JSON.parse(xhr.responseText);
            }
            catch (_a) {
                callback(new SGWTConnectError_1.SGWTConnectError(SGWTConnectErrorList.ERR_FAILED_TO_PARSE_OPENID_CLAIMS));
                return;
            }
            if (isValidOpenIDClaims(openIDUserInfo)) {
                callback(null, openIDUserInfo);
            }
            else {
                callback(new SGWTConnectError_1.SGWTConnectError(SGWTConnectErrorList.ERR_FAILED_TO_VALIDATE_OPENID_CLAIMS));
            }
        }
        else {
            callback(new SGWTConnectError_1.SGWTConnectError(SGWTConnectErrorList.ERR_FAILED_TO_FETCH_OPENID_CLAIMS));
        }
    });
    xhr.send();
}
var fetchOpenIDUserInfo_1 = fetchOpenIDUserInfo;
/**
 * Determines whether the given OpenID Configuration is valid.
 * @param openIDUserInfo JSON-parsed value obtained from the Discovery API.
 */
function isValidOpenIDClaims(openIDUserInfo) {
    return isObject_1.isObject(openIDUserInfo) &&
        typeof openIDUserInfo.sub === 'string' &&
        typeof openIDUserInfo.name === 'string' &&
        typeof openIDUserInfo.locale === 'string';
}


var SGWTConnectOpenIDUserInfo = /*#__PURE__*/Object.defineProperty({
	fetchOpenIDUserInfo: fetchOpenIDUserInfo_1
}, '__esModule', {value: true});

var SGWTConnectCore_1 = createCommonjsModule(function (module, exports) {
var __extends = (commonjsGlobal && commonjsGlobal.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });









exports.SGWTConnectRenewalFrameAttribute = 'data-sgwt-connect-renewal-frame';
exports.SGWTConnectCheckSesssionFrameAttribute = 'data-sgwt-connect-check-session-frame';
/**
 * Main API of SGWTConnect.
 */
var SGWTConnectCore = /** @class */ (function (_super) {
    __extends(SGWTConnectCore, _super);
    function SGWTConnectCore(config, storage, fetchOpenIDMetadata) {
        var _this = _super.call(this) || this;
        _this.config = config;
        _this.storage = storage;
        _this.tokenExpirationTimer = null;
        _this.periodicalRenewalTimer = null;
        _this.periodicalRenewalBackoff = 1000;
        _this.periodicalRenewalTimeout = 30000;
        _this.openIDCheckSessionTimerInterval = 3000;
        if (_this.isAuthorized()) {
            _this.restartTokenExpirationTimer();
        }
        if (fetchOpenIDMetadata && _this.hasRequestedScope('openid')) {
            fetchOpenIDMetadata(function (maybeOpenIDMetadata) {
                if (maybeOpenIDMetadata instanceof Error) {
                    _this.emit(SGWTConnectEventList.EVENT_OPENID_METADATA_FETCH_ERROR, maybeOpenIDMetadata);
                }
                else {
                    _this.openIDMetadata = maybeOpenIDMetadata;
                    _this.enableOpenIDSessionManagement();
                }
            });
        }
        return _this;
    }
    //
    // Public
    // --------------------
    /**
     * Initiates the authorization process.
     *
     * Redirects to the authorization endpoint unless the
     * authorization has already been granted.
     */
    SGWTConnectCore.prototype.requestAuthorization = function () {
        // Check if the user is currently signed in to prevent
        // unnecessary sign-in redirects on application load:
        if (this.isAuthorized()) {
            return this
                .restartTokenExpirationTimer()
                .enablePeriodicalRenewal();
        }
        // At this point the token may not exist, has expired
        // or the authorization server has responded with an
        // error. In any case we clear the current authorization
        // response:
        this.storage.removeItem('AUTH');
        // Cross-Site Request Forgery (CSRF) protection:
        var state = SGWTConnectAuthorizationUri.generateCryptoStrongRandomValue();
        this.storage.setItem(state + ".STATE", state);
        // Remember the current URL, we will need to return
        // the user here after authorization is completed:
        this.storage.setItem(state + ".RETURN_URL", location.href);
        // Initiate the authorization process by redirecting
        // the current page to the authorization endpoint:
        location.replace(SGWTConnectAuthorizationUri.generateAuthorizationUri(this.config, state));
        return this;
    };
    /**
     * Clears the local authorization data and redirects
     * to end_session_endpoint if OpenID is enabled and
     * has loaded the relevant metadata.
     */
    SGWTConnectCore.prototype.discardAuthorization = function () {
        // Redirect is only possible if OpenID Metadata was
        // successfully retrieved from the "well-known" endpoint:
        if (this.openIDMetadata) {
            // Obtain the parameters required for the logout request:
            // https://openid.net/specs/openid-connect-session-1_0.html#RPLogout
            var id_token_hint = this.getIdToken();
            var post_logout_redirect_uri = this.config.post_logout_redirect_uri;
            var end_session_endpoint = this.openIDMetadata.end_session_endpoint;
            // Generate the end session URL:
            var endSessionURL_1 = end_session_endpoint + "?id_token_hint=" + id_token_hint +
                (post_logout_redirect_uri ? "&post_logout_redirect_uri=" + post_logout_redirect_uri : '');
            // Schedule termination of the OpenID session:
            this.once(SGWTConnectEventList.EVENT_AUTH_DISCARDED, function () {
                window.location.replace(endSessionURL_1);
            });
        }
        // Discard the authorization data which will trigger
        // EVENT_AUTH_DISCARDED that we subscribed to above:
        return this.discardAuthorizationLocally();
    };
    /**
     * Initiates a silent renewal of the token.
     *
     * Because the renewal is transparent to the user, we
     * discourage usage of this method before calling `requestAuthorization`
     * as this will not display the authorization approval
     * interface.
     */
    SGWTConnectCore.prototype.renewAuthorization = function (callback) {
        return this.requestAuthorizationWithoutPrompt({}, callback);
    };
    /**
     * Determines if the authorization has been granted.
     *
     * The state of having authorization is determined by the presence
     * of a non-expired access_token. This method does not tell
     * whether the authorization has been revoked or not,
     * or whether the granted scopes are identical to the
     * requested ones.
     */
    SGWTConnectCore.prototype.isAuthorized = function () {
        var authorization = this.storage.getItem('AUTH');
        return Boolean(authorization && authorization.access_token) &&
            authorization.expires_at > Date.now();
    };
    /**
     * Returns the authorization error or null if there is none.
     */
    SGWTConnectCore.prototype.getAuthorizationError = function () {
        var authorization = this.storage.getItem('AUTH');
        return (authorization && authorization.error) ?
            new SGWTConnectError_1.SGWTConnectError(authorization.error) :
            null;
    };
    /**
     * Generates an "Authorization" HTTP header value.
     *
     * Call this method and use the return value as Authorization header
     * value every time you make an HTTP request to your backend API.
     *
     *    const authHttpHeader = sgwtConnect.getAuthorizationHeader();
     *    if (authHttpHeader) {
     *      headers.set('Authorization', authHttpHeader);
     *    }
     *
     * Currently only the "Bearer" token type is supported.
     */
    SGWTConnectCore.prototype.getAuthorizationHeader = function () {
        var authorization = this.storage.getItem('AUTH');
        if (!this.isAuthorized()) {
            return null;
        }
        if (authorization.token_type && authorization.token_type.toLowerCase() === 'bearer') {
            return "Bearer " + authorization.access_token;
        }
        throw new SGWTConnectError_1.SGWTConnectError(SGWTConnectErrorList.ERR_UNSUPPORTED_TOKEN_TYPE);
    };
    /**
     * Returns the scope granted by the authorization server as a space-delimited string.
     */
    SGWTConnectCore.prototype.getGrantedScope = function () {
        // Make sure that the authorization request was successful:
        if (!this.isAuthorized()) {
            return null;
        }
        // Scope is part of authorization server response:
        var authorization = this.storage.getItem('AUTH');
        // Return the scope as is (e.g. "profile openid mail").
        // We leave it up to developer to parse and compare to
        // the requested scope. Also note that the scope
        // may not be returned in the authorization response
        // if it is identical to the scope requested by
        // the client.
        return typeof authorization.scope === 'undefined' ?
            this.config.scope :
            authorization.scope;
    };
    /**
     * Determines whether the given scope has been granted.
     *
     *    sgwtConnect.hasGrantedScope('profile openid');
     */
    SGWTConnectCore.prototype.hasGrantedScope = function (checkedScope) {
        var grantedScope = this.getGrantedScope();
        if (typeof grantedScope !== 'string') {
            return false;
        }
        return isScopeListed_1.isScopeListed(checkedScope, grantedScope);
    };
    /**
     * Obtains the user's ID Token in the form of JWT (JSON Web Token).
     *
     * Use this method to pass user identity to your backend.
     *
     * Calling this method is only useful if the "scope" parameter
     * used to make the authorization request included the "openid"
     * value.
     *
     * See http://openid.net/specs/openid-connect-core-1_0.html#IDToken
     * See https://tools.ietf.org/html/rfc7519
     */
    SGWTConnectCore.prototype.getIdToken = function () {
        // Make sure that the authorization request was successful:
        if (!this.isAuthorized()) {
            return null;
        }
        // Obtain the authorization server response:
        var authorization = this.storage.getItem('AUTH');
        // It is possible that the response_type parameter did not
        // include the "id_token" value while performing an authorization
        // request, so there's no id_token in the current token:
        if (!authorization.id_token) {
            return null;
        }
        // Return the id_token as is so that it can be passed to
        // backend for validation:
        return authorization.id_token;
    };
    /**
     * Obtains basic user information from ID Token claims.
     *
     * Use this method to obtain user id, name, email, etc.
     * without calling the /userinfo endpoint.
     *
     * Calling this method is only useful if the "scope" parameter
     * used to make the authorization request included the "openid"
     * (and optionally "email", "profile", etc.) value.
     *
     * See http://openid.net/specs/openid-connect-core-1_0.html#IDToken
     */
    SGWTConnectCore.prototype.getIdTokenClaims = function () {
        var idToken = this.getIdToken();
        // The ID Token could be missing in the following cases:
        //  1. Authorization not requested
        //  2. Authorization not granted
        //  3. id_token not requested in the authorization request
        //  4. id_token not granted in the authorization response
        if (idToken === null) {
            return null;
        }
        // The id_token conforms to an industry standard (IETF RFC 7519)
        // and contains three parts (header, body, signature) separated
        // by "." (dot) character:
        var idTokenParts = idToken.split('.');
        // The body is the second part (at index 1) containing identity
        // claims about the user:
        var idTokenBody = idTokenParts[1];
        // The id_token body is a base64url encoded JSON structure:
        return JSON.parse(atob(idTokenBody));
    };
    /**
     * Fetches UserInfo Claims from the authorization server.
     *
     * Use this method to obtain user name, email, etc. if
     * you're not requesting id_token or if the id_token
     * does not contain these values.
     *
     * See https://openid.net/specs/openid-connect-core-1_0.html#UserInfo
     */
    SGWTConnectCore.prototype.fetchUserInfo = function (callback) {
        var authorizationHeader = this.getAuthorizationHeader();
        if (authorizationHeader) {
            SGWTConnectOpenIDUserInfo.fetchOpenIDUserInfo(this.config.authorization_endpoint, authorizationHeader, callback);
        }
        else {
            callback(new SGWTConnectError_1.SGWTConnectError(SGWTConnectErrorList.ERR_UNAUTHORIZED));
        }
        return this;
    };
    /**
     * Enables silent periodical renewal of the token.
     *
     * Call this method after checking the result of isAuthorized,
     * because it assumes that the authorization request has been
     * performed successfully.
     */
    SGWTConnectCore.prototype.enablePeriodicalRenewal = function () {
        var _this = this;
        // Make sure that we don't have two renewal timers
        // running at the same time:
        if (this.periodicalRenewalTimer !== null) {
            return this;
        }
        // Whenever renewal succeeds (manual or periodical)
        // we need to restart the timer in order to do reduce
        // the number of requests to the authorization endpoint:
        this.addListener(SGWTConnectEventList.EVENT_AUTH_RENEW_SUCCESS, this.restartRenewalTimer);
        // Start the initial timer. We're using setTimeout to be able
        // to adjust the duration depending on renew success/error:
        this.periodicalRenewalTimer = window.setTimeout(function () {
            _this.renewResiliently();
        }, this.getRenewalTimeout());
        return this;
    };
    /**
     * Disables silent periodical renewal of the token.
     */
    SGWTConnectCore.prototype.disablePeriodicalRenewal = function () {
        // Make sure that the backoff delay is reset so that next time
        // we start the periodical renewal, it is back to default value:
        this.resetRenewalBackoff();
        // Stop restarting periodical renewal on renew success:
        this.removeListener(SGWTConnectEventList.EVENT_AUTH_RENEW_SUCCESS, this.restartRenewalTimer);
        // Clear the current timeout:
        if (typeof this.periodicalRenewalTimer === 'number') {
            window.clearTimeout(this.periodicalRenewalTimer);
            this.periodicalRenewalTimer = null;
        }
        return this;
    };
    //
    // Private
    // --------------------
    /**
     * Discards the local authorization data,
     * cancels all running timers,
     * and emits `EVENT_AUTH_DISCARDED` event.
     */
    SGWTConnectCore.prototype.discardAuthorizationLocally = function () {
        // The authorization is discarded, so it no longer
        // makes sense to do periodical renewal or maintain
        // the expiration timer:
        this.disablePeriodicalRenewal();
        this.clearTokenExpirationTimer();
        if (this.openIDMetadata) {
            // OpenID Session Management is no longer needed:
            this.disableOpenIDSessionManagement();
        }
        // Actually discard the authorization data:
        this.storage.removeItem('AUTH');
        // Notify the interested parties:
        this.emit(SGWTConnectEventList.EVENT_AUTH_DISCARDED);
        return this;
    };
    /**
     * Initiates a silent renewal of the token
     * with additional options that are not available
     * in the public API.
     */
    SGWTConnectCore.prototype.requestAuthorizationWithoutPrompt = function (_a, callback) {
        var _this = this;
        var id_token_hint = _a.id_token_hint;
        // Cross-Site Request Forgery (CSRF) protection:
        var state = SGWTConnectAuthorizationUri.generateCryptoStrongRandomValue();
        // Generate the complete authorization endpoint URL
        // where id_token_hint is used to validate session
        // after receiving a "changed" event from OpenID
        // Session Management frame:
        var authorizationEndpoint = id_token_hint
            ? SGWTConnectAuthorizationUri.generateAuthorizationUri(this.config, state, { prompt: 'none', id_token_hint: id_token_hint })
            : SGWTConnectAuthorizationUri.generateAuthorizationUri(this.config, state, { prompt: 'none' });
        // Because OAuth2 protocol insists on providing access_token
        // in the fragment, we're unable to use XMLHttpRequest as it
        // transparently follows all redirects and the fragment is lost.
        // To solve this issue we use an iframe which gives us access
        // to window.location containing the access_token in its fragment.
        var iframe = document.createElement('iframe');
        // When both of these flags are set to true, then it is safe
        // to remove the iframe from the DOM
        //  1. we must not remove the iframe before it emits the "load"
        //     event because in flight resources may get canceled causing
        //     some browsers to remove them even from the top-level window
        //  2. we must wait for the message from iframe because it may
        //     be emitted after(!) "load" event; removing the iframe from
        //     the DOM will cancel the message in flight
        var isIframeLoaded = false;
        var isMessageReceivedFromIframe = false;
        // Iframe timeout in case it does not message or does not load:
        var iframeTimeoutTimer;
        // The redirect_uri may point to another domain preventing
        // the iframe from accessing the storage to set the token,
        // so it will message the top-level window using cross-origin
        // messaging protocol with window.postMessage. This function
        // securely handles the received message:
        var iframeMessageHandler = function (event) {
            // Make sure that the event comes from the renewal iframe:
            if (event.source !== iframe.contentWindow) {
                return;
            }
            // Make sure that the event comes from redirect_uri page:
            if (!isSameOrigin_1.isSameOrigin(event.origin, _this.config.redirect_uri)) {
                return;
            }
            // Third party scripts use the same API to send messages,
            // so make sure we're dealing with our own event:
            if (!event.data || typeof event.data !== 'object') {
                return;
            }
            if (event.data.type !== 'SGWTConnectFragment') {
                return;
            }
            // All event validity checks have passed; we consider
            // the event as genuine and can flag it as received
            // so that the "load" event handler knows about it:
            isMessageReceivedFromIframe = true;
            // We expect a single message, so the listener is no longer needed:
            window.removeEventListener('message', iframeMessageHandler);
            // We have received a message from the iframe,
            // the timeout no longer makes sense:
            window.clearTimeout(iframeTimeoutTimer);
            // We can remove the iframe if it has already loaded:
            if (isIframeLoaded) {
                document.body.removeChild(iframe);
            }
            // Extract the authorization server response from the message:
            var authorization = SGWTConnectServerResponse.normalizeAuthServerResponse(SGWTConnectServerResponse.parseOAuth2Fragment(event.data.fragment));
            // Cross-Site Request Forgery (CSRF) protection:
            if (authorization.state !== state) {
                var error = new SGWTConnectError_1.SGWTConnectError(SGWTConnectErrorList.ERR_STATE_MISMATCH);
                _this.emit(SGWTConnectEventList.EVENT_AUTH_RENEW_ERROR, error);
                if (callback) {
                    callback(error);
                }
                return;
            }
            // Notify the subscribers about renewal completion:
            var errorCode = authorization.error;
            if (errorCode) {
                // Notify the API consumer about the authorization failure:
                var error = new SGWTConnectError_1.SGWTConnectError(errorCode);
                _this.emit(SGWTConnectEventList.EVENT_AUTH_RENEW_ERROR, error);
                if (callback) {
                    callback(error);
                }
            }
            else {
                // Persist the authorization server response prior to emitting
                // events and calling the completion callback so that the token
                // is available to the completion event handlers:
                _this.storage.setItem('AUTH', authorization);
                // The authorization data has been updated, which means that
                // the expiration time has changed, so we need to restart
                // the expiration timer:
                _this.restartTokenExpirationTimer();
                // Although rare, the authorization state might be initiated
                // by calling renewAuthorization instead of requestAuthorization;
                // in this case we need to enable OpenID Session Management
                // on "renewal" success:
                _this.enableOpenIDSessionManagement();
                // Notify the API consumer about the authorization success:
                _this.emit(SGWTConnectEventList.EVENT_AUTH_RENEW_SUCCESS);
                if (callback) {
                    callback(null);
                }
            }
        };
        // Securely handles the "load" event of the renewal iframe
        // by removing event listeners and the iframe itself;
        // also emits an error event in case no message was
        // received from the iframe before "load" event:
        var iframeLoadHandler = function (event) {
            // Make sure the event is genuine:
            if (!event.isTrusted) {
                return;
            }
            // We consider this event as genuine and can flag it as received
            // so that the iframe message event handler knows about it:
            isIframeLoaded = true;
            // The "load" event can only happen once, so the listener
            // is no longer needed:
            iframe.removeEventListener('load', iframeLoadHandler);
            // We can remove the iframe from the DOM if we have already
            // received the message from it:
            if (isMessageReceivedFromIframe) {
                document.body.removeChild(iframe);
            }
        };
        // Expecting the iframe to send us a message
        // from the redirect_uri page using cross-origin
        // messaging protocol with window.postMessage:
        window.addEventListener('message', iframeMessageHandler);
        // We need to listen to the "load" event because
        // we expect the iframe to load completely
        // before removing it from the DOM, otherwise
        // canceled resource requests may destroy already
        // loaded resources from the top-level window:
        iframe.addEventListener('load', iframeLoadHandler);
        // The iframe may never load or fail to send the message due to
        // changes in network, server failure, or some other error,
        // but we still need to emit+callback, so we use a timeout:
        iframeTimeoutTimer = window.setTimeout(function () {
            window.clearTimeout(iframeTimeoutTimer);
            // Cleanup event listeners:
            iframe.removeEventListener('load', iframeLoadHandler);
            window.removeEventListener('message', iframeMessageHandler);
            // Cleanup the DOM:
            document.body.removeChild(iframe);
            // Notify the API consumer about the renewal failure:
            var error = new SGWTConnectError_1.SGWTConnectError(SGWTConnectErrorList.ERR_RENEW_TIMEOUT);
            _this.emit(SGWTConnectEventList.EVENT_AUTH_RENEW_ERROR, error);
            if (callback) {
                callback(error);
            }
        }, this.periodicalRenewalTimeout);
        // Provide a way for setupSGWTConnect factory to figure out
        // whether the redirect is part of silent renewal or not:
        iframe.setAttribute(exports.SGWTConnectRenewalFrameAttribute, '');
        iframe.style.display = 'none';
        iframe.setAttribute('src', authorizationEndpoint);
        this.appendElementToDocumentWhenLoaded(iframe);
        return this;
    };
    /**
     * Ensures that DOM is loaded and appends the element to document body.
     * @param element Element to append to document body.
     */
    SGWTConnectCore.prototype.appendElementToDocumentWhenLoaded = function (element) {
        if (document.body) {
            document.body.appendChild(element);
        }
        else {
            var appendElementAndRemoveListener_1 = function () {
                window.removeEventListener('DOMContentLoaded', appendElementAndRemoveListener_1);
                document.body.appendChild(element);
            };
            window.addEventListener('DOMContentLoaded', appendElementAndRemoveListener_1);
        }
    };
    /**
     * Determines whether the given scope has been requested.
     *
     *    this.hasRequestedScope('profile openid');
     */
    SGWTConnectCore.prototype.hasRequestedScope = function (checkedScope) {
        return isScopeListed_1.isScopeListed(checkedScope, this.config.scope);
    };
    /**
     * Resets the periodical renewal backoff delay.
     */
    SGWTConnectCore.prototype.resetRenewalBackoff = function () {
        this.periodicalRenewalBackoff = 1000;
        return this;
    };
    /**
     * Increments the periodical renewal backoff delay.
     *
     * Used to reduce authorization server load when periodical
     * renewals fail for some reason.
     */
    SGWTConnectCore.prototype.incrementRenewalBackoff = function () {
        this.periodicalRenewalBackoff *= 2;
        return this;
    };
    /**
     * Clears the token expiration timer.
     */
    SGWTConnectCore.prototype.clearTokenExpirationTimer = function () {
        if (typeof this.tokenExpirationTimer === 'number') {
            window.clearTimeout(this.tokenExpirationTimer);
            this.tokenExpirationTimer = null;
        }
        return this;
    };
    /**
     * Clears the existing token expiration timer and starts a new one.
     */
    SGWTConnectCore.prototype.restartTokenExpirationTimer = function () {
        var _this = this;
        // Ensure that there is only one timer at all times:
        this.clearTokenExpirationTimer();
        // Assuming that the client is currently authorized:
        var authorization = this.storage.getItem('AUTH');
        var timeUntilTokenExpiration = authorization.expires_at - Date.now();
        this.tokenExpirationTimer = window.setTimeout(function () {
            _this.emit(SGWTConnectEventList.EVENT_AUTH_EXPIRED);
        }, timeUntilTokenExpiration);
        return this;
    };
    /**
     * Obtains the timeout (in ms) until token renewal.
     */
    SGWTConnectCore.prototype.getRenewalTimeout = function () {
        var authorization = this.storage.getItem('AUTH');
        // Temporary workaround for the authorization endpoint issue,
        // revert to `- authorization.expires_in / 4` when possible:
        var renewalTime = authorization.expires_at - authorization.expires_in * 0.6;
        var renewalTimePositive = Math.max(renewalTime - Date.now(), 0);
        // The timeout should never be bigger than 2147483647, since setTimeout uses
        // a 32 bits number (cf. https://stackoverflow.com/a/3468650/26457)
        // When the token has an extremely long TTL such as 100 days, this timeout should
        // not exceed this 2147483647 value.
        return Math.min(renewalTimePositive, 2147483647);
    };
    /**
     * Renews the authorization token resiliently.
     *
     * When doing periodical renewal we must be resilient
     * on authorization failures and never abort the timer.
     * Even in case of an error we restart the timer,
     * but with an incrementally increasing interval
     * to avoid network saturation.
     */
    SGWTConnectCore.prototype.renewResiliently = function () {
        var _this = this;
        return this.renewAuthorization(function (error) {
            if (error) {
                _this.periodicalRenewalTimer = window.setTimeout(function () {
                    _this.renewResiliently();
                }, _this.periodicalRenewalBackoff);
                _this.incrementRenewalBackoff();
            }
            else {
                _this.resetRenewalBackoff();
            }
        });
    };
    /**
     * Restarts an existing renewal timer.
     */
    SGWTConnectCore.prototype.restartRenewalTimer = function () {
        var _this = this;
        // Do not attempt to restart a non-existing timer:
        if (this.periodicalRenewalTimer === null) {
            return this;
        }
        // Every time the renewal is restarted we should reset
        // the renewal backoff delay:
        this.resetRenewalBackoff();
        // Cancel the current renewal timeout:
        window.clearTimeout(this.periodicalRenewalTimer);
        // Restart the renewal timer:
        this.periodicalRenewalTimer = window.setTimeout(function () {
            return _this.renewResiliently();
        }, this.getRenewalTimeout());
        return this;
    };
    /**
     * Enables OpenID session management if not previously enabled.
     */
    SGWTConnectCore.prototype.enableOpenIDSessionManagement = function () {
        var _this = this;
        // Make sure that the session management has not already been enabled:
        if (this.openIDCheckSessionIframe && this.openIDCheckSessionIframe.parentNode) {
            return this;
        }
        // Make sure that OpenID has actually been configured:
        if (!this.openIDMetadata || !this.hasRequestedScope('openid')) {
            return this;
        }
        // Enabling session management only makes sense
        // if the authorization has already been granted:
        if (!this.isAuthorized()) {
            return this;
        }
        // To check OpenID session we will be polling an iframe
        // loaded from check_session_iframe as recommended by
        // https://openid.net/specs/openid-connect-session-1_0.html#ChangeNotification
        this.openIDCheckSessionIframe = document.createElement('iframe');
        this.openIDCheckSessionIframe.style.display = 'none';
        this.openIDCheckSessionIframe.setAttribute(exports.SGWTConnectCheckSesssionFrameAttribute, '');
        // Expecting the iframe to send us a message using
        // messaging protocol with window.postMessage:
        window.addEventListener('message', this.handleOpenIDCheckSessionMessage.bind(this));
        // Securely handles the "load" event of the OpenID check_session_iframe:
        var checkSessionIframeLoadHandler = function (event) {
            // Make sure the event is genuine:
            if (!event.isTrusted) {
                return;
            }
            // Make sure that the iframe still exists:
            if (!_this.openIDCheckSessionIframe) {
                return;
            }
            // The "load" event can only happen once,
            // so the listener is no longer needed:
            _this.openIDCheckSessionIframe.removeEventListener('load', checkSessionIframeLoadHandler);
            // Start polling:
            _this.restartOpenIDSessionValidationTimer();
        };
        this.openIDCheckSessionIframe.addEventListener('load', checkSessionIframeLoadHandler);
        this.openIDCheckSessionIframe.setAttribute('src', this.openIDMetadata.check_session_iframe);
        this.appendElementToDocumentWhenLoaded(this.openIDCheckSessionIframe);
        return this;
    };
    /**
     * Disables OpenID session management.
     */
    SGWTConnectCore.prototype.disableOpenIDSessionManagement = function () {
        // Stop listening to messages:
        window.removeEventListener('message', this.handleOpenIDCheckSessionMessage);
        // Stop polling the check_session_iframe:
        if (typeof this.openIDCheckSessionTimerId === 'number') {
            window.clearTimeout(this.openIDCheckSessionTimerId);
            this.openIDCheckSessionTimerId = undefined;
        }
        // Remove the iframe:
        if (this.openIDCheckSessionIframe) {
            document.body.removeChild(this.openIDCheckSessionIframe);
            this.openIDCheckSessionIframe = undefined;
        }
        return this;
    };
    /**
     * Restarts OpenID session validation timer.
     */
    SGWTConnectCore.prototype.restartOpenIDSessionValidationTimer = function () {
        // There should be only one OpenID session validation timer:
        window.clearTimeout(this.openIDCheckSessionTimerId);
        // Schedule a new timer:
        this.openIDCheckSessionTimerId = window.setTimeout(this.validateOpenIDSession.bind(this), this.openIDCheckSessionTimerInterval);
    };
    /**
     * Validates the existing OpenID session.
     */
    SGWTConnectCore.prototype.validateOpenIDSession = function () {
        var _this = this;
        if (this.isAuthorized()) {
            // The current authorization state retrieved from the storage
            // indicates that the session is valid, however it might be
            // terminated already at the authorization server.
            // To validate the session, we need to send a message
            // to the check_session iframe, but before that we make sure
            // that we have metadata and that the check_session iframe
            // still exists in the DOM.
            if (!this.openIDMetadata) {
                return;
            }
            if (this.openIDCheckSessionIframe && this.openIDCheckSessionIframe.contentWindow) {
                var authorization = this.storage.getItem('AUTH');
                this.openIDCheckSessionIframe.contentWindow.postMessage(this.config.client_id + " " + authorization.session_state, this.openIDMetadata.check_session_iframe);
                this.restartOpenIDSessionValidationTimer();
            }
            else {
                // In case the check_session iframe no longer exists,
                // we try to recreate it be re-enabling session management:
                this.enableOpenIDSessionManagement();
            }
        }
        else {
            // In case the authorization state is lost (storage cleared)
            // we attempt a silent authorization renewal. If the session
            // is still valid on the authorization server, the renewal
            // should succeed and we just restart the timer; otherwise
            // we treat it as loss of authorization and act accordingly.
            this.renewAuthorization(function (error) {
                if (error) {
                    _this.discardAuthorizationLocally();
                }
                else {
                    _this.restartOpenIDSessionValidationTimer();
                }
            });
        }
    };
    /**
     * Securely handles events from check_session_iframe.
     * @param event MessageEvent
     */
    SGWTConnectCore.prototype.handleOpenIDCheckSessionMessage = function (event) {
        var _this = this;
        // Sanity checks:
        if (!this.openIDCheckSessionIframe || !this.openIDMetadata) {
            return;
        }
        // Make sure that the event comes from the check_session_iframe:
        if (event.source !== this.openIDCheckSessionIframe.contentWindow) {
            return;
        }
        if (!isSameOrigin_1.isSameOrigin(event.origin, this.openIDMetadata.check_session_iframe)) {
            return;
        }
        // Expecting event.data to be either "unchanged", "changed", or "error".
        // See https://openid.net/specs/openid-connect-session-1_0.html#RPiframe
        if (event.data === 'unchanged') {
            // Session has not changed, so we only notify
            // (mostly for logging and testing purposes):
            this.emit(SGWTConnectEventList.EVENT_OPENID_SESSION_UNCHANGED);
        }
        else if (event.data === 'changed') {
            this.emit(SGWTConnectEventList.EVENT_OPENID_SESSION_CHANGED);
            // Perform re-authentication with prompt=none
            // sending the old id_token as id_token_hint:
            var prevIdToken = this.getIdToken();
            var prevIdTokenClaims_1 = this.getIdTokenClaims();
            this.requestAuthorizationWithoutPrompt({ id_token_hint: prevIdToken }, function (error) {
                if (!error) {
                    // If we receive a new ID Token for the same user
                    // then we simply update the values
                    var nextIdTokenClaims = _this.getIdTokenClaims();
                    if (nextIdTokenClaims && prevIdTokenClaims_1 && nextIdTokenClaims.sub === prevIdTokenClaims_1.sub) {
                        return;
                    }
                }
                // In other cases, such as error response,
                // or absence of ID Token, or it was delivered
                // for another user, we discard authorization:
                _this.discardAuthorizationLocally();
            });
        }
        else if (event.data === 'error') {
            // In case of communication error with check_session_iframe
            // we notify the user and wait for fallback to periodical
            // renewal to check the session validity:
            this.emit(SGWTConnectEventList.EVENT_OPENID_CHECK_SESSION_ERROR, new SGWTConnectError_1.SGWTConnectError(SGWTConnectErrorList.ERR_OPENID_CHECK_SESSION_ERROR));
        }
    };
    return SGWTConnectCore;
}(events.EventEmitter));
exports.SGWTConnectCore = SGWTConnectCore;

});

/* tslint:disable no-bitwise */

/**
 * Generates a lossy hash of an object.
 *
 * Typed implementation of MD5 in JavaScript by Joseph's Myers.
 * This function is not intended to be crypto-secure.
 * @see http://www.myersdaily.org/joseph/javascript/md5-text.html
 */
function hash(obj) {
    return hex(md51(
    // Keys are sorted to ensure that ordering of keys
    // does not affect the hashing result:
    Object.keys(obj).sort()
        .reduce(function (acc, key) { return acc + key + ':' + obj[key] + '|'; }, '|')));
}
var hash_1 = hash;
var hexChr = '0123456789abcdef'.split('');
function rhex(n) {
    var s = '';
    for (var i = 0; i < 4; i += 1) {
        s += hexChr[(n >> (i * 8 + 4)) & 0x0F]
            + hexChr[(n >> (i * 8)) & 0x0F];
    }
    return s;
}
function hex(x) {
    var h = '';
    for (var _i = 0, x_1 = x; _i < x_1.length; _i++) {
        var n = x_1[_i];
        h += rhex(n);
    }
    return h;
}
function md5cycle(x, k) {
    var a = x[0];
    var b = x[1];
    var c = x[2];
    var d = x[3];
    a = ff(a, b, c, d, k[0], 7, -680876936);
    d = ff(d, a, b, c, k[1], 12, -389564586);
    c = ff(c, d, a, b, k[2], 17, 606105819);
    b = ff(b, c, d, a, k[3], 22, -1044525330);
    a = ff(a, b, c, d, k[4], 7, -176418897);
    d = ff(d, a, b, c, k[5], 12, 1200080426);
    c = ff(c, d, a, b, k[6], 17, -1473231341);
    b = ff(b, c, d, a, k[7], 22, -45705983);
    a = ff(a, b, c, d, k[8], 7, 1770035416);
    d = ff(d, a, b, c, k[9], 12, -1958414417);
    c = ff(c, d, a, b, k[10], 17, -42063);
    b = ff(b, c, d, a, k[11], 22, -1990404162);
    a = ff(a, b, c, d, k[12], 7, 1804603682);
    d = ff(d, a, b, c, k[13], 12, -40341101);
    c = ff(c, d, a, b, k[14], 17, -1502002290);
    b = ff(b, c, d, a, k[15], 22, 1236535329);
    a = gg(a, b, c, d, k[1], 5, -165796510);
    d = gg(d, a, b, c, k[6], 9, -1069501632);
    c = gg(c, d, a, b, k[11], 14, 643717713);
    b = gg(b, c, d, a, k[0], 20, -373897302);
    a = gg(a, b, c, d, k[5], 5, -701558691);
    d = gg(d, a, b, c, k[10], 9, 38016083);
    c = gg(c, d, a, b, k[15], 14, -660478335);
    b = gg(b, c, d, a, k[4], 20, -405537848);
    a = gg(a, b, c, d, k[9], 5, 568446438);
    d = gg(d, a, b, c, k[14], 9, -1019803690);
    c = gg(c, d, a, b, k[3], 14, -187363961);
    b = gg(b, c, d, a, k[8], 20, 1163531501);
    a = gg(a, b, c, d, k[13], 5, -1444681467);
    d = gg(d, a, b, c, k[2], 9, -51403784);
    c = gg(c, d, a, b, k[7], 14, 1735328473);
    b = gg(b, c, d, a, k[12], 20, -1926607734);
    a = hh(a, b, c, d, k[5], 4, -378558);
    d = hh(d, a, b, c, k[8], 11, -2022574463);
    c = hh(c, d, a, b, k[11], 16, 1839030562);
    b = hh(b, c, d, a, k[14], 23, -35309556);
    a = hh(a, b, c, d, k[1], 4, -1530992060);
    d = hh(d, a, b, c, k[4], 11, 1272893353);
    c = hh(c, d, a, b, k[7], 16, -155497632);
    b = hh(b, c, d, a, k[10], 23, -1094730640);
    a = hh(a, b, c, d, k[13], 4, 681279174);
    d = hh(d, a, b, c, k[0], 11, -358537222);
    c = hh(c, d, a, b, k[3], 16, -722521979);
    b = hh(b, c, d, a, k[6], 23, 76029189);
    a = hh(a, b, c, d, k[9], 4, -640364487);
    d = hh(d, a, b, c, k[12], 11, -421815835);
    c = hh(c, d, a, b, k[15], 16, 530742520);
    b = hh(b, c, d, a, k[2], 23, -995338651);
    a = ii(a, b, c, d, k[0], 6, -198630844);
    d = ii(d, a, b, c, k[7], 10, 1126891415);
    c = ii(c, d, a, b, k[14], 15, -1416354905);
    b = ii(b, c, d, a, k[5], 21, -57434055);
    a = ii(a, b, c, d, k[12], 6, 1700485571);
    d = ii(d, a, b, c, k[3], 10, -1894986606);
    c = ii(c, d, a, b, k[10], 15, -1051523);
    b = ii(b, c, d, a, k[1], 21, -2054922799);
    a = ii(a, b, c, d, k[8], 6, 1873313359);
    d = ii(d, a, b, c, k[15], 10, -30611744);
    c = ii(c, d, a, b, k[6], 15, -1560198380);
    b = ii(b, c, d, a, k[13], 21, 1309151649);
    a = ii(a, b, c, d, k[4], 6, -145523070);
    d = ii(d, a, b, c, k[11], 10, -1120210379);
    c = ii(c, d, a, b, k[2], 15, 718787259);
    b = ii(b, c, d, a, k[9], 21, -343485551);
    x[0] = add32(a, x[0]);
    x[1] = add32(b, x[1]);
    x[2] = add32(c, x[2]);
    x[3] = add32(d, x[3]);
}
function cmn(q, a, b, x, s, t) {
    a = add32(add32(a, q), add32(x, t));
    return add32((a << s) | (a >>> (32 - s)), b);
}
function add32(a, b) {
    return (a + b) & 0xFFFFFFFF;
}
function ff(a, b, c, d, x, s, t) {
    return cmn((b & c) | ((~b) & d), a, b, x, s, t);
}
function gg(a, b, c, d, x, s, t) {
    return cmn((b & d) | (c & (~d)), a, b, x, s, t);
}
function hh(a, b, c, d, x, s, t) {
    return cmn(b ^ c ^ d, a, b, x, s, t);
}
function ii(a, b, c, d, x, s, t) {
    return cmn(c ^ (b | (~d)), a, b, x, s, t);
}
function md51(s) {
    var n = s.length;
    var state = [1732584193, -271733879, -1732584194, 271733878];
    var tail = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
    var i;
    for (i = 64; i <= s.length; i += 64) {
        md5cycle(state, md5blk(s.substring(i - 64, i)));
    }
    s = s.substring(i - 64);
    for (i = 0; i < s.length; i += 1) {
        tail[i >> 2] |= s.charCodeAt(i) << ((i % 4) << 3);
    }
    tail[i >> 2] |= 0x80 << ((i % 4) << 3);
    if (i > 55) {
        md5cycle(state, tail);
        for (i = 0; i < 16; i += 1) {
            tail[i] = 0;
        }
    }
    tail[14] = n * 8;
    md5cycle(state, tail);
    return state;
}
function md5blk(s) {
    var md5blks = [];
    for (var i = 0; i < 64; i += 4) {
        md5blks[i >> 2] = s.charCodeAt(i)
            + (s.charCodeAt(i + 1) << 8)
            + (s.charCodeAt(i + 2) << 16)
            + (s.charCodeAt(i + 3) << 24);
    }
    return md5blks;
}


var SGWTConnectHash = /*#__PURE__*/Object.defineProperty({
	hash: hash_1
}, '__esModule', {value: true});

var __extends = (commonjsGlobal && commonjsGlobal.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();


/**
 * Alternative implementation of SGWTConnectCore.
 *
 * This class should only be instantiated and used
 * when the user is on redirect_uri or in an iframe.
 * See explanation in setupSGWTConnect.ts
 */
var SGWTConnectNoop = /** @class */ (function (_super) {
    __extends(SGWTConnectNoop, _super);
    function SGWTConnectNoop() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Noop.
     */
    SGWTConnectNoop.prototype.requestAuthorization = function () {
        return this;
    };
    /**
     * Noop.
     */
    SGWTConnectNoop.prototype.discardAuthorization = function () {
        return this;
    };
    /**
     * Noop.
     */
    SGWTConnectNoop.prototype.renewAuthorization = function () {
        return this;
    };
    /**
     * Noop.
     */
    SGWTConnectNoop.prototype.isAuthorized = function () {
        return false;
    };
    /**
     * Noop.
     */
    SGWTConnectNoop.prototype.getAuthorizationError = function () {
        return null;
    };
    /**
     * Noop.
     */
    SGWTConnectNoop.prototype.getAuthorizationHeader = function () {
        return null;
    };
    /**
     * Noop.
     */
    SGWTConnectNoop.prototype.getGrantedScope = function () {
        return null;
    };
    /**
     * Noop.
     */
    SGWTConnectNoop.prototype.hasGrantedScope = function () {
        return false;
    };
    /**
     * Noop.
     */
    SGWTConnectNoop.prototype.getIdToken = function () {
        return null;
    };
    /**
     * Noop.
     */
    SGWTConnectNoop.prototype.getIdTokenClaims = function () {
        return null;
    };
    /**
     * Noop.
     */
    SGWTConnectNoop.prototype.enablePeriodicalRenewal = function () {
        return this;
    };
    /**
     * Noop.
     */
    SGWTConnectNoop.prototype.disablePeriodicalRenewal = function () {
        return this;
    };
    return SGWTConnectNoop;
}(SGWTConnectCore_1.SGWTConnectCore));
var SGWTConnectNoop_2 = SGWTConnectNoop;


var SGWTConnectNoop_1 = /*#__PURE__*/Object.defineProperty({
	SGWTConnectNoop: SGWTConnectNoop_2
}, '__esModule', {value: true});

/**
 * Generates a function that upon invocation asynchronously
 * fetches OpenID Metadata from the OpenID Provider.
 * @param authorization_endpoint OpenID Provider's endpoint URL.
 */
function createOpenIDMetadataFetcher(authorization_endpoint) {
    return function fetchOpenIDMetadata(callback) {
        var xhr = new XMLHttpRequest();
        xhr.open('GET', authorization_endpoint + "/oauth2/.well-known/openid-configuration");
        xhr.setRequestHeader('Accept', 'application/json');
        xhr.addEventListener('load', function onOpenIDMetadataLoad() {
            if (xhr.status === 200) {
                var openIDMetadata = void 0;
                try {
                    openIDMetadata = JSON.parse(xhr.responseText);
                }
                catch (_a) {
                    callback(new SGWTConnectError_1.SGWTConnectError(SGWTConnectErrorList.ERR_FAILED_TO_PARSE_OPENID_METADATA));
                    return;
                }
                if (isValidOpenIDMetadata(openIDMetadata)) {
                    callback(openIDMetadata);
                }
                else {
                    callback(new SGWTConnectError_1.SGWTConnectError(SGWTConnectErrorList.ERR_FAILED_TO_VALIDATE_OPENID_METADATA));
                }
            }
            else {
                callback(new SGWTConnectError_1.SGWTConnectError(SGWTConnectErrorList.ERR_FAILED_TO_FETCH_OPENID_METADATA));
            }
        });
        xhr.send();
    };
}
var createOpenIDMetadataFetcher_1 = createOpenIDMetadataFetcher;
/**
 * Determines whether the given OpenID Configuration is valid.
 * @param openIDMetadata JSON-parsed value obtained from the Discovery API.
 */
function isValidOpenIDMetadata(openIDMetadata) {
    return isObject_1.isObject(openIDMetadata) &&
        typeof openIDMetadata.check_session_iframe === 'string' &&
        typeof openIDMetadata.end_session_endpoint === 'string';
}


var SGWTConnectOpenIDMetadata = /*#__PURE__*/Object.defineProperty({
	createOpenIDMetadataFetcher: createOpenIDMetadataFetcher_1
}, '__esModule', {value: true});

/**
 * SGWTConnect instance factory.
 *
 * Determines the execution environment (top-level window or iframe),
 * instantiates the relevant SGWTConnect class with the given configuration,
 * and handles authorization redirects in the top-level window.
 */
function setupSGWTConnect(userConfig) {
    var config = SGWTConnectConfiguration.normalizeConfiguration(userConfig, location);
    // Ensure that the stored token and other data have been obtained
    // using the current configuration options (note that we're not
    // using JSON.stringify here because it will generate different
    // results for identical configurations with different ordering
    // of keys in them):
    var storage = new SGWTConnectStorage_1.SGWTConnectStorage(SGWTConnectHash.hash(config));
    // Check if we're currently on the redirect_uri page:
    if (SGWTConnectRedirectUri.isOnRedirectUri(config, location)) {
        // Check if we are currently in a silent renewal iframe:
        if (window.frameElement && window.frameElement.hasAttribute(SGWTConnectCore_1.SGWTConnectRenewalFrameAttribute)) {
            // We only message the top-level window if the iframe's URI
            // matches the redirect URI exactly (without the fragment):
            window.parent.postMessage({
                type: 'SGWTConnectFragment',
                fragment: location.hash
            }, config.redirect_uri);
            // Because we are currently on the redirect_uri page, we must not
            // return the fully-functional API as this may result in undesired
            // behavior and infinite reload, but we still need to return a
            // compliant API to prevent JS runtime errors on the page, so we
            // return a dummy API where most methods are noop:
            return new SGWTConnectNoop_1.SGWTConnectNoop(config, storage);
        }
        // We are currently doing a hard redirect.
        // Extract the authorization server response from the current URL fragment:
        var authorization = SGWTConnectServerResponse.normalizeAuthServerResponse(SGWTConnectServerResponse.parseOAuth2Fragment(window.location.hash));
        var stateInResponse = authorization.state;
        // Cross-Site Request Forgery (CSRF) protection:
        var stateInStore = storage.getItem(stateInResponse + ".STATE");
        if (stateInResponse === stateInStore) {
            // Persist the authorization server response prior to emitting
            // events and calling the completion callback so that the token
            // is available to the completion event handlers (note that
            // the server response might be a failed one):
            storage.setItem('AUTH', authorization);
        }
        else if (stateInStore) {
            // The "state" parameter failed to match; it may be dangerous
            // to keep the received server response, so we replace it
            // with a custom "state_mismatch" error response:
            var authError = {
                error: SGWTConnectErrorList.ERR_STATE_MISMATCH
            };
            storage.setItem('AUTH', authError);
        }
        // We are currently on the "redirect_uri", but the user most
        // probably initiated the authorization process from another
        // URI, so we need to redirect them back there (or to home
        // page if RETURN_URL has been cleared):
        var returnUrl = storage.getItem(stateInResponse + ".RETURN_URL") ||
            window.location.protocol + "//" + window.location.host;
        // location.replace doesn't reload the page if only the fragment
        // has changed, so we need the following workaround to force
        // the page reload, but also to set the fragment of the returnUrl:
        if (returnUrl.indexOf('#') !== -1 && location.href.split('#')[0] === returnUrl.split('#')[0]) {
            window.location.hash = returnUrl.split('#')[1];
            window.location.reload(true);
        }
        else {
            window.location.replace(returnUrl);
        }
        // Because we are currently on the redirect_uri page, we must not
        // return the fully-functional API as this may result in undesired
        // behavior and infinite reload, but we still need to return a
        // compliant API to prevent JS runtime errors on the page, so we
        // return a dummy API where most methods are noop:
        return new SGWTConnectNoop_1.SGWTConnectNoop(config, storage);
    }
    // We are NOT on the redirect_uri page, do we have authorization?:
    var auth = storage.getItem('AUTH');
    // Clean up the storage of values needed during redirects:
    if (auth) {
        storage.removeItem(auth.state + ".STATE");
        storage.removeItem(auth.state + ".RETURN_URL");
    }
    // Clean up the storage of the expired tokens:
    storage.clearBy(function (value, key) {
        return key.indexOf('AUTH') !== -1 && value.expires_at < Date.now();
    });
    // At this point we know that this code is running in the top-level window,
    // (not in iframe) so we can instantiate a fully-functional API:
    var sgwtConnect = isScopeListed_1.isScopeListed('openid', config.scope)
        ? new SGWTConnectCore_1.SGWTConnectCore(config, storage, SGWTConnectOpenIDMetadata.createOpenIDMetadataFetcher(config.authorization_endpoint))
        : new SGWTConnectCore_1.SGWTConnectCore(config, storage);
    // Checking if the authorization has been explicitly granted:
    if (sgwtConnect.isAuthorized()) {
        // The user-friendly behavior is to have periodical renewal enabled by default:
        return sgwtConnect.enablePeriodicalRenewal();
    }
    // Checking if the authorization has been explicitly denied:
    if (auth && auth.error) {
        if (auth.markedForDeletion) {
            storage.removeItem('AUTH');
        }
        else {
            auth.markedForDeletion = true;
            storage.setItem('AUTH', auth);
        }
    }
    return sgwtConnect;
}
var setupSGWTConnect_2 = setupSGWTConnect;


var setupSGWTConnect_1 = /*#__PURE__*/Object.defineProperty({
	setupSGWTConnect: setupSGWTConnect_2
}, '__esModule', {value: true});

var dist$1 = createCommonjsModule(function (module, exports) {
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @module SGWTConnectCore
 * @description
 * Entry point for all public APIs and interfaces of the @sgwt/connect-core package.
 */
__export(SGWTConnectErrorList);
__export(SGWTConnectError_1);
__export(SGWTConnectEventList);
__export(SGWTConnectConfiguration);
__export(SGWTConnectStorage_1);
__export(SGWTConnectCore_1);
__export(setupSGWTConnect_1);

});

var utils = createCommonjsModule(function (module, exports) {
var __awaiter = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (commonjsGlobal && commonjsGlobal.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
// Topics on SG Widgets bus
exports.BUS_ACCESS_TOKEN = 'sg-connect.access-token';
exports.BUS_ACCESS_TOKEN_EXPIRATION = 'sg-connect.access-token.expiration';
exports.BUS_USER_CONNECTION = 'sg-connect.user-connection';
exports.BUS_USER_INFO = 'sg-connect.user-info';
exports.BUS_GRANTED_SCOPE = 'sg-connect.granted-scope';
/**
 * Log a message if the debug attribute is set...
 */
exports.logMessage = function (msg) {
    if (window.SGWT_CONNECT_DELEGATION_LOG) {
        console.log("[SgwtConnect | SG Dashboard] [" + new Date().toISOString() + "] " + msg); // tslint:disable-line
    }
};
/**
 * Check if an object is null, undefined or empty.
 */
exports.isEmpty = function (obj) { return !obj || Object.keys(obj).length === 0; };
/**
 * Get the Widget bus.
 */
var getBus = function () { return window.SGWTWidgetConfiguration.bus; };
/**
 * Get the value for a given topic from the Widgets bus.
 */
exports.getBusValue = function (topic) { return getBus().dangerouslyGetCurrentValue(topic); };
/**
 * Publis a value for a given topic in the Widgets bus, if the value is different from the one already present.
 */
exports.publishOnBus = function (topic, value) {
    var current = exports.getBusValue(topic);
    // Publish only a new value...
    if (value !== current) {
        getBus().publish(topic, value);
    }
};
/**
 * Wait until a condition is true. Check every `interval` ms, with a maximum timeout of `timeout` ms.
 * Once the condition is true, the Promise is resolved to `true`.
 * If the timeout is reached, the Promise is resolved to `false`.
 */
function waitUntil(condition, interval, timeout) {
    return __awaiter(this, void 0, void 0, function () {
        var remaining;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    remaining = timeout;
                    return [4 /*yield*/, new Promise(function (resolve) {
                            var intervalId = setInterval(function () {
                                if (condition()) {
                                    resolve(true);
                                    clearInterval(intervalId);
                                }
                                remaining -= interval;
                                if (remaining <= 0) {
                                    resolve(false);
                                    clearInterval(intervalId);
                                }
                            }, interval);
                        })];
                case 1: return [2 /*return*/, _a.sent()];
            }
        });
    });
}
exports.waitUntil = waitUntil;

});

var __assign = (commonjsGlobal && commonjsGlobal.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (commonjsGlobal && commonjsGlobal.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var _this = commonjsGlobal;



/**
 * Get a new token from the current one by calling a Delegation endpoint.
 */
var getDelegationToken = function (delegationEndpoint, token) { return __awaiter(_this, void 0, void 0, function () {
    return __generator(this, function (_a) {
        utils.logMessage("get delegation token from token " + token + ".");
        if (token === null) {
            throw new Error('Cannot get a delegation token without a valid access token.');
        }
        return [2 /*return*/, fetch(delegationEndpoint, {
                method: 'POST',
                mode: 'cors',
                headers: {
                    Authorization: token
                }
            })
                .then(function (response) { return response.json(); })
                .then(function (response) {
                utils.logMessage("New delegation token retrieved \"" + response.access_token + "\"");
                if (response.access_token === undefined || response.access_token === null) {
                    throw new Error('ERROR, access_token is null or undefined');
                }
                utils.publishOnBus(utils.BUS_ACCESS_TOKEN, "Bearer " + response.access_token);
                utils.publishOnBus(utils.BUS_GRANTED_SCOPE, response.scope);
                var expiration = Date.now() + (response.expires_in * 1000);
                utils.publishOnBus(utils.BUS_ACCESS_TOKEN_EXPIRATION, expiration);
                return true;
            })
                .catch(function (e) {
                console.error('Cannot retrieve a delegation token', e);
                throw e;
            })];
    });
}); };
/**
 * Check if we have, in the bus, a valid delegation token...
 */
var hasValidDelegationToken = function () {
    var token = utils.getBusValue(utils.BUS_ACCESS_TOKEN);
    if (!token) {
        return false;
    }
    // We have a token in the bus, we check its expiration date...
    var expiration = utils.getBusValue(utils.BUS_ACCESS_TOKEN_EXPIRATION);
    return expiration && Date.now() < parseInt(expiration, 10);
};
/**
 * Setup the sgwtConnect library with delegation of token feature.
 */
function setupSGWTConnectWithDelegation$1(userConfig) {
    var _this = this;
    var requestInProgress = false;
    var delegationError = null;
    window.SGWT_CONNECT_DELEGATION_LOG = typeof userConfig.debug !== 'undefined' && userConfig.debug;
    // First of all, we setup the sgwtConnect library.
    utils.logMessage('Setup SGWT Connect Delegation library');
    var sgwtConnect = dist$1.setupSGWTConnect(userConfig);
    // Then, we put it in the `window` object (required by some widget for example).
    window.sgwtConnect = __assign({}, sgwtConnect, { 
        // We mock the `getAuthorizationHeader()` function in case a widget tries to access it directly...
        getAuthorizationHeader: function () { return utils.getBusValue(utils.BUS_ACCESS_TOKEN); }, 
        // We also mock the old getJWTClaims function...
        getJWTClaims: function () { return sgwtConnect.getIdTokenClaims(); } });
    // We check if the user is authorized, and publish information regarding the user...
    if (!sgwtConnect.isAuthorized()) {
        sgwtConnect.isAuthorizedAsync = function () { return __awaiter(_this, void 0, void 0, function () { return __generator(this, function (_a) {
            return [2 /*return*/, false];
        }); }); };
        sgwtConnect.getAuthorizationDelegationError = function () { return sgwtConnect.getAuthorizationError(); };
        return sgwtConnect;
    }
    // Check if we have a valid delegation token in the bus to avoid making a new call to the delegation endpoint.
    if (!hasValidDelegationToken()) {
        // No token, or an expired one...
        utils.logMessage('no valid delegation token found, calling the delegation endpoint...');
        requestInProgress = true;
        delegationError = null;
        getDelegationToken(userConfig.delegation_endpoint, sgwtConnect.getAuthorizationHeader())
            .then(function () { requestInProgress = false; })
            .catch(function (e) {
            delegationError = e;
        });
    }
    // Publish user connection information...
    utils.publishOnBus(utils.BUS_USER_CONNECTION, {
        connected: true,
        claims: sgwtConnect.getIdTokenClaims()
    });
    // Fetch /userInfo
    var userInfo = utils.getBusValue(utils.BUS_USER_INFO);
    if (utils.isEmpty(userInfo)) {
        sgwtConnect.fetchUserInfo(function (err, claims) {
            if (!err && claims) {
                utils.publishOnBus(utils.BUS_USER_INFO, claims);
            }
        });
    }
    // Make sure the token renewal process is started!
    utils.logMessage('enable periodical token renewal.');
    sgwtConnect.enablePeriodicalRenewal();
    // The authorization has been discarded, we clear the bus.
    sgwtConnect.on(dist$1.EVENT_AUTH_DISCARDED, function () {
        utils.logMessage('Authorization has been discarded, cleaning the Widget bus...');
        utils.publishOnBus(utils.BUS_ACCESS_TOKEN, undefined);
        utils.publishOnBus(utils.BUS_ACCESS_TOKEN_EXPIRATION, undefined);
        utils.publishOnBus(utils.BUS_USER_CONNECTION, undefined);
        utils.publishOnBus(utils.BUS_USER_INFO, undefined);
        utils.publishOnBus(utils.BUS_GRANTED_SCOPE, undefined);
    });
    sgwtConnect.on(dist$1.EVENT_AUTH_RENEW_SUCCESS, function () {
        utils.logMessage('Token has been renewed, calling the delegation endpoint...');
        requestInProgress = true;
        delegationError = null;
        getDelegationToken(userConfig.delegation_endpoint, sgwtConnect.getAuthorizationHeader())
            .then(function () { requestInProgress = false; })
            .catch(function (e) {
            delegationError = e;
        });
    });
    sgwtConnect.isAuthorizedAsync = function () { return __awaiter(_this, void 0, void 0, function () {
        var requestFinished, hasToken;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!sgwtConnect.isAuthorized()) {
                        // Case 1: the user is not authorized => KO
                        return [2 /*return*/, false];
                    }
                    if (hasValidDelegationToken()) {
                        // Case 2: we have a valid delegation token => OK
                        return [2 /*return*/, true];
                    }
                    if (!requestInProgress) return [3 /*break*/, 2];
                    // Case 3.a: a request is in progress, so we wait for it to finish (or reach a 30s timeout)...
                    utils.logMessage('We do not have a valid delegation token, but a request is in progress...');
                    return [4 /*yield*/, utils.waitUntil(function () { return !requestInProgress; }, 100, 30000)];
                case 1:
                    requestFinished = _a.sent();
                    hasToken = hasValidDelegationToken();
                    utils.logMessage("The request " + (requestFinished ? 'has finished' : 'reached a 30s timeout') + ". Do we have a delegation token? " + hasToken);
                    return [2 /*return*/, hasToken];
                case 2:
                    // Case 3.b: a request is not in progress, so we launch one!
                    utils.logMessage('We do not have a valid delegation token, no request is currently in progress...');
                    delegationError = null;
                    requestInProgress = true;
                    return [2 /*return*/, getDelegationToken(userConfig.delegation_endpoint, sgwtConnect.getAuthorizationHeader())
                            .then(function () {
                            requestInProgress = false;
                            return hasValidDelegationToken();
                        })
                            .catch(function (e) {
                            delegationError = e;
                            requestInProgress = false;
                            return false;
                        })];
            }
        });
    }); };
    sgwtConnect.getAuthorizationDelegationError = function () {
        if (sgwtConnect.getAuthorizationError()) {
            return sgwtConnect.getAuthorizationError();
        }
        return delegationError;
    };
    return sgwtConnect;
}
var setupSGWTConnectWithDelegation_2 = setupSGWTConnectWithDelegation$1;


var setupSGWTConnectWithDelegation_1 = /*#__PURE__*/Object.defineProperty({
	setupSGWTConnectWithDelegation: setupSGWTConnectWithDelegation_2
}, '__esModule', {value: true});

var dist = createCommonjsModule(function (module, exports) {
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @module SGWTConnectCoreDelegation
 * @description
 * Entry point for the SGWT Connect core with Delegation feature.
 */
__export(setupSGWTConnectWithDelegation_1);
__export(utils);

});

// process.env.REACT_APP_API_URL is not defined during the unittests
const apiUrl = 'undefined';

const testEnv = {
  environment: 'development',
  sgConnectRedirectUri: '/',
  helpCenterAppId: 'sg-dashboard',
  sgConnectEndpoint: 'https://sso.sgmarkets.com/sgconnect/oauth2',
  sgConnectClientId: '90c9c778-9220-4958-8a9e-60f53cd9b829',
  apiUrl: apiUrl,
  piwikBaseUrl: 'https://sg-analytics-uat.fr.world.socgen/piwik',
  // @ts-ignore
  piwikSiteId: 0,
  splashScreenAppId: 'sg-dashboard-dev-v2',
  cdnUrl: 'https://shared.sgmarkets.com/arclab-sg-dashboard/dev',
  dateTimePickerBaseUrl: 'https://shared.sgmarkets.com/widgets/sgwt-datetime-picker',
  tokenOnDemand: 'no',
  disableProjectCreationFeature: 'no',
  importDesignStudioDataset: 'yes',
  importDesignStudioWidget: 'yes'
};

function getEnvVariables() {
  return window._environment || testEnv;
}
function isTokenOnDemandMode() {
  const {
    tokenOnDemand
  } = getEnvVariables();
  return tokenOnDemand === 'yes';
}

const Log$5 = Logger; // needed for jest
function fromSgwtLogLevel(level) {
  switch (level) {
    case 'debug':
      return Level.Debug;
    case 'error':
      return Level.Error;
    case 'info':
      return Level.Info;
    case 'warn':
      return Level.Warning;
    default:
      return Level.Warning;
  }
}
const {
  sgConnectEndpoint,
  sgConnectClientId
} = getEnvVariables();
const setupSGWTConnectWithDelegation = isTokenOnDemandMode() ? dist$2.setupSGWTConnectWithDelegation : dist.setupSGWTConnectWithDelegation;
const sgwtConnect = setupSGWTConnectWithDelegation({
  /* eslint-disable @typescript-eslint/no-non-null-assertion */
  authorization_endpoint: sgConnectEndpoint ? sgConnectEndpoint + "/authorize" : '',
  client_id: sgConnectClientId ? sgConnectClientId : '',
  acr_values: 'L3',
  scope: 'profile openid mail api.sg-dashboard-api.v1 api.manage-contacts.v1 api.sgbot-directline.v3 api.dx-services.v1 api.analytics-reporting.v1',
  delegation_endpoint: "" + getEnvVariables().apiUrl + (isTokenOnDemandMode() ? '/api/v2/delegate-on-demand' : '/api/v2/delegate'),
  debug: true // to have additional logs
});
// SGWT widgets need this exposed on 'window' (needed for instance for 'sgwt-datetime-picker'):
// eslint-disable-next-line @typescript-eslint/no-explicit-any
window.sgwtConnect = sgwtConnect;
sgwtConnect.once('authorizationDiscarded', () => {
  (function () {
    if (Log$5.categories[Category.Common] >= Level.Debug) {
      const formattedMessage = Log$5.formatMessage(Category.Common, Level.Debug, 'Token is no longer available on the client side.');
      console.log(formattedMessage);
      return Log$5.log(formattedMessage);
    }
  })();
  sgwtConnect.requestAuthorization();
});
function getAccessToken() {
  return sgwtConnect.getAuthorizationHeader();
}
sgwtConnect.on('renewAuthorizationSuccess', () => {
  return function () {
    if (Log$5.categories[Category.Common] >= Level.Debug) {
      const formattedMessage = Log$5.formatMessage(Category.Common, Level.Debug, "renewAuthorizationSuccess token[" + getAccessToken() + "]");
      console.log(formattedMessage);
      return Log$5.log(formattedMessage);
    }
  }();
});
if (window.SGWTWidgetConfiguration) {
  window.SGWTWidgetConfiguration.update({
    log: (tagName, logLevel, msg) => {
      const level = fromSgwtLogLevel(logLevel);
      (function () {
        if (Log$5.categories[Category.SGWT] >= level) {
          const formattedMessage = Log$5.formatMessage(Category.SGWT, level, "tagName[" + tagName + "] " + msg);
          console.log(formattedMessage);
          return Log$5.log(formattedMessage);
        }
      })();
    }
  });
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function getSgwtWidgetConfiguration() {
  return window.SGWTWidgetConfiguration;
}
/**
 *
 * @returns token that impersonates sg dasbhoard api backend with user identity
 */
function dangerouslyGetAccessToken() {
  return getSgwtWidgetConfiguration().bus.dangerouslyGetCurrentValue('sg-connect.access-token');
}
/**
 *
 * @returns token that impersonates sg dasbhoard api backend with user identity
 */
function getSgwtEnvironment() {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const env = getSgwtWidgetConfiguration().environment;
  if (!Object.values(sgDashboardSdk.Environment).includes(env)) {
    return function () {
      {
        const formattedMessage = Log$5.formatMessage(Category.Common, Log$5.Level.Error, "getSgwtEnvironment() invalid env[" + env + "]");
        console.log(formattedMessage);
        Log$5.log(formattedMessage);
        throw new Error(formattedMessage);
      }
    }();
  }
  return env;
}
// Inspired by this code
// https://sgithub.fr.world.socgen/SG-Web-Toolkit/sgwt-widgets/blob/master/src/common/sgwt-widgets-utils.ts#L333
function whichEnvironment(widgetConfiguration) {
  const envFromConfig = widgetConfiguration.environment.toLowerCase();
  if (!envFromConfig || envFromConfig === 'prod' || envFromConfig === 'production') {
    return sgDashboardSdk.SgConnectEnvironment.Production;
  }
  return sgDashboardSdk.SgConnectEnvironment.Homologation;
}
function getSgConnectEnvironment() {
  // It implicitely says that SGM dashboard component for getting SG Connect Environment is more prevalent than using the one in sgwtWidget Configuration,  Sgwidget configuration is used wrongly since it's used to discriminate between dev, uat and prd SG dashboard environment.
  // In the SGWT widget context, it should only says if you're using homologation sg connect or Production
  const widgetConfiguration = getSgwtWidgetConfiguration().widgets['sgm-dashboard-component'] != null ? getSgwtWidgetConfiguration().widgets['sgm-dashboard-component'] : getSgwtWidgetConfiguration();
  return whichEnvironment(widgetConfiguration);
}

//------------------------------------------------------------------------------
// query
var ResponseType;
(function (ResponseType) {
  ResponseType["Json"] = "application/json";
  ResponseType["Html"] = "text/html";
})(ResponseType || (ResponseType = {}));
var DatasetType;
(function (DatasetType) {
  DatasetType["CODE"] = "CODE";
  DatasetType["DESIGN_STUDIO"] = "DESIGN_STUDIO";
  DatasetType["URL"] = "URL";
})(DatasetType || (DatasetType = {}));
var UserProfileTheme;
(function (UserProfileTheme) {
  UserProfileTheme["Standard"] = "STANDARD";
  UserProfileTheme["Dark"] = "DARK";
})(UserProfileTheme || (UserProfileTheme = {}));
var ConfidentialityLevel;
(function (ConfidentialityLevel) {
  ConfidentialityLevel["C0"] = "C0";
  ConfidentialityLevel["C1"] = "C1";
  ConfidentialityLevel["C2"] = "C2";
  ConfidentialityLevel["C3"] = "C3";
})(ConfidentialityLevel || (ConfidentialityLevel = {}));
var ValidationStatus;
(function (ValidationStatus) {
  ValidationStatus["NONE"] = "NONE";
  ValidationStatus["PENDING"] = "PENDING";
  ValidationStatus["REJECTED"] = "REJECTED";
})(ValidationStatus || (ValidationStatus = {}));
var ChangeRequestStatus;
(function (ChangeRequestStatus) {
  ChangeRequestStatus["All"] = "all";
  ChangeRequestStatus["Pending"] = "pending";
  ChangeRequestStatus["Validated"] = "validated";
  ChangeRequestStatus["Rejected"] = "rejected";
  ChangeRequestStatus["Cancelled"] = "cancelled";
})(ChangeRequestStatus || (ChangeRequestStatus = {}));
var RequestFor;
(function (RequestFor) {
  RequestFor["Project"] = "Project";
  RequestFor["Project_Draft"] = "Project_Draft";
  RequestFor["Widget"] = "Widget";
  RequestFor["Widget_Draft"] = "Widget_Draft";
  RequestFor["Selector"] = "Selector";
  RequestFor["Selector_Draft"] = "Selector_Draft";
  RequestFor["Dataset"] = "Dataset";
  RequestFor["Dataset_Draft"] = "Dataset_Draft";
  RequestFor["Board"] = "Board";
})(RequestFor || (RequestFor = {}));
var DraftType;
(function (DraftType) {
  DraftType["PROJECT"] = "PROJECT";
  DraftType["WIDGET"] = "WIDGET";
  DraftType["SELECTOR"] = "SELECTOR";
  DraftType["DATASOURCE"] = "DATASOURCE";
})(DraftType || (DraftType = {}));

var AppRoutes;
(function (AppRoutes) {
  AppRoutes["MyBoards"] = "/my-boards";
  AppRoutes["Explore"] = "/explore";
  AppRoutes["Catalog"] = "/catalog";
  AppRoutes["DesignStudio"] = "/studio";
  AppRoutes["DevTools"] = "/developer";
  AppRoutes["MainError"] = "/error";
  AppRoutes["Administration"] = "/administration";
  AppRoutes["Projects"] = "/projects";
})(AppRoutes || (AppRoutes = {}));

var Routes;
(function (Routes) {
  Routes["InternalServerError"] = "/500";
  Routes["PageNotFound"] = "/404";
  Routes["ServiceUnavailable"] = "/503";
  Routes["RemoteAccessError"] = "/remote";
  Routes["ClientOutdatedError"] = "/outdated";
})(Routes || (Routes = {}));
 // for React.lazy()

var SCOPE_ENUM;
(function (SCOPE_ENUM) {
  SCOPE_ENUM["NO_SCOPE"] = "no.scope";
})(SCOPE_ENUM || (SCOPE_ENUM = {}));

function getEnvToUse() {
  const env = getSgwtEnvironment();
  const userInUatEnv = env === 'homologation';
  const userInDevEnv = env === 'development';
  let envToUse = '';
  if (userInUatEnv) {
    envToUse += 'UAT';
  }
  if (userInDevEnv) {
    envToUse += 'DEV';
  }
  return envToUse;
}

var BiPrimitive;
(function (BiPrimitive) {
  BiPrimitive["Date"] = "date";
  BiPrimitive["String"] = "string";
})(BiPrimitive || (BiPrimitive = {}));
var QueryJsonDefaultValue;
(function (QueryJsonDefaultValue) {
  QueryJsonDefaultValue["TRUE"] = "Yes";
  QueryJsonDefaultValue["FALSE"] = "No";
  QueryJsonDefaultValue["EMPTY"] = "";
  QueryJsonDefaultValue[QueryJsonDefaultValue["METRICNULL"] = 0] = "METRICNULL";
  QueryJsonDefaultValue["INVALID_DATE"] = "Invalid date";
})(QueryJsonDefaultValue || (QueryJsonDefaultValue = {}));
const deepAccessorFunction = (item, keys) => {
  let itemToAccess = item;
  for (let i = 0; i < keys.length; i++) {
    itemToAccess = itemToAccess != null ? itemToAccess[keys[i]] : null;
  }
  return itemToAccess;
};
// TODO: add this function to dashboard sdk with queryjson array
const dataAccessorFunction = (item, key, columns) => {
  if (columns != null) {
    const index = columns.indexOf(key);
    return index > -1 ? item[index] : null;
  }
  if (key.includes(sgDashboardSdk.SUB_OBJECT_SEPARATOR)) {
    const keys = key.split(sgDashboardSdk.SUB_OBJECT_SEPARATOR);
    return deepAccessorFunction(item, keys);
  } else {
    return item[key];
  }
};
function isTypeDataFrame(items) {
  const itemsToDetermine = items;
  if (itemsToDetermine != null && !Array.isArray(itemsToDetermine) && Array.isArray(itemsToDetermine.data) && Array.isArray(itemsToDetermine.columns)) {
    return true;
  }
  return false;
}

const filterDataJsonPath = (items, jsonPath) => {
  if (jsonPath && jsonPath !== '') {
    const dir = jsonPath.split('.');
    let data = items;
    for (let i = 0; i < dir.length; i++) {
      const path = dir[i];
      if (data.hasOwnProperty(path)) {
        data = data[path];
      } else {
        let parent = 'JSON response';
        if (i > 0) {
          parent = '"' + dir[i - 1] + '"';
        }
        throw new Error(parent + " does not contain property \"" + path + "\"");
      }
    }
    return data;
  }
  return items;
};

const Log$4 = Logger; // needed for jest
function createItems(items) {
  return items.map(x => ({
    label: "" + x,
    value: x,
    key: x
  }));
}
var SourceSecurityProducerEnum;
(function (SourceSecurityProducerEnum) {
  SourceSecurityProducerEnum["Homologation"] = "hom";
  SourceSecurityProducerEnum["Production"] = "prd";
  SourceSecurityProducerEnum["None"] = "none";
})(SourceSecurityProducerEnum || (SourceSecurityProducerEnum = {}));
function createHeaders(token, type) {
  const headersTemplate = {
    accept: 'application/json',
    'content-type': 'application/json'
  };
  const headers = _extends({}, headersTemplate);
  if (token !== SourceSecurityProducerEnum.None) {
    if (getSgConnectEnvironment() === sgDashboardSdk.SgConnectEnvironment.Homologation && token === SourceSecurityProducerEnum.Production) {
      throw new Error("in order to use this " + type + " you must be on dev or uat environment");
    }
    if (getSgConnectEnvironment() === sgDashboardSdk.SgConnectEnvironment.Production && token === SourceSecurityProducerEnum.Homologation) {
      throw new Error("in order to use this " + type + " you must be on dev2 or uat2 environment");
    }
    const authorization = dangerouslyGetAccessToken();
    headers.authorization = authorization;
  }
  return headers;
}
function registerSourceToSgDashApiwithParams(identifier, dataUrl, jsonPath, fieldsUrl, dataToken, fieldsToken, fieldsDescription, refresh, envToUse) {
  if (envToUse === void 0) {
    envToUse = getEnvToUse();
  }
  const sgDashApi = window.sgDashboard;
  if (dataToken !== SourceSecurityProducerEnum.None && fieldsToken !== SourceSecurityProducerEnum.None && dataToken !== fieldsToken) {
    return function () {
      {
        const formattedMessage = Log$4.formatMessage(Category.Producer, Log$4.Level.Error, "registerSourceToSgDashApiwithParams failed source[" + identifier + "] dataToken[" + dataToken + " and fieldsToken[" + fieldsToken + " cannot be on different sg connect environment] ");
        console.log(formattedMessage);
        Log$4.log(formattedMessage);
        throw new Error(formattedMessage);
      }
    }();
  }
  if (sgDashApi != null) {
    if (sgDashApi.propsBySource[identifier] == null || refresh) {
      const headersTemplate = {
        accept: 'application/json',
        'content-type': 'application/json'
      };
      const queryFields = function () {
        try {
          let _exit;
          function _temp2(_result) {
            if (_exit) return _result;
            if (fieldsDescription.length > 0) {
              // TODO: remove this after backend update existing fieldsDescription format (add fields and deletedFields)
              const fieldsDescriptionAsJson = JSON.parse(fieldsDescription);
              const {
                fields: allFields,
                deletedFields
              } = fieldsDescriptionAsJson;
              const fields = (allFields || fieldsDescriptionAsJson).filter(field => !(deletedFields || []).map(deletedField => deletedField.id).includes(field.id));
              return Promise.resolve(fields);
            }
          }
          const headers = createHeaders(fieldsToken, 'widget');
          const _temp = function () {
            if (fieldsUrl != null && fieldsUrl.length > 0) {
              return Promise.resolve(fetch(fieldsUrl, {
                method: 'GET',
                mode: 'cors',
                headers
              })).then(function (fetchItems) {
                if (!fetchItems.ok) throw new Error("query()  fetch failed status[" + fetchItems.status + "]");
                return Promise.resolve(fetchItems.json()).then(function (_await$fetchItems$jso) {
                  _exit = 1;
                  return _await$fetchItems$jso;
                });
              });
            }
          }();
          return Promise.resolve(_temp && _temp.then ? _temp.then(_temp2) : _temp2(_temp));
        } catch (e) {
          return Promise.reject(e);
        }
      };
      const query = function (_ref) {
        let {
          bucket,
          metrics,
          numberOfValues,
          sort,
          inputData,
          UserActionRequiredError,
          BiSourceHelper,
          widgetConfiguration,
          fields,
          fieldModes,
          showLast
        } = _ref;
        try {
          const {
            fetch,
            bus,
            debug,
            environment
          } = widgetConfiguration;
          const headers = _extends({}, headersTemplate);
          if (dataToken !== SourceSecurityProducerEnum.None) {
            if (getSgConnectEnvironment() === sgDashboardSdk.SgConnectEnvironment.Homologation && dataToken === SourceSecurityProducerEnum.Production) {
              throw new UserActionRequiredError("Please use " + envToUse + " (and not " + envToUse + "2) environment for this dataset.");
            }
            if (getSgConnectEnvironment() === sgDashboardSdk.SgConnectEnvironment.Production && dataToken === SourceSecurityProducerEnum.Homologation) {
              throw new UserActionRequiredError("Please use " + envToUse + "2 (and not " + envToUse + ") environment for this dataset.");
            }
            const authorization = bus.dangerouslyGetCurrentValue('sg-connect.access-token');
            headers.authorization = authorization;
          }
          return Promise.resolve(fetch(dataUrl, {
            method: 'GET',
            mode: 'cors',
            headers
          })).then(function (fetchItems) {
            if (!fetchItems.ok) throw new Error("query()  fetch failed status[" + fetchItems.status + "]");
            return Promise.resolve(fetchItems.json()).then(function (json) {
              const data = filterDataJsonPath(json, jsonPath);
              return BiSourceHelper.queryJSONArray({
                items: data,
                bucket,
                metrics,
                numberOfValues,
                sort,
                inputData,
                fields,
                fieldModes,
                showLast
              });
            });
          });
        } catch (e) {
          return Promise.reject(e);
        }
      };
      const filtersQuery = function (_ref2) {
        let {
          field,
          search,
          maxNbResults,
          logKey,
          widgetConfiguration,
          inputData,
          sgConnectEnvironment
        } = _ref2;
        try {
          const {
            fetch,
            bus,
            debug,
            environment
          } = widgetConfiguration;
          const headers = _extends({}, headersTemplate);
          if (dataToken !== SourceSecurityProducerEnum.None) {
            const authorization = bus.dangerouslyGetCurrentValue('sg-connect.access-token');
            headers.authorization = authorization;
          }
          return Promise.resolve(fetch(dataUrl, {
            method: 'GET',
            mode: 'cors',
            headers
          })).then(function (fetchItems) {
            return Promise.resolve(fetchItems.json()).then(function (json) {
              const data = filterDataJsonPath(json, jsonPath);
              let columns = null;
              const set = new Set();
              if (isTypeDataFrame(data)) {
                columns = data.columns;
                const columnIndex = data.columns.indexOf(field);
                data.data.forEach(x => {
                  set.add(x[columnIndex]);
                });
              } else {
                data.forEach(x => {
                  set.add(dataAccessorFunction(x, field, columns));
                });
              }
              const values = [...set];
              // return search hits
              if (search && values.length > 0) {
                /* Not case sensitive, stringify to manage special types like booleans */
                const found = values.filter(x => JSON.stringify(x).toLowerCase().includes(search.toLowerCase()));
                found.sort();
                const keepFirst = found.slice(0, maxNbResults);
                return createItems(keepFirst);
              }
              // return values
              return values.length > 0 ? createItems(values.sort().slice(0, maxNbResults)) : createItems([]);
            }); // return empty
          });
        } catch (e) {
          return Promise.reject(e);
        }
      };
      const filtersQuerySelected = function (_ref3) {
        let {
          field,
          selected,
          logKey,
          widgetConfiguration,
          inputData,
          sgConnectEnvironment
        } = _ref3;
        try {
          return Promise.resolve(createItems(selected));
        } catch (e) {
          return Promise.reject(e);
        }
      };
      try {
        sgDashApi.registerSource(identifier, {
          sgDashboard: {
            queryFields
          },
          webComponent: {
            query,
            filtersQuery,
            filtersQuerySelected
          },
          additional: {
            fieldsDescription: fieldsDescription
          }
        }, refresh);
      } catch (err) {
        return function () {
          {
            const formattedMessage = Log$4.formatMessage(Category.Producer, Log$4.Level.Error, "registerSourceToSgDashApiwithParams failed");
            console.log(formattedMessage);
            Log$4.log(formattedMessage);
            throw new Error(formattedMessage);
          }
        }();
      }
    } else {
      (function () {
        if (Log$4.categories[Category.Producer] >= Level.Debug) {
          const formattedMessage = Log$4.formatMessage(Category.Producer, Level.Debug, "registerSourceToSgDashApiwithParams called but source is already registered identifier[" + identifier + "] dataUrl[" + dataUrl + "] fieldsUrl[" + fieldsUrl + "]");
          console.log(formattedMessage);
          return Log$4.log(formattedMessage);
        }
      })();
    }
  }
}

var Action$1;
(function (Action) {
  Action[Action["UpdateJsStatus"] = 0] = "UpdateJsStatus";
})(Action$1 || (Action$1 = {}));

var JsStatus;
(function (JsStatus) {
  JsStatus["None"] = "None";
  JsStatus["Loading"] = "Loading";
  JsStatus["Loaded"] = "Loaded";
  JsStatus["Error"] = "Error";
})(JsStatus || (JsStatus = {}));
var JsType;
(function (JsType) {
  JsType["WebComponent"] = "WebComponent";
  JsType["WebComponentPrerequisite"] = "WebComponentPrerequisite";
  JsType["SourcePrerequisite"] = "SourcePrerequisite";
})(JsType || (JsType = {}));

var SgWidgetType;
(function (SgWidgetType) {
  SgWidgetType["GlobalSelector"] = "GlobalSelector";
  SgWidgetType["LocalSelector"] = "LocalSelector";
  SgWidgetType["Widget"] = "Widget";
})(SgWidgetType || (SgWidgetType = {}));
function getPriority(type) {
  // optimize to render the first widget as soon as possible (for a better user experience)
  switch (type) {
    case SgWidgetType.Widget:
      return Priority.VeryHigh;
    case SgWidgetType.GlobalSelector:
      return Priority.High;
    case SgWidgetType.LocalSelector:
      return Priority.Normal;
    default:
      return Priority.Normal;
  }
}

/**
 * Fake producer to make a false task for Sg Dashboard external widgets
 */
const Log$3 = Logger; // needed for jest
class FakeProducer {
  get priority() {
    return getPriority(this.sgWidgetType);
  }
  //
  constructor(key, label, sgWidgetType, jsLoaderKeys, output) {
    this.key = void 0;
    this.label = void 0;
    this.sgWidgetType = void 0;
    this.jsLoaderKeys = void 0;
    this.output = void 0;
    this.sgWidgetPredecessorKeys = [];
    this.eventReceived = true;
    this.withInitialEvent = false;
    this.eventWhenInputProcessed = false;
    this.key = key;
    this.label = label;
    this.sgWidgetType = sgWidgetType;
    this.jsLoaderKeys = jsLoaderKeys;
    this.output = output;
  }
  declarePredecessors() {
    return [...this.jsLoaderKeys];
  }
  compute(onComputed) {
    const {
      key,
      output
    } = this;
    (function () {
      if (Log$3.categories[Category.Producer] >= Level.Debug) {
        const formattedMessage = Log$3.formatMessage(Category.Producer, Level.Debug, "FakeProducer.compute() key[" + key + "] output[" + JSON.stringify(output) + "]");
        console.log(formattedMessage);
        return Log$3.log(formattedMessage);
      }
    })();
    onComputed(output, false);
  }
  cancel() {}
  toJson() {
    const {
      sgWidgetType,
      sgWidgetPredecessorKeys,
      jsLoaderKeys
    } = this;
    return {
      type: ProducerType.SgWidget,
      sgWidgetType,
      sgWidgetPredecessorKeys,
      jsLoaderKeys
    };
  }
  /*
  clone() returns a new producer in its intial state. transient state (seqNum, eventReceived, ...) is not copied
  (toJson() could be used instead, but writing a type-safe JSON parser is not that simple)
  */
  clone() {
    const {
      key,
      label,
      sgWidgetType,
      jsLoaderKeys,
      sgWidgetPredecessorKeys,
      output
    } = this;
    const res = new FakeProducer(key, label, sgWidgetType, jsLoaderKeys, output);
    res.sgWidgetPredecessorKeys = [...sgWidgetPredecessorKeys];
    return res;
  }
  onGraphOutput(_requestSeqNum, _output) {
    return false;
  }
  onSelfOutput(_output) {}
}

var Breakpoint;
(function (Breakpoint) {
  Breakpoint["None"] = "None";
  Breakpoint["XSmall"] = "XSmall";
  Breakpoint["Small"] = "Small";
  Breakpoint["Medium"] = "Medium";
  Breakpoint["Large"] = "Large";
  Breakpoint["XLarge"] = "XLarge";
  Breakpoint["XXLarge"] = "XXLarge";
})(Breakpoint || (Breakpoint = {}));
const sgBootstrapSharedCDN = 'https://shared.sgmarkets.com/sg-bootstrap';
var BootstrapLatest;
(function (BootstrapLatest) {
  BootstrapLatest["Five"] = "5.33.0";
  BootstrapLatest["Four"] = "4.39.0";
})(BootstrapLatest || (BootstrapLatest = {}));
const createSGBootstrapFilePath = (version, module, fileType, fileName) => {
  const specificVersion = version === sgDashboardSdk.BootstrapVersion.Five ? BootstrapLatest.Five : BootstrapLatest.Four;
  let modulePath = module;
  if (module === 'core') {
    modulePath = version === sgDashboardSdk.BootstrapVersion.Five ? "core/" + fileType : '';
  }
  switch (module) {
    case 'core':
      return sgBootstrapSharedCDN + "/v" + version + "/" + specificVersion + "/" + modulePath + "/" + fileName;
    case 'icons':
      return sgBootstrapSharedCDN + "/v" + version + "/" + (version === sgDashboardSdk.BootstrapVersion.Five ? specificVersion : '') + "/" + modulePath + "/" + fileName;
    case 'js':
      return sgBootstrapSharedCDN + "/v" + version + "/" + specificVersion + "/" + modulePath + "/" + fileName;
    default:
      throw new Error('Unrecognized module');
  }
};
const createBootstrapUrl = (version, theme) => createSGBootstrapFilePath(version, 'core', 'css', "sg-bootstrap-" + theme + ".min.css");

//
const Log$2 = Logger; // needed for jest
var SgDashboardApiMode;
(function (SgDashboardApiMode) {
  SgDashboardApiMode["DEFAULT"] = "default";
  SgDashboardApiMode["TEST"] = "test";
})(SgDashboardApiMode || (SgDashboardApiMode = {}));
class SgDashboardApi {
  constructor() {
    this._sourceTest = {};
    this._templateTest = {};
    this._propsByTemplate = {};
    this._propsBySource = {};
    this._mode = SgDashboardApiMode.DEFAULT;
  }
  get templateTest() {
    return this._templateTest;
  }
  get propsByTemplate() {
    return this._propsByTemplate;
  }
  get propsBySource() {
    return this._propsBySource;
  }
  setMode(mode) {
    (function () {
      if (Log$2.categories[Category.ValidationTest] >= Level.Debug) {
        const formattedMessage = Log$2.formatMessage(Category.ValidationTest, Level.Debug, "SgDashboardApi.setMode() mode: [" + JSON.stringify(mode) + "]");
        console.log(formattedMessage);
        return Log$2.log(formattedMessage);
      }
    })();
    this._mode = mode;
    if (mode == SgDashboardApiMode.DEFAULT) {
      this._templateTest = {};
    }
  }
  //
  registerPropertiesTest(templateIdentifier, properties) {
    if (typeof properties !== 'object') {
      return function () {
        {
          const formattedMessage = Log$2.formatMessage(Category.ValidationTest, Log$2.Level.Error, "SgDashboardApi.registerProperties() invalid properties[" + properties + "] type[" + typeof properties + "]");
          console.log(formattedMessage);
          Log$2.log(formattedMessage);
          throw new Error(formattedMessage);
        }
      }();
    }
    (function () {
      if (Log$2.categories[Category.ValidationTest] >= Level.Debug) {
        const formattedMessage = Log$2.formatMessage(Category.ValidationTest, Level.Debug, "SgDashboardApi.registerProperties() templateIdentifier[" + templateIdentifier + "] properties[" + JSON.stringify(Object.keys(properties)) + "]");
        console.log(formattedMessage);
        return Log$2.log(formattedMessage);
      }
    })();
    this._templateTest = _extends({}, this._templateTest, {
      [templateIdentifier]: properties
    });
  }
  registerPropertiesNormal(templateIdentifier, properties) {
    if (typeof properties !== 'object') {
      return function () {
        {
          const formattedMessage = Log$2.formatMessage(Category.Common, Log$2.Level.Error, "SgDashboardApi.registerProperties() invalid properties[" + properties + "] type[" + typeof properties + "]");
          console.log(formattedMessage);
          Log$2.log(formattedMessage);
          throw new Error(formattedMessage);
        }
      }();
    }
    if (templateIdentifier in this._propsByTemplate) {
      return function () {
        {
          const formattedMessage = Log$2.formatMessage(Category.Common, Log$2.Level.Error, "SgDashboardApi.registerProperties() failed templateIdentifier[" + templateIdentifier + "] has already been used with this registry");
          console.log(formattedMessage);
          Log$2.log(formattedMessage);
          throw new Error(formattedMessage);
        }
      }();
    }
    (function () {
      if (Log$2.categories[Category.Common] >= Level.Debug) {
        const formattedMessage = Log$2.formatMessage(Category.Common, Level.Debug, "SgDashboardApi.registerProperties() templateIdentifier[" + templateIdentifier + "] properties[" + JSON.stringify(Object.keys(properties)) + "]");
        console.log(formattedMessage);
        return Log$2.log(formattedMessage);
      }
    })();
    this._propsByTemplate = _extends({}, this._propsByTemplate, {
      [templateIdentifier]: properties
    });
  }
  registerProperties(templateIdentifier, properties) {
    switch (this._mode) {
      case SgDashboardApiMode.DEFAULT:
        this.registerPropertiesNormal(templateIdentifier, properties);
        break;
      case SgDashboardApiMode.TEST:
        this.registerPropertiesTest(templateIdentifier, properties);
        break;
    }
  }
  registerSourceNormal(id, properties, refresh) {
    if (typeof properties !== 'object') {
      return function () {
        {
          const formattedMessage = Log$2.formatMessage(Category.Widget, Log$2.Level.Error, "SgDashboardApi.registerSource() invalid properties[" + properties + "] type[" + typeof properties + "]");
          console.log(formattedMessage);
          Log$2.log(formattedMessage);
          throw new Error(formattedMessage);
        }
      }();
    }
    if (id in this._propsBySource && !refresh) {
      return function () {
        {
          const formattedMessage = Log$2.formatMessage(Category.Widget, Log$2.Level.Error, "SgDashboardApi.registerSource() failed id[" + id + "] has already been used with this registry");
          console.log(formattedMessage);
          Log$2.log(formattedMessage);
          throw new Error(formattedMessage);
        }
      }();
    }
    if (properties.sgDashboard === undefined || typeof properties.sgDashboard !== 'object') {
      return function () {
        {
          const formattedMessage = Log$2.formatMessage(Category.Widget, Log$2.Level.Error, "SgDashboardApi.registerSource() failed id[" + id + "] invalid property[sgDashboard]");
          console.log(formattedMessage);
          Log$2.log(formattedMessage);
          throw new Error(formattedMessage);
        }
      }();
    }
    if (properties.webComponent === undefined || typeof properties.webComponent !== 'object') {
      return function () {
        {
          const formattedMessage = Log$2.formatMessage(Category.Widget, Log$2.Level.Error, "SgDashboardApi.registerSource() failed id[" + id + "] invalid property[webComponent]");
          console.log(formattedMessage);
          Log$2.log(formattedMessage);
          throw new Error(formattedMessage);
        }
      }();
    }
    const {
      sgDashboard,
      webComponent
    } = properties;
    (function () {
      if (Log$2.categories[Category.Widget] >= Level.Debug) {
        const formattedMessage = Log$2.formatMessage(Category.Widget, Level.Debug, "SgDashboardApi.registerSource() id[" + id + "] sgDashboard[" + JSON.stringify(Object.keys(sgDashboard)) + "] webComponent[" + JSON.stringify(Object.keys(webComponent)) + "]");
        console.log(formattedMessage);
        return Log$2.log(formattedMessage);
      }
    })();
    //
    // check below the functions that are called within sg-dashboard (other functions will be checked at webcomponent level)
    if (sgDashboard.queryFields === undefined) {
      return function () {
        {
          const formattedMessage = Log$2.formatMessage(Category.Widget, Log$2.Level.Error, "SgDashboardApi.registerSource() failed id[" + id + "] missing property[queryFields]");
          console.log(formattedMessage);
          Log$2.log(formattedMessage);
          throw new Error(formattedMessage);
        }
      }();
    }
    this._propsBySource = _extends({}, this._propsBySource, {
      [id]: properties
    });
  }
  registerSourceTest(id, properties, refresh) {
    if (typeof properties !== 'object') {
      return function () {
        {
          const formattedMessage = Log$2.formatMessage(Category.Widget, Log$2.Level.Error, "SgDashboardApi.registerSource() invalid properties[" + properties + "] type[" + typeof properties + "]");
          console.log(formattedMessage);
          Log$2.log(formattedMessage);
          throw new Error(formattedMessage);
        }
      }();
    }
    const {
      sgDashboard,
      webComponent
    } = properties;
    (function () {
      if (Log$2.categories[Category.Widget] >= Level.Debug) {
        const formattedMessage = Log$2.formatMessage(Category.Widget, Level.Debug, "SgDashboardApi.registerSource() id[" + id + "] sgDashboard[" + JSON.stringify(Object.keys(sgDashboard)) + "] webComponent[" + JSON.stringify(Object.keys(webComponent)) + "]");
        console.log(formattedMessage);
        return Log$2.log(formattedMessage);
      }
    })();
    //
    // check below the functions that are called within sg-dashboard (other functions will be checked at webcomponent level)
    if (sgDashboard.queryFields === undefined) {
      return function () {
        {
          const formattedMessage = Log$2.formatMessage(Category.Widget, Log$2.Level.Error, "SgDashboardApi.registerSource() failed id[" + id + "] missing property[queryFields]");
          console.log(formattedMessage);
          Log$2.log(formattedMessage);
          throw new Error(formattedMessage);
        }
      }();
    }
    this._sourceTest = {
      [id]: properties
    };
  }
  registerSource(id, properties, refresh) {
    switch (this._mode) {
      case SgDashboardApiMode.DEFAULT:
        this.registerSourceNormal(id, properties, refresh);
        break;
      case SgDashboardApiMode.TEST:
        this.registerSourceTest(id, properties, refresh);
        break;
    }
  }
}

/**
 * BoardLightSpecialAppinfo, it's used for having a portable AppInfo object setted with values in order to instatiate widgets outsides of sg dasbhoard app.
 */
class BoardLightAppInfo {
  constructor(_ref) {
    let {
      environment,
      sgConnectEnvironment
    } = _ref;
    this.environment = void 0;
    this.sgConnectEnvironment = void 0;
    this.userProfile = void 0;
    this.userInfo = void 0;
    this.bootstrap = void 0;
    this.getApi = void 0;
    this.disableInitialJSLoading = void 0;
    this.environment = environment;
    this.sgConnectEnvironment = sgConnectEnvironment;
    this.userProfile = constructBoardLightUserProfile();
    this.userInfo = constructBoardLightUserInfo();
    this.bootstrap = constructBoardLightBootstrapInfo();
    this.getApi = customGetApi();
    this.disableInitialJSLoading = false;
    return this;
  }
}
const boardLightUserName = 'boardlight@sgcib.com';
function constructBoardLightUserProfile() {
  return {
    unmountLocalSelectors: false,
    compressGraph: false,
    email: boardLightUserName,
    isDeveloper: false,
    logLevel: '',
    logLevels: null,
    logInterval: 0,
    themeDoNotUse: sgDashboardSdk.BootstrapTheme.Dark,
    showMyWidgets: false,
    myWidgetsLocalDev: false,
    interceptedRequests: {},
    showRenderCount: false
  };
}
function constructBoardLightUserInfo() {
  return {
    userName: boardLightUserName,
    isExternalNetwork: false,
    isSgGroupUser: false,
    mail: boardLightUserName,
    orgs: '',
    userAuthorization: []
  };
}
function constructBoardLightBootstrapInfo() {
  return {
    isXSmall: false,
    isSmall: false,
    isMedium: false,
    isLarge: false,
    isXLarge: false,
    isXXLarge: false,
    breakpoint: Breakpoint.None,
    theme: sgDashboardSdk.BootstrapTheme.Standard
  };
}
function customGetApi() {
  function getApi() {
    const w = window;
    if (w.sgDashboard == null) {
      w.sgDashboard = new SgDashboardApi();
    }
    return w.sgDashboard;
  }
  return getApi;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function isJsonValid(value) {
  try {
    JSON.stringify(value);
    return true;
  } catch (e) {
    return false;
  }
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function isJsonObject(value) {
  if (typeof value !== 'object') return false;
  const obj = value;
  return isJsonValid(obj);
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function stringifyWithUndefined(value) {
  const str = JSON.stringify(value, (key, value) => value === undefined ? '__undefined__' : value);
  return str.replace(/"__undefined__"/g, 'undefined');
}
function cloneAndNormalize(val) {
  /*
  perform a stringify/parse to remove the potential 'undefined' values (e.g JSON.parse(JSON.stringify({"selectedIds":undefined})) === {})
  this also creates a cloned JsonValue which ensure that the returned object is not shared someone else (webcomponent, ...)
  */
  return JSON.parse(JSON.stringify(val));
}

var GraphOutputType;
(function (GraphOutputType) {
  GraphOutputType["ProducerOutput"] = "Producer";
  GraphOutputType["EventMissing"] = "Event missing";
  GraphOutputType["Unmounted"] = "Unmounted";
})(GraphOutputType || (GraphOutputType = {}));

var SEPARATORS;
(function (SEPARATORS) {
  SEPARATORS["COMMA"] = ", ";
  SEPARATORS["SEMICOLON"] = ";";
  SEPARATORS["SPACE"] = " ";
  SEPARATORS["SEMICOLON_SPACE"] = "; ";
})(SEPARATORS || (SEPARATORS = {}));

var ContentType;
(function (ContentType) {
  ContentType["WIDGET"] = "widget";
  ContentType["FILTER"] = "filter";
  ContentType["DATASET"] = "dataset";
  ContentType["BOARD"] = "board";
  ContentType["PROJECT"] = "project";
})(ContentType || (ContentType = {}));

var ExploreRoutes;
(function (ExploreRoutes) {
  ExploreRoutes["Boards"] = "/boards";
  ExploreRoutes["Widgets"] = "/widgets";
  ExploreRoutes["Datasets"] = "/datasets";
})(ExploreRoutes || (ExploreRoutes = {}));
var DesignStudioRoutes;
(function (DesignStudioRoutes) {
  DesignStudioRoutes["Boards"] = "/boards";
  DesignStudioRoutes["Widgets"] = "/widgets";
  DesignStudioRoutes["Datasets"] = "/datasets";
  DesignStudioRoutes["Creator"] = "/creator";
})(DesignStudioRoutes || (DesignStudioRoutes = {}));
var MyBoardsRoutes;
(function (MyBoardsRoutes) {
  MyBoardsRoutes["All"] = "/all";
  MyBoardsRoutes["Favorites"] = "/favorites";
  MyBoardsRoutes["Created"] = "/created";
  MyBoardsRoutes["Official"] = "/official";
  MyBoardsRoutes["Shared"] = "/shared";
  MyBoardsRoutes["CreatorBoard"] = "/creator";
  MyBoardsRoutes["EditorBoard"] = "/editor";
  MyBoardsRoutes["Boards"] = "/boards";
})(MyBoardsRoutes || (MyBoardsRoutes = {}));
var EditorRoutes;
(function (EditorRoutes) {
  EditorRoutes["Home"] = "/";
  EditorRoutes["Widgets"] = "/widgets";
  EditorRoutes["Official"] = "/official";
  EditorRoutes["Project"] = "/project";
  EditorRoutes["DesignStudio"] = "/studio";
})(EditorRoutes || (EditorRoutes = {}));
var AdministrationRoutes;
(function (AdministrationRoutes) {
  AdministrationRoutes["All"] = "/";
  AdministrationRoutes["Project"] = "/projects";
  AdministrationRoutes["Domain"] = "/domains";
  AdministrationRoutes["Stats"] = "/stats";
  AdministrationRoutes["UserFeedback"] = "/user-feedback";
  AdministrationRoutes["Request"] = "/requests";
})(AdministrationRoutes || (AdministrationRoutes = {}));
var ProjectRoutes;
(function (ProjectRoutes) {
  ProjectRoutes["Home"] = "/";
  ProjectRoutes["Edit"] = "/edit";
  ProjectRoutes["Layout"] = "/layout";
  ProjectRoutes["Creator"] = "/creator";
  ProjectRoutes["Information"] = "/information";
  ProjectRoutes["Import"] = "/import";
  ProjectRoutes["Validation"] = "/validation";
  ProjectRoutes["Settings"] = "/settings";
  ProjectRoutes["Content"] = "/content";
  ProjectRoutes["History"] = "/history";
  ProjectRoutes["Preview"] = "/preview";
})(ProjectRoutes || (ProjectRoutes = {}));
var ContentRoutes;
(function (ContentRoutes) {
  ContentRoutes["Draft"] = "/drafts";
  ContentRoutes["Widgets"] = "/widgets";
  ContentRoutes["Filters"] = "/filters";
  ContentRoutes["Boards"] = "/boards";
  ContentRoutes["Datasets"] = "/datasets";
  ContentRoutes["Projects"] = "/projects";
})(ContentRoutes || (ContentRoutes = {}));

var TemplateWidget;
(function (TemplateWidget) {
  TemplateWidget["CHART"] = "Chart";
  TemplateWidget["CHART_V10"] = "Chart v10";
  TemplateWidget["TEXT"] = "Text";
  TemplateWidget["KPI"] = "KPI";
  TemplateWidget["TABLE"] = "Table";
  TemplateWidget["TABLE_V25"] = "Table v25";
  TemplateWidget["TABLE_V26X"] = "Table v26x";
  TemplateWidget["COMMENT"] = "Comment";
})(TemplateWidget || (TemplateWidget = {}));
const TEMPLATE_WIDGET_IDENTIFIER_MAP = new Map();
TEMPLATE_WIDGET_IDENTIFIER_MAP.set(TemplateWidget.CHART, 'arclab-highcharts');
TEMPLATE_WIDGET_IDENTIFIER_MAP.set(TemplateWidget.TEXT, 'arclab-text');
TEMPLATE_WIDGET_IDENTIFIER_MAP.set(TemplateWidget.KPI, 'arclab-kpi');
TEMPLATE_WIDGET_IDENTIFIER_MAP.set(TemplateWidget.TABLE, 'arclab-ag-grid');
TEMPLATE_WIDGET_IDENTIFIER_MAP.set(TemplateWidget.TABLE_V25, 'arclab-ag-grid-v25');
TEMPLATE_WIDGET_IDENTIFIER_MAP.set(TemplateWidget.TABLE_V26X, 'arclab-ag-grid-v26-x');
TEMPLATE_WIDGET_IDENTIFIER_MAP.set(TemplateWidget.COMMENT, 'arclab-comment');
TEMPLATE_WIDGET_IDENTIFIER_MAP.set(TemplateWidget.CHART_V10, 'arclab-highcharts-v10');
const TEMPLATE_WIDGET_DESIGN_STUDIO_IDENTIFIER_MAP = new Map();
TEMPLATE_WIDGET_DESIGN_STUDIO_IDENTIFIER_MAP.set(TemplateWidget.CHART, 'arclab-bi-highcharts');
TEMPLATE_WIDGET_DESIGN_STUDIO_IDENTIFIER_MAP.set(TemplateWidget.KPI, 'arclab-bi-kpi');
TEMPLATE_WIDGET_DESIGN_STUDIO_IDENTIFIER_MAP.set(TemplateWidget.TABLE, 'arclab-bi-ag-grid');
var TemplateFilter;
(function (TemplateFilter) {
  TemplateFilter["SINGLE_SELECTION"] = "Single selection";
  TemplateFilter["SINGLE_SELECTION_WITH_SEARCH"] = "Single selection with search";
  TemplateFilter["MULTIPLE_SELECTION_WITH_SEARCH"] = "Multiple selection with search";
  TemplateFilter["BUTTON_GROUP"] = "Button group";
  TemplateFilter["CHECKBOX"] = "Checkbox";
  TemplateFilter["DATETIME"] = "Date-time";
})(TemplateFilter || (TemplateFilter = {}));
const TEMPLATE_FILTER_IDENTIFIER_MAP = new Map();
TEMPLATE_FILTER_IDENTIFIER_MAP.set(TemplateFilter.SINGLE_SELECTION, 'arclab-select');
TEMPLATE_FILTER_IDENTIFIER_MAP.set(TemplateFilter.SINGLE_SELECTION_WITH_SEARCH, 'arclab-single-picker');
TEMPLATE_FILTER_IDENTIFIER_MAP.set(TemplateFilter.MULTIPLE_SELECTION_WITH_SEARCH, 'arclab-picker');
TEMPLATE_FILTER_IDENTIFIER_MAP.set(TemplateFilter.BUTTON_GROUP, 'arclab-button-group');
TEMPLATE_FILTER_IDENTIFIER_MAP.set(TemplateFilter.CHECKBOX, 'arclab-checkbox');
TEMPLATE_FILTER_IDENTIFIER_MAP.set(TemplateFilter.DATETIME, 'sgwt-datetime-picker');
const TEMPLATE_FILTER_DESIGN_STUDIO_IDENTIFIER_MAP = new Map();
TEMPLATE_FILTER_DESIGN_STUDIO_IDENTIFIER_MAP.set(TemplateFilter.SINGLE_SELECTION, 'arclab-bi-select');
TEMPLATE_FILTER_DESIGN_STUDIO_IDENTIFIER_MAP.set(TemplateFilter.SINGLE_SELECTION_WITH_SEARCH, 'arclab-bi-single-picker');
TEMPLATE_FILTER_DESIGN_STUDIO_IDENTIFIER_MAP.set(TemplateFilter.MULTIPLE_SELECTION_WITH_SEARCH, 'arclab-bi-picker');
TEMPLATE_FILTER_DESIGN_STUDIO_IDENTIFIER_MAP.set(TemplateFilter.DATETIME, 'sgwt-datetime-picker');
const draftTypeContentRouteMap = new Map();
draftTypeContentRouteMap.set(DraftType.DATASOURCE, ContentRoutes.Datasets);
draftTypeContentRouteMap.set(DraftType.SELECTOR, ContentRoutes.Filters);
draftTypeContentRouteMap.set(DraftType.WIDGET, ContentRoutes.Widgets);
draftTypeContentRouteMap.set(DraftType.PROJECT, ContentRoutes.Projects);

/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */

/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = function() {};

if (process.env.NODE_ENV !== 'production') {
  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
        '`warning(condition, format, ...args)` requires a warning ' +
        'message argument'
      );
    }

    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
      throw new Error(
        'The warning format should be able to uniquely identify this ' +
        'warning. Please, use a more descriptive format than: ' + format
      );
    }

    if (!condition) {
      var argIndex = 0;
      var message = 'Warning: ' +
        format.replace(/%s/g, function() {
          return args[argIndex++];
        });
      if (typeof console !== 'undefined') {
        console.error(message);
      }
      try {
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
      } catch(x) {}
    }
  };
}

var browser = warning;

var urlJoin = createCommonjsModule(function (module) {
(function (name, context, definition) {
  if (module.exports) module.exports = definition();
  else context[name] = definition();
})('urljoin', commonjsGlobal, function () {

  function normalize (str, options) {

    // make sure protocol is followed by two slashes
    str = str.replace(/:\//g, '://');

    // remove consecutive slashes
    str = str.replace(/([^:\s])\/+/g, '$1/');

    // remove trailing slash before parameters or hash
    str = str.replace(/\/(\?|&|#[^!])/g, '$1');

    // replace ? in parameters with &
    str = str.replace(/(\?.+)\?/g, '$1&');

    return str;
  }

  return function () {
    var input = arguments;

    if (typeof arguments[0] === 'object') {
      // new syntax with array and options
      input = arguments[0];
    }

    var joined = [].slice.call(input, 0).join('/');
    return normalize(joined);
  };

});
});

var piwikReactRouter = createCommonjsModule(function (module) {




// api shim. used for serverside rendering and misconfigured tracker instances
var apiShim = {
	_isShim: true,
	track: function () {},
	push: function (args) {},
	setUserId: function (userId) {},
	trackError: function (e) {},
	connectToHistory: function (history, modifier) { return history; },
	disconnectFromHistory: function () {}
};

var previousPath = null;
var unlistenFromHistory = null;

var PiwikTracker = function(opts) {
	var getEnvironment = function () {
		return process && process.env && process.env.NODE_ENV ? process.env.NODE_ENV.toLowerCase() : 'development';
	};

	var getBaseUrl = function () {
		var u = '';
		var url = opts.url;

		if (url.indexOf('http://') !== -1 || url.indexOf('https://') !== -1) {
			u = url + '/';
		}
		else {
			u = (('https:' == document.location.protocol) ? 'https://' + url + '/' : 'http://' + url + '/');
		}

		return u;
	};

	var piwikIsAlreadyInitialized = function () {
		if (typeof window._paq === 'undefined' || typeof window._paq.push !== 'function') {
			return false;
		}

		var hasSiteId = false;
		var hasTrackerUrl = false;

		if (window._paq.length === undefined) {
			// piwik seems to have replaced the array by the TrackerProxy
			// @see https://github.com/piwik/piwik/blob/3.x-dev/js/piwik.js#L7050
			// @see https://github.com/piwik/piwik/blob/3.x-dev/js/piwik.js#L7115
			return true;
		}

		for (var j = 0, l = window._paq.length; j < l; j++) {
			if (~window._paq[j].indexOf('setSiteId')) {
				hasSiteId = true;
			}

			if (~window._paq[j].indexOf('setTrackerUrl')) {
				hasTrackerUrl = true;
			}

			if (hasTrackerUrl && hasSiteId) {
				return true
			}
		}

		return false;
	};

	opts = opts || {};
	opts.trackErrors = ((opts.trackErrors !== undefined) ? opts.trackErrors : false);
	opts.trackErrorHandler = ((opts.trackErrorHandler !== undefined) ? opts.trackErrorHandler : trackError);
	opts.enableLinkTracking = ((opts.enableLinkTracking !== undefined) ? opts.enableLinkTracking : true);
	opts.updateDocumentTitle = ((opts.updateDocumentTitle !== undefined) ? opts.updateDocumentTitle : true);
	opts.ignoreInitialVisit = ((opts.ignoreInitialVisit !== undefined) ? opts.ignoreInitialVisit : false);
	opts.injectScript = ((opts.injectScript !== undefined) ? opts.injectScript : true);
	opts.clientTrackerName = ((opts.clientTrackerName !== undefined) ? opts.clientTrackerName : 'piwik.js');
	opts.serverTrackerName = ((opts.serverTrackerName !== undefined) ? opts.serverTrackerName : 'piwik.php');

	var alreadyInitialized = piwikIsAlreadyInitialized();

	window._paq = window['_paq'] || [];

	var piwikWithoutUrlOrSiteId = (!opts.url || !opts.siteId) && !alreadyInitialized;
	var piwikWithoutInjectScript = !opts.injectScript && !alreadyInitialized;


	if (piwikWithoutUrlOrSiteId || piwikWithoutInjectScript) {
		// Only return warning if this is not in the test environment as it can break the Tests/CI.
		if (getEnvironment() !== 'test') {
			browser(null, 'PiwikTracker cannot be initialized! You haven\'t passed a url and siteId to it.');
		}

		return apiShim;
	}

	/**
	 * Adds a page view for the given location
	 */
	var track = function track (loc) {
		var currentPath;

		if (loc.path) {
			currentPath = loc.path;
		} else if (loc.basename) {
			currentPath = urlJoin(loc.basename, loc.pathname, loc.search);
		} else {
			currentPath = urlJoin(loc.pathname, loc.search);
		}

		if (previousPath === currentPath) {
			return;
		}

		if (opts.updateDocumentTitle) {
			push(['setDocumentTitle', document.title]);
		}
		push(['setCustomUrl', currentPath]);
		push(['trackPageView']);

		previousPath = currentPath;
	};

	/*
	 * Pushes the specified args to the piwik tracker.
	 * You can use this method as the low-level api to call methods from the piwik API or call custom functions
	 *
	 * @see https://developer.piwik.org/guides/tracking-javascript-guide
	 */
	var push = function push (args) {
		window._paq.push(args);
	};

	/**
	 * Sets a user ID to the piwik tracker.
	 * This method can be used after PiwikReactRouter is instantiated, for example after a user has logged in
	 *
	 * @see https://developer.piwik.org/guides/tracking-javascript-guide#user-id
	 */
	var setUserId = function setUserId (userId) {
		window._paq.push(['setUserId', userId]);
	};

	/**
	 * Tracks occurring javascript errors as a `JavaScript Error` piwik event.
	 *
	 * @see http://davidwalsh.name/track-errors-google-analytics
	 */
	function trackError (e, eventName) {
		eventName = eventName || 'JavaScript Error';

		push([
			'trackEvent',
			eventName,
			e.message,
			e.filename + ': ' + e.lineno
		]);
	}
	/**
	 * Connects to the given history
	 */
	var connectToHistory = function (history, modifier) {
				modifier = (typeof modifier === 'function') ? modifier : function (location) { return location; };

				var applyModifierAndTrackLocation = function (modifier, location) {
						var modifiedLocation = modifier(location);

						if (modifiedLocation !== undefined) {
								track(modifiedLocation);
						}
						else if (getEnvironment() === 'development') {
								browser(null, 'The modifier given to .connectToHistory did not return any object. Please make sure to return the modified location object in your modifier.');
						}
				};

		unlistenFromHistory = history.listen(function (location) {
						applyModifierAndTrackLocation(modifier, location);
		});

				if (!opts.ignoreInitialVisit && history.location) {
						applyModifierAndTrackLocation(modifier, history.location);
				}

		return history;
	};

	/**
	 * Disconnects from a previous connected history
	 */
	var disconnectFromHistory = function () {
		if (unlistenFromHistory) {
			unlistenFromHistory();
			return true;
		}

		return false;
	};

	if (opts.trackErrors) {
		if (window.addEventListener) {
			window.addEventListener('error', opts.trackErrorHandler, false);
		}
		else if (window.attachEvent) {
			window.attachEvent('onerror', opts.trackErrorHandler);
		}
		else {
			window.onerror = opts.trackErrorHandler;
		}
	}

	// piwik initializer
	(function() {
		var alreadyInitialized = piwikIsAlreadyInitialized();

		if (!alreadyInitialized) {
			var u = getBaseUrl();

			push(['setSiteId', opts.siteId]);
			push(['setTrackerUrl', u + opts.serverTrackerName]);
		}

		if (opts.userId) {
			setUserId(opts.userId);
		}

		if (opts.enableLinkTracking) {
			push(['enableLinkTracking']);
		}

		if (opts.injectScript && !alreadyInitialized) {
			var d=document;
			var g=d.createElement('script');
			var s=d.getElementsByTagName('script')[0];
			g.type='text/javascript';
			g.defer=true;
			g.async=true;
			g.src=u+opts.clientTrackerName;
			s.parentNode.insertBefore(g, s);
		}
	})();

	// return api
	return {
		_isShim: false,
		track: track,
		push: push,
		setUserId: setUserId,
		trackError: opts.trackErrorHandler,
		connectToHistory: connectToHistory,
		disconnectFromHistory: disconnectFromHistory
	};
};

if (typeof window === 'undefined') {
	module.exports = function() {
		return apiShim;
	};
}
else {
	module.exports = PiwikTracker;
}
});

var PiwikCategory;
(function (PiwikCategory) {
  PiwikCategory["Root"] = "root";
  PiwikCategory["MyBoards"] = "myBoards";
  PiwikCategory["MyWidgets"] = "myWidgets";
  PiwikCategory["Explore"] = "explore";
  PiwikCategory["ExploreBoard"] = "exploreBoard";
  PiwikCategory["ExploreWidgets"] = "exploreWidgets";
  PiwikCategory["ExploreDatasets"] = "exploreDatasets";
  PiwikCategory["Board"] = "board";
  PiwikCategory["Widget"] = "widget";
  PiwikCategory["Dataset"] = "dataset";
  PiwikCategory["EditMode"] = "editMode";
  PiwikCategory["WidgetLibrary"] = "widgetLibrary";
  PiwikCategory["Global"] = "global";
  PiwikCategory["Technical"] = "Technical";
  PiwikCategory["DesignStudio"] = "designStudio";
  PiwikCategory["DesignStudioBoard"] = "designStudioBoard";
  PiwikCategory["DesignStudioWidgets"] = "designStudioWidgets";
  PiwikCategory["DesignStudioDatasets"] = "designStudioDatasets";
  PiwikCategory["DesignStudioWidgetsCreateStep"] = "designStudioWidgetsCreateStep";
  PiwikCategory["DesignStudioWidgetsCreateStep1"] = "designStudioWidgetsCreateStep1";
  PiwikCategory["DesignStudioWidgetsCreateStep2"] = "designStudioWidgetsCreateStep2";
  PiwikCategory["DesignStudioWidgetsCreateStep3"] = "designStudioWidgetsCreateStep3";
  PiwikCategory["DesignStudioWidgetsCreateStep4"] = "designStudioWidgetsCreateStep4";
  PiwikCategory["DesignStudioWidgetsCreateStep5"] = "designStudioWidgetsCreateStep5";
  PiwikCategory["DesignStudioWidgetsEdit"] = "designStudioWidgetsEdit";
  PiwikCategory["DesignStudioDatasetEdit"] = "DdsignStudioDatasetEdit";
  PiwikCategory["DesignStudioDatasetCreate"] = "designStudioDatasetCreateStep";
  PiwikCategory["HelpCenter"] = "helpCenter";
  PiwikCategory["ProjectExplore"] = "projectExplore";
})(PiwikCategory || (PiwikCategory = {}));
var PiwikAction;
(function (PiwikAction) {
  PiwikAction["Administration"] = "administration";
  PiwikAction["MyBoards"] = "myBoards";
  PiwikAction["Explore"] = "explore";
  PiwikAction["Delete"] = "delete";
  PiwikAction["Developer"] = "developer";
  PiwikAction["Unknown"] = "Unknown";
  PiwikAction["Search"] = "search";
  PiwikAction["TabOfficialWidgets"] = "tabOfficialWidgets";
  PiwikAction["TabDesignStudioWidgets"] = "tabDesignStudioWidgets";
  PiwikAction["TabWidgets"] = "tabWidgets";
  PiwikAction["TabDatasets"] = "tabDatasets";
  PiwikAction["TabBoards"] = "tabBoards";
  PiwikAction["BoardCard"] = "boardCard";
  PiwikAction["BoardCardInfo"] = "boardCardInfo";
  PiwikAction["BoardInfo"] = "boardInfo";
  PiwikAction["BoardShared"] = "boardShare";
  PiwikAction["BoardView"] = "boardView";
  PiwikAction["BoardEdit"] = "boardEdit";
  PiwikAction["BoardReset"] = "boardReset";
  PiwikAction["BoardDelete"] = "boardDelete";
  PiwikAction["BoardExportPowerPoint"] = "boardExportPowerpoint";
  PiwikAction["BoardFiltersReset"] = "boardFiltersReset";
  PiwikAction["BoardFiltersOpen"] = "boardFiltersOpen";
  PiwikAction["BoardFiltersAdd"] = "boardFiltersAdd";
  PiwikAction["BoardFiltersRemove"] = "boardFiltersRemove";
  PiwikAction["BoardSaveAsNew"] = "boardSaveAsNew";
  PiwikAction["BoardSaveNotify"] = "boardSaveAndNotify";
  PiwikAction["BoardSave"] = "boardSave";
  PiwikAction["BoardFamilyNav"] = "boardFamilyNav";
  PiwikAction["BoardRemoveFromBoard"] = "boardRemoveFromBoard";
  PiwikAction["BoardGoToBoard"] = "boardGoToBoard";
  PiwikAction["BoardAddBoard"] = "boardAddBoard";
  PiwikAction["BoardFiltersCloseX"] = "boardFiltersCloseX";
  PiwikAction["BoardSortBy"] = "boardsSortBy";
  PiwikAction["BoardStar"] = "boardStar";
  PiwikAction["BoardUnstar"] = "boardUnstar";
  PiwikAction["BoardDuplicate"] = "boardDuplicate";
  PiwikAction["BoardRename"] = "boardRename";
  PiwikAction["BoardAddWidget"] = "boardAddWidget";
  PiwikAction["BoardUpdateBannerPreviewUpdate"] = "boardUpdateBannerPreviewUpdate";
  PiwikAction["BoardUpdateBannerUpdateLater"] = "boardUpdateBannerUpdateLater";
  PiwikAction["BoardPreviewUpdateBannerReturn"] = "BoardPreviewUpdateBannerReturn";
  PiwikAction["BoardPreviewUpdateBannerSaveBoard"] = "boardPreviewUpdateBannerSaveBoard";
  PiwikAction["BoardUpdateBoardIcon"] = "boardUpdateBoardIcon";
  PiwikAction["BoardUpdateBoardIconPreviewUpdate"] = "boardUpdateBoardIconPreviewUpdate";
  PiwikAction["BoardUpdateBoardIconUpdateLater"] = "boardUpdateBoardIconUpdateLater";
  PiwikAction["MoveToDesignStudio"] = "moveToDesignStudio";
  PiwikAction["RemoveFromDesignStudio"] = "removeFromDesignStudio";
  PiwikAction["CardStar"] = "cardStar";
  PiwikAction["CardUnstar"] = "cardUnstar";
  PiwikAction["CardMore"] = "cardMore";
  PiwikAction["CardEdit"] = "cardEdit";
  PiwikAction["CardDelete"] = "cardDelete";
  PiwikAction["CreateBoard"] = "createBoard";
  PiwikAction["SortBy"] = "sortBy";
  PiwikAction["FilterCard"] = "FilterCard";
  PiwikAction["ValidationHistory"] = "ValidationHistory";
  PiwikAction["WidgetCard"] = "widgetCard";
  PiwikAction["WidgetView"] = "widgetView";
  PiwikAction["WidgetShared"] = "widgetShare";
  PiwikAction["WidgetsSortBy"] = "widgetsSortBy";
  PiwikAction["WidgetInfo"] = "widgetInfo";
  PiwikAction["WidgetFiltersReset"] = "widgetFiltersReset";
  PiwikAction["WidgetFiltersOpen"] = "widgetFiltersOpen";
  PiwikAction["WidgetFiltersCloseBtn"] = "widgetFiltersCloseBtn";
  PiwikAction["WidgetDrillDown"] = "widgetRelatedBoards";
  PiwikAction["WidgetAddToExistingBoard"] = "widgetAddWidgetExistingBoard";
  PiwikAction["WidgetAddToNewBoard"] = "widgetAddWidgetNewBoard";
  PiwikAction["WidgetZoom"] = "widgetZoom";
  PiwikAction["WidgetEdit"] = "widgetEdit";
  PiwikAction["WidgetRename"] = "widgetRename";
  PiwikAction["WidgetDelete"] = "widgetDelete";
  PiwikAction["WidgetResize"] = "widgetResize";
  PiwikAction["SelfBiWidgetSave"] = "saveWidget";
  PiwikAction["SelfBiWidgetCancelCreate"] = "CancelCreate";
  PiwikAction["SelfBiCreateNextStep"] = "NextStep";
  PiwikAction["CreateWidget"] = "createWidget";
  PiwikAction["Information"] = "information";
  PiwikAction["WidgetTypeCard"] = "widgetTypeCard";
  PiwikAction["PreviousStep"] = "previousStep";
  PiwikAction["UpdatePreviewPanel"] = "updatePreviewPanel";
  PiwikAction["UpdatePreviewPreviewCard"] = "updatePreviewPreviewCard";
  PiwikAction["AddFilter"] = "AddFilter";
  PiwikAction["EditFilter"] = "EditFilter";
  PiwikAction["DeleteFilter"] = "deleteFilter";
  PiwikAction["BiWidgetEdit"] = "biWidgetEdit";
  PiwikAction["WidgetPreviewEdit"] = "WidgetPreviewEdit";
  PiwikAction["WidgetPreviewAddNewBoard"] = "WidgetPreviewAddNewBoard";
  PiwikAction["WidgetPreviewAddExistingBoard"] = "WidgetPreviewAddExistingBoard";
  PiwikAction["DesignStudio"] = "DesignStudio";
  PiwikAction["DatasetPreview"] = "DatasetPreview";
  PiwikAction["DatasetEdit"] = "DatasetEdit";
  PiwikAction["DatasetLoadData"] = "DatasetLoadData";
  PiwikAction["DatasetCard"] = "datasetCard";
  PiwikAction["DatasetInfo"] = "datasetInfo";
  PiwikAction["DatasetsSortBy"] = "datasetsSortBy";
  PiwikAction["DatasetShared"] = "datasetShare";
  PiwikAction["DatasetTransferOwnership"] = "datasetTransferOwnership";
  PiwikAction["WidgetTransferOwnership"] = "widgetTransferOwnership";
  PiwikAction["ContactUs"] = "ContactUs";
  PiwikAction["Feedback"] = "Feedback";
  PiwikAction["SearchDashboardDoc"] = "SearchDashboardDoc";
  PiwikAction["Projects"] = "Projects";
})(PiwikAction || (PiwikAction = {}));
var PiwikPrefix;
(function (PiwikPrefix) {
  PiwikPrefix["ADM"] = "ADM";
  PiwikPrefix["MBB"] = "MBB";
  PiwikPrefix["MBW"] = "MBW";
  PiwikPrefix["B"] = "B";
  PiwikPrefix["MBBE"] = "MBBE";
  PiwikPrefix["MB"] = "MB";
  PiwikPrefix["EB"] = "EB";
  PiwikPrefix["E"] = "E";
  PiwikPrefix["EW"] = "EW";
  PiwikPrefix["ED"] = "ED";
  PiwikPrefix["DSW"] = "DSW";
  PiwikPrefix["DSB"] = "DSB";
  PiwikPrefix["DSD"] = "DSD";
  PiwikPrefix["DSWE"] = "DSWE";
  PiwikPrefix["DSWCS1"] = "DSWCS1";
  PiwikPrefix["DSWCS2"] = "DSWCS2";
  PiwikPrefix["DSWCS3"] = "DSWCS3";
  PiwikPrefix["DSWCS4"] = "DSWCS4";
  PiwikPrefix["DSWCS5"] = "DSWCS5";
  PiwikPrefix["DSDSE"] = "DSDSE";
  PiwikPrefix["DSDSC"] = "DSDSC";
  PiwikPrefix["DSDSS"] = "DSDSS";
  PiwikPrefix["HCS"] = "HCS";
  PiwikPrefix["PRJ"] = "PRJ";
  PiwikPrefix["PRJB"] = "PRJB";
})(PiwikPrefix || (PiwikPrefix = {}));
const {
  piwikBaseUrl,
  piwikSiteId
} = getEnvVariables();
piwikBaseUrl && piwikSiteId ? piwikReactRouter({
  url: piwikBaseUrl,
  siteId: piwikSiteId
}) : undefined;

var strictUriEncode = str => encodeURIComponent(str).replace(/[!'()*]/g, x => `%${x.charCodeAt(0).toString(16).toUpperCase()}`);

var token = '%[a-f0-9]{2}';
var singleMatcher = new RegExp('(' + token + ')|([^%]+?)', 'gi');
var multiMatcher = new RegExp('(' + token + ')+', 'gi');

function decodeComponents(components, split) {
	try {
		// Try to decode the entire string first
		return [decodeURIComponent(components.join(''))];
	} catch (err) {
		// Do nothing
	}

	if (components.length === 1) {
		return components;
	}

	split = split || 1;

	// Split the array in 2 parts
	var left = components.slice(0, split);
	var right = components.slice(split);

	return Array.prototype.concat.call([], decodeComponents(left), decodeComponents(right));
}

function decode(input) {
	try {
		return decodeURIComponent(input);
	} catch (err) {
		var tokens = input.match(singleMatcher) || [];

		for (var i = 1; i < tokens.length; i++) {
			input = decodeComponents(tokens, i).join('');

			tokens = input.match(singleMatcher) || [];
		}

		return input;
	}
}

function customDecodeURIComponent(input) {
	// Keep track of all the replacements and prefill the map with the `BOM`
	var replaceMap = {
		'%FE%FF': '\uFFFD\uFFFD',
		'%FF%FE': '\uFFFD\uFFFD'
	};

	var match = multiMatcher.exec(input);
	while (match) {
		try {
			// Decode as big chunks as possible
			replaceMap[match[0]] = decodeURIComponent(match[0]);
		} catch (err) {
			var result = decode(match[0]);

			if (result !== match[0]) {
				replaceMap[match[0]] = result;
			}
		}

		match = multiMatcher.exec(input);
	}

	// Add `%C2` at the end of the map to make sure it does not replace the combinator before everything else
	replaceMap['%C2'] = '\uFFFD';

	var entries = Object.keys(replaceMap);

	for (var i = 0; i < entries.length; i++) {
		// Replace all decoded components
		var key = entries[i];
		input = input.replace(new RegExp(key, 'g'), replaceMap[key]);
	}

	return input;
}

var decodeUriComponent = function (encodedURI) {
	if (typeof encodedURI !== 'string') {
		throw new TypeError('Expected `encodedURI` to be of type `string`, got `' + typeof encodedURI + '`');
	}

	try {
		encodedURI = encodedURI.replace(/\+/g, ' ');

		// Try the built in decoder first
		return decodeURIComponent(encodedURI);
	} catch (err) {
		// Fallback to a more advanced decoder
		return customDecodeURIComponent(encodedURI);
	}
};

var splitOnFirst = (string, separator) => {
	if (!(typeof string === 'string' && typeof separator === 'string')) {
		throw new TypeError('Expected the arguments to be of type `string`');
	}

	if (separator === '') {
		return [string];
	}

	const separatorIndex = string.indexOf(separator);

	if (separatorIndex === -1) {
		return [string];
	}

	return [
		string.slice(0, separatorIndex),
		string.slice(separatorIndex + separator.length)
	];
};

var filterObj = function (obj, predicate) {
	var ret = {};
	var keys = Object.keys(obj);
	var isArr = Array.isArray(predicate);

	for (var i = 0; i < keys.length; i++) {
		var key = keys[i];
		var val = obj[key];

		if (isArr ? predicate.indexOf(key) !== -1 : predicate(key, val, obj)) {
			ret[key] = val;
		}
	}

	return ret;
};

createCommonjsModule(function (module, exports) {





const isNullOrUndefined = value => value === null || value === undefined;

function encoderForArrayFormat(options) {
	switch (options.arrayFormat) {
		case 'index':
			return key => (result, value) => {
				const index = result.length;

				if (
					value === undefined ||
					(options.skipNull && value === null) ||
					(options.skipEmptyString && value === '')
				) {
					return result;
				}

				if (value === null) {
					return [...result, [encode(key, options), '[', index, ']'].join('')];
				}

				return [
					...result,
					[encode(key, options), '[', encode(index, options), ']=', encode(value, options)].join('')
				];
			};

		case 'bracket':
			return key => (result, value) => {
				if (
					value === undefined ||
					(options.skipNull && value === null) ||
					(options.skipEmptyString && value === '')
				) {
					return result;
				}

				if (value === null) {
					return [...result, [encode(key, options), '[]'].join('')];
				}

				return [...result, [encode(key, options), '[]=', encode(value, options)].join('')];
			};

		case 'comma':
		case 'separator':
			return key => (result, value) => {
				if (value === null || value === undefined || value.length === 0) {
					return result;
				}

				if (result.length === 0) {
					return [[encode(key, options), '=', encode(value, options)].join('')];
				}

				return [[result, encode(value, options)].join(options.arrayFormatSeparator)];
			};

		default:
			return key => (result, value) => {
				if (
					value === undefined ||
					(options.skipNull && value === null) ||
					(options.skipEmptyString && value === '')
				) {
					return result;
				}

				if (value === null) {
					return [...result, encode(key, options)];
				}

				return [...result, [encode(key, options), '=', encode(value, options)].join('')];
			};
	}
}

function parserForArrayFormat(options) {
	let result;

	switch (options.arrayFormat) {
		case 'index':
			return (key, value, accumulator) => {
				result = /\[(\d*)\]$/.exec(key);

				key = key.replace(/\[\d*\]$/, '');

				if (!result) {
					accumulator[key] = value;
					return;
				}

				if (accumulator[key] === undefined) {
					accumulator[key] = {};
				}

				accumulator[key][result[1]] = value;
			};

		case 'bracket':
			return (key, value, accumulator) => {
				result = /(\[\])$/.exec(key);
				key = key.replace(/\[\]$/, '');

				if (!result) {
					accumulator[key] = value;
					return;
				}

				if (accumulator[key] === undefined) {
					accumulator[key] = [value];
					return;
				}

				accumulator[key] = [].concat(accumulator[key], value);
			};

		case 'comma':
		case 'separator':
			return (key, value, accumulator) => {
				const isArray = typeof value === 'string' && value.includes(options.arrayFormatSeparator);
				const isEncodedArray = (typeof value === 'string' && !isArray && decode(value, options).includes(options.arrayFormatSeparator));
				value = isEncodedArray ? decode(value, options) : value;
				const newValue = isArray || isEncodedArray ? value.split(options.arrayFormatSeparator).map(item => decode(item, options)) : value === null ? value : decode(value, options);
				accumulator[key] = newValue;
			};

		default:
			return (key, value, accumulator) => {
				if (accumulator[key] === undefined) {
					accumulator[key] = value;
					return;
				}

				accumulator[key] = [].concat(accumulator[key], value);
			};
	}
}

function validateArrayFormatSeparator(value) {
	if (typeof value !== 'string' || value.length !== 1) {
		throw new TypeError('arrayFormatSeparator must be single character string');
	}
}

function encode(value, options) {
	if (options.encode) {
		return options.strict ? strictUriEncode(value) : encodeURIComponent(value);
	}

	return value;
}

function decode(value, options) {
	if (options.decode) {
		return decodeUriComponent(value);
	}

	return value;
}

function keysSorter(input) {
	if (Array.isArray(input)) {
		return input.sort();
	}

	if (typeof input === 'object') {
		return keysSorter(Object.keys(input))
			.sort((a, b) => Number(a) - Number(b))
			.map(key => input[key]);
	}

	return input;
}

function removeHash(input) {
	const hashStart = input.indexOf('#');
	if (hashStart !== -1) {
		input = input.slice(0, hashStart);
	}

	return input;
}

function getHash(url) {
	let hash = '';
	const hashStart = url.indexOf('#');
	if (hashStart !== -1) {
		hash = url.slice(hashStart);
	}

	return hash;
}

function extract(input) {
	input = removeHash(input);
	const queryStart = input.indexOf('?');
	if (queryStart === -1) {
		return '';
	}

	return input.slice(queryStart + 1);
}

function parseValue(value, options) {
	if (options.parseNumbers && !Number.isNaN(Number(value)) && (typeof value === 'string' && value.trim() !== '')) {
		value = Number(value);
	} else if (options.parseBooleans && value !== null && (value.toLowerCase() === 'true' || value.toLowerCase() === 'false')) {
		value = value.toLowerCase() === 'true';
	}

	return value;
}

function parse(query, options) {
	options = Object.assign({
		decode: true,
		sort: true,
		arrayFormat: 'none',
		arrayFormatSeparator: ',',
		parseNumbers: false,
		parseBooleans: false
	}, options);

	validateArrayFormatSeparator(options.arrayFormatSeparator);

	const formatter = parserForArrayFormat(options);

	// Create an object with no prototype
	const ret = Object.create(null);

	if (typeof query !== 'string') {
		return ret;
	}

	query = query.trim().replace(/^[?#&]/, '');

	if (!query) {
		return ret;
	}

	for (const param of query.split('&')) {
		if (param === '') {
			continue;
		}

		let [key, value] = splitOnFirst(options.decode ? param.replace(/\+/g, ' ') : param, '=');

		// Missing `=` should be `null`:
		// http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
		value = value === undefined ? null : ['comma', 'separator'].includes(options.arrayFormat) ? value : decode(value, options);
		formatter(decode(key, options), value, ret);
	}

	for (const key of Object.keys(ret)) {
		const value = ret[key];
		if (typeof value === 'object' && value !== null) {
			for (const k of Object.keys(value)) {
				value[k] = parseValue(value[k], options);
			}
		} else {
			ret[key] = parseValue(value, options);
		}
	}

	if (options.sort === false) {
		return ret;
	}

	return (options.sort === true ? Object.keys(ret).sort() : Object.keys(ret).sort(options.sort)).reduce((result, key) => {
		const value = ret[key];
		if (Boolean(value) && typeof value === 'object' && !Array.isArray(value)) {
			// Sort object keys, not values
			result[key] = keysSorter(value);
		} else {
			result[key] = value;
		}

		return result;
	}, Object.create(null));
}

exports.extract = extract;
exports.parse = parse;

exports.stringify = (object, options) => {
	if (!object) {
		return '';
	}

	options = Object.assign({
		encode: true,
		strict: true,
		arrayFormat: 'none',
		arrayFormatSeparator: ','
	}, options);

	validateArrayFormatSeparator(options.arrayFormatSeparator);

	const shouldFilter = key => (
		(options.skipNull && isNullOrUndefined(object[key])) ||
		(options.skipEmptyString && object[key] === '')
	);

	const formatter = encoderForArrayFormat(options);

	const objectCopy = {};

	for (const key of Object.keys(object)) {
		if (!shouldFilter(key)) {
			objectCopy[key] = object[key];
		}
	}

	const keys = Object.keys(objectCopy);

	if (options.sort !== false) {
		keys.sort(options.sort);
	}

	return keys.map(key => {
		const value = object[key];

		if (value === undefined) {
			return '';
		}

		if (value === null) {
			return encode(key, options);
		}

		if (Array.isArray(value)) {
			return value
				.reduce(formatter(key), [])
				.join('&');
		}

		return encode(key, options) + '=' + encode(value, options);
	}).filter(x => x.length > 0).join('&');
};

exports.parseUrl = (url, options) => {
	options = Object.assign({
		decode: true
	}, options);

	const [url_, hash] = splitOnFirst(url, '#');

	return Object.assign(
		{
			url: url_.split('?')[0] || '',
			query: parse(extract(url), options)
		},
		options && options.parseFragmentIdentifier && hash ? {fragmentIdentifier: decode(hash, options)} : {}
	);
};

exports.stringifyUrl = (object, options) => {
	options = Object.assign({
		encode: true,
		strict: true
	}, options);

	const url = removeHash(object.url).split('?')[0] || '';
	const queryFromUrl = exports.extract(object.url);
	const parsedQueryFromUrl = exports.parse(queryFromUrl, {sort: false});

	const query = Object.assign(parsedQueryFromUrl, object.query);
	let queryString = exports.stringify(query, options);
	if (queryString) {
		queryString = `?${queryString}`;
	}

	let hash = getHash(object.url);
	if (object.fragmentIdentifier) {
		hash = `#${encode(object.fragmentIdentifier, options)}`;
	}

	return `${url}${queryString}${hash}`;
};

exports.pick = (input, filter, options) => {
	options = Object.assign({
		parseFragmentIdentifier: true
	}, options);

	const {url, query, fragmentIdentifier} = exports.parseUrl(input, options);
	return exports.stringifyUrl({
		url,
		query: filterObj(query, filter),
		fragmentIdentifier
	}, options);
};

exports.exclude = (input, filter, options) => {
	const exclusionFilter = Array.isArray(filter) ? key => !filter.includes(key) : (key, value) => !filter(key, value);

	return exports.pick(input, exclusionFilter, options);
};
});

// TODO: REPLACE ACTION ENUM BY STRING LITTERRALS, since the order of the declaration in the enum determine the type of actions in the reducers
var Action;
(function (Action) {
  Action[Action["ResetState"] = 0] = "ResetState";
  Action[Action["GraphInput"] = 1] = "GraphInput";
  Action[Action["NewGraph"] = 2] = "NewGraph";
  Action[Action["GraphShow"] = 3] = "GraphShow";
  Action[Action["GraphHide"] = 4] = "GraphHide";
  Action[Action["GraphUpdateOutput"] = 5] = "GraphUpdateOutput";
  Action[Action["NewOutput"] = 6] = "NewOutput";
  Action[Action["ProducerCompute"] = 7] = "ProducerCompute";
  Action[Action["UpdateSgWidgets"] = 8] = "UpdateSgWidgets";
  Action[Action["ResetGraph"] = 9] = "ResetGraph";
  Action[Action["EventReceived"] = 10] = "EventReceived";
  Action[Action["UpdateConfiguration"] = 11] = "UpdateConfiguration";
  Action[Action["BoardSaved"] = 12] = "BoardSaved";
  Action[Action["BoardName"] = 13] = "BoardName";
  Action[Action["ResetGrid"] = 14] = "ResetGrid";
  Action[Action["WidgetName"] = 15] = "WidgetName";
  Action[Action["ApplyDrilldownConfig"] = 16] = "ApplyDrilldownConfig";
  Action[Action["ClearFilters"] = 17] = "ClearFilters";
  Action[Action["AddError"] = 18] = "AddError";
  Action[Action["BoardShared"] = 19] = "BoardShared";
  Action[Action["ApplySharedBoardConfiguration"] = 20] = "ApplySharedBoardConfiguration";
  Action[Action["UpdateNotify"] = 21] = "UpdateNotify";
  Action[Action["UpdateNotifyState"] = 22] = "UpdateNotifyState";
  Action[Action["ForceApplyFilters"] = 23] = "ForceApplyFilters";
  Action[Action["ToggleApplyFilters"] = 24] = "ToggleApplyFilters";
})(Action || (Action = {}));

//
const Log$1 = Logger; // needed for jest
class ConstantProducer {
  get priority() {
    return getPriority(this.sgWidgetType);
  }
  //
  constructor(key, label, sgWidgetType, jsLoaderKeys, output) {
    this.key = void 0;
    this.label = void 0;
    this.sgWidgetType = void 0;
    this.jsLoaderKeys = void 0;
    this.output = void 0;
    this.sgWidgetPredecessorKeys = [];
    this.eventReceived = true;
    this.withInitialEvent = false;
    this.eventWhenInputProcessed = false;
    this.key = key;
    this.label = label;
    this.sgWidgetType = sgWidgetType;
    this.jsLoaderKeys = jsLoaderKeys;
    this.output = output;
  }
  declarePredecessors() {
    return [...this.jsLoaderKeys];
  }
  compute(onComputed) {
    const {
      key,
      output
    } = this;
    (function () {
      if (Log$1.categories[Category.Producer] >= Level.Debug) {
        const formattedMessage = Log$1.formatMessage(Category.Producer, Level.Debug, "ConstantProducer.compute() key[" + key + "] output[" + JSON.stringify(output) + "]");
        console.log(formattedMessage);
        return Log$1.log(formattedMessage);
      }
    })();
    onComputed(output, false);
  }
  cancel() {}
  toJson() {
    const {
      sgWidgetType,
      sgWidgetPredecessorKeys,
      jsLoaderKeys
    } = this;
    return {
      type: ProducerType.SgWidget,
      sgWidgetType,
      sgWidgetPredecessorKeys,
      jsLoaderKeys
    };
  }
  /*
  clone() returns a new producer in its intial state. transient state (seqNum, eventReceived, ...) is not copied
  (toJson() could be used instead, but writing a type-safe JSON parser is not that simple)
  */
  clone() {
    const {
      key,
      label,
      sgWidgetType,
      jsLoaderKeys,
      sgWidgetPredecessorKeys,
      output
    } = this;
    const res = new ConstantProducer(key, label, sgWidgetType, jsLoaderKeys, output);
    res.sgWidgetPredecessorKeys = [...sgWidgetPredecessorKeys];
    return res;
  }
  onGraphOutput(requestSeqNum, output) {
    var _this2 = this;
    const {
      key
    } = this;
    (function () {
      {
        const formattedMessage = Log$1.formatMessage(Category.Producer, Log$1.Level.Error, "ConstantProducer key[" + key + "] onGraphOutput() unexpected event requestSeqNum[" + requestSeqNum + "] output[" + JSON.stringify(output) + "] constantOutput[" + JSON.stringify(_this2.output) + "]");
        console.log(formattedMessage);
        Log$1.log(formattedMessage);
        throw new Error(formattedMessage);
      }
    })();
    return false;
  }
  onSelfOutput(output) {
    var _this = this;
    const {
      key
    } = this;
    const identical = lodash.isEqual(this.output, output);
    if (identical) {
      (function () {
        if (Log$1.categories[Category.Producer] >= Level.Warning) {
          const formattedMessage = Log$1.formatMessage(Category.Producer, Level.Warning, "ConstantProducer key[" + key + "] onSelfOutput() unexpected identical event output[" + JSON.stringify(output) + "] constantOutput[" + JSON.stringify(_this.output) + "]");
          console.log(formattedMessage);
          return Log$1.log(formattedMessage);
        }
      })();
    } else {
      (function () {
        {
          const formattedMessage = Log$1.formatMessage(Category.Producer, Log$1.Level.Error, "ConstantProducer key[" + key + "] onSelfOutput() unexpected event output[" + JSON.stringify(output) + "] constantOutput[" + JSON.stringify(_this.output) + "]");
          console.log(formattedMessage);
          Log$1.log(formattedMessage);
          throw new Error(formattedMessage);
        }
      })();
    }
  }
}
function toConstantProducer(key, taskDico, producerDico, output) {
  (function () {
    if (Log$1.categories[Category.Producer] >= Level.Debug) {
      const formattedMessage = Log$1.formatMessage(Category.Producer, Level.Debug, "fromLocalToConstant() key[" + key + "] output[" + JSON.stringify(output) + "]");
      console.log(formattedMessage);
      return Log$1.log(formattedMessage);
    }
  })();
  const producer = producerDico.getSgWidget(key);
  const {
    label,
    jsLoaderKeys,
    sgWidgetType
  } = producer;
  const task = taskDico.get(key);
  const constantProducer = new ConstantProducer(key, label, sgWidgetType, jsLoaderKeys, output);
  if (!lodash.isEqual(task.output, constantProducer.output)) {
    (function () {
      {
        const formattedMessage = Log$1.formatMessage(Category.Producer, Log$1.Level.Error, "fromLocalToConstant() key[" + key + "] invalid output oldOutput[" + JSON.stringify(task.output) + "] newOutput[" + JSON.stringify(constantProducer.output) + "]");
        console.log(formattedMessage);
        Log$1.log(formattedMessage);
        throw new Error(formattedMessage);
      }
    })();
  }
  //
  task.cancel();
  producerDico.remove(key);
  producerDico.addSgWidget(constantProducer);
  task.updateProducer(constantProducer);
}
function canUnmount(key, taskDico, producerDico, hidden, withPredecessorInConfig, unmountLocalSelectors) {
  const producer = producerDico.getSgWidget(key);
  const task = taskDico.get(key);
  return hidden && producer.sgWidgetType === SgWidgetType.LocalSelector && !withPredecessorInConfig &&
  // even if the predecessor in not currently in the board (i.e. not in producer.sgWidgetPredecessorKeys) it can be added later in the editor
  producer.eventReceived && task.output !== null && unmountLocalSelectors;
}

const _excluded = ["__from__"],
  _excluded2 = ["requestSeqNum"];
//
const Log = Logger; // needed for jest
const dataTestIdSgWidget = 'sgWidget';
function setInputsProperty(widgetEl, inputsProperty, inputsValue) {
  /*
  IMPORTANT
  cloneDeep() needed because the webcomponent can modify anything contained in 'inputsValue'
  (e.g. it could modify a producer output used in our react state)
  */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  widgetEl[inputsProperty] = lodash.cloneDeep(inputsValue);
}
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const createOnSelfOutput = getTasks => (key, output) => {
  const {
    taskDico,
    taskGraph,
    scheduler
  } = getTasks();
  if (taskDico && taskGraph) {
    const producer = taskDico.get(key);
    const modified = producer.onOutput(output);
    if (modified) {
      taskGraph.cancel(scheduler);
      taskGraph.execute(scheduler);
    }
  }
};
function fillInputsProperty(key, widgetEl, inputsProperty, inputs, newProducer, type, tagName) {
  if (!inputs || !inputsProperty) return;
  const {
    predecessors,
    seqNum
  } = inputs;
  const duplicatedKeys = [];
  /*
  - each predecessor generates an output of type JsonObject
  then all the predecessor outputs are merged in one single JsonObject
  which is provided as [props.inputsProperty] on the widget
  - if there are clashes among the keys of different predecessor outputs
  the widget devs need to handle them on their side
  (usually props.attributes is used to tell the predecessor which key to use in its output)
  */
  const inputsValue = predecessors.filter(item => item ? true : false).map(item => {
    const it = item;
    const rawOutput = _objectWithoutPropertiesLoose(it, _excluded);
    return rawOutput;
  }).reduce((acc, item) => {
    Object.keys(item).forEach(key => {
      if (key in acc) {
        duplicatedKeys.push(key);
      }
    });
    return _extends({}, acc, item);
  },
  /*
  'input values' and seqNum must be provided "atomically" to the sg-widget
  for instance if the seqNum is set in another property, the sg-widget might be able to observe an incoherent state
  (e.g. new 'input values' with old seqNum)
  */
  newProducer ? {
    seqNum
  } : {});
  if (duplicatedKeys.length) {
    (function () {
      if (Log.categories[Category.Producer] >= Level.Error) {
        const formattedMessage = Log.formatMessage(Category.Producer, Level.Error, "SgWidget key[" + key + "] type[" + type + "] tagName[" + tagName + "] inputsProperty[" + inputsProperty + "] with duplicatedKeys[" + JSON.stringify(duplicatedKeys) + "]");
        console.log(formattedMessage);
        return Log.log(formattedMessage);
      }
    })();
    return;
  }
  (function () {
    if (Log.categories[Category.Producer] >= Level.Debug) {
      const formattedMessage = Log.formatMessage(Category.Producer, Level.Debug, "SgWidget key[" + key + "] type[" + type + "] tagName[" + tagName + "] set inputsProperty[" + inputsProperty + "] with value[" + JSON.stringify(inputsValue) + "]");
      console.log(formattedMessage);
      return Log.log(formattedMessage);
    }
  })();
  setInputsProperty(widgetEl, inputsProperty,
  // WebComponentDto.inputDataProperty
  inputsValue);
}
function fillConfiguration(key, widgetEl, configuration, tagName, type) {
  (function () {
    if (Log.categories[Category.Producer] >= Level.Debug) {
      const formattedMessage = Log.formatMessage(Category.Producer, Level.Debug, "SgWidget key[" + key + "] type[" + type + "] tagName[" + tagName + "] set configuration with value[" + JSON.stringify(configuration) + "]");
      console.log(formattedMessage);
      return Log.log(formattedMessage);
    }
  })();
  /*
    - cloneDeep() needed because the webcomponent can modify anything contained in 'userSelection'
    (which is stored in our react state)
    - configuration contains the value below if it is not empty:
    globalSelector: JSON.parse(GlobalSelectorDto.configuration)['inputs']
    localSelector: JSON.parse(WidgetDto.configuration)['localSelectorInputs'][selectorTemplateId]
    widget: JSON.parse(WidgetDto.internalConfiguration)
    - otherwise it contains a default value (can be empty) coming from the widget/selector template:
    JSON.parse(decodeURIComponent(WebComponentDto.userSelection))
    */
  widgetEl.userSelection = lodash.cloneDeep(configuration);
}
function createWidgetElement(key, tagName, outputEvent, properties, attributes, logKeyAttribute, configuration, inputsProperty, inputs, newProducer, savedCallbackRef, type, getApi, templateIdentifier, dataSourceIdentifiers, theme, sgConnectEnvironment) {
  const {
    propsByTemplate,
    propsBySource
  } = getApi();
  const customProperties = propsByTemplate[templateIdentifier];
  /*
  the webcomponent must not be rendered inside 'react render' because addEventListener() must be called first:
  attributeChangedCallback() is called synchronously below when widgetEl.setAttribute() is called
  connectedCallback() is called inside HTMLElement.appendChild()
  ...
  */
  const widgetEl = document.createElement(tagName);
  const customPropertiesMsg = customProperties !== undefined ? " templateIdentifier[" + templateIdentifier + "] customProperties[" + JSON.stringify(Object.keys(customProperties)) + "]" : '';
  let sourcesProperties;
  let sourcesPropertiesMsg = '';
  if (dataSourceIdentifiers.length) {
    sourcesProperties = dataSourceIdentifiers.reduce((acc, dataSourceIdentifier) => {
      const props = propsBySource[dataSourceIdentifier];
      if (props === undefined) {
        return function () {
          {
            const formattedMessage = Log.formatMessage(Category.Producer, Log.Level.Error, "SgWidget key[" + key + "] type[" + type + "] tagName[" + tagName + "] missing sourceProperties[" + dataSourceIdentifier + "]");
            console.log(formattedMessage);
            Log.log(formattedMessage);
            throw new Error(formattedMessage);
          }
        }();
      }
      const sourceProperties = props.webComponent;
      sourceProperties.queryFields = props.sgDashboard.queryFields;
      sourcesPropertiesMsg += " dataSourceIdentifier[" + dataSourceIdentifier + "] sourceProperties[" + JSON.stringify(Object.keys(sourceProperties)) + "]";
      return _extends({}, acc, {
        [dataSourceIdentifier]: sourceProperties
      });
    }, {});
  }
  (function () {
    if (Log.categories[Category.Producer] >= Level.Debug) {
      const formattedMessage = Log.formatMessage(Category.Producer, Level.Debug, "SgWidget key[" + key + "] type[" + type + "] create element tagName[" + tagName + "] outputEvent[" + (outputEvent ? outputEvent : '') + "] properties[" + JSON.stringify(properties) + "] attributes[" + JSON.stringify(attributes) + "] configuration[" + JSON.stringify(configuration) + "] logKeyAttribute[" + logKeyAttribute + "]" + customPropertiesMsg + sourcesPropertiesMsg);
      console.log(formattedMessage);
      return Log.log(formattedMessage);
    }
  })();
  const onOutputEvent = event => {
    const {
      current: savedCallback
    } = savedCallbackRef;
    if (!savedCallback) {
      return function () {
        {
          const formattedMessage = Log.formatMessage(Category.Producer, Log.Level.Error, "SgWidget.onOutputEvent() key[" + key + "] type[" + type + "] tagName[" + tagName + "] missing callback");
          console.log(formattedMessage);
          Log.log(formattedMessage);
          throw new Error(formattedMessage);
        }
      }();
    }
    savedCallback(widgetEl, event);
  };
  if (outputEvent) {
    widgetEl.addEventListener(outputEvent, onOutputEvent);
  }
  //
  if (logKeyAttribute) {
    widgetEl.setAttribute(logKeyAttribute, key);
  }
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const widgetElAny = widgetEl;
  widgetElAny.widgetProperties = {};
  widgetElAny.widgetAttributes = {};
  if (Object.keys(properties).length) {
    // must be done before setting the 'userSelection' because the format of the output event (triggered after setting the 'userSelection') depends on the attributes
    Object.entries(properties).forEach(_ref => {
      let [property, value] = _ref;
      widgetElAny[property] = lodash.cloneDeep(value);
      widgetElAny.widgetProperties[property] = lodash.cloneDeep(value);
    });
  }
  if (Object.keys(attributes).length) {
    Object.entries(attributes).forEach(_ref2 => {
      let [attribute, value] = _ref2;
      widgetEl.setAttribute(attribute, value);
      widgetElAny.widgetAttributes[attribute] = lodash.cloneDeep(value);
    });
  }
  widgetEl.setAttribute('theme', theme);
  widgetEl.setAttribute('data-bs-theme', sgDashboardSdk.BootstrapTheme.Dark === theme ? 'dark' : 'light');
  widgetEl.setAttribute('sg-connect-environment', sgConnectEnvironment);
  if (customProperties) {
    Object.entries(customProperties).forEach(_ref3 => {
      let [property, value] = _ref3;
      widgetElAny[property] = value;
    });
  }
  if (sourcesProperties) {
    widgetElAny.sources = sourcesProperties;
  }
  widgetEl.setAttribute('data-testid', dataTestIdSgWidget);
  fillConfiguration(key, widgetEl, configuration, tagName, type);
  /*
  it is important to fill the inputsProperty in the same useEffect() as the one which mounts the webcomponent
  otherwise some webcomponents will trigger two fetch (one before fillInputsProperty() is called and one after)
  */
  fillInputsProperty(key, widgetEl, inputsProperty, inputs, newProducer, type, tagName);
  const removeWidget = () => {
    (function () {
      if (Log.categories[Category.Producer] >= Level.Debug) {
        const formattedMessage = Log.formatMessage(Category.Producer, Level.Debug, "SgWidget key[" + key + "] type[" + type + "] remove element tagName[" + tagName + "]");
        console.log(formattedMessage);
        return Log.log(formattedMessage);
      }
    })();
    if (outputEvent) {
      widgetEl.removeEventListener(outputEvent, onOutputEvent);
    }
    widgetEl.remove();
  };
  return {
    widgetEl,
    removeWidget
  };
}
function createStyleElement(imports) {
  const styleEl = document.createElement('style');
  styleEl.innerHTML = imports.map(url => "@import url(" + url + ");").join('\n');
  return styleEl;
}
function createRootElement(key, shadowDomIncompatible, bootstrapVersion, bootstrapTheme, type, tagName) {
  const rootEl = document.createElement('div'); // extra element needed to be able to remove the shadow DOM
  const withShadowDom = !!(!shadowDomIncompatible && rootEl.attachShadow);
  if (!shadowDomIncompatible && !rootEl.attachShadow) {
    (function () {
      if (Log.categories[Category.Producer] >= Level.Error) {
        const formattedMessage = Log.formatMessage(Category.Producer, Level.Error, "SgWidget key[" + key + "] type[" + type + "] tagName[" + tagName + "] HTMLElement.attachShadow() not available");
        console.log(formattedMessage);
        return Log.log(formattedMessage);
      }
    })();
  }
  const shadowRoot = withShadowDom ? rootEl.attachShadow({
    mode: 'open'
  }) : rootEl;
  if (withShadowDom) {
    let imports = [];
    switch (bootstrapVersion) {
      case sgDashboardSdk.BootstrapVersion.Three:
        // use custom CSS without @font-face from sg-dashboard-v1 (needed to avoid blinks with safari when CSS is imported)
        imports = [process.env.PUBLIC_URL + "/widget-font-awesome.min.css", process.env.PUBLIC_URL + "/widget-pe-icon-7-stroke.min.css", process.env.PUBLIC_URL + "/widget-sg-bootstrap-standard.min.css"];
        break;
      case sgDashboardSdk.BootstrapVersion.Four:
      case sgDashboardSdk.BootstrapVersion.Five:
        imports = [createBootstrapUrl(bootstrapVersion, bootstrapTheme), createSGBootstrapFilePath(bootstrapVersion, 'icons', 'css', 'index.min.css')];
        break;
      default:
        return function () {
          {
            const formattedMessage = Log.formatMessage(Category.Producer, Log.Level.Error, "SgWidget.createRootElement() key[" + key + "] type[" + type + "] tagName[" + tagName + "] invalid sg-booststrap version[" + bootstrapVersion + "]");
            console.log(formattedMessage);
            Log.log(formattedMessage);
            throw new Error(formattedMessage);
          }
        }();
    }
    if (imports.length) {
      shadowRoot.appendChild(createStyleElement(imports));
    }
  }
  return {
    rootEl,
    shadowRoot
  };
}
function createEventCallback(key, getTasks, configuration, dispatch, sgWidgetType, hidden, tagName, newProducer, persistConfiguration, withPredecessorInConfig, unmountLocalSelectors, compressGraph) {
  return function onOutputEvent(widgetEl, event) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const evt = event;
    if (!evt.detail) {
      return function () {
        {
          const formattedMessage = Log.formatMessage(Category.Producer, Log.Level.Error, "SgWidget.onOutputEvent() key[" + key + "] type[" + sgWidgetType + "] tagName[" + tagName + "] invalid event[" + JSON.stringify(evt) + "] \"detail\" property is falsy (e.g. undefined or null) whereas it should be a JSON object");
          console.log(formattedMessage);
          Log.log(formattedMessage);
          throw new Error(formattedMessage);
        }
      }();
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const {
      detail: anyOutput
    } = event;
    if (!isJsonObject(anyOutput)) {
      return function () {
        {
          const formattedMessage = Log.formatMessage(Category.Producer, Log.Level.Error, "SgWidget.onOutputEvent() key[" + key + "] type[" + sgWidgetType + "] tagName[" + tagName + "] output[" + JSON.stringify(anyOutput) + "] is of type[" + typeof anyOutput + "] outputWithUndefined[" + stringifyWithUndefined(anyOutput) + "]");
          console.log(formattedMessage);
          Log.log(formattedMessage);
          throw new Error(formattedMessage);
        }
      }();
    }
    const output = cloneAndNormalize(anyOutput);
    if (Array.isArray(output)) {
      const errorMsg = "tagName[" + tagName + "] event contains an array output[" + JSON.stringify(output) + "]";
      (function () {
        if (Log.categories[Category.Producer] >= Level.Error) {
          const formattedMessage = Log.formatMessage(Category.Producer, Level.Error, "SgWidget key[" + key + "] type[" + sgWidgetType + "] " + errorMsg);
          console.log(formattedMessage);
          return Log.log(formattedMessage);
        }
      })();
      dispatch({
        type: Action.AddError,
        errorMsg
      });
    }
    let requestSeqNum = 0;
    let outputValue = output;
    if (newProducer) {
      const {
          requestSeqNum: requestSeqNumJsonValue
        } = output,
        rest = _objectWithoutPropertiesLoose(output, _excluded2);
      if (typeof requestSeqNumJsonValue !== 'number' || isNaN(requestSeqNumJsonValue) || requestSeqNumJsonValue < 0) {
        const errorMsg = "tagName[" + tagName + "] with \"eventWhenInputProcessed\" triggered an event with an invalid \"requestSeqNum\" output[" + JSON.stringify(output) + "]";
        (function () {
          if (Log.categories[Category.Producer] >= Level.Error) {
            const formattedMessage = Log.formatMessage(Category.Producer, Level.Error, "SgWidget key[" + key + "] type[" + sgWidgetType + "] " + errorMsg);
            console.log(formattedMessage);
            return Log.log(formattedMessage);
          }
        })();
        dispatch({
          type: Action.AddError,
          errorMsg
        });
        return; // ignore the event
      }
      requestSeqNum = requestSeqNumJsonValue; // requestSeqNum is a number >= 0
      outputValue = rest;
    }
    //
    (function () {
      if (Log.categories[Category.Producer] >= Level.Debug) {
        const formattedMessage = Log.formatMessage(Category.Producer, Level.Debug, "SgWidget.onOutputEvent() key[" + key + "] type[" + sgWidgetType + "] tagName[" + tagName + "] output[" + JSON.stringify(output) + "] outputWithUndefined[" + stringifyWithUndefined(output) + "]");
        console.log(formattedMessage);
        return Log.log(formattedMessage);
      }
    })();
    //
    const {
      producerDico,
      taskDico
    } = getTasks();
    const producer = producerDico.getSgWidget(key);
    let ignoreEvent = false;
    outputValue = _extends({
      __from__: sgWidgetType
    }, outputValue); // append where the even is coming from
    if (requestSeqNum > 0) {
      ignoreEvent = producer.onGraphOutput(requestSeqNum, outputValue);
    } else {
      producer.onSelfOutput(outputValue, createOnSelfOutput(getTasks));
    }
    //
    if (ignoreEvent) return;
    /*
    - call Action.UpdateConfiguration even if persistConfiguration is false
    because the configuration needs to be updated in memory for some specific use cases (drilldown, ...)
    - _.isEqual() is called incorrectly in sg-dashboard-v1
    for some reason sg-dashboard-v1 calls _.isEqual({ ...configuration }, { ...widgetEl.userSelection })
    and this returns true for instance if configuration=null and widgetEl.userSelection=[] which is wrong
    - this can lead to situations where a board is considered as modified (save button visible)
    right after it is loaded in sg-dashboard-v2
    */
    if (widgetEl.userSelection !== undefined) {
      if (!isJsonValid(widgetEl.userSelection)) {
        return function () {
          {
            const formattedMessage = Log.formatMessage(Category.Producer, Log.Level.Error, "SgWidget.onOutputEvent() key[" + key + "] type[" + sgWidgetType + "] tagName[" + tagName + "] invalid JSON userSelection[" + JSON.stringify(widgetEl.userSelection) + "] userSelectionWithUndefined[" + stringifyWithUndefined(widgetEl.userSelection) + "]");
            console.log(formattedMessage);
            Log.log(formattedMessage);
            throw new Error(formattedMessage);
          }
        }();
      }
      const newConfiguration = cloneAndNormalize(widgetEl.userSelection);
      if (!lodash.isEqual(configuration, newConfiguration)) {
        if (persistConfiguration) {
          (function () {
            if (Log.categories[Category.Board] >= Level.Debug) {
              const formattedMessage = Log.formatMessage(Category.Board, Level.Debug, "SgWidget.onOutputEvent() key[" + key + "] type[" + sgWidgetType + "] tagName[" + tagName + "] add pendingChanges due to userSelection before[" + JSON.stringify(configuration) + "] after[" + JSON.stringify(newConfiguration) + "] afterWithUndefined[" + stringifyWithUndefined(newConfiguration) + "]");
              console.log(formattedMessage);
              return Log.log(formattedMessage);
            }
          })();
        }
        configuration = newConfiguration;
        dispatch({
          type: Action.UpdateConfiguration,
          sgWidgetType,
          key,
          configuration,
          persistConfiguration
        });
      }
    }
    //
    const unmount = hidden !== null && canUnmount(key, taskDico, producerDico, hidden, withPredecessorInConfig, unmountLocalSelectors);
    if (unmount) {
      /*
      ATTENTION
      the code below can be called several times on the same producer
      for instance if the webcomponent generates a sequence of close events before it is unmounted
      */
      (function () {
        if (Log.categories[Category.Producer] >= Level.Debug) {
          const formattedMessage = Log.formatMessage(Category.Producer, Level.Debug, "SgWidget.onOutputEvent() key[" + key + "] type[" + sgWidgetType + "] tagName[" + tagName + "] unmount after event");
          console.log(formattedMessage);
          return Log.log(formattedMessage);
        }
      })();
      toConstantProducer(key, taskDico, producerDico, outputValue);
    }
    dispatch({
      type: Action.EventReceived,
      sgWidgetType,
      key,
      unmount,
      compressGraph
    });
  };
}
function useSgWidget(divRef, key, tagName, type, outputEvent, getTasks, inputs, inputsProperty, configuration, properties, attributes, shadowDomIncompatible, bootstrapVersion, width, newProducer, dispatch, hidden,
// null when the info (hidden/shown) is not filled
logKeyAttribute, persistConfiguration, withPredecessorInConfig, appInfo, templateIdentifier, dataSourceIdentifiers) {
  const {
    userProfile: {
      unmountLocalSelectors,
      compressGraph
    },
    bootstrap: {
      theme: bootstrapTheme
    },
    getApi,
    sgConnectEnvironment
  } = appInfo;
  const [elements, setElements] = React.useState(null);
  const ignoreInputProps = React.useRef(false);
  const fakeDepsRef = React.useRef(null);
  React.useEffect(() => {
    fakeDepsRef.current = {
      inputsProperty,
      inputs,
      newProducer,
      configuration
    };
  }, [inputsProperty, inputs, newProducer, configuration]);
  const savedCallbackRef = React.useRef(null);
  React.useEffect(() => {
    savedCallbackRef.current = createEventCallback(key, getTasks, configuration, dispatch, type, hidden, tagName, newProducer, persistConfiguration, withPredecessorInConfig, unmountLocalSelectors, compressGraph);
  }, [key, getTasks, configuration, dispatch, type, hidden, tagName, newProducer, persistConfiguration, withPredecessorInConfig, unmountLocalSelectors, compressGraph]);
  React.useEffect(() => {
    const {
      current: fakeDeps
    } = fakeDepsRef;
    if (!fakeDeps) return;
    const {
      current: divEl
    } = divRef;
    if (!divEl) return;
    const {
      widgetEl,
      removeWidget
    } = createWidgetElement(key, tagName, outputEvent, properties, attributes, logKeyAttribute, fakeDeps.configuration, fakeDeps.inputsProperty, fakeDeps.inputs, fakeDeps.newProducer, savedCallbackRef, type, getApi, templateIdentifier, dataSourceIdentifiers, bootstrapTheme, sgConnectEnvironment);
    const {
      shadowRoot,
      rootEl
    } = createRootElement(key, shadowDomIncompatible, bootstrapVersion, bootstrapTheme, type, tagName);
    if (key) {
      switch (type) {
        case SgWidgetType.Widget:
          rootEl.setAttribute('id', "widget-" + key);
          rootEl.classList.add('sg-widget');
          break;
        case SgWidgetType.GlobalSelector:
          rootEl.setAttribute('id', "selector-" + key);
          rootEl.classList.add('sg-selector');
          break;
      }
    }
    shadowRoot.appendChild(widgetEl);
    divEl.appendChild(rootEl);
    setElements({
      widgetEl,
      rootEl
    });
    ignoreInputProps.current = true;
    return () => {
      setElements(null);
      removeWidget();
      rootEl.remove();
      ignoreInputProps.current = false;
    };
  }, [divRef, key, tagName, outputEvent, shadowDomIncompatible, bootstrapVersion, bootstrapTheme, properties, attributes, logKeyAttribute,
  /*
  the webcomponent must not be unmount/mount when the content of fakeDepsRef.current changes
  another useEffect() below will handle the changes of fakeDepsRef.current content
  */
  fakeDepsRef, savedCallbackRef, type, getApi, templateIdentifier, dataSourceIdentifiers, sgConnectEnvironment]);
  React.useEffect(() => {
    if (!elements) return;
    const {
      widgetEl
    } = elements;
    if (ignoreInputProps.current) {
      // the webcomponent has just been mounted so its inputsProperty has already been set
      ignoreInputProps.current = false;
      return;
    }
    fillInputsProperty(key, widgetEl, inputsProperty, inputs, newProducer, type, tagName);
  }, [elements, key, inputsProperty, inputs, newProducer, ignoreInputProps, type, tagName, dispatch]);
  React.useEffect(() => {
    if (!elements) return;
    const {
      rootEl
    } = elements;
    rootEl.setAttribute('style', "width: " + width + "; height: 100%");
  }, [divRef, width, elements]);
}

exports.BoardLightAppInfo = BoardLightAppInfo;
exports.FakeProducer = FakeProducer;
exports.ProducerDictionary = ProducerDictionary;
exports.SgDashboardApi = SgDashboardApi;
exports.SimpleProducerTaskDictionary = SimpleProducerTaskDictionary;
exports.SimpleScheduler = SimpleScheduler;
exports.getSgConnectEnvironment = getSgConnectEnvironment;
exports.registerSourceToSgDashApiwithParams = registerSourceToSgDashApiwithParams;
exports.useSgWidget = useSgWidget;
